import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** An RFC-3339 compliant Full Date Scalar */
  Date: Date | string;
  /** Java LocalDateTime as scalar. */
  DateTime: Date | string;
  /** Java Duration as scalar. */
  Duration: string;
  /** A 64-bit signed integer */
  Long: number;
  /** Java LocalTime as scalar. */
  Time: string;
  /**
   * represents java ZoneId object: https://docs.oracle.com/javase/8/docs/api/java/time/ZoneId.html
   * examples: "+01:00", "-05:00", "Europe/Warsaw", "UTC", "Etc/GMT+10", "Etc/GMT"
   */
  ZoneId: string;
  /**
   * represents java ZonedDateTime object: https://docs.oracle.com/javase/8/docs/api/java/time/ZonedDateTime.html
   * example: "2023-01-01T11:11:11.111+01:00", "2023-01-01T11:11:11.111Z"
   */
  ZonedDateTime: string;
};

export type AbstractFilter = {
  child?: Maybe<AbstractFilter>;
  filterType?: Maybe<FilterType>;
  operationType?: Maybe<OperationType>;
};

export type AbstractFilterDto = {
  accessKey?: InputMaybe<Scalars['String']>;
  child?: InputMaybe<AbstractFilterDto>;
  duration?: InputMaybe<Scalars['Duration']>;
  filter?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  filterField?: InputMaybe<Scalars['String']>;
  filterType?: InputMaybe<FilterType>;
  freeText?: InputMaybe<Scalars['String']>;
  fromTime?: InputMaybe<Scalars['Time']>;
  messageGroupId?: InputMaybe<Scalars['String']>;
  messageType?: InputMaybe<MessageType>;
  operationType?: InputMaybe<OperationType>;
  otherChild?: InputMaybe<AbstractFilterDto>;
  region?: InputMaybe<Scalars['String']>;
  secretKey?: InputMaybe<Scalars['String']>;
  supportedMessageTypes?: InputMaybe<Array<InputMaybe<MessageType>>>;
  toTime?: InputMaybe<Scalars['Time']>;
  topic?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  webhookMessageTrigger?: InputMaybe<MessageType>;
  webhookType?: InputMaybe<WebhookType>;
};

export type ActivationInfo = {
  effectiveBillingDate?: InputMaybe<Scalars['DateTime']>;
  moduleId: Scalars['String'];
  paymentIntervalType?: InputMaybe<PaymentIntervalType>;
};

export type Alert = {
  __typename?: 'Alert';
  alertLevel?: Maybe<AlertLevel>;
  alertText?: Maybe<Scalars['String']>;
  contact?: Maybe<Scalars['String']>;
  dateTime?: Maybe<Scalars['DateTime']>;
  filterType?: Maybe<FilterType>;
  locationName?: Maybe<Scalars['String']>;
  locationNodeId?: Maybe<Scalars['String']>;
  machineName?: Maybe<Scalars['String']>;
  machineNodeId?: Maybe<Scalars['String']>;
  nodeId?: Maybe<Scalars['String']>;
  triggerType?: Maybe<TriggerType>;
};

export type AlertHistoryDto = {
  __typename?: 'AlertHistoryDto';
  columns?: Maybe<Array<Maybe<AlertHistoryReportPairDtoOut>>>;
  fullSize?: Maybe<Scalars['Int']>;
  rows?: Maybe<Array<Maybe<Alert>>>;
};

export type AlertHistoryDtoIn = {
  alertHistoryFilteringField?: InputMaybe<AlertHistoryFilteringField>;
  fromDate: Scalars['DateTime'];
  limit: Scalars['Int'];
  locationNodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  machineNodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  order: Order;
  orderColumn?: InputMaybe<AlertHistoryOrderColumn>;
  skip: Scalars['Int'];
  toDate: Scalars['DateTime'];
};

export type AlertHistoryFilteringField = {
  filteringField?: InputMaybe<AlertHistoryOrderColumn>;
  value: Scalars['String'];
};

export type AlertHistoryOrderColumn =
  | 'ALERT_LEVEL'
  | 'ALERT_TEXT'
  | 'CONTACT'
  | 'DATE_TIME'
  | 'FILTER_TYPE'
  | 'LOCATION_NAME'
  | 'LOCATION_NODE_ID'
  | 'MACHINE_NAME'
  | 'MACHINE_NODE_ID'
  | 'TRIGGER_TYPE';

export type AlertHistoryReportPairDtoOut = {
  __typename?: 'AlertHistoryReportPairDtoOut';
  key?: Maybe<AlertHistoryOrderColumn>;
  values?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type AlertLevel =
  | 'ERROR'
  | 'INFO'
  | 'UNKNOWN'
  | 'WARNING';

export type AmountDto = {
  __typename?: 'AmountDto';
  amount?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  currency?: Maybe<Scalars['String']>;
};

export type BatchableReportDtoIn = {
  dbName: Scalars['String'];
  dbUser: Scalars['String'];
  inputPayload?: InputMaybe<Scalars['String']>;
  reportName: ScheduledReportName;
  reportsRequestNodeId: Scalars['String'];
};

export type BiNodeFilter = AbstractFilter & {
  __typename?: 'BiNodeFilter';
  biNodeFilterType?: Maybe<BiNodeFilterType>;
  child?: Maybe<AbstractFilter>;
  filterType?: Maybe<FilterType>;
  operationType?: Maybe<OperationType>;
  otherChild?: Maybe<AbstractFilter>;
};

export type BiNodeFilterType =
  | 'AND'
  | 'EQ'
  | 'OR';

export type BillingIntervalDto = {
  __typename?: 'BillingIntervalDto';
  beginDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  finishedTimestamp?: Maybe<Scalars['DateTime']>;
  interval?: Maybe<PaymentIntervalType>;
  invoiceId?: Maybe<Scalars['String']>;
  isUpcoming?: Maybe<Scalars['Boolean']>;
  nodeId?: Maybe<Scalars['String']>;
  processingTimestamp?: Maybe<Scalars['DateTime']>;
  referenceId?: Maybe<Scalars['String']>;
  sentTimestamp?: Maybe<Scalars['DateTime']>;
  status?: Maybe<BillingStatus>;
};

export type BillingStatus =
  | 'NOT_PAID'
  | 'NOT_SENT'
  | 'OVERDUE'
  | 'PENDING'
  | 'PROCESSED'
  | 'PROCESSING'
  | 'SENT';

export type BoxTotalsDtoIn = {
  currency?: InputMaybe<Scalars['String']>;
  reportName: ScheduledReportName;
  transactionsNodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type BoxTotalsDtoOut = {
  __typename?: 'BoxTotalsDtoOut';
  boxTotals?: Maybe<Array<Maybe<RmPairDto>>>;
};

export type CacheKey =
  | 'USER_LIST_KEY'
  | 'USER_ROLES_LIST_KEY';

export type CashAmountFilter = AbstractFilter & {
  __typename?: 'CashAmountFilter';
  cashAmountIn?: Maybe<Array<Maybe<CashAmountIn>>>;
  child?: Maybe<AbstractFilter>;
  filterType?: Maybe<FilterType>;
  operationType?: Maybe<OperationType>;
};

export type CashAmountIn = {
  __typename?: 'CashAmountIn';
  amount?: Maybe<Scalars['Int']>;
  currency?: Maybe<Scalars['String']>;
  decimals?: Maybe<Scalars['Int']>;
  nodeId?: Maybe<Scalars['String']>;
};

export type CashInventoryReportCriteriaDtoIn = {
  container?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
  /** TODO: not implemented yet */
  locationNodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  machineName?: InputMaybe<Scalars['String']>;
  machineNodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  machineType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Order>;
  orderColumn?: InputMaybe<CashInventoryReportOrderColumn>;
  referenceDate: Scalars['DateTime'];
  reportName: ScheduledReportName;
  siteGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  skip: Scalars['Int'];
  zoneId?: InputMaybe<Scalars['ZoneId']>;
};

export type CashInventoryReportDto = {
  __typename?: 'CashInventoryReportDto';
  columns?: Maybe<Array<Maybe<ReportPairDtoOut>>>;
  fullSize?: Maybe<Scalars['Int']>;
  rows?: Maybe<Array<Maybe<CashInventoryReportRowDto>>>;
};

export type CashInventoryReportOrderColumn =
  | 'LOCATION'
  | 'MACHINE'
  | 'MACHINE_TYPE';

export type CashInventoryReportRowDto = {
  __typename?: 'CashInventoryReportRowDto';
  boxNodeIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  locationName?: Maybe<Scalars['String']>;
  machineName?: Maybe<Scalars['String']>;
  machineNodeId?: Maybe<Scalars['String']>;
  machineTypeName?: Maybe<Scalars['String']>;
  rawResponse?: Maybe<Array<Maybe<RmBoxContentDto>>>;
  totalAmounts?: Maybe<Array<Maybe<AmountDto>>>;
};

export type CashOperationsDtoOut = {
  __typename?: 'CashOperationsDtoOut';
  machineContentDtos?: Maybe<Array<Maybe<MachineContentDto>>>;
};

export type CashOperationsReportCriteriaDto = {
  machineNodeId: Scalars['String'];
  referenceDate: Scalars['DateTime'];
  reportName: ScheduledReportName;
  zoneId?: InputMaybe<Scalars['ZoneId']>;
};

export type CashSummaryReportCriteriaDto = {
  locationNodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  referenceDate: Scalars['DateTime'];
  reportName: ScheduledReportName;
  zoneId?: InputMaybe<Scalars['ZoneId']>;
};

export type CashSummaryReportDto = {
  __typename?: 'CashSummaryReportDto';
  grandTotals?: Maybe<Array<Maybe<SummaryGrandTotalDto>>>;
  machineContents?: Maybe<Array<Maybe<MachineCurrencyContentDto>>>;
};

export type ChartBarColor =
  | 'GREEN'
  | 'RED'
  | 'YELLOW';

export type ChartBarDto = {
  __typename?: 'ChartBarDto';
  color?: Maybe<ChartBarColor>;
  description?: Maybe<Array<Maybe<Scalars['String']>>>;
  name?: Maybe<Scalars['String']>;
  percent?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

export type ClaimedValuesGroupFactor =
  | 'MACHINE'
  | 'SITE'
  | 'TYPE';

export type ClaimedValuesReportCriteriaDtoIn = {
  groupFactor: ClaimedValuesGroupFactor;
  /** TODO: not implemented yet */
  locationNodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  machineNodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  referenceDate: Scalars['DateTime'];
  reportName: ScheduledReportName;
  siteGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  zoneId?: InputMaybe<Scalars['ZoneId']>;
};

export type ClaimedValuesReportDtoOut = {
  __typename?: 'ClaimedValuesReportDtoOut';
  grandTotals?: Maybe<Array<Maybe<RmPairDto>>>;
  rows?: Maybe<Array<Maybe<ClaimedValuesReportRowDto>>>;
};

export type ClaimedValuesReportRowDto = {
  __typename?: 'ClaimedValuesReportRowDto';
  container?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  currency?: Maybe<Scalars['String']>;
  denomination?: Maybe<Scalars['String']>;
  machine?: Maybe<Scalars['String']>;
  site?: Maybe<Scalars['String']>;
  subRows?: Maybe<Array<Maybe<ClaimedValuesReportRowDto>>>;
  total?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** New model */
export type CoDLicenseDtoOut = {
  __typename?: 'CoDLicenseDtoOut';
  comment?: Maybe<Scalars['String']>;
  createdByUser?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['DateTime']>;
  customer?: Maybe<Scalars['String']>;
  deactivatedDate?: Maybe<Scalars['DateTime']>;
  deliveredDate?: Maybe<Scalars['DateTime']>;
  edition?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  invoiceManager?: Maybe<Scalars['String']>;
  licenseId?: Maybe<Scalars['String']>;
  licenseKey?: Maybe<Scalars['String']>;
  licenseStartDate?: Maybe<Scalars['DateTime']>;
  lockedDueToFlipFlopping?: Maybe<Scalars['Boolean']>;
  machine?: Maybe<MachineDtoOut>;
  nodeId?: Maybe<Scalars['String']>;
  paymentIntervalType?: Maybe<PaymentIntervalType>;
  serialNo?: Maybe<Scalars['String']>;
  subscriptionActive?: Maybe<Scalars['Boolean']>;
  uuid?: Maybe<Scalars['String']>;
};

export type CorrectionReasonDtoIn = {
  active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

export type CorrectionReasonDtoOut = {
  __typename?: 'CorrectionReasonDtoOut';
  active?: Maybe<Scalars['Boolean']>;
  lastEditedBy?: Maybe<Scalars['String']>;
  lastEditedDate?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  nodeId?: Maybe<Scalars['String']>;
};

export type CorrectionTransactionDtoIn = {
  comment?: InputMaybe<Scalars['String']>;
  correctionReason: Scalars['String'];
  currency: RmCurrencyCode;
  dateTime: Scalars['DateTime'];
  decimals: Scalars['Int'];
  machineNodeId: Scalars['String'];
  timeZoneUtcOffset: Scalars['String'];
  totalAmount: Scalars['Int'];
  userId: Scalars['String'];
  userName: Scalars['String'];
};

export type CorrectionTransactionDtoOut = {
  __typename?: 'CorrectionTransactionDtoOut';
  comment?: Maybe<Scalars['String']>;
  correctionReason?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  locationNodeId?: Maybe<Scalars['String']>;
  machineNodeId?: Maybe<Scalars['String']>;
  machineUserName?: Maybe<Scalars['String']>;
  nodeId?: Maybe<Scalars['String']>;
  totalAmount?: Maybe<Scalars['String']>;
};

export type CorrectionTransactionReportRowDto = RmHeaderDto & {
  __typename?: 'CorrectionTransactionReportRowDto';
  accountingDate?: Maybe<Scalars['ZonedDateTime']>;
  comment?: Maybe<Scalars['String']>;
  correctionReason?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  dateTime?: Maybe<Scalars['ZonedDateTime']>;
  formattedAccountingDate?: Maybe<Scalars['String']>;
  formattedDateTime?: Maybe<Scalars['String']>;
  formattedReceivedDate?: Maybe<Scalars['String']>;
  licenseId?: Maybe<Scalars['String']>;
  locationNodeId?: Maybe<Scalars['String']>;
  machineId?: Maybe<Scalars['String']>;
  machineName?: Maybe<Scalars['String']>;
  machineNodeId?: Maybe<Scalars['String']>;
  machineType?: Maybe<Scalars['String']>;
  machineUserId?: Maybe<Scalars['String']>;
  machineUserName?: Maybe<Scalars['String']>;
  md5?: Maybe<Scalars['String']>;
  messageSequence?: Maybe<Scalars['Long']>;
  messageType?: Maybe<Scalars['String']>;
  /** RmHeaderDto fields: */
  nodeId?: Maybe<Scalars['String']>;
  receivedDateTime?: Maybe<Scalars['ZonedDateTime']>;
  receiver?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['Long']>;
  timeZoneUtcOffset?: Maybe<Scalars['ZoneId']>;
  totalAmounts?: Maybe<Array<Maybe<RmPairDto>>>;
  transactionSeq?: Maybe<Scalars['Long']>;
  type?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type CostScaling =
  | 'PER_DEVICE_ON_CONNECT'
  | 'PER_DEVICE_ON_CONNECT_OVERAGE_020MB'
  | 'PER_HOSTED_SOLUTION'
  | 'PER_HOSTED_SOLUTION_PER_CUSTOMER'
  | 'PER_NO_USERS'
  | 'SINGLE'
  | 'SINGLE_TARGETED';

export type CountOperationFilter = AbstractFilter & {
  __typename?: 'CountOperationFilter';
  child?: Maybe<AbstractFilter>;
  countValue?: Maybe<Scalars['Int']>;
  filterType?: Maybe<FilterType>;
  operationType?: Maybe<OperationType>;
};

export type CpPageRequest = {
  page: Scalars['Int'];
  size: Scalars['Int'];
  sort?: InputMaybe<Sort>;
};

export type DefaultFilter = AbstractFilter & {
  __typename?: 'DefaultFilter';
  child?: Maybe<AbstractFilter>;
  filterType?: Maybe<FilterType>;
  operationType?: Maybe<OperationType>;
};

export type DenominationRowDto = {
  __typename?: 'DenominationRowDto';
  bankableAmount?: Maybe<Scalars['String']>;
  bankableCount?: Maybe<Scalars['Int']>;
  currency?: Maybe<Scalars['String']>;
  denomination?: Maybe<Scalars['String']>;
  dispensableAmount?: Maybe<Scalars['String']>;
  dispensableCount?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type DenominationValueDto = {
  __typename?: 'DenominationValueDto';
  count?: Maybe<Scalars['Int']>;
  currency?: Maybe<Scalars['String']>;
  denomination?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type DeploymentDtoIn = {
  machineUuids: Array<Scalars['String']>;
  scheduleInfo: Scalars['String'];
  templateNodeId: Scalars['String'];
};

export type DeploymentDtoOut = {
  __typename?: 'DeploymentDtoOut';
  createdBy?: Maybe<Scalars['String']>;
  current?: Maybe<Scalars['Boolean']>;
  machineNodeId?: Maybe<Scalars['String']>;
  nodeId?: Maybe<Scalars['String']>;
  scheduleInfo?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  statusChangedDate?: Maybe<Scalars['DateTime']>;
  template?: Maybe<TemplateDtoOut>;
};

export type Dto = {
  nodeChangeDate?: Maybe<Scalars['DateTime']>;
  nodeId?: Maybe<Scalars['String']>;
  nodeStatus?: Maybe<NodeStatus>;
};

export type DurationFilter = AbstractFilter & {
  __typename?: 'DurationFilter';
  child?: Maybe<AbstractFilter>;
  duration?: Maybe<Scalars['Duration']>;
  filterType?: Maybe<FilterType>;
  operationType?: Maybe<OperationType>;
};

export type ErrorsReportCriteriaDtoIn = {
  errorCodeFilter?: InputMaybe<Scalars['String']>;
  errorKindFilter?: InputMaybe<RmErrorKind>;
  errorSeverityFilter?: InputMaybe<RmSeverity>;
  fromDate: Scalars['DateTime'];
  limit: Scalars['Int'];
  /** TODO: not implemented yet */
  locationNodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  machineNodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  order: Order;
  orderColumn?: InputMaybe<MachineErrorsReportOrderColumn>;
  queryBy: MessageDateTime;
  reportName: ScheduledReportName;
  siteGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  skip: Scalars['Int'];
  toDate: Scalars['DateTime'];
  zoneId?: InputMaybe<Scalars['ZoneId']>;
};

export type ErrorsReportRowDto = RmHeaderDto & {
  __typename?: 'ErrorsReportRowDto';
  cleared?: Maybe<Scalars['Boolean']>;
  dateTime?: Maybe<Scalars['ZonedDateTime']>;
  deviceId?: Maybe<Scalars['String']>;
  errorCode?: Maybe<Scalars['String']>;
  extendedInfo?: Maybe<Scalars['String']>;
  formattedDateTime?: Maybe<Scalars['String']>;
  formattedReceivedDate?: Maybe<Scalars['String']>;
  /** RmErrorFields */
  information?: Maybe<Scalars['String']>;
  kind?: Maybe<Scalars['String']>;
  licenseId?: Maybe<Scalars['String']>;
  locationNodeId?: Maybe<Scalars['String']>;
  machineId?: Maybe<Scalars['String']>;
  machineName?: Maybe<Scalars['String']>;
  machineNodeId?: Maybe<Scalars['String']>;
  machineType?: Maybe<Scalars['String']>;
  md5?: Maybe<Scalars['String']>;
  messageSequence?: Maybe<Scalars['Long']>;
  messageType?: Maybe<Scalars['String']>;
  /** RmHeaderDto fields: */
  nodeId?: Maybe<Scalars['String']>;
  receivedDateTime?: Maybe<Scalars['ZonedDateTime']>;
  receiver?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['Long']>;
  severity?: Maybe<Scalars['String']>;
  timeZoneUtcOffset?: Maybe<Scalars['ZoneId']>;
  uuid?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type ExtendedDeploymentDtoOut = {
  __typename?: 'ExtendedDeploymentDtoOut';
  createdBy?: Maybe<Scalars['String']>;
  current?: Maybe<Scalars['Boolean']>;
  currentVersions?: Maybe<Array<Maybe<RmPairDto>>>;
  nodeChangeDate?: Maybe<Scalars['DateTime']>;
  nodeId?: Maybe<Scalars['String']>;
  scheduleInfo?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  template?: Maybe<TemplateDtoOut>;
};

export type ExtendedSoftwareInstallationDtoOut = {
  __typename?: 'ExtendedSoftwareInstallationDtoOut';
  createdBy?: Maybe<Scalars['String']>;
  nodeId?: Maybe<Scalars['String']>;
  scheduleInfo?: Maybe<Scalars['String']>;
  softwarePackage?: Maybe<SoftwarePackageDtoOut>;
  state?: Maybe<State>;
};

export type FeatureDtoOut = {
  __typename?: 'FeatureDtoOut';
  description?: Maybe<Scalars['String']>;
  featureId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nodeId?: Maybe<Scalars['String']>;
};

export type FileType =
  | 'CSV'
  | 'Excel';

export type FilterType =
  | 'ANY_BOX_EXCEEDS'
  | 'ANY_BOX_EXCEEDS_COUNT_RATIO'
  | 'BOX_GOES_ABOVE_COUNT'
  | 'BOX_GOES_BELOW_COUNT'
  | 'CONTENT_EXCEEDS'
  | 'DEVICE_ID'
  | 'DOOR_CLOSED'
  | 'DOOR_OPEN'
  | 'ERROR_CLEARED'
  | 'ERROR_INFORMATION'
  | 'ERROR_KIND'
  | 'ERROR_LOCATION'
  | 'ERROR_SEVERITY'
  | 'ERROR_UNCLEARED'
  | 'LOCATION_FILTER'
  | 'MACHINE_CONNECTED'
  | 'MACHINE_DISCONNECTED'
  | 'MACHINE_UUID_FILTER'
  | 'MESSAGE_OLD_STATUS'
  | 'MESSAGE_STATUS'
  | 'MESSAGE_TYPE'
  | 'TIME_OF_DAY'
  | 'TRANSACTION_BOX_ID'
  | 'TRANSACTION_DEVICE_ID'
  | 'TRANSACTION_SUB_TYPE'
  | 'TRANSACTION_TYPE'
  | 'USER_BALANCE_CHANGE_ABOVE_THRESHOLD'
  | 'USER_BALANCE_CHANGE_BELOW_THRESHOLD'
  | 'WEBHOOK';

export type IdentifyRolesDtoOut = {
  __typename?: 'IdentifyRolesDtoOut';
  domainName?: Maybe<Scalars['String']>;
  totalResults?: Maybe<Scalars['Int']>;
  userRoles?: Maybe<Array<Maybe<UserIdentifyRolOrGroupDtoOut>>>;
};

export type IdentifyUserDtoOut = {
  __typename?: 'IdentifyUserDtoOut';
  accountLocked?: Maybe<Scalars['Boolean']>;
  createdDate?: Maybe<Scalars['String']>;
  domainName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastModifiedDate?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  locationGroupPermissions?: Maybe<Array<Maybe<UserIdentifyRolOrGroupDtoOut>>>;
  locationPermissions?: Maybe<Array<Maybe<UserIdentifyRolOrGroupDtoOut>>>;
  machinePermissions?: Maybe<Array<Maybe<UserIdentifyRolOrGroupDtoOut>>>;
  phoneNumber?: Maybe<Scalars['String']>;
  tenantPermissions?: Maybe<Array<Maybe<UserIdentifyRolOrGroupDtoOut>>>;
  userName?: Maybe<Scalars['String']>;
  userRoles?: Maybe<Array<Maybe<UserIdentifyRolOrGroupDtoOut>>>;
};

export type IdentifyUserListDtoOut = {
  __typename?: 'IdentifyUserListDtoOut';
  domainName?: Maybe<Scalars['String']>;
  isUserDtoOut?: Maybe<Array<Maybe<IdentifyUserDtoOut>>>;
  totalResults?: Maybe<Scalars['Int']>;
};

export type ImportedLicenseDtoIn = {
  comment?: InputMaybe<Scalars['String']>;
  created?: InputMaybe<Scalars['String']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  edition: Scalars['String'];
  licenseId: Scalars['String'];
  licenseKey?: InputMaybe<Scalars['String']>;
  machineId: Scalars['String'];
  paymentIntervalType?: InputMaybe<Scalars['String']>;
  serialNo?: InputMaybe<Scalars['String']>;
};

export type ImportedLocationDtoIn = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  customerReference?: InputMaybe<Scalars['String']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nodeId: Scalars['String'];
};

export type ImportedMachineDtoIn = {
  deleted?: InputMaybe<Scalars['Boolean']>;
  locationNodeId: Scalars['String'];
  machineType: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  uuid: Scalars['String'];
};

export type ImportedMachineTypeDtoIn = {
  deleted?: InputMaybe<Scalars['Boolean']>;
  licenseLabel?: InputMaybe<Scalars['String']>;
  licenseLevel?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type ImportedSiteGroupDtoIn = {
  cities?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  containedSites?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countries?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name: Scalars['String'];
  sites?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token: Scalars['String'];
};

export type IsUserDtoIn = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
  userName: Scalars['String'];
};

export type IsUserDtoInDto = {
  domainName: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  locationGroupNodeIdsPermission?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  locationNodeIdsPermission?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  machineNodeIdsPermission?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  password: Scalars['String'];
  phoneNumber: Scalars['String'];
  tenantIdsPermission?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userName: Scalars['String'];
  userRoleNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IsUserFilterDtoIn = {
  userName?: InputMaybe<Scalars['String']>;
  userRole?: InputMaybe<Scalars['String']>;
};

export type IsUserUpdateDtoIn = {
  domainName: Scalars['String'];
  locationGroupNodeIdsPermission?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  locationNodeIdsPermission?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  machineNodeIdsPermission?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tenantIdsPermission?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userName: Scalars['String'];
  userRoleNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LabelRetentionEnum =
  | 'ERROR'
  | 'IDENTIFY'
  | 'SYSTEM_STATUS';

export type LabelRetentionPolicyDto = {
  __typename?: 'LabelRetentionPolicyDto';
  active?: Maybe<Scalars['Boolean']>;
  batchSize?: Maybe<Scalars['Long']>;
  label?: Maybe<LabelRetentionEnum>;
  retentionDurationInMonths?: Maybe<Scalars['Long']>;
  tenantId?: Maybe<Scalars['String']>;
};

export type LabelRetentionPolicyDtoIn = {
  active?: InputMaybe<Scalars['Boolean']>;
  batchSize?: InputMaybe<Scalars['Long']>;
  label: LabelRetentionEnum;
  retentionDurationInMonths?: InputMaybe<Scalars['Long']>;
};

export type LaneAllocationDto = Dto & {
  __typename?: 'LaneAllocationDto';
  active?: Maybe<Scalars['Boolean']>;
  allocationDateTime?: Maybe<Scalars['ZonedDateTime']>;
  allocationId?: Maybe<Scalars['String']>;
  expirationDateTime?: Maybe<Scalars['ZonedDateTime']>;
  locationName?: Maybe<Scalars['String']>;
  machineName?: Maybe<Scalars['String']>;
  nodeChangeDate?: Maybe<Scalars['DateTime']>;
  nodeId?: Maybe<Scalars['String']>;
  nodeStatus?: Maybe<NodeStatus>;
  userName?: Maybe<Scalars['String']>;
  workUnitName?: Maybe<Scalars['String']>;
};

export type LaneAllocationFiltersDto = {
  active?: InputMaybe<Scalars['Boolean']>;
  allocationDateTime?: InputMaybe<Scalars['DateTime']>;
  allocationId?: InputMaybe<Scalars['String']>;
  expirationDateTime?: InputMaybe<Scalars['DateTime']>;
  locationNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  machineName?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
  workUnitName?: InputMaybe<Scalars['String']>;
};

/** New model */
export type LicenseContentDtoIn = {
  features?: InputMaybe<Array<InputMaybe<LicenseFeatureDtoIn>>>;
  uuid: Scalars['String'];
};

/** New model */
export type LicenseContentDtoOut = {
  __typename?: 'LicenseContentDtoOut';
  createdDateTime?: Maybe<Scalars['DateTime']>;
  deactivatedDateTime?: Maybe<Scalars['DateTime']>;
  features?: Maybe<Array<Maybe<LicenseFeatureDtoOut>>>;
  hardwareId?: Maybe<Scalars['String']>;
  lockedDueToFlipFlopping?: Maybe<Scalars['Boolean']>;
  nodeId?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

export type LicenseExpirationDtoOut = {
  __typename?: 'LicenseExpirationDtoOut';
  date?: Maybe<Scalars['Date']>;
  disableFeatureWhenExpired?: Maybe<Scalars['Boolean']>;
  nodeId?: Maybe<Scalars['String']>;
  warningBeforeExpirationDays?: Maybe<Scalars['Int']>;
};

export type LicenseFeatureDtoIn = {
  disableFeatureWhenExpired: Scalars['Boolean'];
  key: Scalars['String'];
  warningBeforeExpirationDays: Scalars['Int'];
};

export type LicenseFeatureDtoOut = {
  __typename?: 'LicenseFeatureDtoOut';
  expiration?: Maybe<LicenseExpirationDtoOut>;
  key?: Maybe<Scalars['String']>;
  nodeId?: Maybe<Scalars['String']>;
};

export type LicenseMultiSubscriptionDtoIn = {
  comment?: InputMaybe<Scalars['String']>;
  machineUuids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  paymentIntervalType?: InputMaybe<PaymentIntervalType>;
  serialNo?: InputMaybe<Scalars['String']>;
};

/** New model */
export type LicenseSubscriptionDtoIn = {
  comment?: InputMaybe<Scalars['String']>;
  machineUuid: Scalars['String'];
  paymentIntervalType?: InputMaybe<PaymentIntervalType>;
  serialNo?: InputMaybe<Scalars['String']>;
};

export type LocationDtoIn = {
  city: Scalars['String'];
  country: Scalars['String'];
  customerReference?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  nodeChangeDate?: InputMaybe<Scalars['DateTime']>;
  nodeStatus?: InputMaybe<NodeStatus>;
};

export type LocationDtoOut = Dto & {
  __typename?: 'LocationDtoOut';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  customerReference?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['String']>;
  machineNodeIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  name?: Maybe<Scalars['String']>;
  nodeChangeDate?: Maybe<Scalars['DateTime']>;
  nodeId?: Maybe<Scalars['String']>;
  nodeStatus?: Maybe<NodeStatus>;
};

export type LocationFiltersDto = {
  cities?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countryCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  locationGroupNodeId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  statuses?: InputMaybe<Array<InputMaybe<NodeStatus>>>;
};

export type LocationGroupFiltersDto = {
  authorizedUsers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cities?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countries?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  locationNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LogInfoDto = {
  __typename?: 'LogInfoDto';
  fromDate?: Maybe<Scalars['DateTime']>;
  nodeId?: Maybe<Scalars['String']>;
  numberOfLogfiles?: Maybe<Scalars['Int']>;
  originUri?: Maybe<Scalars['String']>;
  retrievalDate?: Maybe<Scalars['DateTime']>;
  retrievedBy?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  toDate?: Maybe<Scalars['DateTime']>;
  zipFileName?: Maybe<Scalars['String']>;
};

export type LogSearchDtoIn = {
  fromDate?: InputMaybe<Scalars['DateTime']>;
  logTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  machineName?: InputMaybe<Scalars['String']>;
  machineNodeId: Scalars['String'];
  systemDump?: InputMaybe<Scalars['Boolean']>;
  toDate?: InputMaybe<Scalars['DateTime']>;
};

export type MumEnabledMachines = {
  __typename?: 'MUMEnabledMachines';
  nodeId?: Maybe<Scalars['String']>;
  uuids?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type MumEnabledMachinesIn = {
  uuids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MachineContentDto = {
  __typename?: 'MachineContentDto';
  containerBankableMap?: Maybe<Array<Maybe<ChartBarDto>>>;
  containerDispensableMap?: Maybe<Array<Maybe<ChartBarDto>>>;
  currency?: Maybe<Scalars['String']>;
  denominationBankableMap?: Maybe<Array<Maybe<ChartBarDto>>>;
  denominationDispensableMap?: Maybe<Array<Maybe<ChartBarDto>>>;
  dispenseAvailabilityRatio?: Maybe<Scalars['Int']>;
  refillStatus?: Maybe<RefillStatus>;
  totals?: Maybe<Array<Maybe<RmPairDto>>>;
};

export type MachineCurrencyContentDto = {
  __typename?: 'MachineCurrencyContentDto';
  bankableAmount?: Maybe<Scalars['String']>;
  bankableCount?: Maybe<Scalars['Int']>;
  currency?: Maybe<Scalars['String']>;
  denominationRows?: Maybe<Array<Maybe<DenominationRowDto>>>;
  dispensableAmount?: Maybe<Scalars['String']>;
  dispensableCount?: Maybe<Scalars['Int']>;
  locationName?: Maybe<Scalars['String']>;
  machineName?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['String']>;
};

export type MachineDataDto = {
  __typename?: 'MachineDataDto';
  latitude?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['String']>;
  machineUuid?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
};

export type MachineDetailsDto = {
  __typename?: 'MachineDetailsDto';
  capabilities?: Maybe<Array<Maybe<Scalars['String']>>>;
  dateTime?: Maybe<Scalars['ZonedDateTime']>;
  devices?: Maybe<Array<Maybe<RmDeviceDto>>>;
  nodeId?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type MachineDetailsReportCriteriaDto = {
  limit: Scalars['Int'];
  /** TODO: not implemented yet */
  locationNodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  machineNodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  reportName: ScheduledReportName;
  siteGroupNodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  skip: Scalars['Int'];
};

export type MachineDetailsReportDto = {
  __typename?: 'MachineDetailsReportDto';
  fullSize?: Maybe<Scalars['Int']>;
  rows?: Maybe<Array<Maybe<MachineDetailsReportRowDto>>>;
};

export type MachineDetailsReportRowDto = {
  __typename?: 'MachineDetailsReportRowDto';
  accountingDate?: Maybe<Scalars['ZonedDateTime']>;
  codVersion?: Maybe<Scalars['String']>;
  lastError?: Maybe<Scalars['String']>;
  lastErrorDate?: Maybe<Scalars['ZonedDateTime']>;
  location?: Maybe<Scalars['String']>;
  machineAlias?: Maybe<Scalars['String']>;
  machineDate?: Maybe<Scalars['ZonedDateTime']>;
  machineNodeId?: Maybe<Scalars['String']>;
  machineType?: Maybe<Scalars['String']>;
  machineUuid?: Maybe<Scalars['String']>;
  nodeId?: Maybe<Scalars['String']>;
};

export type MachineDtoIn = {
  comment?: InputMaybe<Scalars['String']>;
  locationNodeId: Scalars['String'];
  machineId?: InputMaybe<Scalars['String']>;
  machineTypeNodeId: Scalars['String'];
  machineUserGroupNodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name: Scalars['String'];
  uuid: Scalars['ID'];
};

export type MachineDtoOut = Dto & {
  __typename?: 'MachineDtoOut';
  comment?: Maybe<Scalars['String']>;
  details?: Maybe<MachineDetailsDto>;
  licenseId?: Maybe<Scalars['String']>;
  location?: Maybe<LocationDtoOut>;
  locationNodeId?: Maybe<Scalars['String']>;
  machineId?: Maybe<Scalars['String']>;
  machineType?: Maybe<MachineTypeDto>;
  machineUserGroupNodeIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  name?: Maybe<Scalars['String']>;
  nodeChangeDate?: Maybe<Scalars['DateTime']>;
  nodeId?: Maybe<Scalars['String']>;
  nodeStatus?: Maybe<NodeStatus>;
  uuid?: Maybe<Scalars['ID']>;
};

export type MachineErrorsReportOrderColumn =
  | 'CLEARED'
  | 'DATE'
  | 'DEVICE_ID'
  | 'ERROR_CODE'
  | 'EXTENDED_INFORMATION'
  | 'INFORMATION'
  | 'KIND'
  | 'LOCATION'
  | 'MACHINE'
  | 'SEVERITY';

export type MachineFiltersDto = {
  codVersion?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  locationGroupNodeId?: InputMaybe<Scalars['String']>;
  locationNodeId?: InputMaybe<Scalars['String']>;
  machineTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  statuses?: InputMaybe<Array<InputMaybe<NodeStatus>>>;
  uuid?: InputMaybe<Scalars['String']>;
};

export type MachineGroupDtoIn = {
  machineNodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  machineUuids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name: Scalars['String'];
  nodeStatus?: InputMaybe<NodeStatus>;
};

export type MachineGroupDtoOut = Dto & {
  __typename?: 'MachineGroupDtoOut';
  machines?: Maybe<Array<Maybe<MachineDtoOut>>>;
  name?: Maybe<Scalars['String']>;
  nodeChangeDate?: Maybe<Scalars['DateTime']>;
  nodeId?: Maybe<Scalars['String']>;
  nodeStatus?: Maybe<NodeStatus>;
};

export type MachineGroupFiltersDto = {
  machineNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  statuses?: InputMaybe<Array<InputMaybe<NodeStatus>>>;
};

export type MachineHistoryStatusDto = Dto & {
  __typename?: 'MachineHistoryStatusDto';
  eventDate?: Maybe<Scalars['ZonedDateTime']>;
  formattedEventDate?: Maybe<Scalars['String']>;
  formattedReceivedDate?: Maybe<Scalars['String']>;
  formattedStatusChangeDate?: Maybe<Scalars['String']>;
  licenseId?: Maybe<Scalars['String']>;
  machineStatus?: Maybe<MachineStatus>;
  machineUuid?: Maybe<Scalars['String']>;
  nodeChangeDate?: Maybe<Scalars['DateTime']>;
  nodeId?: Maybe<Scalars['String']>;
  nodeStatus?: Maybe<NodeStatus>;
  onlineStatus?: Maybe<OnlineStatus>;
  receivedDate?: Maybe<Scalars['ZonedDateTime']>;
  statusChangeDate?: Maybe<Scalars['ZonedDateTime']>;
};

export type MachineOnlineStatusDto = Dto & {
  __typename?: 'MachineOnlineStatusDto';
  eventDate?: Maybe<Scalars['ZonedDateTime']>;
  formattedEventDate?: Maybe<Scalars['String']>;
  formattedReceivedDate?: Maybe<Scalars['String']>;
  formattedStatusChangeDate?: Maybe<Scalars['String']>;
  licenseId?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['String']>;
  locationName?: Maybe<Scalars['String']>;
  machineName?: Maybe<Scalars['String']>;
  machineStatus?: Maybe<MachineStatus>;
  machineUuid?: Maybe<Scalars['String']>;
  nodeChangeDate?: Maybe<Scalars['DateTime']>;
  nodeId?: Maybe<Scalars['String']>;
  nodeStatus?: Maybe<NodeStatus>;
  onlineStatus?: Maybe<OnlineStatus>;
  receivedDate?: Maybe<Scalars['ZonedDateTime']>;
  statusChangeDate?: Maybe<Scalars['ZonedDateTime']>;
  tenantId?: Maybe<Scalars['String']>;
};

export type MachineOnlineStatusHistoryRequest = {
  fromDateTime: Scalars['DateTime'];
  includeHistoryStatuses?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['String']>;
  machineUuid?: InputMaybe<Scalars['String']>;
  onlineStatus?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  tenantId: Scalars['String'];
  toDateTime: Scalars['DateTime'];
  zoneId?: InputMaybe<Scalars['String']>;
};

export type MachineOnlineStatusInfoDto = {
  __typename?: 'MachineOnlineStatusInfoDto';
  eventDate?: Maybe<Scalars['ZonedDateTime']>;
  licenseId?: Maybe<Scalars['String']>;
  machineStatus?: Maybe<MachineStatus>;
  onlineStatus?: Maybe<OnlineStatus>;
  receivedDate?: Maybe<Scalars['ZonedDateTime']>;
  uuid?: Maybe<Scalars['String']>;
};

export type MachineOnlineStatusRequest = {
  dateTime?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['String']>;
  machineUuid?: InputMaybe<Scalars['String']>;
  onlineStatus?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  tenantId: Scalars['String'];
  zoneId?: InputMaybe<Scalars['String']>;
};

export type MachineOnlineWithHistoryStatusDto = Dto & {
  __typename?: 'MachineOnlineWithHistoryStatusDto';
  eventDate?: Maybe<Scalars['ZonedDateTime']>;
  formattedEventDate?: Maybe<Scalars['String']>;
  formattedReceivedDate?: Maybe<Scalars['String']>;
  formattedStatusChangeDate?: Maybe<Scalars['String']>;
  historyStatuses?: Maybe<Array<Maybe<MachineHistoryStatusDto>>>;
  licenseId?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['String']>;
  locationName?: Maybe<Scalars['String']>;
  machineName?: Maybe<Scalars['String']>;
  machineStatus?: Maybe<MachineStatus>;
  machineUuid?: Maybe<Scalars['String']>;
  nodeChangeDate?: Maybe<Scalars['DateTime']>;
  nodeId?: Maybe<Scalars['String']>;
  nodeStatus?: Maybe<NodeStatus>;
  onlineStatus?: Maybe<OnlineStatus>;
  receivedDate?: Maybe<Scalars['ZonedDateTime']>;
  statusChangeDate?: Maybe<Scalars['ZonedDateTime']>;
  tenantId?: Maybe<Scalars['String']>;
};

export type MachineStatus =
  | 'Disconnected'
  | 'Unknown';

export type MachineThinDtoOut = {
  __typename?: 'MachineThinDtoOut';
  machineImageUrl?: Maybe<Scalars['String']>;
  machineType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nodeChangeDate?: Maybe<Scalars['DateTime']>;
  nodeId?: Maybe<Scalars['String']>;
  nodeStatus?: Maybe<NodeStatus>;
  uuid?: Maybe<Scalars['String']>;
};

export type MachineTypeDto = {
  __typename?: 'MachineTypeDto';
  imageUrl?: Maybe<Scalars['String']>;
  licenseLabel?: Maybe<Scalars['String']>;
  licenseLevel?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  nodeId?: Maybe<Scalars['String']>;
  table: Scalars['String'];
};

export type MachineTypePatternDtoIn = {
  imageUrl?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  table?: InputMaybe<Scalars['String']>;
};

export type MachineUserDtoIn = {
  alias?: InputMaybe<Scalars['String']>;
  cardIdentifier?: InputMaybe<Scalars['String']>;
  changePinOnLogin?: InputMaybe<Scalars['Boolean']>;
  deactivated?: InputMaybe<Scalars['Boolean']>;
  doors?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  encodePin?: InputMaybe<Scalars['Boolean']>;
  fingerprints?: InputMaybe<Scalars['String']>;
  list?: InputMaybe<Scalars['Boolean']>;
  /** dto only */
  machineUserGroupNodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nbrOfBadPin?: InputMaybe<Scalars['Int']>;
  nbrOfLogins?: InputMaybe<Scalars['Int']>;
  noPin?: InputMaybe<Scalars['Boolean']>;
  noPinBio?: InputMaybe<Scalars['Boolean']>;
  noPinCard?: InputMaybe<Scalars['Boolean']>;
  noPinDoor?: InputMaybe<Scalars['Boolean']>;
  noPinLogin?: InputMaybe<Scalars['Boolean']>;
  pin?: InputMaybe<Scalars['String']>;
  roleName?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  validFrom?: InputMaybe<Scalars['DateTime']>;
  validUntil?: InputMaybe<Scalars['DateTime']>;
};

export type MachineUserDtoOut = Dto & {
  __typename?: 'MachineUserDtoOut';
  alias?: Maybe<Scalars['String']>;
  cardIdentifier?: Maybe<Scalars['String']>;
  changePinOnLogin?: Maybe<Scalars['Boolean']>;
  deactivated?: Maybe<Scalars['Boolean']>;
  doors?: Maybe<Array<Maybe<Scalars['String']>>>;
  fingerprints?: Maybe<Scalars['String']>;
  list?: Maybe<Scalars['Boolean']>;
  /** dto only */
  machineUserGroupNodeIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  name?: Maybe<Scalars['String']>;
  nbrOfBadPin?: Maybe<Scalars['Int']>;
  nbrOfLogins?: Maybe<Scalars['Int']>;
  noPin?: Maybe<Scalars['Boolean']>;
  noPinBio?: Maybe<Scalars['Boolean']>;
  noPinCard?: Maybe<Scalars['Boolean']>;
  noPinDoor?: Maybe<Scalars['Boolean']>;
  noPinLogin?: Maybe<Scalars['Boolean']>;
  nodeChangeDate?: Maybe<Scalars['DateTime']>;
  nodeId?: Maybe<Scalars['String']>;
  nodeStatus?: Maybe<NodeStatus>;
  pin?: Maybe<Scalars['String']>;
  roleName?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  validFrom?: Maybe<Scalars['String']>;
  validUntil?: Maybe<Scalars['String']>;
};

export type MachineUserFiltersDto = {
  cardIdentifier?: InputMaybe<Scalars['String']>;
  deactivated?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  nodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  roleNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  validFrom?: InputMaybe<Scalars['DateTime']>;
  /** UTC */
  validUntil?: InputMaybe<Scalars['DateTime']>;
};

export type MachineUserGroupDtoIn = {
  machineNodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  machineUserNodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name: Scalars['String'];
};

export type MachineUserGroupDtoOut = Dto & {
  __typename?: 'MachineUserGroupDtoOut';
  machineUsers?: Maybe<Array<Maybe<MachineUserDtoOut>>>;
  machineUsersCount?: Maybe<Scalars['Int']>;
  machines?: Maybe<Array<Maybe<MachineDtoOut>>>;
  machinesCount?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  nodeChangeDate?: Maybe<Scalars['DateTime']>;
  nodeId?: Maybe<Scalars['String']>;
  nodeStatus?: Maybe<NodeStatus>;
};

export type MachineUserGroupFiltersDto = {
  machineNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  machineUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  showMachineExclusive?: InputMaybe<Scalars['Boolean']>;
};

export type MachineUserGroupUpdateDtoIn = {
  name: Scalars['String'];
};

export type MachineUserGroupViewDtoOut = {
  __typename?: 'MachineUserGroupViewDtoOut';
  name: Scalars['String'];
  nodeId: Scalars['String'];
};

export type MachineUserTransactionsReportCriteriaDto = {
  fromDate: Scalars['DateTime'];
  locationNodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  machineNodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  machineUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  machineUserNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  queryTransactionBy: TransactionDateTime;
  reportName: ScheduledReportName;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  toDate: Scalars['DateTime'];
  zoneId?: InputMaybe<Scalars['ZoneId']>;
};

export type MachineUserTransactionsReportDto = {
  __typename?: 'MachineUserTransactionsReportDto';
  columns?: Maybe<Array<Maybe<ReportPairDtoOut>>>;
  machines?: Maybe<Array<Maybe<MachineDtoOut>>>;
  rows?: Maybe<Array<Maybe<MachineUserTransactionsReportRowDto>>>;
  totalDiff?: Maybe<Array<Maybe<RmPairDto>>>;
  totalIn?: Maybe<Array<Maybe<RmPairDto>>>;
  totalOut?: Maybe<Array<Maybe<RmPairDto>>>;
};

export type MachineUserTransactionsReportRowDto = {
  __typename?: 'MachineUserTransactionsReportRowDto';
  rows?: Maybe<Array<Maybe<TransactionsReportRowDto>>>;
  totalDiff?: Maybe<Array<Maybe<RmPairDto>>>;
  totalIn?: Maybe<Array<Maybe<RmPairDto>>>;
  totalOut?: Maybe<Array<Maybe<RmPairDto>>>;
  userId?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type MachineUserXmlImport = {
  machineUserGroupNodeId: Scalars['String'];
  replace: Scalars['Boolean'];
  usersXml: Scalars['String'];
};

export type MachineViewDtoIn = {
  limit: Scalars['Int'];
  machineViewFilteringField?: InputMaybe<Array<InputMaybe<MachineViewFilteringField>>>;
  machineViewTabType: MachineViewTabType;
  order: Order;
  orderColumn?: InputMaybe<MachineViewOrderColumn>;
  skip: Scalars['Int'];
};

export type MachineViewDtoOut = {
  __typename?: 'MachineViewDtoOut';
  fullSize?: Maybe<Scalars['Int']>;
  rows?: Maybe<Array<Maybe<MachineViewRowDtoOut>>>;
};

export type MachineViewFilteringField = {
  filteringField: MachineViewOrderColumn;
  value: Scalars['String'];
};

export type MachineViewOrderColumn =
  | 'INSTALLED_SOFTWARE_CREATED_DATE'
  | 'INSTALLED_SOFTWARE_NAME'
  | 'INSTALLED_SOFTWARE_PRODUCT_NAME'
  | 'INSTALLED_SOFTWARE_VERSION'
  | 'LICENSE_CREATED_DATE'
  | 'LICENSE_EDITION'
  | 'LICENSE_EXPIRATION_DATE'
  | 'LICENSE_KEY'
  | 'LICENSE_LABEL'
  | 'LICENSE_LICENSE_START_DATE'
  | 'LOCATION_NAME'
  | 'MACHINE_CREATED_DATE'
  | 'MACHINE_GROUP_NAMES'
  | 'MACHINE_NAME'
  | 'MACHINE_NODE_ID'
  | 'MACHINE_STATUS'
  | 'MACHINE_TYPE'
  | 'MACHINE_UUID'
  | 'ONGOING_DEPLOYMENT_CONFIGURATION_NAME'
  | 'ONGOING_DEPLOYMENT_CONFIGURATION_STATUS'
  | 'ONGOING_DEPLOYMENT_CREATED_BY'
  | 'SOFTWARE_UPDATE_CREATED_DATE'
  | 'SOFTWARE_UPDATE_NAME'
  | 'SOFTWARE_UPDATE_PRODUCT_NAME'
  | 'SOFTWARE_UPDATE_STATUS'
  | 'SOFTWARE_UPDATE_VERSION'
  | 'TEMPLATE_DEPLOYMENT_CONFIGURATION_NAME'
  | 'TEMPLATE_DEPLOYMENT_CONFIGURATION_STATUS'
  | 'TEMPLATE_DEPLOYMENT_CREATED_BY';

export type MachineViewRowDtoOut = {
  __typename?: 'MachineViewRowDtoOut';
  license?: Maybe<CoDLicenseDtoOut>;
  location?: Maybe<LocationDtoOut>;
  machine?: Maybe<MachineThinDtoOut>;
  machineUserGroup?: Maybe<Array<Maybe<MachineUserGroupViewDtoOut>>>;
  ongoingDeployment?: Maybe<ExtendedDeploymentDtoOut>;
  ongoingSoftwareInstallation?: Maybe<ExtendedSoftwareInstallationDtoOut>;
  softwareInstalled?: Maybe<ExtendedSoftwareInstallationDtoOut>;
  template?: Maybe<TemplateDtoOut>;
  templateDeployment?: Maybe<ExtendedDeploymentDtoOut>;
};

export type MachineViewTabType =
  | 'ALL'
  | 'AUTHORIZED_GROUP'
  | 'DEPLOYMENT_AND_SOFTWARE'
  | 'LICENSE';

export type MachinesOnlineStatusForDateTimeResponse = {
  __typename?: 'MachinesOnlineStatusForDateTimeResponse';
  fullSize?: Maybe<Scalars['Long']>;
  rows?: Maybe<Array<Maybe<MachineOnlineStatusDto>>>;
};

export type MachinesOnlineStatusHistoryResponse = {
  __typename?: 'MachinesOnlineStatusHistoryResponse';
  fullSize?: Maybe<Scalars['Long']>;
  rows?: Maybe<Array<Maybe<MachineOnlineWithHistoryStatusDto>>>;
};

export type ManualDepositGroupFactor =
  | 'CASHIER'
  | 'SITE'
  | 'TYPE'
  | 'WORK_UNIT';

export type ManualDepositsGroupDto = {
  __typename?: 'ManualDepositsGroupDto';
  grandTotals?: Maybe<Array<Maybe<RmPairDto>>>;
  groupValue?: Maybe<Scalars['String']>;
  subRows?: Maybe<Array<Maybe<TransactionsReportRowDto>>>;
};

export type ManualDepositsReportCriteriaDto = {
  fromDate: Scalars['DateTime'];
  groupFactor: ManualDepositGroupFactor;
  locationNodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  machineNodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  queryTransactionBy: TransactionDateTime;
  reportName: ScheduledReportName;
  toDate: Scalars['DateTime'];
  zoneId?: InputMaybe<Scalars['ZoneId']>;
};

export type ManualDepositsReportDto = {
  __typename?: 'ManualDepositsReportDto';
  grandTotals?: Maybe<Array<Maybe<RmPairDto>>>;
  rows?: Maybe<Array<Maybe<ManualDepositsGroupDto>>>;
};

export type MapDto = {
  __typename?: 'MapDto';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type MapDtoIn = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type MessageCriteriaDtoIn = {
  fromDate: Scalars['DateTime'];
  fromMessageSequence?: InputMaybe<Scalars['Int']>;
  limit: Scalars['Int'];
  machineUuids: Array<InputMaybe<Scalars['String']>>;
  md5?: InputMaybe<Scalars['String']>;
  messageTypes: Array<InputMaybe<Scalars['String']>>;
  order: Order;
  skip: Scalars['Int'];
  toDate: Scalars['DateTime'];
  toMessageSequence?: InputMaybe<Scalars['Int']>;
  zoneId?: InputMaybe<Scalars['ZoneId']>;
};

export type MessageDateTime =
  | 'DATE_TIME'
  | 'RECEIVED_DATE_TIME';

export type MessageFieldFiltering = AbstractFilter & {
  __typename?: 'MessageFieldFiltering';
  canFilterCustomValueInFilter?: Maybe<Scalars['Boolean']>;
  child?: Maybe<AbstractFilter>;
  filter?: Maybe<Array<Maybe<Scalars['String']>>>;
  filterType?: Maybe<FilterType>;
  operationType?: Maybe<OperationType>;
};

export type MessageType =
  | 'ERROR'
  | 'MACHINE_CONTENT_CHANGE'
  | 'MACHINE_ONLINE_STATUS_CHANGE'
  | 'SYSTEM_STATUS'
  | 'TRANSACTION'
  | 'TRANSACTION_WITH_BOX_CONTENT';

export type MessageTypeFilter = AbstractFilter & {
  __typename?: 'MessageTypeFilter';
  child?: Maybe<AbstractFilter>;
  filterType?: Maybe<FilterType>;
  messageType?: Maybe<MessageType>;
  operationType?: Maybe<OperationType>;
};

export type MetadataDtoIn = {
  executeFrom: Scalars['Date'];
  executeUntil: Scalars['Date'];
  executionTime: Scalars['Time'];
  nodeId?: InputMaybe<Scalars['String']>;
  repeat: Repeat;
  repeatOnDay?: InputMaybe<Scalars['Int']>;
  zoneName: Scalars['String'];
};

export type MetadataDtoOut = Dto & {
  __typename?: 'MetadataDtoOut';
  executeFrom?: Maybe<Scalars['Date']>;
  executeUntil?: Maybe<Scalars['Date']>;
  executionTime: Scalars['Time'];
  nodeChangeDate?: Maybe<Scalars['DateTime']>;
  nodeId?: Maybe<Scalars['String']>;
  nodeStatus?: Maybe<NodeStatus>;
  repeat: Repeat;
  repeatOnDay?: Maybe<Scalars['Int']>;
  zoneName: Scalars['String'];
};

export type ModuleActivationDto = {
  selectedModules: Array<InputMaybe<ActivationInfo>>;
  tenantId: Scalars['String'];
};

export type ModuleDto = {
  __typename?: 'ModuleDto';
  cost?: Maybe<Scalars['Int']>;
  currency?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  features?: Maybe<Array<Maybe<FeatureDtoOut>>>;
  moduleId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nodeId?: Maybe<Scalars['String']>;
  optional?: Maybe<Scalars['Boolean']>;
  scaling?: Maybe<CostScaling>;
  series?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  activateLicenseByNodeId?: Maybe<CoDLicenseDtoOut>;
  activateLocation?: Maybe<LocationDtoOut>;
  activateMachine?: Maybe<MachineDtoOut>;
  activateMachineGroup?: Maybe<MachineGroupDtoOut>;
  activateReportRequest?: Maybe<Scalars['Boolean']>;
  activateSubscriptions?: Maybe<Array<Maybe<SubscriptionDto>>>;
  activateTenant?: Maybe<TenantDtoOut>;
  activeDeactivateUser?: Maybe<Scalars['Boolean']>;
  addMachineUsersToMachineUserGroup?: Maybe<MachineUserGroupDtoOut>;
  addMachinesToMachineUserGroup?: Maybe<MachineUserGroupDtoOut>;
  cancelDeployment?: Maybe<Scalars['Boolean']>;
  clearAllMachineLicenseContents?: Maybe<Scalars['Int']>;
  clearAllMachineLicenses?: Maybe<Scalars['Int']>;
  configureTenant?: Maybe<TenantDtoOut>;
  createCorrectionReason?: Maybe<CorrectionReasonDtoOut>;
  createCorrectionTransaction?: Maybe<CorrectionTransactionDtoOut>;
  createDeployments?: Maybe<Array<Maybe<DeploymentDtoOut>>>;
  createLocation?: Maybe<LocationDtoOut>;
  createMachine?: Maybe<MachineDtoOut>;
  createMachineGroup?: Maybe<MachineGroupDtoOut>;
  createMachineLicenseContent?: Maybe<LicenseContentDtoOut>;
  createMachineUser?: Maybe<MachineUserDtoOut>;
  createMachineUserGroup?: Maybe<MachineUserGroupDtoOut>;
  createOtaAuthorization?: Maybe<OtaAuthorizationDto>;
  createOtaKeyPair?: Maybe<Scalars['String']>;
  createRules?: Maybe<Scalars['String']>;
  createScheduledReport?: Maybe<ScheduledReportDtoOut>;
  createShift?: Maybe<ShiftDtoOut>;
  createSoftwareInstallations?: Maybe<Array<Maybe<SoftwareInstallationDtoOut>>>;
  createSoftwarePackage?: Maybe<SoftwarePackageDtoOut>;
  createTemplate?: Maybe<TemplateDtoOut>;
  createTenantWithExistingUser?: Maybe<TenantDtoOut>;
  createTenantWithNewUser?: Maybe<TenantDtoOut>;
  createUser?: Maybe<Scalars['Boolean']>;
  deactivateLaneAllocation?: Maybe<Scalars['Boolean']>;
  deactivateLicenseByNodeId?: Maybe<CoDLicenseDtoOut>;
  deactivateMachine?: Maybe<MachineDtoOut>;
  deactivateOtaAuthorization?: Maybe<Scalars['Boolean']>;
  deactivateOtaKeyPair?: Maybe<Scalars['Boolean']>;
  deactivateReportRequest?: Maybe<Scalars['Boolean']>;
  deactivateTenant?: Maybe<TenantDtoOut>;
  deleteCorrectionReason?: Maybe<Scalars['Boolean']>;
  deleteImportedLicenses?: Maybe<Scalars['Boolean']>;
  deleteImportedLocations?: Maybe<Scalars['Boolean']>;
  deleteImportedMachineTypes?: Maybe<Scalars['Boolean']>;
  deleteImportedMachines?: Maybe<Scalars['Boolean']>;
  deleteImportedSiteGroups?: Maybe<Scalars['Boolean']>;
  deleteLocation?: Maybe<LocationDtoOut>;
  deleteLog?: Maybe<Scalars['Boolean']>;
  deleteMachine?: Maybe<MachineDtoOut>;
  deleteMachineGroup?: Maybe<MachineGroupDtoOut>;
  deleteMachineUser?: Maybe<MachineUserDtoOut>;
  deleteMachineUserGroupByNodeId?: Maybe<MachineUserGroupDtoOut>;
  deleteMachineUsers?: Maybe<Scalars['Int']>;
  deleteReportRequest?: Maybe<Scalars['Boolean']>;
  deleteRmCommand?: Maybe<Scalars['Boolean']>;
  deleteRules?: Maybe<Scalars['Boolean']>;
  deleteSmartLocationGroup?: Maybe<Scalars['Boolean']>;
  deleteSoftwareInstallation?: Maybe<Scalars['Boolean']>;
  deleteSoftwarePackage?: Maybe<Scalars['Boolean']>;
  deleteTemplate?: Maybe<Scalars['Boolean']>;
  deleteUser?: Maybe<Scalars['Boolean']>;
  detachLocation?: Maybe<LocationDtoOut>;
  detachMachine?: Maybe<MachineDtoOut>;
  detachMachineGroup?: Maybe<MachineGroupDtoOut>;
  detachMachines?: Maybe<Array<Maybe<MachineDtoOut>>>;
  evictAllUserManagementCacheByKey?: Maybe<Scalars['Boolean']>;
  forceSendWebhook?: Maybe<Scalars['Boolean']>;
  getOrCreate?: Maybe<OtaCodeDtoOut>;
  importLicenses?: Maybe<Scalars['Long']>;
  importLocations?: Maybe<Scalars['Long']>;
  importMachineTypes?: Maybe<Scalars['Long']>;
  importMachineUsers?: Maybe<Scalars['Boolean']>;
  importMachines?: Maybe<Scalars['Long']>;
  importSiteGroups?: Maybe<Scalars['Long']>;
  loadLicenses?: Maybe<Scalars['Long']>;
  loadLocations?: Maybe<Scalars['Long']>;
  loadMachines?: Maybe<Scalars['Long']>;
  loadSiteGroups?: Maybe<Scalars['Long']>;
  passThroughWebhook?: Maybe<Scalars['Boolean']>;
  postRebootCommand?: Maybe<RmCommandDto>;
  postRestartCommand?: Maybe<RmCommandDto>;
  postRetrieveLogs?: Maybe<RmCommandDto>;
  removeLocation?: Maybe<Scalars['Boolean']>;
  removeMachineGroup?: Maybe<Scalars['Boolean']>;
  removeMachineUsersFromMachineUserGroup?: Maybe<MachineUserGroupDtoOut>;
  removeMachinesFromMachineUserGroup?: Maybe<MachineUserGroupDtoOut>;
  resetAllMachinesUserChanges?: Maybe<Scalars['Boolean']>;
  retrySingleExecution?: Maybe<Scalars['Boolean']>;
  setTenantFeatures?: Maybe<TenantFeaturesDto>;
  synchronizeMqttCredentials?: Maybe<Scalars['Boolean']>;
  updateCorrectionReason?: Maybe<CorrectionReasonDtoOut>;
  updateLabelRetentionPolicy?: Maybe<LabelRetentionPolicyDto>;
  updateLocation?: Maybe<LocationDtoOut>;
  updateMUMEnabledMachines?: Maybe<MumEnabledMachines>;
  updateMachine?: Maybe<MachineDtoOut>;
  updateMachineGroup?: Maybe<MachineGroupDtoOut>;
  updateMachineUser?: Maybe<MachineUserDtoOut>;
  updateMachineUserGroup?: Maybe<MachineUserGroupDtoOut>;
  updatePasswordForTenant?: Maybe<Scalars['Boolean']>;
  updateRules?: Maybe<Scalars['String']>;
  updateScheduledReport?: Maybe<ScheduledReportDtoOut>;
  updateSoftwarePackage?: Maybe<SoftwarePackageDtoOut>;
  updateTemplate?: Maybe<TemplateDtoOut>;
  updateTenant?: Maybe<TenantDtoOut>;
  updateTenantRetentionPolicy?: Maybe<TenantRetentionPolicyDto>;
  updateUserPassword?: Maybe<Scalars['Boolean']>;
  updateUserPermissionOrRole?: Maybe<Scalars['Boolean']>;
  upgradeMachineLatestLicense?: Maybe<CoDLicenseDtoOut>;
  upgradeMultiMachineLatestLicense?: Maybe<Scalars['String']>;
  upsertSmartLocationGroup?: Maybe<SmartLocationGroupDtoOut>;
};


export type MutationActivateLicenseByNodeIdArgs = {
  nodeId: Scalars['String'];
};


export type MutationActivateLocationArgs = {
  nodeId?: InputMaybe<Scalars['String']>;
};


export type MutationActivateMachineArgs = {
  nodeId: Scalars['String'];
};


export type MutationActivateMachineGroupArgs = {
  nodeId: Scalars['String'];
};


export type MutationActivateReportRequestArgs = {
  nodeId: Scalars['String'];
};


export type MutationActivateSubscriptionsArgs = {
  activationDto?: InputMaybe<ModuleActivationDto>;
};


export type MutationActivateTenantArgs = {
  tenantId?: InputMaybe<Scalars['String']>;
};


export type MutationActiveDeactivateUserArgs = {
  activeOrDeactivate?: InputMaybe<Scalars['Boolean']>;
  domainName?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
};


export type MutationAddMachineUsersToMachineUserGroupArgs = {
  machineUserNodeIds: Array<InputMaybe<Scalars['String']>>;
  nodeId: Scalars['String'];
};


export type MutationAddMachinesToMachineUserGroupArgs = {
  machineNodeIds: Array<InputMaybe<Scalars['String']>>;
  nodeId: Scalars['String'];
};


export type MutationCancelDeploymentArgs = {
  nodeId: Scalars['String'];
};


export type MutationClearAllMachineLicenseContentsArgs = {
  tenantId: Scalars['String'];
  uuid: Scalars['String'];
};


export type MutationClearAllMachineLicensesArgs = {
  nodeId: Scalars['String'];
};


export type MutationConfigureTenantArgs = {
  tenant?: InputMaybe<TenantDtoIn>;
};


export type MutationCreateCorrectionReasonArgs = {
  correctionReason?: InputMaybe<CorrectionReasonDtoIn>;
};


export type MutationCreateCorrectionTransactionArgs = {
  correctionTransaction?: InputMaybe<CorrectionTransactionDtoIn>;
};


export type MutationCreateDeploymentsArgs = {
  deployment: DeploymentDtoIn;
};


export type MutationCreateLocationArgs = {
  location?: InputMaybe<LocationDtoIn>;
};


export type MutationCreateMachineArgs = {
  machine?: InputMaybe<MachineDtoIn>;
};


export type MutationCreateMachineGroupArgs = {
  machineGroup?: InputMaybe<MachineGroupDtoIn>;
};


export type MutationCreateMachineLicenseContentArgs = {
  licenseContentDtoIn?: InputMaybe<LicenseContentDtoIn>;
  tenantId: Scalars['String'];
};


export type MutationCreateMachineUserArgs = {
  machineUser?: InputMaybe<MachineUserDtoIn>;
};


export type MutationCreateMachineUserGroupArgs = {
  machineUserGroup?: InputMaybe<MachineUserGroupDtoIn>;
};


export type MutationCreateOtaAuthorizationArgs = {
  otaAuthorizationIn: OtaAuthorizationIn;
};


export type MutationCreateOtaKeyPairArgs = {
  machineUuid: Scalars['String'];
  requestKey: Scalars['String'];
};


export type MutationCreateRulesArgs = {
  input: RulesDto;
};


export type MutationCreateScheduledReportArgs = {
  params: ScheduledReportDtoIn;
};


export type MutationCreateShiftArgs = {
  shift?: InputMaybe<ShiftDtoIn>;
};


export type MutationCreateSoftwareInstallationsArgs = {
  softwareInstallation: SoftwareInstallationDtoIn;
};


export type MutationCreateSoftwarePackageArgs = {
  softwarePackage: SoftwarePackageDtoIn;
};


export type MutationCreateTemplateArgs = {
  template: TemplateDtoIn;
};


export type MutationCreateTenantWithExistingUserArgs = {
  tenant?: InputMaybe<TenantWithExistingUserDtoIn>;
};


export type MutationCreateTenantWithNewUserArgs = {
  tenant?: InputMaybe<TenantWithNewUserDtoIn>;
};


export type MutationCreateUserArgs = {
  isUserDtoInDto?: InputMaybe<IsUserDtoInDto>;
};


export type MutationDeactivateLaneAllocationArgs = {
  allocationNodeId: Scalars['String'];
};


export type MutationDeactivateLicenseByNodeIdArgs = {
  nodeId: Scalars['String'];
};


export type MutationDeactivateMachineArgs = {
  nodeId: Scalars['String'];
};


export type MutationDeactivateOtaAuthorizationArgs = {
  nodeId: Scalars['String'];
};


export type MutationDeactivateOtaKeyPairArgs = {
  machineUuid: Scalars['String'];
};


export type MutationDeactivateReportRequestArgs = {
  nodeId: Scalars['String'];
};


export type MutationDeactivateTenantArgs = {
  tenantId?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteCorrectionReasonArgs = {
  nodeId: Scalars['String'];
};


export type MutationDeleteLocationArgs = {
  nodeId?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteLogArgs = {
  nodeId: Scalars['String'];
};


export type MutationDeleteMachineArgs = {
  nodeId: Scalars['String'];
};


export type MutationDeleteMachineGroupArgs = {
  nodeId: Scalars['String'];
};


export type MutationDeleteMachineUserArgs = {
  nodeId: Scalars['String'];
};


export type MutationDeleteMachineUserGroupByNodeIdArgs = {
  nodeId: Scalars['String'];
};


export type MutationDeleteMachineUsersArgs = {
  nodeId: Array<InputMaybe<Scalars['String']>>;
};


export type MutationDeleteReportRequestArgs = {
  nodeId: Scalars['String'];
};


export type MutationDeleteRmCommandArgs = {
  commandNodeId: Scalars['String'];
};


export type MutationDeleteRulesArgs = {
  input?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteSmartLocationGroupArgs = {
  nodeId?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteSoftwareInstallationArgs = {
  nodeId: Scalars['String'];
};


export type MutationDeleteSoftwarePackageArgs = {
  nodeId: Scalars['String'];
};


export type MutationDeleteTemplateArgs = {
  nodeId?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteUserArgs = {
  domainName?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
};


export type MutationDetachLocationArgs = {
  nodeId?: InputMaybe<Scalars['String']>;
};


export type MutationDetachMachineArgs = {
  nodeId: Scalars['String'];
};


export type MutationDetachMachineGroupArgs = {
  nodeId: Scalars['String'];
};


export type MutationDetachMachinesArgs = {
  nodeIds: Array<InputMaybe<Scalars['String']>>;
};


export type MutationEvictAllUserManagementCacheByKeyArgs = {
  cacheKey?: InputMaybe<CacheKey>;
};


export type MutationForceSendWebhookArgs = {
  input: WebhookQuery;
};


export type MutationGetOrCreateArgs = {
  otaCodeDtoIn: OtaCodeInputDto;
};


export type MutationImportLicensesArgs = {
  importedLicensesDtos?: InputMaybe<Array<InputMaybe<ImportedLicenseDtoIn>>>;
};


export type MutationImportLocationsArgs = {
  importedLocationsDtos?: InputMaybe<Array<InputMaybe<ImportedLocationDtoIn>>>;
};


export type MutationImportMachineTypesArgs = {
  importedMachineTypesDtos?: InputMaybe<Array<InputMaybe<ImportedMachineTypeDtoIn>>>;
};


export type MutationImportMachineUsersArgs = {
  machineUserImport: MachineUserXmlImport;
};


export type MutationImportMachinesArgs = {
  importedMachinesDtos?: InputMaybe<Array<InputMaybe<ImportedMachineDtoIn>>>;
};


export type MutationImportSiteGroupsArgs = {
  importedSiteGroupsDtos?: InputMaybe<Array<InputMaybe<ImportedSiteGroupDtoIn>>>;
};


export type MutationPassThroughWebhookArgs = {
  input: PassThroughQuery;
};


export type MutationPostRebootCommandArgs = {
  machineNodeId: Scalars['String'];
};


export type MutationPostRestartCommandArgs = {
  machineNodeId: Scalars['String'];
};


export type MutationPostRetrieveLogsArgs = {
  logSearch?: InputMaybe<LogSearchDtoIn>;
};


export type MutationRemoveLocationArgs = {
  nodeId?: InputMaybe<Scalars['String']>;
};


export type MutationRemoveMachineGroupArgs = {
  nodeId: Scalars['String'];
};


export type MutationRemoveMachineUsersFromMachineUserGroupArgs = {
  machineUserNodeIds: Array<InputMaybe<Scalars['String']>>;
  nodeId: Scalars['String'];
};


export type MutationRemoveMachinesFromMachineUserGroupArgs = {
  machineNodeIds: Array<InputMaybe<Scalars['String']>>;
  nodeId: Scalars['String'];
};


export type MutationResetAllMachinesUserChangesArgs = {
  machineNodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type MutationRetrySingleExecutionArgs = {
  nodeId: Scalars['String'];
};


export type MutationSetTenantFeaturesArgs = {
  features: TenantFeaturesDtoIn;
  tenantId: Scalars['String'];
};


export type MutationSynchronizeMqttCredentialsArgs = {
  tenantId: Scalars['String'];
};


export type MutationUpdateCorrectionReasonArgs = {
  correctionReason?: InputMaybe<CorrectionReasonDtoIn>;
  nodeId: Scalars['String'];
};


export type MutationUpdateLabelRetentionPolicyArgs = {
  policy: LabelRetentionPolicyDtoIn;
  tenantId: Scalars['String'];
};


export type MutationUpdateLocationArgs = {
  location?: InputMaybe<LocationDtoIn>;
  nodeId: Scalars['String'];
};


export type MutationUpdateMumEnabledMachinesArgs = {
  mumEnabledMachines?: InputMaybe<MumEnabledMachinesIn>;
};


export type MutationUpdateMachineArgs = {
  machine?: InputMaybe<MachineDtoIn>;
  nodeId: Scalars['String'];
};


export type MutationUpdateMachineGroupArgs = {
  machineGroup?: InputMaybe<MachineGroupDtoIn>;
  nodeId: Scalars['String'];
};


export type MutationUpdateMachineUserArgs = {
  machineUser?: InputMaybe<MachineUserDtoIn>;
  nodeId?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateMachineUserGroupArgs = {
  machineUserGroup?: InputMaybe<MachineUserGroupUpdateDtoIn>;
  nodeId: Scalars['String'];
};


export type MutationUpdatePasswordForTenantArgs = {
  password: Scalars['String'];
  tenantId: Scalars['String'];
};


export type MutationUpdateRulesArgs = {
  input: RulesDto;
};


export type MutationUpdateScheduledReportArgs = {
  params: ScheduledReportDtoIn;
};


export type MutationUpdateSoftwarePackageArgs = {
  nodeId: Scalars['String'];
  softwarePackage: SoftwarePackageDtoIn;
};


export type MutationUpdateTemplateArgs = {
  nodeId: Scalars['String'];
  template: TemplateDtoIn;
};


export type MutationUpdateTenantArgs = {
  tenant?: InputMaybe<TenantUpdateDtoIn>;
};


export type MutationUpdateTenantRetentionPolicyArgs = {
  policy: TenantRetentionPolicyDtoIn;
  tenantId: Scalars['String'];
};


export type MutationUpdateUserPasswordArgs = {
  domainName?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateUserPermissionOrRoleArgs = {
  isUserUpdateDtoIn?: InputMaybe<IsUserUpdateDtoIn>;
};


export type MutationUpgradeMachineLatestLicenseArgs = {
  licenseSubscription: LicenseSubscriptionDtoIn;
};


export type MutationUpgradeMultiMachineLatestLicenseArgs = {
  licenseMultiSubscription: LicenseMultiSubscriptionDtoIn;
};


export type MutationUpsertSmartLocationGroupArgs = {
  smartGroup?: InputMaybe<SmartLocationGroupDtoIn>;
};

export type NetCashReportCriteriaDto = {
  durationInDays?: InputMaybe<Scalars['Int']>;
  locationNodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  machineNodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  referenceDate: Scalars['DateTime'];
  reportName: ScheduledReportName;
  transactionType?: InputMaybe<Array<RmTransactionType>>;
  zoneId?: InputMaybe<Scalars['ZoneId']>;
};

export type NetCashReportDtoOut = {
  __typename?: 'NetCashReportDtoOut';
  netCashReportRowDtos?: Maybe<Array<Maybe<NetCashReportRowDto>>>;
};

export type NetCashReportRowDto = {
  __typename?: 'NetCashReportRowDto';
  closingTotalAmounts?: Maybe<Array<Maybe<TotalAmountsDto>>>;
  locationName?: Maybe<Scalars['String']>;
  machineName?: Maybe<Scalars['String']>;
  openingTotalAmounts?: Maybe<Array<Maybe<TotalAmountsDto>>>;
  transactionsInTotalAmounts?: Maybe<Array<Maybe<AmountDto>>>;
  transactionsOutTotalAmounts?: Maybe<Array<Maybe<AmountDto>>>;
};

export type NoParamFilter = AbstractFilter & {
  __typename?: 'NoParamFilter';
  child?: Maybe<AbstractFilter>;
  filterType?: Maybe<FilterType>;
  operationType?: Maybe<OperationType>;
};

export type NodeStatus =
  | 'ACTIVE'
  | 'DELETED'
  | 'DETACHED'
  | 'INACTIVE'
  | 'UNKNOWN';

export type OnlineStatus =
  | 'CatchingUp'
  | 'Offline'
  | 'Online';

export type OpenShiftDto = {
  __typename?: 'OpenShiftDto';
  role?: Maybe<Scalars['String']>;
  totals?: Maybe<Array<Maybe<RmPairDto>>>;
  transactions?: Maybe<Array<Maybe<TransactionsReportRowDto>>>;
  userId?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type OpenShiftReportDto = {
  __typename?: 'OpenShiftReportDto';
  columns?: Maybe<Array<Maybe<ReportPairDtoOut>>>;
  grandTotals?: Maybe<Array<Maybe<RmPairDto>>>;
  machines?: Maybe<Array<Maybe<MachineDtoOut>>>;
  openShifts?: Maybe<Array<Maybe<OpenShiftDto>>>;
};

export type OpenShiftsReportCriteriaDto = {
  /** TODO: not implemented yet */
  locationNodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  machineNodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  machineUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  machineUserNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  queryTransactionBy: TransactionDateTime;
  referenceDate: Scalars['DateTime'];
  reportName: ScheduledReportName;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  zoneId?: InputMaybe<Scalars['ZoneId']>;
};

export type OperationType =
  | 'BI_NODE'
  | 'COUNT'
  | 'DURATION'
  | 'LIST_FILTER'
  | 'MESSAGE_FIELD_FILTER'
  | 'MESSAGE_TYPE_FILTER'
  | 'NONE'
  | 'NO_PARAM'
  | 'RATIO'
  | 'TIME_FILTER'
  | 'TOTAL_AMOUNT_IN'
  | 'WEBHOOK';

export type Order =
  | 'ASC'
  | 'DESC';

export type OtaAlgorithm =
  | 'OR1';

export type OtaAuthorizationDto = Dto & {
  __typename?: 'OtaAuthorizationDto';
  codeValidityIntervalMinutes?: Maybe<Scalars['Long']>;
  connectUserName?: Maybe<Scalars['String']>;
  customData?: Maybe<Array<MapDto>>;
  deleteAfterFirstUse?: Maybe<Scalars['Boolean']>;
  expirationDateTime?: Maybe<Scalars['DateTime']>;
  machineUuid?: Maybe<Scalars['String']>;
  nodeChangeDate?: Maybe<Scalars['DateTime']>;
  nodeId?: Maybe<Scalars['String']>;
  nodeStatus?: Maybe<NodeStatus>;
  siteGroupNodeId?: Maybe<Scalars['String']>;
  siteNodeId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  userRole?: Maybe<Scalars['String']>;
};

export type OtaAuthorizationFiltersDto = {
  connectUserName?: InputMaybe<Scalars['String']>;
  deleteAfterFirstUse?: InputMaybe<Scalars['Boolean']>;
  expiringFrom?: InputMaybe<Scalars['DateTime']>;
  expiringTo?: InputMaybe<Scalars['DateTime']>;
  machineUuid?: InputMaybe<Scalars['String']>;
  nodeStatus?: InputMaybe<NodeStatus>;
  siteGroupNodeId?: InputMaybe<Scalars['String']>;
  siteNodeId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
  userRole?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['ZoneId']>;
};

export type OtaAuthorizationIn = {
  codeValidityIntervalMinutes: Scalars['Long'];
  connectUserName: Scalars['String'];
  customData?: InputMaybe<Array<MapDtoIn>>;
  deleteAfterFirstUse?: InputMaybe<Scalars['Boolean']>;
  expirationDateTime?: InputMaybe<Scalars['DateTime']>;
  machineUuid?: InputMaybe<Scalars['String']>;
  siteGroupNodeId?: InputMaybe<Scalars['String']>;
  siteNodeId?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
  userName: Scalars['String'];
  userRole: Scalars['String'];
  zoneId?: InputMaybe<Scalars['ZoneId']>;
};

export type OtaCodeDtoOut = Dto & {
  __typename?: 'OtaCodeDtoOut';
  code?: Maybe<Scalars['String']>;
  codeFormatVersion?: Maybe<Scalars['String']>;
  expirationDateTime?: Maybe<Scalars['DateTime']>;
  machineUuid?: Maybe<Scalars['String']>;
  nodeChangeDate?: Maybe<Scalars['DateTime']>;
  nodeId?: Maybe<Scalars['String']>;
  nodeStatus?: Maybe<NodeStatus>;
  otaAlgorithm?: Maybe<OtaAlgorithm>;
};

export type OtaCodeFiltersDto = {
  authorizationNodeId?: InputMaybe<Scalars['String']>;
  expiringAfter?: InputMaybe<Scalars['DateTime']>;
  machineUuid?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['ZoneId']>;
};

export type OtaCodeInputDto = {
  codeFormatVersion: Scalars['String'];
  machineUuid: Scalars['String'];
};

export type PassThroughQuery = {
  data: Scalars['String'];
  rulesNodeId: Scalars['String'];
};

export type PaymentIntervalType =
  | 'ANNUAL'
  | 'MONTHLY'
  | 'NONE'
  | 'PERPETUAL'
  | 'QUARTERLY';

export type PredictedExecutionDtoOut = {
  __typename?: 'PredictedExecutionDtoOut';
  endDate?: Maybe<Scalars['ZonedDateTime']>;
  execution?: Maybe<Scalars['ZonedDateTime']>;
  startDate?: Maybe<Scalars['ZonedDateTime']>;
};

export type Query = {
  __typename?: 'Query';
  findActiveSubscriptions?: Maybe<Array<Maybe<SubscriptionDto>>>;
  findAlertsByCriteria?: Maybe<AlertHistoryDto>;
  findAllActiveCoDLicenses?: Maybe<Array<Maybe<CoDLicenseDtoOut>>>;
  findAllAdminCandidate?: Maybe<IdentifyUserListDtoOut>;
  findAllAvailableLicenseFeatureKeys?: Maybe<Array<Maybe<Scalars['String']>>>;
  findAllCities?: Maybe<Array<Maybe<Scalars['String']>>>;
  findAllCoDLicenses?: Maybe<Array<Maybe<CoDLicenseDtoOut>>>;
  findAllCorrectionReasons?: Maybe<Array<Maybe<CorrectionReasonDtoOut>>>;
  findAllCountries?: Maybe<Array<Maybe<Scalars['String']>>>;
  findAllDistinctRoles?: Maybe<Array<Maybe<Scalars['String']>>>;
  findAllDomainNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  findAllLaneAllocations?: Maybe<SearchResultDto>;
  findAllLocationGroupsFiltered?: Maybe<SearchResultDto>;
  findAllLocations?: Maybe<Array<Maybe<LocationDtoOut>>>;
  findAllLocationsByNodeIds?: Maybe<Array<Maybe<LocationDtoOut>>>;
  findAllLocationsByNodeIdsIncludingDeleted?: Maybe<Array<Maybe<LocationDtoOut>>>;
  findAllLocationsFiltered?: Maybe<SearchResultDto>;
  findAllMachineCoDLicenses?: Maybe<Array<Maybe<CoDLicenseDtoOut>>>;
  findAllMachineGroups?: Maybe<Array<Maybe<MachineGroupDtoOut>>>;
  findAllMachineGroupsByNodeIds?: Maybe<Array<Maybe<MachineGroupDtoOut>>>;
  findAllMachineGroupsByNodeIdsIncludingDeleted?: Maybe<Array<Maybe<MachineGroupDtoOut>>>;
  findAllMachineGroupsFiltered?: Maybe<SearchResultDto>;
  findAllMachineTypePatterns: Array<MachineTypeDto>;
  findAllMachineUserGroups?: Maybe<Array<Maybe<MachineUserGroupDtoOut>>>;
  findAllMachineUserGroupsContainingMachineByNodeId?: Maybe<Array<Maybe<MachineUserGroupDtoOut>>>;
  findAllMachineUserGroupsContainingMachineUserByNodeId?: Maybe<Array<Maybe<MachineUserGroupDtoOut>>>;
  findAllMachineUserGroupsFiltered?: Maybe<SearchResultDto>;
  findAllMachineUsers?: Maybe<Array<Maybe<MachineUserDtoOut>>>;
  findAllMachineUsersFiltered?: Maybe<SearchResultDto>;
  findAllMachines?: Maybe<SearchResultDto>;
  findAllMachinesByNodeIds?: Maybe<Array<Maybe<MachineDtoOut>>>;
  findAllMachinesByNodeIdsIncludingDeleted?: Maybe<Array<Maybe<MachineDtoOut>>>;
  findAllOtaAuthorizations?: Maybe<SearchResultDto>;
  findAllOtaCodes?: Maybe<SearchResultDto>;
  findAllShifts?: Maybe<Array<Maybe<ShiftDtoOut>>>;
  findAllSmartLocationGroups?: Maybe<Array<Maybe<SmartLocationGroupDtoOut>>>;
  findAllSoftwarePackages?: Maybe<Array<Maybe<SoftwarePackageDtoOut>>>;
  findAllSoftwarePackagesFiltered?: Maybe<SearchResultDto>;
  findAllTenantDbsNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  findAllTenants?: Maybe<Array<Maybe<TenantDtoOut>>>;
  findBoxTotalsByCurrency?: Maybe<BoxTotalsDtoOut>;
  findCoDLicenseByNodeId?: Maybe<CoDLicenseDtoOut>;
  findCorrectionReasonByNodeId?: Maybe<CorrectionReasonDtoOut>;
  findCountriesToCities?: Maybe<Array<Maybe<StringToStringList>>>;
  findDeviceMovementsForRmTransaction?: Maybe<Array<Maybe<RmDeviceMovementDto>>>;
  findFirstByMachineUuid?: Maybe<ShiftDtoOut>;
  findLatestCoDLicenseByMachineUuid?: Maybe<CoDLicenseDtoOut>;
  findListOfUsers?: Maybe<IdentifyUserListDtoOut>;
  findListOfUsersByTenant?: Maybe<IdentifyUserListDtoOut>;
  findLocationByNodeId?: Maybe<LocationDtoOut>;
  findLocationByNodeIdIncludingDeleted?: Maybe<LocationDtoOut>;
  findMachineByNodeId?: Maybe<MachineDtoOut>;
  findMachineByNodeIdIncludingDeleted?: Maybe<MachineDtoOut>;
  findMachineByUuid?: Maybe<MachineDtoOut>;
  findMachineGroupByNodeId?: Maybe<MachineGroupDtoOut>;
  findMachineGroupByNodeIdIncludingDeleted?: Maybe<MachineGroupDtoOut>;
  findMachineUserByUserId?: Maybe<MachineUserDtoOut>;
  findMachineUserGroupByNodeId?: Maybe<MachineUserGroupDtoOut>;
  findMachinesEligibleToAttachToLocation?: Maybe<Array<Maybe<MachineDtoOut>>>;
  findMachinesEligibleToAttachToMG?: Maybe<Array<Maybe<MachineDtoOut>>>;
  findMessagesByCriteria?: Maybe<Array<Maybe<RmHeaderDto>>>;
  findMyTenantsMetadata?: Maybe<Array<Maybe<TenantMetadataDtoOut>>>;
  findRmDevicesForMachineDetails?: Maybe<Array<Maybe<RmDeviceDto>>>;
  findRmValuesForRmBox?: Maybe<Array<Maybe<RmBoxDto>>>;
  findSoftwareInstallations?: Maybe<Array<Maybe<SoftwareInstallationDtoOut>>>;
  findSoftwarePackageByNodeId?: Maybe<SoftwarePackageDtoOut>;
  findSubscriptionByNodeId?: Maybe<SubscriptionDto>;
  findTenant?: Maybe<TenantDtoOut>;
  findTenantByTenantId?: Maybe<TenantDtoOut>;
  findTenantFeatures?: Maybe<TenantFeaturesDto>;
  findTenantsMetadataByDomainName?: Maybe<Array<Maybe<TenantMetadataDtoOut>>>;
  findUserBalances?: Maybe<Array<Maybe<UserBalanceDtoOut>>>;
  findUserBalancesFiltered?: Maybe<SearchResultDto>;
  findUserByUserName?: Maybe<IdentifyUserDtoOut>;
  findUserPermissionList?: Maybe<IdentifyRolesDtoOut>;
  findUserRolesList?: Maybe<IdentifyRolesDtoOut>;
  findValueBagsForRmTransaction?: Maybe<Array<Maybe<RmValueBagDto>>>;
  generate?: Maybe<Scalars['Boolean']>;
  generateCashInventoryReport?: Maybe<CashInventoryReportDto>;
  generateCashOperationsReport?: Maybe<CashOperationsDtoOut>;
  generateCashSummaryReport?: Maybe<CashSummaryReportDto>;
  generateClaimedValuesReport?: Maybe<ClaimedValuesReportDtoOut>;
  generateMachineDetailsReport?: Maybe<MachineDetailsReportDto>;
  generateMachineErrorsReport?: Maybe<ReportDtoOut>;
  generateMachineUserTransactionsReport?: Maybe<MachineUserTransactionsReportDto>;
  generateMachineViewTab?: Maybe<MachineViewDtoOut>;
  generateManualDepositsReport?: Maybe<ManualDepositsReportDto>;
  generateNetCashReport?: Maybe<NetCashReportDtoOut>;
  generateOpenShiftsReport?: Maybe<OpenShiftReportDto>;
  generateRefillReport?: Maybe<RefillReportDto>;
  generateTransactionsReport?: Maybe<ReportDtoOut>;
  getActiveScheduledReports?: Maybe<Array<Maybe<ScheduledReportDtoOut>>>;
  getAllCommands?: Maybe<Array<Maybe<RmCommandDto>>>;
  getAllExecutions?: Maybe<Array<Maybe<SingleExecutionDtoOut>>>;
  getAllLogs?: Maybe<Array<Maybe<LogInfoDto>>>;
  getAllMachineLicenseContents?: Maybe<Array<Maybe<LicenseContentDtoOut>>>;
  getAllReboots?: Maybe<Array<Maybe<RmCommandDto>>>;
  getAllRestarts?: Maybe<Array<Maybe<RmCommandDto>>>;
  getAllRules?: Maybe<Array<Maybe<Rules>>>;
  getAllSchedulableReportNameToType?: Maybe<Array<Maybe<ReportTripleOut>>>;
  getAllSchedulableReportTypes?: Maybe<Array<Maybe<ReportTriple>>>;
  getAllScheduledReports?: Maybe<Array<Maybe<ScheduledReportDtoOut>>>;
  getAllTemplates?: Maybe<Array<Maybe<TemplateDtoOut>>>;
  getAllTemplatesFiltered?: Maybe<SearchResultDto>;
  getAvailableLogs?: Maybe<Array<Maybe<LogInfoDto>>>;
  getBase64TileGridImage?: Maybe<TileGrid>;
  getBase64TileImage?: Maybe<Tile>;
  getDeployment?: Maybe<DeploymentDtoOut>;
  getDeploymentsForMachineNodeId?: Maybe<Array<Maybe<DeploymentDtoOut>>>;
  getExecutions?: Maybe<SearchResultDto>;
  getLatestOnlineStatusForMachine?: Maybe<Scalars['String']>;
  getLogLinks?: Maybe<S3PreSignedData>;
  getMUMEnabledMachines?: Maybe<MumEnabledMachines>;
  getMachineData?: Maybe<MachineDataDto>;
  getMachineHistoryStatusList?: Maybe<SearchResultDto>;
  getMachineLicenseContent?: Maybe<LicenseContentDtoOut>;
  getMachinesOnlineStatus?: Maybe<MachinesOnlineStatusForDateTimeResponse>;
  getMachinesOnlineStatusHistory?: Maybe<MachinesOnlineStatusHistoryResponse>;
  getMachinesOnlineStatusInfoForMachines?: Maybe<Array<Maybe<MachineOnlineStatusInfoDto>>>;
  getPreSignedDataForConfiguration?: Maybe<S3PreSignedData>;
  getPreSignedDataForSoftwarePackage?: Maybe<S3PreSignedData>;
  getPublicKey?: Maybe<Scalars['String']>;
  getReportHeader?: Maybe<ReportHeaderDtoOut>;
  getRulesByNodeId?: Maybe<Rules>;
  getScheduledReport?: Maybe<ScheduledReportDtoOut>;
  getSumValueOfTransactions?: Maybe<Scalars['Float']>;
  getSupportedFilters?: Maybe<Array<Maybe<Array<Maybe<AbstractFilter>>>>>;
  getUpcomingExecutionDates?: Maybe<Array<Maybe<PredictedExecutionDtoOut>>>;
};


export type QueryFindActiveSubscriptionsArgs = {
  tenantId: Scalars['String'];
};


export type QueryFindAlertsByCriteriaArgs = {
  input?: InputMaybe<AlertHistoryDtoIn>;
};


export type QueryFindAllAdminCandidateArgs = {
  domainName: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryFindAllLaneAllocationsArgs = {
  laneAllocationFilters?: InputMaybe<LaneAllocationFiltersDto>;
  searchRequest: SearchRequestDto;
};


export type QueryFindAllLocationGroupsFilteredArgs = {
  locationGroupFilters?: InputMaybe<LocationGroupFiltersDto>;
  searchRequest: SearchRequestDto;
};


export type QueryFindAllLocationsByNodeIdsArgs = {
  nodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryFindAllLocationsByNodeIdsIncludingDeletedArgs = {
  nodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryFindAllLocationsFilteredArgs = {
  locationFilters?: InputMaybe<LocationFiltersDto>;
  searchRequest: SearchRequestDto;
};


export type QueryFindAllMachineCoDLicensesArgs = {
  machineUuid: Scalars['String'];
};


export type QueryFindAllMachineGroupsArgs = {
  cpPageRequest: CpPageRequest;
};


export type QueryFindAllMachineGroupsByNodeIdsArgs = {
  nodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryFindAllMachineGroupsByNodeIdsIncludingDeletedArgs = {
  nodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryFindAllMachineGroupsFilteredArgs = {
  machineGroupFilters?: InputMaybe<MachineGroupFiltersDto>;
  searchRequest: SearchRequestDto;
};


export type QueryFindAllMachineUserGroupsArgs = {
  cpPageRequest: CpPageRequest;
};


export type QueryFindAllMachineUserGroupsContainingMachineByNodeIdArgs = {
  machineNodeId: Scalars['String'];
};


export type QueryFindAllMachineUserGroupsContainingMachineUserByNodeIdArgs = {
  machineUserNodeId: Scalars['String'];
};


export type QueryFindAllMachineUserGroupsFilteredArgs = {
  machineUserGroupFilters?: InputMaybe<MachineUserGroupFiltersDto>;
  searchRequest: SearchRequestDto;
};


export type QueryFindAllMachineUsersArgs = {
  cpPageRequest: CpPageRequest;
};


export type QueryFindAllMachineUsersFilteredArgs = {
  machineUserFilters?: InputMaybe<MachineUserFiltersDto>;
  searchRequest: SearchRequestDto;
};


export type QueryFindAllMachinesArgs = {
  machineFilters?: InputMaybe<MachineFiltersDto>;
  searchRequest: SearchRequestDto;
};


export type QueryFindAllMachinesByNodeIdsArgs = {
  nodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryFindAllMachinesByNodeIdsIncludingDeletedArgs = {
  nodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryFindAllOtaAuthorizationsArgs = {
  otaAuthorizationFiltersDto?: InputMaybe<OtaAuthorizationFiltersDto>;
  searchRequest: SearchRequestDto;
};


export type QueryFindAllOtaCodesArgs = {
  otaCodeFiltersDto?: InputMaybe<OtaCodeFiltersDto>;
  searchRequest: SearchRequestDto;
};


export type QueryFindAllSoftwarePackagesArgs = {
  cpPageRequest: CpPageRequest;
};


export type QueryFindAllSoftwarePackagesFilteredArgs = {
  searchRequest: SearchRequestDto;
  softwarePackageFilters?: InputMaybe<SoftwarePackageFiltersDto>;
};


export type QueryFindBoxTotalsByCurrencyArgs = {
  boxTotalsDtoIn?: InputMaybe<BoxTotalsDtoIn>;
};


export type QueryFindCoDLicenseByNodeIdArgs = {
  nodeId: Scalars['String'];
};


export type QueryFindCorrectionReasonByNodeIdArgs = {
  nodeId: Scalars['String'];
};


export type QueryFindDeviceMovementsForRmTransactionArgs = {
  transactionNodeId?: InputMaybe<Scalars['String']>;
};


export type QueryFindFirstByMachineUuidArgs = {
  machineUuid: Scalars['String'];
};


export type QueryFindLatestCoDLicenseByMachineUuidArgs = {
  machineUuid: Scalars['String'];
};


export type QueryFindListOfUsersArgs = {
  domainName: Scalars['String'];
  isUserFilterDtoIn?: InputMaybe<IsUserFilterDtoIn>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryFindListOfUsersByTenantArgs = {
  filterByUserName?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryFindLocationByNodeIdArgs = {
  nodeId: Scalars['String'];
};


export type QueryFindLocationByNodeIdIncludingDeletedArgs = {
  nodeId: Scalars['String'];
};


export type QueryFindMachineByNodeIdArgs = {
  nodeId?: InputMaybe<Scalars['String']>;
};


export type QueryFindMachineByNodeIdIncludingDeletedArgs = {
  nodeId?: InputMaybe<Scalars['String']>;
};


export type QueryFindMachineByUuidArgs = {
  machineUuid?: InputMaybe<Scalars['String']>;
};


export type QueryFindMachineGroupByNodeIdArgs = {
  nodeId?: InputMaybe<Scalars['String']>;
};


export type QueryFindMachineGroupByNodeIdIncludingDeletedArgs = {
  nodeId?: InputMaybe<Scalars['String']>;
};


export type QueryFindMachineUserByUserIdArgs = {
  userId: Scalars['String'];
};


export type QueryFindMachineUserGroupByNodeIdArgs = {
  nodeId: Scalars['String'];
};


export type QueryFindMessagesByCriteriaArgs = {
  input?: InputMaybe<MessageCriteriaDtoIn>;
};


export type QueryFindRmDevicesForMachineDetailsArgs = {
  machineDetailsNodeId?: InputMaybe<Scalars['String']>;
};


export type QueryFindRmValuesForRmBoxArgs = {
  rmBoxNodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryFindSoftwareInstallationsArgs = {
  current?: InputMaybe<Scalars['Boolean']>;
  installationNodeId?: InputMaybe<Scalars['String']>;
  machineNodeId?: InputMaybe<Scalars['String']>;
  ongoing?: InputMaybe<Scalars['Boolean']>;
};


export type QueryFindSoftwarePackageByNodeIdArgs = {
  nodeId: Scalars['String'];
};


export type QueryFindSubscriptionByNodeIdArgs = {
  nodeId: Scalars['String'];
};


export type QueryFindTenantByTenantIdArgs = {
  tenantId?: InputMaybe<Scalars['String']>;
};


export type QueryFindTenantFeaturesArgs = {
  tenantId: Scalars['String'];
};


export type QueryFindTenantsMetadataByDomainNameArgs = {
  domainName: Scalars['String'];
};


export type QueryFindUserBalancesArgs = {
  currencyCode?: InputMaybe<RmCurrencyCode>;
  date: Scalars['Date'];
  machineUserId?: InputMaybe<Scalars['String']>;
};


export type QueryFindUserBalancesFilteredArgs = {
  searchRequest: SearchRequestDto;
  userBalanceFiltersDto?: InputMaybe<UserBalanceFiltersDto>;
};


export type QueryFindUserByUserNameArgs = {
  domainName: Scalars['String'];
  username: Scalars['String'];
};


export type QueryFindUserRolesListArgs = {
  domainName: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryFindValueBagsForRmTransactionArgs = {
  transactionNodeId?: InputMaybe<Scalars['String']>;
};


export type QueryGenerateArgs = {
  reportDto?: InputMaybe<BatchableReportDtoIn>;
};


export type QueryGenerateCashInventoryReportArgs = {
  cashInventoryReportCriteria?: InputMaybe<CashInventoryReportCriteriaDtoIn>;
};


export type QueryGenerateCashOperationsReportArgs = {
  cashOperationsReportCriteriaDto?: InputMaybe<CashOperationsReportCriteriaDto>;
};


export type QueryGenerateCashSummaryReportArgs = {
  criteriaDto?: InputMaybe<CashSummaryReportCriteriaDto>;
};


export type QueryGenerateClaimedValuesReportArgs = {
  claimedValuesReportCriteria?: InputMaybe<ClaimedValuesReportCriteriaDtoIn>;
};


export type QueryGenerateMachineDetailsReportArgs = {
  criteriaDto?: InputMaybe<MachineDetailsReportCriteriaDto>;
};


export type QueryGenerateMachineErrorsReportArgs = {
  reportHeaderCriteria?: InputMaybe<ErrorsReportCriteriaDtoIn>;
};


export type QueryGenerateMachineUserTransactionsReportArgs = {
  criteriaDto?: InputMaybe<MachineUserTransactionsReportCriteriaDto>;
};


export type QueryGenerateMachineViewTabArgs = {
  input?: InputMaybe<MachineViewDtoIn>;
};


export type QueryGenerateManualDepositsReportArgs = {
  criteriaDto?: InputMaybe<ManualDepositsReportCriteriaDto>;
};


export type QueryGenerateNetCashReportArgs = {
  criteriaDto?: InputMaybe<NetCashReportCriteriaDto>;
};


export type QueryGenerateOpenShiftsReportArgs = {
  criteriaDto?: InputMaybe<OpenShiftsReportCriteriaDto>;
};


export type QueryGenerateRefillReportArgs = {
  criteriaDto?: InputMaybe<RefillReportCriteriaDto>;
};


export type QueryGenerateTransactionsReportArgs = {
  transactionsReportCriteria?: InputMaybe<TransactionsReportCriteriaDtoIn>;
};


export type QueryGetAllCommandsArgs = {
  cpPageRequest: CpPageRequest;
  machineNodeId: Scalars['String'];
};


export type QueryGetAllExecutionsArgs = {
  scheduledReportNodeId?: InputMaybe<Scalars['String']>;
};


export type QueryGetAllLogsArgs = {
  cpPageRequest: CpPageRequest;
  machineNodeId: Scalars['String'];
};


export type QueryGetAllMachineLicenseContentsArgs = {
  machineUuid: Scalars['String'];
};


export type QueryGetAllRebootsArgs = {
  cpPageRequest: CpPageRequest;
  machineNodeId: Scalars['String'];
};


export type QueryGetAllRestartsArgs = {
  cpPageRequest: CpPageRequest;
  machineNodeId: Scalars['String'];
};


export type QueryGetAllTemplatesArgs = {
  cpPageRequest: CpPageRequest;
};


export type QueryGetAllTemplatesFilteredArgs = {
  searchRequest: SearchRequestDto;
  templateFilters?: InputMaybe<TemplateFiltersDto>;
};


export type QueryGetAvailableLogsArgs = {
  cpPageRequest: CpPageRequest;
  machineNodeId: Scalars['String'];
};


export type QueryGetBase64TileGridImageArgs = {
  input?: InputMaybe<TileGridDto>;
};


export type QueryGetBase64TileImageArgs = {
  input?: InputMaybe<TileDto>;
};


export type QueryGetDeploymentArgs = {
  nodeId: Scalars['String'];
};


export type QueryGetDeploymentsForMachineNodeIdArgs = {
  machineUuid: Scalars['String'];
};


export type QueryGetExecutionsArgs = {
  filters?: InputMaybe<SingleExecutionFiltersDto>;
  scheduledReportNodeId?: InputMaybe<Scalars['String']>;
  searchDto: SearchRequestDto;
};


export type QueryGetLatestOnlineStatusForMachineArgs = {
  machineUuid: Scalars['String'];
  tenantId: Scalars['String'];
};


export type QueryGetLogLinksArgs = {
  key: Scalars['String'];
};


export type QueryGetMachineDataArgs = {
  machineUuid: Scalars['String'];
  tenantId: Scalars['String'];
};


export type QueryGetMachineHistoryStatusListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  nodeId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  zoneId: Scalars['String'];
};


export type QueryGetMachineLicenseContentArgs = {
  machineUuid: Scalars['String'];
};


export type QueryGetMachinesOnlineStatusArgs = {
  input?: InputMaybe<MachineOnlineStatusRequest>;
};


export type QueryGetMachinesOnlineStatusHistoryArgs = {
  input?: InputMaybe<MachineOnlineStatusHistoryRequest>;
};


export type QueryGetMachinesOnlineStatusInfoForMachinesArgs = {
  machineUuids: Array<InputMaybe<Scalars['String']>>;
  tenantId: Scalars['String'];
};


export type QueryGetPreSignedDataForConfigurationArgs = {
  fileName?: InputMaybe<Scalars['String']>;
};


export type QueryGetPreSignedDataForSoftwarePackageArgs = {
  fileName?: InputMaybe<Scalars['String']>;
};


export type QueryGetPublicKeyArgs = {
  machineUuid: Scalars['String'];
};


export type QueryGetRulesByNodeIdArgs = {
  nodeId?: InputMaybe<Scalars['String']>;
};


export type QueryGetScheduledReportArgs = {
  scheduledReportNodeId?: InputMaybe<Scalars['String']>;
};


export type QueryGetSumValueOfTransactionsArgs = {
  transportationOperationCriteriaDto?: InputMaybe<TransportationOperationCriteriaDto>;
};


export type QueryGetSupportedFiltersArgs = {
  input?: InputMaybe<AbstractFilterDto>;
};


export type QueryGetUpcomingExecutionDatesArgs = {
  metadataDtoIn?: InputMaybe<MetadataDtoIn>;
};

export type RatioFilter = AbstractFilter & {
  __typename?: 'RatioFilter';
  child?: Maybe<AbstractFilter>;
  filterType?: Maybe<FilterType>;
  operationType?: Maybe<OperationType>;
  ratio?: Maybe<Scalars['Float']>;
};

export type RecipientData = {
  __typename?: 'RecipientData';
  contact?: Maybe<Scalars['String']>;
  nodeId?: Maybe<Scalars['String']>;
  triggerType?: Maybe<TriggerType>;
};

export type RecipientDataDto = {
  contact?: InputMaybe<Scalars['String']>;
  triggerType?: InputMaybe<TriggerType>;
};

export type RefillReportBoxContentDto = {
  __typename?: 'RefillReportBoxContentDto';
  containerName?: Maybe<Scalars['String']>;
  currentCount?: Maybe<Scalars['Int']>;
  denomination?: Maybe<Array<Maybe<AmountDto>>>;
  highCount?: Maybe<Scalars['Int']>;
  locationName?: Maybe<Scalars['String']>;
  lowCount?: Maybe<Scalars['Int']>;
  machineName?: Maybe<Scalars['String']>;
  machineNodeId?: Maybe<Scalars['String']>;
  machineType?: Maybe<Scalars['String']>;
  minimumLevel?: Maybe<Scalars['Int']>;
  refillCount?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

export type RefillReportColumns =
  | 'CONTAINER'
  | 'CURRENT_COUNT'
  | 'HIGH_COUNT'
  | 'LOCATION_NAME'
  | 'LOW_COUNT'
  | 'MACHINE_NAME'
  | 'MACHINE_TYPE'
  | 'REFILL_COUNT'
  | 'TYPE';

export type RefillReportCriteriaDto = {
  limit: Scalars['Int'];
  locationNodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  machineNodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  order: Order;
  orderColumn?: InputMaybe<RefillReportColumns>;
  reportName: ScheduledReportName;
  skip: Scalars['Int'];
  threshold: Scalars['Float'];
};

export type RefillReportDto = {
  __typename?: 'RefillReportDto';
  columns?: Maybe<Array<Maybe<ReportPairDtoOut>>>;
  fullSize?: Maybe<Scalars['Int']>;
  rows?: Maybe<Array<Maybe<RefillReportRowDto>>>;
};

export type RefillReportRowDto = {
  __typename?: 'RefillReportRowDto';
  locationName?: Maybe<Scalars['String']>;
  machineName?: Maybe<Scalars['String']>;
  machineNodeId?: Maybe<Scalars['String']>;
  rawResponse?: Maybe<Array<Maybe<RefillReportBoxContentDto>>>;
};

export type RefillStatus =
  | 'APPROACHING'
  | 'OK'
  | 'REFILL';

export type Repeat =
  /** RUN_ONCE - not used for MVP */
  | 'DAILY'
  /** BIWEEKLY - not used for MVP */
  | 'MONTHLY'
  | 'WEEKLY';

export type ReportDtoOut = {
  __typename?: 'ReportDtoOut';
  columns?: Maybe<Array<Maybe<ReportPairDtoOut>>>;
  fullSize?: Maybe<Scalars['Int']>;
  machines?: Maybe<Array<Maybe<MachineDtoOut>>>;
  rows?: Maybe<Array<Maybe<RmHeaderDto>>>;
};

export type ReportExecutionStatus =
  /** email sending fail */
  | 'DONE'
  /** email + file/link sent */
  | 'EMAIL_FAILED'
  /** issue with storage service, */
  | 'EMAIL_SENT'
  /** error when generating, some chunks may already be generated */
  | 'FILE_CREATION_FAILED'
  /** tried to send to cp-core, but failed */
  | 'GENERATING'
  /** chunks(s) received from cp-core */
  | 'GENERATING_FAILED'
  /** processing done, cp-reports DB cleaned up */
  | 'MANUALLY_RETRIED'
  /** error when building CSV file */
  | 'PROCESSING_FAILED'
  /** sent to cp-core */
  | 'SENDING_FAILED'
  /** request sent to cp-core */
  | 'SENT'
  | 'STARTED'
  /** issue with processing on cp-reports side */
  | 'UPLOAD_FAILED';

export type ReportHeaderDtoOut = {
  __typename?: 'ReportHeaderDtoOut';
  locations?: Maybe<Array<Maybe<LocationDtoOut>>>;
  machines?: Maybe<Array<Maybe<MachineDtoOut>>>;
  smartLocationGroups?: Maybe<Array<Maybe<SmartLocationGroupDtoOut>>>;
};

export type ReportPairDtoOut = {
  __typename?: 'ReportPairDtoOut';
  key?: Maybe<Scalars['String']>;
  values?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ReportTriple = {
  __typename?: 'ReportTriple';
  dtoInName?: Maybe<Scalars['String']>;
  dtoOutName?: Maybe<Scalars['String']>;
  reportName?: Maybe<Scalars['String']>;
};

export type ReportTripleOut = {
  __typename?: 'ReportTripleOut';
  dtoInName: Scalars['String'];
  dtoOutName: Scalars['String'];
  reportName: Scalars['String'];
};

export type RmAccountDto = {
  __typename?: 'RmAccountDto';
  accountNumber?: Maybe<Scalars['String']>;
  nodeId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type RmAllocationDto = {
  __typename?: 'RmAllocationDto';
  barcode?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  nodeId?: Maybe<Scalars['String']>;
  workUnitName?: Maybe<Scalars['String']>;
};

export type RmAmountDto = {
  __typename?: 'RmAmountDto';
  currency?: Maybe<Scalars['String']>;
  decimals?: Maybe<Scalars['Int']>;
  nodeId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
};

export type RmBoxContentDto = RmHeaderDto & {
  __typename?: 'RmBoxContentDto';
  boxContents?: Maybe<Array<Maybe<RmBoxDto>>>;
  dateTime?: Maybe<Scalars['ZonedDateTime']>;
  device?: Maybe<Scalars['String']>;
  deviceId?: Maybe<Scalars['String']>;
  deviceType?: Maybe<Scalars['String']>;
  hideContents?: Maybe<Scalars['Boolean']>;
  licenseId?: Maybe<Scalars['String']>;
  machineId?: Maybe<Scalars['String']>;
  machineType?: Maybe<Scalars['String']>;
  md5?: Maybe<Scalars['String']>;
  messageSequence?: Maybe<Scalars['Long']>;
  messageType?: Maybe<Scalars['String']>;
  /** RmHeaderDto fields: */
  nodeId?: Maybe<Scalars['String']>;
  receivedDateTime?: Maybe<Scalars['ZonedDateTime']>;
  receiver?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['Long']>;
  timeZoneUtcOffset?: Maybe<Scalars['ZoneId']>;
  transactionSeq?: Maybe<Scalars['Long']>;
  uuid?: Maybe<Scalars['String']>;
  valueType?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type RmBoxDto = {
  __typename?: 'RmBoxDto';
  boxId?: Maybe<Scalars['String']>;
  capabilities?: Maybe<Array<Maybe<Scalars['String']>>>;
  containerId?: Maybe<Scalars['String']>;
  defaultLevel?: Maybe<Scalars['Int']>;
  errorStatus?: Maybe<Array<Maybe<Scalars['String']>>>;
  fillStatus?: Maybe<Scalars['String']>;
  highLimitLevel?: Maybe<Scalars['Int']>;
  lowLimitLevel?: Maybe<Scalars['Int']>;
  maximumLevel?: Maybe<Scalars['Int']>;
  minimumLevel?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  nodeId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
  values?: Maybe<Array<Maybe<RmValueDto>>>;
};

export type RmBoxExchangeDto = RmHeaderDto & {
  __typename?: 'RmBoxExchangeDto';
  boxContents?: Maybe<Array<Maybe<RmBoxDto>>>;
  dateTime?: Maybe<Scalars['ZonedDateTime']>;
  /** RmBoxContentDto fields: */
  device?: Maybe<Scalars['String']>;
  deviceId?: Maybe<Scalars['String']>;
  deviceType?: Maybe<Scalars['String']>;
  hideContents?: Maybe<Scalars['Boolean']>;
  licenseId?: Maybe<Scalars['String']>;
  machineId?: Maybe<Scalars['String']>;
  machineType?: Maybe<Scalars['String']>;
  md5?: Maybe<Scalars['String']>;
  messageSequence?: Maybe<Scalars['Long']>;
  messageType?: Maybe<Scalars['String']>;
  /** RmHeaderDto fields: */
  nodeId?: Maybe<Scalars['String']>;
  receivedDateTime?: Maybe<Scalars['ZonedDateTime']>;
  receiver?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['Long']>;
  timeZoneUtcOffset?: Maybe<Scalars['ZoneId']>;
  transactionSeq?: Maybe<Scalars['Long']>;
  user?: Maybe<RmUserDto>;
  uuid?: Maybe<Scalars['String']>;
  valueType?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type RmBoxMovementDto = {
  __typename?: 'RmBoxMovementDto';
  boxId?: Maybe<Scalars['String']>;
  containerId?: Maybe<Scalars['String']>;
  movement?: Maybe<Array<Maybe<RmValueBagDto>>>;
  nodeId?: Maybe<Scalars['String']>;
  resultingContent?: Maybe<Array<Maybe<RmValueBagDto>>>;
};

export type RmCashAmountDto = {
  __typename?: 'RmCashAmountDto';
  currency?: Maybe<Scalars['String']>;
  decimals?: Maybe<Scalars['Int']>;
  reference?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Long']>;
  type?: Maybe<Scalars['String']>;
};

export type RmCashierInfoDto = {
  __typename?: 'RmCashierInfoDto';
  cashierId?: Maybe<Scalars['String']>;
  cashierName?: Maybe<Scalars['String']>;
  roleName?: Maybe<Scalars['String']>;
};

export type RmCommandDto = {
  __typename?: 'RmCommandDto';
  ended?: Maybe<Scalars['String']>;
  executedBy?: Maybe<Scalars['String']>;
  machineNodeId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nodeId?: Maybe<Scalars['String']>;
  parameters?: Maybe<RmCommandParametersDto>;
  started?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type RmCommandParametersDto = {
  __typename?: 'RmCommandParametersDto';
  deviceId?: Maybe<Scalars['String']>;
  from?: Maybe<Scalars['DateTime']>;
  link?: Maybe<Scalars['String']>;
  systemDump?: Maybe<Scalars['Boolean']>;
  timeout?: Maybe<Scalars['Int']>;
  types?: Maybe<Array<Maybe<Scalars['String']>>>;
  until?: Maybe<Scalars['DateTime']>;
};

export type RmConfigurationUpdateDto = {
  __typename?: 'RmConfigurationUpdateDto';
  nodeId?: Maybe<Scalars['String']>;
  rmTemplate?: Maybe<RmTemplateDto>;
};

export type RmConfigurationVersionsDto = {
  __typename?: 'RmConfigurationVersionsDto';
  current?: Maybe<RmConfigurationVersionsTypeDto>;
  nodeId?: Maybe<Scalars['String']>;
  waiting?: Maybe<RmConfigurationVersionsTypeDto>;
};

export type RmConfigurationVersionsOrUpdateDto = {
  __typename?: 'RmConfigurationVersionsOrUpdateDto';
  nodeId?: Maybe<Scalars['String']>;
  rmConfigurationUpdate?: Maybe<RmConfigurationUpdateDto>;
  rmConfigurationVersions?: Maybe<RmConfigurationVersionsDto>;
};

export type RmConfigurationVersionsOrUpgradeDto = {
  __typename?: 'RmConfigurationVersionsOrUpgradeDto';
  name?: Maybe<RmFirmwareVersionsDto>;
  nodeId?: Maybe<Scalars['String']>;
  version?: Maybe<RmFirmwareUpgradeDto>;
};

export type RmConfigurationVersionsTypeDto = {
  __typename?: 'RmConfigurationVersionsTypeDto';
  configuration?: Maybe<Scalars['String']>;
  help?: Maybe<Scalars['String']>;
  i18n?: Maybe<Scalars['String']>;
  nodeId?: Maybe<Scalars['String']>;
  receipts?: Maybe<Scalars['String']>;
  scripts?: Maybe<Scalars['String']>;
  sdk?: Maybe<Scalars['String']>;
  themes?: Maybe<Scalars['String']>;
};

export type RmCounterDto = {
  __typename?: 'RmCounterDto';
  boxIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  count?: Maybe<Scalars['Int']>;
  countedOperation?: Maybe<Scalars['String']>;
  deviceId?: Maybe<Scalars['String']>;
  nodeId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type RmCurrencyCode =
  | 'AED'
  | 'AFN'
  | 'ALL'
  | 'AMD'
  | 'ANG'
  | 'AOA'
  | 'ARS'
  | 'AUD'
  | 'AWG'
  | 'AZN'
  | 'BAM'
  | 'BBD'
  | 'BDT'
  | 'BGN'
  | 'BHD'
  | 'BIF'
  | 'BMD'
  | 'BND'
  | 'BOB'
  | 'BOV'
  | 'BRL'
  | 'BSD'
  | 'BTN'
  | 'BWP'
  | 'BYN'
  | 'BZD'
  | 'CAD'
  | 'CDF'
  | 'CHE'
  | 'CHF'
  | 'CHW'
  | 'CLF'
  | 'CLP'
  | 'CNY'
  | 'COP'
  | 'COU'
  | 'CRC'
  | 'CUC'
  | 'CUP'
  | 'CVE'
  | 'CZK'
  | 'DJF'
  | 'DKK'
  | 'DOP'
  | 'DZD'
  | 'EGP'
  | 'ERN'
  | 'ETB'
  | 'EUR'
  | 'FJD'
  | 'FKP'
  | 'GBP'
  | 'GEL'
  | 'GHS'
  | 'GIP'
  | 'GMD'
  | 'GNF'
  | 'GTQ'
  | 'GYD'
  | 'HKD'
  | 'HNL'
  | 'HRK'
  | 'HTG'
  | 'HUF'
  | 'IDR'
  | 'ILS'
  | 'INR'
  | 'IQD'
  | 'IRR'
  | 'ISK'
  | 'JMD'
  | 'JOD'
  | 'JPY'
  | 'KES'
  | 'KGS'
  | 'KHR'
  | 'KMF'
  | 'KPW'
  | 'KRW'
  | 'KWD'
  | 'KYD'
  | 'KZT'
  | 'LAK'
  | 'LBP'
  | 'LKR'
  | 'LRD'
  | 'LSL'
  | 'LYD'
  | 'MAD'
  | 'MDL'
  | 'MGA'
  | 'MKD'
  | 'MMK'
  | 'MNT'
  | 'MOP'
  | 'MRU'
  | 'MUR'
  | 'MVR'
  | 'MWK'
  | 'MXN'
  | 'MXV'
  | 'MYR'
  | 'MZN'
  | 'NAD'
  | 'NGN'
  | 'NIO'
  | 'NOK'
  | 'NPR'
  | 'NZD'
  | 'OMR'
  | 'PAB'
  | 'PEN'
  | 'PGK'
  | 'PHP'
  | 'PKR'
  | 'PLN'
  | 'PYG'
  | 'QAR'
  | 'RON'
  | 'RSD'
  | 'RUB'
  | 'RWF'
  | 'SAR'
  | 'SBD'
  | 'SCR'
  | 'SDG'
  | 'SEK'
  | 'SGD'
  | 'SHP'
  | 'SLL'
  | 'SOS'
  | 'SRD'
  | 'SSP'
  | 'STN'
  | 'SVC'
  | 'SYP'
  | 'SZL'
  | 'THB'
  | 'TJS'
  | 'TMT'
  | 'TND'
  | 'TOP'
  | 'TRY'
  | 'TTD'
  | 'TWD'
  | 'TZS'
  | 'UAH'
  | 'UGX'
  | 'UNK'
  | 'USD'
  | 'USN'
  | 'UYI'
  | 'UYU'
  | 'UYW'
  | 'UZS'
  | 'VES'
  | 'VND'
  | 'VUV'
  | 'WST'
  | 'XAF'
  | 'XAG'
  | 'XAU'
  | 'XBA'
  | 'XBB'
  | 'XBC'
  | 'XBD'
  | 'XCD'
  | 'XDR'
  | 'XOF'
  | 'XPD'
  | 'XPF'
  | 'XPT'
  | 'XSU'
  | 'XTS'
  | 'XUA'
  | 'XXX'
  | 'YER'
  | 'ZAR'
  | 'ZMW'
  | 'ZWL';

export type RmDailyDispenseLimitDto = {
  __typename?: 'RmDailyDispenseLimitDto';
  amountList?: Maybe<Array<Maybe<RmAmountDto>>>;
  dayBreakHour?: Maybe<Scalars['Int']>;
  ident?: Maybe<Scalars['String']>;
  nodeId?: Maybe<Scalars['String']>;
};

export type RmDailyDispenseLimitSettingsDto = {
  __typename?: 'RmDailyDispenseLimitSettingsDto';
  canExceedInitial?: Maybe<Scalars['Boolean']>;
  dailyDispenseLimits?: Maybe<RmDailyDispenseLimitsDto>;
  dayBreakHour?: Maybe<Scalars['Int']>;
  nodeId?: Maybe<Scalars['String']>;
  transactionTypesAffectingLimits?: Maybe<RmTransactionTypesAffectingLimitsDto>;
};

export type RmDailyDispenseLimitsDto = {
  __typename?: 'RmDailyDispenseLimitsDto';
  machine?: Maybe<Array<Maybe<RmDailyDispenseLimitDto>>>;
  nodeId?: Maybe<Scalars['String']>;
  role?: Maybe<Array<Maybe<RmDailyDispenseLimitDto>>>;
  user?: Maybe<Array<Maybe<RmDailyDispenseLimitDto>>>;
  workUnit?: Maybe<Array<Maybe<RmDailyDispenseLimitDto>>>;
};

export type RmDayBreakDto = {
  __typename?: 'RmDayBreakDto';
  hour?: Maybe<Scalars['Int']>;
  minute?: Maybe<Scalars['Int']>;
  nodeId?: Maybe<Scalars['String']>;
};

export type RmDeviceDto = {
  __typename?: 'RmDeviceDto';
  deviceInfo?: Maybe<RmInfoDto>;
  id?: Maybe<Scalars['String']>;
  nodeId?: Maybe<Scalars['String']>;
  sensorInfo?: Maybe<RmInfoDto>;
};

export type RmDeviceMovementDto = {
  __typename?: 'RmDeviceMovementDto';
  boxMovements?: Maybe<Array<Maybe<RmBoxMovementDto>>>;
  deviceId?: Maybe<Scalars['String']>;
  nodeId?: Maybe<Scalars['String']>;
};

export type RmDoorDto = {
  __typename?: 'RmDoorDto';
  name?: Maybe<Scalars['String']>;
  nodeId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type RmErrorDto = RmHeaderDto & {
  __typename?: 'RmErrorDto';
  cleared?: Maybe<Scalars['Boolean']>;
  dateTime?: Maybe<Scalars['ZonedDateTime']>;
  deviceErrorCode?: Maybe<Scalars['String']>;
  deviceId?: Maybe<Scalars['String']>;
  errorArgs?: Maybe<Array<Maybe<Scalars['String']>>>;
  errorId?: Maybe<Scalars['String']>;
  errorKey?: Maybe<Scalars['String']>;
  information?: Maybe<Scalars['String']>;
  jxfsErrorCode?: Maybe<Scalars['Int']>;
  kind?: Maybe<Scalars['String']>;
  licenseId?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  machineId?: Maybe<Scalars['String']>;
  machineType?: Maybe<Scalars['String']>;
  md5?: Maybe<Scalars['String']>;
  messageSequence?: Maybe<Scalars['Long']>;
  messageType?: Maybe<Scalars['String']>;
  /** RmHeaderDto fields: */
  nodeId?: Maybe<Scalars['String']>;
  receivedDateTime?: Maybe<Scalars['ZonedDateTime']>;
  receiver?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['Long']>;
  severity?: Maybe<Scalars['String']>;
  timeZoneUtcOffset?: Maybe<Scalars['ZoneId']>;
  uuid?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type RmErrorKind =
  | 'Busy'
  | 'Communication'
  | 'Configuration'
  | 'Discrepancy'
  | 'IO'
  | 'InputOverLimit'
  | 'Jam'
  | 'Malfunction'
  | 'Other'
  | 'Power'
  | 'RemoteUpdate'
  | 'Statistics'
  | 'ThresholdEmpty'
  | 'ThresholdFull'
  | 'Unknown';

export type RmFirmwareUpgradeDto = {
  __typename?: 'RmFirmwareUpgradeDto';
  nodeId?: Maybe<Scalars['String']>;
  rmTemplate?: Maybe<RmTemplateDto>;
};

export type RmFirmwareVersionDto = {
  __typename?: 'RmFirmwareVersionDto';
  firmware?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nodeId?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type RmFirmwareVersionsDto = {
  __typename?: 'RmFirmwareVersionsDto';
  current?: Maybe<Array<Maybe<RmFirmwareVersionDto>>>;
  nodeId?: Maybe<Scalars['String']>;
  waiting?: Maybe<Array<Maybe<RmFirmwareVersionDto>>>;
};

export type RmHeaderDto = {
  dateTime?: Maybe<Scalars['ZonedDateTime']>;
  licenseId?: Maybe<Scalars['String']>;
  machineId?: Maybe<Scalars['String']>;
  machineType?: Maybe<Scalars['String']>;
  md5?: Maybe<Scalars['String']>;
  messageSequence?: Maybe<Scalars['Long']>;
  messageType?: Maybe<Scalars['String']>;
  nodeId?: Maybe<Scalars['String']>;
  receivedDateTime?: Maybe<Scalars['ZonedDateTime']>;
  receiver?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['Long']>;
  timeZoneUtcOffset?: Maybe<Scalars['ZoneId']>;
  uuid?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type RmIdentifyDto = RmHeaderDto & {
  __typename?: 'RmIdentifyDto';
  alarm?: Maybe<Scalars['Boolean']>;
  dateTime?: Maybe<Scalars['ZonedDateTime']>;
  licenseId?: Maybe<Scalars['String']>;
  machineId?: Maybe<Scalars['String']>;
  machineType?: Maybe<Scalars['String']>;
  md5?: Maybe<Scalars['String']>;
  messageSequence?: Maybe<Scalars['Long']>;
  messageType?: Maybe<Scalars['String']>;
  /** RmHeaderDto fields: */
  nodeId?: Maybe<Scalars['String']>;
  receivedDateTime?: Maybe<Scalars['ZonedDateTime']>;
  receiver?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['Long']>;
  timeZoneUtcOffset?: Maybe<Scalars['ZoneId']>;
  user?: Maybe<RmUserDto>;
  uuid?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type RmInfoDto = {
  __typename?: 'RmInfoDto';
  accType?: Maybe<Scalars['String']>;
  firmware?: Maybe<Scalars['String']>;
  hardware?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nodeId?: Maybe<Scalars['String']>;
  protocol?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type RmMixDto = {
  __typename?: 'RmMixDto';
  mixDisplayName?: Maybe<Scalars['String']>;
  mixEdited?: Maybe<Scalars['Boolean']>;
  mixName?: Maybe<Scalars['String']>;
  nodeId?: Maybe<Scalars['String']>;
};

export type RmPairDto = {
  __typename?: 'RmPairDto';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type RmRoleDto = {
  __typename?: 'RmRoleDto';
  nodeId?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Scalars['String']>>>;
  roleId?: Maybe<Scalars['String']>;
};

export type RmSettingsDto = {
  __typename?: 'RmSettingsDto';
  nodeId?: Maybe<Scalars['String']>;
  setConfigurationUpdate?: Maybe<RmConfigurationVersionsOrUpdateDto>;
  setDayBreak?: Maybe<RmDayBreakDto>;
  setDispenseLimit?: Maybe<RmDailyDispenseLimitDto>;
  setDispenseLimitSettings?: Maybe<RmDailyDispenseLimitSettingsDto>;
  setExchangeRates?: Maybe<Scalars['String']>;
  setFirmwareUpgrade?: Maybe<RmConfigurationVersionsOrUpgradeDto>;
  setRoles?: Maybe<Array<Maybe<RmRoleDto>>>;
  setWorkUnitAllocations?: Maybe<Array<Maybe<RmPairDto>>>;
  setWorkUnits?: Maybe<Array<Maybe<RmWorkUnitDataDto>>>;
};

export type RmSeverity =
  | 'Error'
  | 'Warning';

export type RmSystemStatusDto = RmHeaderDto & {
  __typename?: 'RmSystemStatusDto';
  capabilities?: Maybe<Array<Maybe<Scalars['String']>>>;
  code?: Maybe<Scalars['String']>;
  configurationVersion?: Maybe<Array<Maybe<RmPairDto>>>;
  dateTime?: Maybe<Scalars['ZonedDateTime']>;
  devices?: Maybe<Array<Maybe<RmDeviceDto>>>;
  dispenseLimitSettings?: Maybe<RmDailyDispenseLimitSettingsDto>;
  door?: Maybe<RmDoorDto>;
  doors?: Maybe<Array<Maybe<RmDoorDto>>>;
  fileVersion?: Maybe<Array<Maybe<RmPairDto>>>;
  info?: Maybe<Scalars['String']>;
  licenseId?: Maybe<Scalars['String']>;
  machineId?: Maybe<Scalars['String']>;
  machineType?: Maybe<Scalars['String']>;
  md5?: Maybe<Scalars['String']>;
  messageSequence?: Maybe<Scalars['Long']>;
  messageType?: Maybe<Scalars['String']>;
  /** RmHeaderDto fields: */
  nodeId?: Maybe<Scalars['String']>;
  oldStatus?: Maybe<Scalars['String']>;
  passwdFormat?: Maybe<Scalars['String']>;
  receivedDateTime?: Maybe<Scalars['ZonedDateTime']>;
  receiver?: Maybe<Scalars['String']>;
  remotelyClaimed?: Maybe<Scalars['Boolean']>;
  roles?: Maybe<Array<Maybe<RmRoleDto>>>;
  sequence?: Maybe<Scalars['Long']>;
  serviceCounters?: Maybe<Array<Maybe<RmCounterDto>>>;
  settings?: Maybe<RmSettingsDto>;
  showUserInfo?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
  targetLevels?: Maybe<Array<Maybe<RmValueDto>>>;
  timeZoneUtcOffset?: Maybe<Scalars['ZoneId']>;
  uuid?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
  workUnits?: Maybe<Array<Maybe<RmWorkUnitDataDto>>>;
};

export type RmTemplateDto = {
  __typename?: 'RmTemplateDto';
  keyForLink?: Maybe<Scalars['String']>;
  linkToPackage?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nodeId?: Maybe<Scalars['String']>;
  parts?: Maybe<Array<Maybe<Scalars['String']>>>;
  passwordForLink?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type RmTransactionDto = RmHeaderDto & {
  __typename?: 'RmTransactionDto';
  accountingDate?: Maybe<Scalars['ZonedDateTime']>;
  allocationAdded?: Maybe<RmAllocationDto>;
  allocationRemoved?: Maybe<RmAllocationDto>;
  boxDeposit?: Maybe<Scalars['Long']>;
  cardBalance?: Maybe<Scalars['Long']>;
  cardLoaded?: Maybe<Scalars['Long']>;
  checksum?: Maybe<Scalars['String']>;
  commission?: Maybe<Scalars['Long']>;
  currency?: Maybe<Scalars['String']>;
  customData?: Maybe<Array<Maybe<RmPairDto>>>;
  dateTime?: Maybe<Scalars['ZonedDateTime']>;
  decimals?: Maybe<Scalars['Int']>;
  deviceMovements?: Maybe<Array<Maybe<RmDeviceMovementDto>>>;
  expectedAmounts?: Maybe<Array<Maybe<RmAmountDto>>>;
  licenseId?: Maybe<Scalars['String']>;
  machineId?: Maybe<Scalars['String']>;
  machineType?: Maybe<Scalars['String']>;
  md5?: Maybe<Scalars['String']>;
  messageSequence?: Maybe<Scalars['Long']>;
  messageType?: Maybe<Scalars['String']>;
  mixDisplayName?: Maybe<Scalars['String']>;
  mixEdited?: Maybe<Scalars['Boolean']>;
  mixName?: Maybe<Scalars['String']>;
  /** RmHeaderDto fields: */
  nodeId?: Maybe<Scalars['String']>;
  notesToBox?: Maybe<Scalars['Int']>;
  receivedDateTime?: Maybe<Scalars['ZonedDateTime']>;
  receiver?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['String']>;
  referenceUuid?: Maybe<Scalars['String']>;
  requestedAmounts?: Maybe<Array<Maybe<RmAmountDto>>>;
  sequence?: Maybe<Scalars['Long']>;
  strapSeals?: Maybe<Array<Maybe<Scalars['String']>>>;
  subMixes?: Maybe<Array<Maybe<RmMixDto>>>;
  subType?: Maybe<Scalars['String']>;
  timeZoneUtcOffset?: Maybe<Scalars['ZoneId']>;
  totalAmount?: Maybe<Scalars['Float']>;
  transactionInfo?: Maybe<Array<Maybe<Scalars['String']>>>;
  transactionSeq?: Maybe<Scalars['Long']>;
  transactionUuid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  user?: Maybe<RmUserDto>;
  uuid?: Maybe<Scalars['String']>;
  valueBags?: Maybe<Array<Maybe<RmValueBagDto>>>;
  version?: Maybe<Scalars['String']>;
};

export type RmTransactionSubType =
  | 'CHANGE'
  | 'DISPENSE_RETURN'
  | 'DISPENSE_SURPLUS'
  | 'EXPECTED_AMOUNT'
  | 'IN'
  | 'OUT'
  | 'REQUESTED_AMOUNT'
  | 'SALE';

export type RmTransactionType =
  | 'DEPOSIT'
  | 'DISPENSE'
  | 'EMPTY_OUT'
  | 'END_OF_SHIFT'
  | 'EXCHANGE'
  | 'MANUAL_REFILL'
  | 'POSSIBLE_TAMPERING'
  | 'PURGE'
  | 'REFILL'
  | 'UNFINISHED_TRANSACTION';

export type RmTransactionTypesAffectingLimitsDto = {
  __typename?: 'RmTransactionTypesAffectingLimitsDto';
  machine?: Maybe<Array<Maybe<Scalars['String']>>>;
  nodeId?: Maybe<Scalars['String']>;
  reset?: Maybe<Array<Maybe<Scalars['String']>>>;
  user?: Maybe<Array<Maybe<Scalars['String']>>>;
  workUnit?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type RmUserDto = {
  __typename?: 'RmUserDto';
  accounts?: Maybe<Array<Maybe<RmAccountDto>>>;
  cardIdentifier?: Maybe<Scalars['String']>;
  cardTrack?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  originatingUser?: Maybe<Scalars['String']>;
  originatingUserFull?: Maybe<RmUserDto>;
  roleName?: Maybe<Scalars['String']>;
  secondaryUser?: Maybe<Scalars['String']>;
  secondaryUserFull?: Maybe<RmUserDto>;
  userId?: Maybe<Scalars['String']>;
  workUnit?: Maybe<RmWorkUnitDto>;
  workUnitName?: Maybe<Scalars['String']>;
};

export type RmValueBagDto = {
  __typename?: 'RmValueBagDto';
  nodeId?: Maybe<Scalars['String']>;
  rejects?: Maybe<Scalars['Int']>;
  totalAmount?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
  values?: Maybe<Array<Maybe<RmValueDto>>>;
};

export type RmValueDto = {
  __typename?: 'RmValueDto';
  c2Count?: Maybe<Scalars['Int']>;
  c3Count?: Maybe<Scalars['Int']>;
  c4bCount?: Maybe<Scalars['Int']>;
  claimedValueType?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  creditCat2?: Maybe<Scalars['Boolean']>;
  creditCat3?: Maybe<Scalars['Boolean']>;
  currency?: Maybe<Scalars['String']>;
  customType?: Maybe<Scalars['String']>;
  decimals?: Maybe<Scalars['Int']>;
  denomination?: Maybe<Scalars['Int']>;
  exchangeRate?: Maybe<Scalars['Int']>;
  exchangeRateDecimals?: Maybe<Scalars['Int']>;
  nodeId?: Maybe<Scalars['String']>;
  pieceValue?: Maybe<Scalars['Int']>;
  reference?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Long']>;
  type?: Maybe<Scalars['String']>;
};

export type RmWorkUnitDataDto = {
  __typename?: 'RmWorkUnitDataDto';
  children?: Maybe<Array<Maybe<RmWorkUnitDataDto>>>;
  displayName?: Maybe<Scalars['String']>;
  moneyMixes?: Maybe<Array<Maybe<Scalars['String']>>>;
  name?: Maybe<Scalars['String']>;
  nodeId?: Maybe<Scalars['String']>;
  parent?: Maybe<Scalars['String']>;
  roleIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type RmWorkUnitDto = {
  __typename?: 'RmWorkUnitDto';
  displayName?: Maybe<Scalars['String']>;
  ignoreAllocationDayBreak?: Maybe<Scalars['Boolean']>;
  isMoneyMover?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  nodeId?: Maybe<Scalars['String']>;
  parent?: Maybe<RmWorkUnitDto>;
};

export type RmZReportDto = RmHeaderDto & {
  __typename?: 'RmZReportDto';
  accountingDate?: Maybe<Scalars['DateTime']>;
  cashValues?: Maybe<Array<Maybe<RmCashAmountDto>>>;
  cashierInfo?: Maybe<RmCashierInfoDto>;
  currency?: Maybe<Scalars['String']>;
  dateTime?: Maybe<Scalars['ZonedDateTime']>;
  indexer?: Maybe<Scalars['String']>;
  licenseId?: Maybe<Scalars['String']>;
  machineId?: Maybe<Scalars['String']>;
  machineType?: Maybe<Scalars['String']>;
  md5?: Maybe<Scalars['String']>;
  messageSequence?: Maybe<Scalars['Long']>;
  messageType?: Maybe<Scalars['String']>;
  /** RmHeaderDto fields: */
  nodeId?: Maybe<Scalars['String']>;
  nonCashValues?: Maybe<Array<Maybe<RmCashAmountDto>>>;
  outlet?: Maybe<Scalars['String']>;
  receivedDateTime?: Maybe<Scalars['ZonedDateTime']>;
  receiver?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['Long']>;
  shiftDateTime?: Maybe<Scalars['DateTime']>;
  siteId?: Maybe<Scalars['String']>;
  timeZoneUtcOffset?: Maybe<Scalars['ZoneId']>;
  useInitialBank?: Maybe<Scalars['Boolean']>;
  uuid?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
  workUnitId?: Maybe<Scalars['String']>;
  workUnitName?: Maybe<Scalars['String']>;
};

export type Rules = {
  __typename?: 'Rules';
  filters?: Maybe<AbstractFilter>;
  name?: Maybe<Scalars['String']>;
  nodeId?: Maybe<Scalars['String']>;
  recipients?: Maybe<Array<Maybe<RecipientData>>>;
  tenantId?: Maybe<Scalars['String']>;
};

export type RulesDto = {
  filters?: InputMaybe<AbstractFilterDto>;
  name: Scalars['String'];
  nodeId?: InputMaybe<Scalars['String']>;
  recipients: Array<InputMaybe<RecipientDataDto>>;
};

export type S3PreSignedData = {
  __typename?: 'S3PreSignedData';
  urlForDelete?: Maybe<Scalars['String']>;
  urlForGet?: Maybe<Scalars['String']>;
  urlForPut?: Maybe<Scalars['String']>;
};

export type ScheduledReportDtoIn = {
  fileType: FileType;
  inputPayload?: InputMaybe<Scalars['String']>;
  instanceName: Scalars['String'];
  locationNodeIds: Array<InputMaybe<Scalars['String']>>;
  machineNodeIds: Array<InputMaybe<Scalars['String']>>;
  metadata?: InputMaybe<MetadataDtoIn>;
  nodeId?: InputMaybe<Scalars['String']>;
  reportEmails: Array<InputMaybe<ScheduledReportEmailIn>>;
  reportName?: InputMaybe<ScheduledReportName>;
};

export type ScheduledReportDtoOut = Dto & {
  __typename?: 'ScheduledReportDtoOut';
  fileType: FileType;
  inputPayload?: Maybe<Scalars['String']>;
  instanceName: Scalars['String'];
  locationNodeIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  machineNodeIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  metadata?: Maybe<MetadataDtoOut>;
  nextExecution?: Maybe<Scalars['DateTime']>;
  nodeChangeDate?: Maybe<Scalars['DateTime']>;
  nodeId?: Maybe<Scalars['String']>;
  nodeStatus?: Maybe<NodeStatus>;
  reportEmails: Array<Maybe<ScheduledReportEmailOut>>;
  reportName?: Maybe<ScheduledReportName>;
  status?: Maybe<ScheduledReportStatus>;
};

export type ScheduledReportEmailIn = {
  email: Scalars['String'];
  subject: Scalars['String'];
};

export type ScheduledReportEmailOut = {
  __typename?: 'ScheduledReportEmailOut';
  email: Scalars['String'];
  subject?: Maybe<Scalars['String']>;
};

export type ScheduledReportName =
  | 'BoxTotalsByCurrency'
  | 'CashInventoryReport'
  | 'CashOperationsReport'
  | 'CashSummaryReport'
  | 'ClaimedValuesReport'
  | 'MachineDetailsReport'
  | 'MachineErrorsReport'
  | 'MachineUserTransactionsReport'
  | 'ManualDepositsReport'
  | 'NetCashReport'
  | 'OpenShiftReport'
  | 'RefillReport'
  | 'TransactionsReport';

export type ScheduledReportStatus =
  | 'ACTIVE'
  | 'EXPIRED';

export type SchemaChecksum =
  | 'SHA256_0ddf5ef1c854c71ca2552faed4e8eaf280296852512dc44a8afd5009d847815e'
  | 'SHA256_2616d553264433efc4bb2b723b7bceef657bc7112402528924725e2a8413a151'
  | 'SHA256_3559d0ee413020ff3525f9f63236c59c006158c554c6833772d6ce7e88906d55'
  | 'SHA256_d12de295b02249da526fb71c776a5928ff9459cd289edc1eeee3b00180ec62e4'
  | 'SHA256_ebfb9c256a79cde983dd1e0094613e90c673ed5d7ac023da9fdd4a7aaf1af554';

export type SearchRequestDto = {
  page: Scalars['Int'];
  size: Scalars['Int'];
  sort?: InputMaybe<Array<InputMaybe<SortDto>>>;
};

export type SearchResultDto = {
  __typename?: 'SearchResultDto';
  fullSize?: Maybe<Scalars['Long']>;
  result?: Maybe<Array<Maybe<Dto>>>;
};

export type ShiftDtoIn = {
  active?: InputMaybe<Scalars['String']>;
  circulatingCash?: InputMaybe<ValueDtoIn>;
  circulatingCashList?: InputMaybe<Array<InputMaybe<ValueDtoIn>>>;
  endDateTime?: InputMaybe<Scalars['DateTime']>;
  machineUuid?: InputMaybe<Scalars['String']>;
  startDateTime?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type ShiftDtoOut = {
  __typename?: 'ShiftDtoOut';
  active?: Maybe<Scalars['String']>;
  circulatingCash?: Maybe<ValueDtoOut>;
  circulatingCashList?: Maybe<Array<Maybe<ValueDtoOut>>>;
  endDateTime?: Maybe<Scalars['String']>;
  machineUuid?: Maybe<Scalars['String']>;
  startDateTime?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type SingleExecutionDtoOut = Dto & {
  __typename?: 'SingleExecutionDtoOut';
  enableRetry?: Maybe<Scalars['Boolean']>;
  executionEnd?: Maybe<Scalars['DateTime']>;
  executionStart?: Maybe<Scalars['DateTime']>;
  nodeChangeDate?: Maybe<Scalars['DateTime']>;
  nodeId?: Maybe<Scalars['String']>;
  nodeStatus?: Maybe<NodeStatus>;
  report?: Maybe<ScheduledReportDtoOut>;
  status?: Maybe<ReportExecutionStatus>;
};

export type SingleExecutionFiltersDto = {
  executionStartFrom?: InputMaybe<Scalars['DateTime']>;
  executionStartTo?: InputMaybe<Scalars['DateTime']>;
  executionStatuses?: InputMaybe<Array<InputMaybe<ReportExecutionStatus>>>;
  nodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SmartLocationGroupDtoIn = {
  authorizedUsers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cities?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countries?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  locationNodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name: Scalars['String'];
  nodeId?: InputMaybe<Scalars['String']>;
};

export type SmartLocationGroupDtoOut = Dto & {
  __typename?: 'SmartLocationGroupDtoOut';
  authorizedUsers?: Maybe<Array<Maybe<Scalars['String']>>>;
  cities?: Maybe<Array<Maybe<Scalars['String']>>>;
  citiesCount?: Maybe<Scalars['Int']>;
  countries?: Maybe<Array<Maybe<Scalars['String']>>>;
  countriesCount?: Maybe<Scalars['Int']>;
  locations?: Maybe<Array<Maybe<LocationDtoOut>>>;
  locationsCount?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  nodeChangeDate?: Maybe<Scalars['DateTime']>;
  nodeId?: Maybe<Scalars['String']>;
  nodeStatus?: Maybe<NodeStatus>;
};

export type SoftwareInstallationDtoIn = {
  createdBy: Scalars['String'];
  machineUuids: Array<InputMaybe<Scalars['String']>>;
  scheduleInfo: Scalars['String'];
  softwarePackageNodeId: Scalars['String'];
};

export type SoftwareInstallationDtoOut = {
  __typename?: 'SoftwareInstallationDtoOut';
  createdBy?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['DateTime']>;
  machineNodeId?: Maybe<Scalars['String']>;
  nodeId?: Maybe<Scalars['String']>;
  scheduleInfo?: Maybe<Scalars['String']>;
  softwarePackage?: Maybe<SoftwarePackageDtoOut>;
  state?: Maybe<Scalars['String']>;
  stateChangedDate?: Maybe<Scalars['DateTime']>;
};

export type SoftwarePackageDtoIn = {
  common?: InputMaybe<Scalars['Boolean']>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdDate?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  parts?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productName?: InputMaybe<Scalars['String']>;
  releaseInfo?: InputMaybe<Scalars['String']>;
  revision?: InputMaybe<Scalars['String']>;
  version: Scalars['String'];
};

export type SoftwarePackageDtoOut = Dto & {
  __typename?: 'SoftwarePackageDtoOut';
  common?: Maybe<Scalars['Boolean']>;
  createdBy?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nodeChangeDate?: Maybe<Scalars['DateTime']>;
  nodeId?: Maybe<Scalars['String']>;
  nodeStatus?: Maybe<NodeStatus>;
  originUri?: Maybe<Scalars['String']>;
  parts?: Maybe<Array<Maybe<Scalars['String']>>>;
  productName?: Maybe<Scalars['String']>;
  releaseInfo?: Maybe<Scalars['String']>;
  revision?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type SoftwarePackageFiltersDto = {
  createdBy?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  releaseInfo?: InputMaybe<Scalars['String']>;
  revision?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['String']>;
};

export type Sort = {
  direction?: InputMaybe<Scalars['String']>;
  properties: Array<InputMaybe<Scalars['String']>>;
};

export type SortDto = {
  fieldName: Scalars['String'];
  order: Order;
};

export type State =
  | 'CANCELED'
  | 'CANCELING'
  | 'DONE'
  | 'FAILED'
  | 'PENDING'
  | 'SENT'
  | 'TIMEOUT'
  | 'WAITING';

export type StringToStringList = {
  __typename?: 'StringToStringList';
  key: Scalars['String'];
  value?: Maybe<Array<Scalars['String']>>;
};

export type SubscriptionDto = {
  __typename?: 'SubscriptionDto';
  activationDate?: Maybe<Scalars['DateTime']>;
  billingIntervals?: Maybe<Array<Maybe<BillingIntervalDto>>>;
  createdDate?: Maybe<Scalars['DateTime']>;
  effectiveBillingDate?: Maybe<Scalars['DateTime']>;
  isLicensedPerDevice?: Maybe<Scalars['Boolean']>;
  module?: Maybe<ModuleDto>;
  nodeId?: Maybe<Scalars['String']>;
  paymentIntervalType?: Maybe<PaymentIntervalType>;
  status?: Maybe<SubscriptionStatus>;
  tenant?: Maybe<Scalars['String']>;
  terminatedDate?: Maybe<Scalars['DateTime']>;
  terminatingDate?: Maybe<Scalars['DateTime']>;
};

export type SubscriptionStatus =
  | 'ACTIVE'
  | 'INACTIVE'
  | 'TERMINATED'
  | 'TERMINATING';

export type SummaryGrandTotalDto = {
  __typename?: 'SummaryGrandTotalDto';
  claimedValueTotal?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  grandTotal?: Maybe<Scalars['String']>;
  machineTotal?: Maybe<Scalars['String']>;
  openShiftTotal?: Maybe<Scalars['String']>;
};

export type TemplateDtoIn = {
  createdBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
  name: Scalars['String'];
  parts?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  version?: InputMaybe<Scalars['String']>;
};

export type TemplateDtoOut = Dto & {
  __typename?: 'TemplateDtoOut';
  createdBy?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  fileName: Scalars['String'];
  name: Scalars['String'];
  nodeChangeDate?: Maybe<Scalars['DateTime']>;
  nodeId: Scalars['String'];
  nodeStatus?: Maybe<NodeStatus>;
  parts?: Maybe<Array<Maybe<Scalars['String']>>>;
  version?: Maybe<Scalars['String']>;
};

export type TemplateFiltersDto = {
  fileName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  version?: InputMaybe<Scalars['String']>;
};

export type TenantDtoIn = {
  allowedLicenseFeatureKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  billingId: Scalars['String'];
  contractNumber: Scalars['String'];
  endOfDay?: InputMaybe<Scalars['Time']>;
  licenseAutoRenewalEnabled?: InputMaybe<Scalars['Boolean']>;
  licenseValidityIntervalDays?: InputMaybe<Scalars['Int']>;
  machineTypes: Array<InputMaybe<MachineTypePatternDtoIn>>;
  name?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['String'];
};

export type TenantDtoOut = {
  __typename?: 'TenantDtoOut';
  allowedLicenseFeatureKeys?: Maybe<Array<Maybe<Scalars['String']>>>;
  billingId?: Maybe<Scalars['String']>;
  contractNumber?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['String']>;
  endOfDay?: Maybe<Scalars['Time']>;
  licenseAutoRenewalEnabled?: Maybe<Scalars['Boolean']>;
  licenseValidityIntervalDays?: Maybe<Scalars['Int']>;
  machineTypes?: Maybe<Array<Maybe<MachineTypeDto>>>;
  name?: Maybe<Scalars['String']>;
  nodeChangeDate?: Maybe<Scalars['DateTime']>;
  nodeId?: Maybe<Scalars['String']>;
  nodeStatus?: Maybe<NodeStatus>;
  tenantId?: Maybe<Scalars['String']>;
  updatedDate?: Maybe<Scalars['String']>;
};

export type TenantFeaturesDto = {
  __typename?: 'TenantFeaturesDto';
  commonSoftwarePackageUploadEnabled?: Maybe<Scalars['Boolean']>;
  mumEnabled?: Maybe<Scalars['Boolean']>;
  mumXmlImportEnabled?: Maybe<Scalars['Boolean']>;
  userBalanceEnabled?: Maybe<Scalars['Boolean']>;
};

export type TenantFeaturesDtoIn = {
  commonSoftwarePackageUploadEnabled?: InputMaybe<Scalars['Boolean']>;
  mumEnabled?: InputMaybe<Scalars['Boolean']>;
  mumXmlImportEnabled?: InputMaybe<Scalars['Boolean']>;
  userBalanceEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type TenantMetadataDtoOut = {
  __typename?: 'TenantMetadataDtoOut';
  domainName?: Maybe<Scalars['String']>;
  nodeStatus?: Maybe<NodeStatus>;
  tenantId?: Maybe<Scalars['String']>;
  tenantName?: Maybe<Scalars['String']>;
};

export type TenantRetentionPolicyDto = {
  __typename?: 'TenantRetentionPolicyDto';
  active?: Maybe<Scalars['Boolean']>;
  fixedDelayInMillis?: Maybe<Scalars['Long']>;
  tenantId?: Maybe<Scalars['String']>;
};

export type TenantRetentionPolicyDtoIn = {
  active?: InputMaybe<Scalars['Boolean']>;
  fixedDelayInMillis?: InputMaybe<Scalars['Long']>;
};

export type TenantUpdateDtoIn = {
  endOfDay?: InputMaybe<Scalars['Time']>;
  name?: InputMaybe<Scalars['String']>;
};

export type TenantWithExistingUserDtoIn = {
  domainName: Scalars['String'];
  mqttPassword: Scalars['String'];
  tenantId: Scalars['String'];
  tenantName: Scalars['String'];
  userIsFromSuperDomain?: InputMaybe<Scalars['Boolean']>;
  userName: Scalars['String'];
};

export type TenantWithNewUserDtoIn = {
  createDomain: Scalars['Boolean'];
  domainName: Scalars['String'];
  isUserDtoIn: IsUserDtoIn;
  mqttPassword: Scalars['String'];
  tenantId: Scalars['String'];
  tenantName: Scalars['String'];
};

export type Tile = {
  __typename?: 'Tile';
  base64Image?: Maybe<Scalars['String']>;
  coordinateX: Scalars['Int'];
  coordinateY: Scalars['Int'];
  zoomLevel: Scalars['Int'];
};

export type TileDto = {
  base64Image?: InputMaybe<Scalars['String']>;
  coordinateX: Scalars['Int'];
  coordinateY: Scalars['Int'];
  zoomLevel: Scalars['Int'];
};

export type TileGrid = {
  __typename?: 'TileGrid';
  base64Image?: Maybe<Scalars['String']>;
  fromX: Scalars['Int'];
  fromY: Scalars['Int'];
  toX: Scalars['Int'];
  toY: Scalars['Int'];
  zoomLevel: Scalars['Int'];
};

export type TileGridDto = {
  base64Image?: InputMaybe<Scalars['String']>;
  fromX: Scalars['Int'];
  fromY: Scalars['Int'];
  toX: Scalars['Int'];
  toY: Scalars['Int'];
  zoomLevel: Scalars['Int'];
};

export type TimeFilter = AbstractFilter & {
  __typename?: 'TimeFilter';
  child?: Maybe<AbstractFilter>;
  filterType?: Maybe<FilterType>;
  fromTime?: Maybe<Scalars['Time']>;
  operationType?: Maybe<OperationType>;
  toTime?: Maybe<Scalars['Time']>;
};

export type TotalAmountsDto = {
  __typename?: 'TotalAmountsDto';
  boxContentNodeIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  totalAmounts?: Maybe<Array<Maybe<AmountDto>>>;
};

export type TransactionDateTime =
  | 'ACCOUNTING_DATE_TIME'
  | 'DATE_TIME'
  | 'RECEIVED_DATE_TIME';

export type TransactionType =
  | 'ALL'
  | 'CORRECTION_TRANSACTIONS'
  | 'MACHINE_TRANSACTIONS';

export type TransactionsReportCriteriaDtoIn = {
  account?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  fromDate: Scalars['DateTime'];
  limit: Scalars['Int'];
  locationNodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  machineNodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  machineUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  machineUserNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  messageType: TransactionType;
  order: Order;
  orderColumn?: InputMaybe<TransactionsReportOrderColumn>;
  queryTransactionBy: TransactionDateTime;
  reportName: ScheduledReportName;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sequence?: InputMaybe<Scalars['Long']>;
  siteGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  skip: Scalars['Int'];
  toDate: Scalars['DateTime'];
  transactionSeq?: InputMaybe<Scalars['Long']>;
  transactionSubType?: InputMaybe<Array<InputMaybe<RmTransactionSubType>>>;
  transactionType?: InputMaybe<Array<InputMaybe<RmTransactionType>>>;
  workUnit?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['ZoneId']>;
};

export type TransactionsReportOrderColumn =
  | 'ACCOUNT'
  | 'ACCOUNTING_DATE'
  | 'CARD_IDENTIFIER'
  | 'DATE'
  | 'LOCATION'
  | 'MACHINE'
  | 'ORIGIN_USER'
  | 'ORIGIN_USER_ACCOUNT'
  | 'ROLE'
  | 'SEQUENCE'
  | 'SUB_TYPE'
  | 'TRANSACTION_SEQ'
  | 'TYPE'
  | 'WORK_UNIT_NAME';

export type TransactionsReportRowDto = RmHeaderDto & {
  __typename?: 'TransactionsReportRowDto';
  account?: Maybe<Scalars['String']>;
  accountingDate?: Maybe<Scalars['ZonedDateTime']>;
  bagIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  cardIdentifier?: Maybe<Scalars['String']>;
  claimedValueTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  customData?: Maybe<Array<Maybe<RmPairDto>>>;
  dateTime?: Maybe<Scalars['ZonedDateTime']>;
  devices?: Maybe<Array<Maybe<Scalars['String']>>>;
  formattedAccountingDate?: Maybe<Scalars['String']>;
  formattedDateTime?: Maybe<Scalars['String']>;
  formattedReceivedDate?: Maybe<Scalars['String']>;
  licenseId?: Maybe<Scalars['String']>;
  locationName?: Maybe<Scalars['String']>;
  locationNodeId?: Maybe<Scalars['String']>;
  machineId?: Maybe<Scalars['String']>;
  machineName?: Maybe<Scalars['String']>;
  machineNodeId?: Maybe<Scalars['String']>;
  machineType?: Maybe<Scalars['String']>;
  machineUserId?: Maybe<Scalars['String']>;
  machineUserName?: Maybe<Scalars['String']>;
  md5?: Maybe<Scalars['String']>;
  messageSequence?: Maybe<Scalars['Long']>;
  messageType?: Maybe<Scalars['String']>;
  mixEdited?: Maybe<Scalars['Boolean']>;
  /** RmHeaderDto fields: */
  nodeId?: Maybe<Scalars['String']>;
  originUser?: Maybe<Scalars['String']>;
  originUserAccount?: Maybe<Scalars['String']>;
  receivedDateTime?: Maybe<Scalars['ZonedDateTime']>;
  receiver?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['String']>;
  roleName?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['Long']>;
  subType?: Maybe<Scalars['String']>;
  timeZoneUtcOffset?: Maybe<Scalars['ZoneId']>;
  totalAmounts?: Maybe<Array<Maybe<RmPairDto>>>;
  transactionInfo?: Maybe<Array<Maybe<Scalars['String']>>>;
  transactionSeq?: Maybe<Scalars['Long']>;
  /** transactionId */
  type?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
  valuesByDenomination?: Maybe<Array<Maybe<DenominationValueDto>>>;
  version?: Maybe<Scalars['String']>;
  workUnitName?: Maybe<Scalars['String']>;
};

export type TransportationOperationCriteriaDto = {
  currency: Scalars['String'];
  date: Scalars['DateTime'];
  locationNodeId?: InputMaybe<Scalars['String']>;
  machineNodeId?: InputMaybe<Scalars['String']>;
  queryTransactionBy: TransactionDateTime;
  rmTransactionType: RmTransactionType;
  transactionType: TransactionType;
  zoneId?: InputMaybe<Scalars['ZoneId']>;
};

export type TriggerType =
  | 'EMAIL'
  | 'SMS'
  | 'WEBHOOK'
  | 'WEBHOOK_SNS'
  | 'WEBHOOK_URL';

export type UserBalanceDtoOut = Dto & {
  __typename?: 'UserBalanceDtoOut';
  balance?: Maybe<Scalars['String']>;
  currencyCode?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['Date']>;
  machineUser?: Maybe<MachineUserDtoOut>;
  nodeChangeDate?: Maybe<Scalars['DateTime']>;
  nodeId?: Maybe<Scalars['String']>;
  nodeStatus?: Maybe<NodeStatus>;
};

export type UserBalanceFiltersDto = {
  currencyCode?: InputMaybe<Scalars['String']>;
  date: Scalars['Date'];
  userId?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
};

export type UserIdentifyRolOrGroupDtoOut = {
  __typename?: 'UserIdentifyRolOrGroupDtoOut';
  name?: Maybe<Scalars['String']>;
};

export type ValueDtoIn = {
  c2Count?: InputMaybe<Scalars['String']>;
  c3Count?: InputMaybe<Scalars['String']>;
  c4bCount?: InputMaybe<Scalars['String']>;
  claimedValueType?: InputMaybe<Scalars['String']>;
  count?: InputMaybe<Scalars['String']>;
  creditCat2?: InputMaybe<Scalars['String']>;
  creditCat3?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  customType?: InputMaybe<Scalars['String']>;
  decimals?: InputMaybe<Scalars['String']>;
  denomination?: InputMaybe<Scalars['String']>;
  exchangeRate?: InputMaybe<Scalars['String']>;
  exchangeRateDecimals?: InputMaybe<Scalars['String']>;
  pieceValue?: InputMaybe<Scalars['String']>;
  reference?: InputMaybe<Scalars['String']>;
  total?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type ValueDtoOut = {
  __typename?: 'ValueDtoOut';
  c2Count?: Maybe<Scalars['String']>;
  c3Count?: Maybe<Scalars['String']>;
  c4bCount?: Maybe<Scalars['String']>;
  claimedValueType?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['String']>;
  creditCat2?: Maybe<Scalars['String']>;
  creditCat3?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  customType?: Maybe<Scalars['String']>;
  decimals?: Maybe<Scalars['String']>;
  denomination?: Maybe<Scalars['String']>;
  exchangeRate?: Maybe<Scalars['String']>;
  exchangeRateDecimals?: Maybe<Scalars['String']>;
  pieceValue?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type WebhookFilter = AbstractFilter & {
  __typename?: 'WebhookFilter';
  accessKey?: Maybe<Scalars['String']>;
  child?: Maybe<AbstractFilter>;
  filterType?: Maybe<FilterType>;
  operationType?: Maybe<OperationType>;
  secretKey?: Maybe<Scalars['String']>;
  supportedMessageTypes?: Maybe<Array<Maybe<MessageType>>>;
  topic?: Maybe<Scalars['String']>;
  webhookMessageTrigger?: Maybe<MessageType>;
  webhookType?: Maybe<WebhookType>;
};

export type WebhookQuery = {
  fromDate: Scalars['DateTime'];
  fromMessageSequence?: InputMaybe<Scalars['Int']>;
  machineUuid: Scalars['String'];
  md5?: InputMaybe<Scalars['String']>;
  rulesNodeId: Scalars['String'];
  tenantId: Scalars['String'];
  toDate: Scalars['DateTime'];
  toMessageSequence?: InputMaybe<Scalars['Int']>;
  zoneId?: InputMaybe<Scalars['ZoneId']>;
};

export type WebhookType =
  | 'SNS'
  | 'URL';

export type AddMachineUsersToMachineUserGroupMutationVariables = Exact<{
  machineUserNodeIds: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  nodeId: Scalars['String'];
}>;


export type AddMachineUsersToMachineUserGroupMutation = { __typename?: 'Mutation', addMachineUsersToMachineUserGroup?: { __typename?: 'MachineUserGroupDtoOut', nodeId?: string | null, machineUsersCount?: number | null, machineUsers?: Array<{ __typename?: 'MachineUserDtoOut', nodeId?: string | null, name?: string | null, machineUserGroupNodeIds?: Array<string | null> | null } | null> | null } | null };

export type AddMachinesToMachineUserGroupMutationVariables = Exact<{
  machineNodeIds: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  nodeId: Scalars['String'];
}>;


export type AddMachinesToMachineUserGroupMutation = { __typename?: 'Mutation', addMachinesToMachineUserGroup?: { __typename?: 'MachineUserGroupDtoOut', nodeId?: string | null, machinesCount?: number | null, machines?: Array<{ __typename?: 'MachineDtoOut', nodeId?: string | null, name?: string | null } | null> | null } | null };

export type CreateDeploymentsMutationVariables = Exact<{
  deployment: DeploymentDtoIn;
}>;


export type CreateDeploymentsMutation = { __typename?: 'Mutation', createDeployments?: Array<{ __typename?: 'DeploymentDtoOut', createdBy?: string | null, current?: boolean | null, machineNodeId?: string | null, nodeId?: string | null, scheduleInfo?: string | null, state?: string | null, statusChangedDate?: Date | string | null, template?: { __typename?: 'TemplateDtoOut', nodeId: string } | null } | null> | null };

export type CreateMachineGroupMutationVariables = Exact<{
  input?: InputMaybe<MachineGroupDtoIn>;
}>;


export type CreateMachineGroupMutation = { __typename?: 'Mutation', createMachineGroup?: { __typename?: 'MachineGroupDtoOut', nodeId?: string | null, name?: string | null, nodeStatus?: NodeStatus | null, nodeChangeDate?: Date | string | null, machines?: Array<{ __typename?: 'MachineDtoOut', name?: string | null, uuid?: string | null, nodeId?: string | null } | null> | null } | null };

export type CreateMachineUserGroupMutationVariables = Exact<{
  input: MachineUserGroupDtoIn;
}>;


export type CreateMachineUserGroupMutation = { __typename?: 'Mutation', createMachineUserGroup?: { __typename?: 'MachineUserGroupDtoOut', nodeId?: string | null, name?: string | null, machinesCount?: number | null, machineUsersCount?: number | null, machines?: Array<{ __typename?: 'MachineDtoOut', nodeId?: string | null, name?: string | null, uuid?: string | null } | null> | null, machineUsers?: Array<{ __typename?: 'MachineUserDtoOut', nodeId?: string | null, name?: string | null } | null> | null } | null };

export type CreateSoftwareInstallationsMutationVariables = Exact<{
  softwareInstallation: SoftwareInstallationDtoIn;
}>;


export type CreateSoftwareInstallationsMutation = { __typename?: 'Mutation', createSoftwareInstallations?: Array<{ __typename?: 'SoftwareInstallationDtoOut', createdBy?: string | null, createdDate?: Date | string | null, machineNodeId?: string | null, nodeId?: string | null, stateChangedDate?: Date | string | null, scheduleInfo?: string | null, softwarePackage?: { __typename?: 'SoftwarePackageDtoOut', nodeId?: string | null } | null } | null> | null };

export type CreateSoftwarePackageMutationVariables = Exact<{
  input: SoftwarePackageDtoIn;
}>;


export type CreateSoftwarePackageMutation = { __typename?: 'Mutation', createSoftwarePackage?: { __typename?: 'SoftwarePackageDtoOut', nodeId?: string | null, common?: boolean | null, productName?: string | null, releaseInfo?: string | null, revision?: string | null, version?: string | null, createdBy?: string | null, createdDate?: Date | string | null, description?: string | null, fileName?: string | null, id?: string | null, label?: string | null, name?: string | null, originUri?: string | null } | null };

export type CreateTemplateMutationVariables = Exact<{
  template: TemplateDtoIn;
}>;


export type CreateTemplateMutation = { __typename?: 'Mutation', createTemplate?: { __typename?: 'TemplateDtoOut', nodeId: string, name: string, description?: string | null, version?: string | null, fileName: string, parts?: Array<string | null> | null } | null };

export type DeactivateLaneAllocationMutationVariables = Exact<{
  allocationNodeId: Scalars['String'];
}>;


export type DeactivateLaneAllocationMutation = { __typename?: 'Mutation', deactivateLaneAllocation?: boolean | null };

export type DeleteMachineGroupMutationVariables = Exact<{
  nodeId: Scalars['String'];
}>;


export type DeleteMachineGroupMutation = { __typename?: 'Mutation', deleteMachineGroup?: { __typename?: 'MachineGroupDtoOut', nodeId?: string | null, nodeStatus?: NodeStatus | null, nodeChangeDate?: Date | string | null, machines?: Array<{ __typename?: 'MachineDtoOut', uuid?: string | null, nodeId?: string | null } | null> | null } | null };

export type DeleteMachineUserGroupByNodeIdMutationVariables = Exact<{
  nodeId: Scalars['String'];
}>;


export type DeleteMachineUserGroupByNodeIdMutation = { __typename?: 'Mutation', deleteMachineUserGroupByNodeId?: { __typename?: 'MachineUserGroupDtoOut', nodeId?: string | null, name?: string | null } | null };

export type DeleteSmartLocationGroupMutationVariables = Exact<{
  nodeId?: InputMaybe<Scalars['String']>;
}>;


export type DeleteSmartLocationGroupMutation = { __typename?: 'Mutation', deleteSmartLocationGroup?: boolean | null };

export type DeleteSoftwarePackageMutationVariables = Exact<{
  nodeId: Scalars['String'];
}>;


export type DeleteSoftwarePackageMutation = { __typename?: 'Mutation', deleteSoftwarePackage?: boolean | null };

export type DeleteTemplateMutationVariables = Exact<{
  nodeId: Scalars['String'];
}>;


export type DeleteTemplateMutation = { __typename?: 'Mutation', deleteTemplate?: boolean | null };

export type FindAllCitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type FindAllCitiesQuery = { __typename?: 'Query', findAllCities?: Array<string | null> | null };

export type FindAllCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type FindAllCountriesQuery = { __typename?: 'Query', findAllCountries?: Array<string | null> | null };

export type FindAllLaneAllocationsQueryVariables = Exact<{
  searchRequest: SearchRequestDto;
  laneAllocationFilters?: InputMaybe<LaneAllocationFiltersDto>;
}>;


export type FindAllLaneAllocationsQuery = { __typename?: 'Query', findAllLaneAllocations?: { __typename?: 'SearchResultDto', fullSize?: number | null, result?: Array<{ __typename?: 'LaneAllocationDto', nodeId?: string | null, allocationId?: string | null, locationName?: string | null, workUnitName?: string | null, allocationDateTime?: string | null, expirationDateTime?: string | null, userName?: string | null, machineName?: string | null, active?: boolean | null } | { __typename?: 'LocationDtoOut' } | { __typename?: 'MachineDtoOut' } | { __typename?: 'MachineGroupDtoOut' } | { __typename?: 'MachineHistoryStatusDto' } | { __typename?: 'MachineOnlineStatusDto' } | { __typename?: 'MachineOnlineWithHistoryStatusDto' } | { __typename?: 'MachineUserDtoOut' } | { __typename?: 'MachineUserGroupDtoOut' } | { __typename?: 'MetadataDtoOut' } | { __typename?: 'OtaAuthorizationDto' } | { __typename?: 'OtaCodeDtoOut' } | { __typename?: 'ScheduledReportDtoOut' } | { __typename?: 'SingleExecutionDtoOut' } | { __typename?: 'SmartLocationGroupDtoOut' } | { __typename?: 'SoftwarePackageDtoOut' } | { __typename?: 'TemplateDtoOut' } | { __typename?: 'UserBalanceDtoOut' } | null> | null } | null };

export type FindAllLocationGroupsFilteredQueryVariables = Exact<{
  locationGroupFilters?: InputMaybe<LocationGroupFiltersDto>;
  searchRequest: SearchRequestDto;
}>;


export type FindAllLocationGroupsFilteredQuery = { __typename?: 'Query', findAllLocationGroupsFiltered?: { __typename?: 'SearchResultDto', fullSize?: number | null, result?: Array<{ __typename?: 'LaneAllocationDto' } | { __typename?: 'LocationDtoOut' } | { __typename?: 'MachineDtoOut' } | { __typename?: 'MachineGroupDtoOut' } | { __typename?: 'MachineHistoryStatusDto' } | { __typename?: 'MachineOnlineStatusDto' } | { __typename?: 'MachineOnlineWithHistoryStatusDto' } | { __typename?: 'MachineUserDtoOut' } | { __typename?: 'MachineUserGroupDtoOut' } | { __typename?: 'MetadataDtoOut' } | { __typename?: 'OtaAuthorizationDto' } | { __typename?: 'OtaCodeDtoOut' } | { __typename?: 'ScheduledReportDtoOut' } | { __typename?: 'SingleExecutionDtoOut' } | { __typename?: 'SmartLocationGroupDtoOut', nodeId?: string | null, name?: string | null, countries?: Array<string | null> | null, cities?: Array<string | null> | null, authorizedUsers?: Array<string | null> | null, locations?: Array<{ __typename?: 'LocationDtoOut', nodeId?: string | null, name?: string | null, nodeStatus?: NodeStatus | null } | null> | null } | { __typename?: 'SoftwarePackageDtoOut' } | { __typename?: 'TemplateDtoOut' } | { __typename?: 'UserBalanceDtoOut' } | null> | null } | null };

export type FindAllLocationGroupsFilteredCountsQueryVariables = Exact<{
  locationGroupFilters?: InputMaybe<LocationGroupFiltersDto>;
  searchRequest: SearchRequestDto;
}>;


export type FindAllLocationGroupsFilteredCountsQuery = { __typename?: 'Query', findAllLocationGroupsFiltered?: { __typename?: 'SearchResultDto', fullSize?: number | null, result?: Array<{ __typename?: 'LaneAllocationDto' } | { __typename?: 'LocationDtoOut' } | { __typename?: 'MachineDtoOut' } | { __typename?: 'MachineGroupDtoOut' } | { __typename?: 'MachineHistoryStatusDto' } | { __typename?: 'MachineOnlineStatusDto' } | { __typename?: 'MachineOnlineWithHistoryStatusDto' } | { __typename?: 'MachineUserDtoOut' } | { __typename?: 'MachineUserGroupDtoOut' } | { __typename?: 'MetadataDtoOut' } | { __typename?: 'OtaAuthorizationDto' } | { __typename?: 'OtaCodeDtoOut' } | { __typename?: 'ScheduledReportDtoOut' } | { __typename?: 'SingleExecutionDtoOut' } | { __typename?: 'SmartLocationGroupDtoOut', nodeId?: string | null, name?: string | null, authorizedUsers?: Array<string | null> | null, countriesCount?: number | null, citiesCount?: number | null, locationsCount?: number | null } | { __typename?: 'SoftwarePackageDtoOut' } | { __typename?: 'TemplateDtoOut' } | { __typename?: 'UserBalanceDtoOut' } | null> | null } | null };

export type FindAllMachineGroupsFilteredQueryVariables = Exact<{
  machineGroupFilters?: InputMaybe<MachineGroupFiltersDto>;
  searchRequest: SearchRequestDto;
}>;


export type FindAllMachineGroupsFilteredQuery = { __typename?: 'Query', findAllMachineGroupsFiltered?: { __typename?: 'SearchResultDto', fullSize?: number | null, result?: Array<{ __typename?: 'LaneAllocationDto' } | { __typename?: 'LocationDtoOut' } | { __typename?: 'MachineDtoOut' } | { __typename?: 'MachineGroupDtoOut', nodeId?: string | null, name?: string | null, nodeStatus?: NodeStatus | null, nodeChangeDate?: Date | string | null, machines?: Array<{ __typename?: 'MachineDtoOut', name?: string | null, uuid?: string | null, nodeId?: string | null } | null> | null } | { __typename?: 'MachineHistoryStatusDto' } | { __typename?: 'MachineOnlineStatusDto' } | { __typename?: 'MachineOnlineWithHistoryStatusDto' } | { __typename?: 'MachineUserDtoOut' } | { __typename?: 'MachineUserGroupDtoOut' } | { __typename?: 'MetadataDtoOut' } | { __typename?: 'OtaAuthorizationDto' } | { __typename?: 'OtaCodeDtoOut' } | { __typename?: 'ScheduledReportDtoOut' } | { __typename?: 'SingleExecutionDtoOut' } | { __typename?: 'SmartLocationGroupDtoOut' } | { __typename?: 'SoftwarePackageDtoOut' } | { __typename?: 'TemplateDtoOut' } | { __typename?: 'UserBalanceDtoOut' } | null> | null } | null };

export type FindAllMachineUserGroupsFilteredQueryVariables = Exact<{
  filters?: InputMaybe<MachineUserGroupFiltersDto>;
  searchRequest: SearchRequestDto;
}>;


export type FindAllMachineUserGroupsFilteredQuery = { __typename?: 'Query', findAllMachineUserGroupsFiltered?: { __typename?: 'SearchResultDto', fullSize?: number | null, result?: Array<{ __typename?: 'LaneAllocationDto', nodeId?: string | null } | { __typename?: 'LocationDtoOut', nodeId?: string | null } | { __typename?: 'MachineDtoOut', nodeId?: string | null } | { __typename?: 'MachineGroupDtoOut', nodeId?: string | null } | { __typename?: 'MachineHistoryStatusDto', nodeId?: string | null } | { __typename?: 'MachineOnlineStatusDto', nodeId?: string | null } | { __typename?: 'MachineOnlineWithHistoryStatusDto', nodeId?: string | null } | { __typename?: 'MachineUserDtoOut', nodeId?: string | null } | { __typename?: 'MachineUserGroupDtoOut', name?: string | null, nodeId?: string | null } | { __typename?: 'MetadataDtoOut', nodeId?: string | null } | { __typename?: 'OtaAuthorizationDto', nodeId?: string | null } | { __typename?: 'OtaCodeDtoOut', nodeId?: string | null } | { __typename?: 'ScheduledReportDtoOut', nodeId?: string | null } | { __typename?: 'SingleExecutionDtoOut', nodeId?: string | null } | { __typename?: 'SmartLocationGroupDtoOut', nodeId?: string | null } | { __typename?: 'SoftwarePackageDtoOut', nodeId?: string | null } | { __typename?: 'TemplateDtoOut', nodeId: string } | { __typename?: 'UserBalanceDtoOut', nodeId?: string | null } | null> | null } | null };

export type FindAllMachineUserGroupsFilteredCountsQueryVariables = Exact<{
  filters?: InputMaybe<MachineUserGroupFiltersDto>;
  searchRequest: SearchRequestDto;
}>;


export type FindAllMachineUserGroupsFilteredCountsQuery = { __typename?: 'Query', findAllMachineUserGroupsFiltered?: { __typename?: 'SearchResultDto', fullSize?: number | null, result?: Array<{ __typename?: 'LaneAllocationDto', nodeId?: string | null } | { __typename?: 'LocationDtoOut', nodeId?: string | null } | { __typename?: 'MachineDtoOut', nodeId?: string | null } | { __typename?: 'MachineGroupDtoOut', nodeId?: string | null } | { __typename?: 'MachineHistoryStatusDto', nodeId?: string | null } | { __typename?: 'MachineOnlineStatusDto', nodeId?: string | null } | { __typename?: 'MachineOnlineWithHistoryStatusDto', nodeId?: string | null } | { __typename?: 'MachineUserDtoOut', nodeId?: string | null } | { __typename?: 'MachineUserGroupDtoOut', name?: string | null, machinesCount?: number | null, machineUsersCount?: number | null, nodeId?: string | null } | { __typename?: 'MetadataDtoOut', nodeId?: string | null } | { __typename?: 'OtaAuthorizationDto', nodeId?: string | null } | { __typename?: 'OtaCodeDtoOut', nodeId?: string | null } | { __typename?: 'ScheduledReportDtoOut', nodeId?: string | null } | { __typename?: 'SingleExecutionDtoOut', nodeId?: string | null } | { __typename?: 'SmartLocationGroupDtoOut', nodeId?: string | null } | { __typename?: 'SoftwarePackageDtoOut', nodeId?: string | null } | { __typename?: 'TemplateDtoOut', nodeId: string } | { __typename?: 'UserBalanceDtoOut', nodeId?: string | null } | null> | null } | null };

export type FindAllSoftwarePackagesFilteredQueryVariables = Exact<{
  searchRequest: SearchRequestDto;
  softwarePackageFilters?: InputMaybe<SoftwarePackageFiltersDto>;
}>;


export type FindAllSoftwarePackagesFilteredQuery = { __typename?: 'Query', findAllSoftwarePackagesFiltered?: { __typename?: 'SearchResultDto', fullSize?: number | null, result?: Array<{ __typename?: 'LaneAllocationDto', nodeId?: string | null } | { __typename?: 'LocationDtoOut', nodeId?: string | null } | { __typename?: 'MachineDtoOut', nodeId?: string | null } | { __typename?: 'MachineGroupDtoOut', nodeId?: string | null } | { __typename?: 'MachineHistoryStatusDto', nodeId?: string | null } | { __typename?: 'MachineOnlineStatusDto', nodeId?: string | null } | { __typename?: 'MachineOnlineWithHistoryStatusDto', nodeId?: string | null } | { __typename?: 'MachineUserDtoOut', nodeId?: string | null } | { __typename?: 'MachineUserGroupDtoOut', nodeId?: string | null } | { __typename?: 'MetadataDtoOut', nodeId?: string | null } | { __typename?: 'OtaAuthorizationDto', nodeId?: string | null } | { __typename?: 'OtaCodeDtoOut', nodeId?: string | null } | { __typename?: 'ScheduledReportDtoOut', nodeId?: string | null } | { __typename?: 'SingleExecutionDtoOut', nodeId?: string | null } | { __typename?: 'SmartLocationGroupDtoOut', nodeId?: string | null } | { __typename?: 'SoftwarePackageDtoOut', id?: string | null, name?: string | null, productName?: string | null, version?: string | null, parts?: Array<string | null> | null, fileName?: string | null, revision?: string | null, label?: string | null, description?: string | null, originUri?: string | null, common?: boolean | null, releaseInfo?: string | null, createdBy?: string | null, createdDate?: Date | string | null, nodeId?: string | null } | { __typename?: 'TemplateDtoOut', nodeId: string } | { __typename?: 'UserBalanceDtoOut', nodeId?: string | null } | null> | null } | null };

export type FindCountriesToCitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type FindCountriesToCitiesQuery = { __typename?: 'Query', findCountriesToCities?: Array<{ __typename?: 'StringToStringList', key: string, value?: Array<string> | null } | null> | null };

export type FindMachineGroupByNodeIdQueryVariables = Exact<{
  nodeId: Scalars['String'];
}>;


export type FindMachineGroupByNodeIdQuery = { __typename?: 'Query', findMachineGroupByNodeId?: { __typename?: 'MachineGroupDtoOut', nodeId?: string | null, name?: string | null, nodeStatus?: NodeStatus | null, nodeChangeDate?: Date | string | null, machines?: Array<{ __typename?: 'MachineDtoOut', name?: string | null, uuid?: string | null, nodeId?: string | null } | null> | null } | null };

export type FindMachineUserGroupByNodeIdQueryVariables = Exact<{
  nodeId: Scalars['String'];
}>;


export type FindMachineUserGroupByNodeIdQuery = { __typename?: 'Query', findMachineUserGroupByNodeId?: { __typename?: 'MachineUserGroupDtoOut', nodeId?: string | null, name?: string | null, machinesCount?: number | null, machineUsersCount?: number | null, machines?: Array<{ __typename?: 'MachineDtoOut', nodeId?: string | null, name?: string | null, uuid?: string | null } | null> | null, machineUsers?: Array<{ __typename?: 'MachineUserDtoOut', nodeId?: string | null, name?: string | null } | null> | null } | null };

export type FindMachineUserGroupWithMachinesByNodeIdQueryVariables = Exact<{
  nodeId: Scalars['String'];
}>;


export type FindMachineUserGroupWithMachinesByNodeIdQuery = { __typename?: 'Query', findMachineUserGroupByNodeId?: { __typename?: 'MachineUserGroupDtoOut', nodeId?: string | null, machines?: Array<{ __typename?: 'MachineDtoOut', nodeId?: string | null, uuid?: string | null, name?: string | null } | null> | null } | null };

export type FindMachineUserGroupWithMachineUsersByNodeIdQueryVariables = Exact<{
  nodeId: Scalars['String'];
}>;


export type FindMachineUserGroupWithMachineUsersByNodeIdQuery = { __typename?: 'Query', findMachineUserGroupByNodeId?: { __typename?: 'MachineUserGroupDtoOut', nodeId?: string | null, machineUsers?: Array<{ __typename?: 'MachineUserDtoOut', nodeId?: string | null, name?: string | null } | null> | null } | null };

export type MachineUserGroupFragmentFragment = { __typename?: 'MachineUserGroupDtoOut', nodeId?: string | null, name?: string | null, machinesCount?: number | null, machineUsersCount?: number | null, machines?: Array<{ __typename?: 'MachineDtoOut', nodeId?: string | null, name?: string | null, uuid?: string | null } | null> | null, machineUsers?: Array<{ __typename?: 'MachineUserDtoOut', nodeId?: string | null, name?: string | null } | null> | null };

export type FindMachinesEligibleToAttachToMgQueryVariables = Exact<{ [key: string]: never; }>;


export type FindMachinesEligibleToAttachToMgQuery = { __typename?: 'Query', findMachinesEligibleToAttachToMG?: Array<{ __typename?: 'MachineDtoOut', nodeId?: string | null, name?: string | null, nodeStatus?: NodeStatus | null, nodeChangeDate?: Date | string | null } | null> | null };

export type GetAllTemplatesFilteredQueryVariables = Exact<{
  searchRequest: SearchRequestDto;
  templateFilters?: InputMaybe<TemplateFiltersDto>;
}>;


export type GetAllTemplatesFilteredQuery = { __typename?: 'Query', getAllTemplatesFiltered?: { __typename?: 'SearchResultDto', fullSize?: number | null, result?: Array<{ __typename?: 'LaneAllocationDto', nodeId?: string | null } | { __typename?: 'LocationDtoOut', nodeId?: string | null } | { __typename?: 'MachineDtoOut', nodeId?: string | null } | { __typename?: 'MachineGroupDtoOut', nodeId?: string | null } | { __typename?: 'MachineHistoryStatusDto', nodeId?: string | null } | { __typename?: 'MachineOnlineStatusDto', nodeId?: string | null } | { __typename?: 'MachineOnlineWithHistoryStatusDto', nodeId?: string | null } | { __typename?: 'MachineUserDtoOut', nodeId?: string | null } | { __typename?: 'MachineUserGroupDtoOut', nodeId?: string | null } | { __typename?: 'MetadataDtoOut', nodeId?: string | null } | { __typename?: 'OtaAuthorizationDto', nodeId?: string | null } | { __typename?: 'OtaCodeDtoOut', nodeId?: string | null } | { __typename?: 'ScheduledReportDtoOut', nodeId?: string | null } | { __typename?: 'SingleExecutionDtoOut', nodeId?: string | null } | { __typename?: 'SmartLocationGroupDtoOut', nodeId?: string | null } | { __typename?: 'SoftwarePackageDtoOut', nodeId?: string | null } | { __typename?: 'TemplateDtoOut', name: string, description?: string | null, version?: string | null, fileName: string, parts?: Array<string | null> | null, nodeId: string } | { __typename?: 'UserBalanceDtoOut', nodeId?: string | null } | null> | null } | null };

export type GetPreSignedDataForConfigurationQueryVariables = Exact<{
  fileName: Scalars['String'];
}>;


export type GetPreSignedDataForConfigurationQuery = { __typename?: 'Query', getPreSignedDataForConfiguration?: { __typename?: 'S3PreSignedData', urlForGet?: string | null, urlForPut?: string | null, urlForDelete?: string | null } | null };

export type GetPreSignedDataForSoftwarePackageQueryVariables = Exact<{
  fileName: Scalars['String'];
}>;


export type GetPreSignedDataForSoftwarePackageQuery = { __typename?: 'Query', getPreSignedDataForSoftwarePackage?: { __typename?: 'S3PreSignedData', urlForGet?: string | null, urlForPut?: string | null, urlForDelete?: string | null } | null };

export type RemoveMachineUsersFromMachineUserGroupMutationVariables = Exact<{
  machineUserNodeIds: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  nodeId: Scalars['String'];
}>;


export type RemoveMachineUsersFromMachineUserGroupMutation = { __typename?: 'Mutation', removeMachineUsersFromMachineUserGroup?: { __typename?: 'MachineUserGroupDtoOut', nodeId?: string | null, machineUsersCount?: number | null, machineUsers?: Array<{ __typename?: 'MachineUserDtoOut', nodeId?: string | null, name?: string | null, machineUserGroupNodeIds?: Array<string | null> | null } | null> | null } | null };

export type RemoveMachinesFromMachineUserGroupMutationVariables = Exact<{
  machineNodeIds: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  nodeId: Scalars['String'];
}>;


export type RemoveMachinesFromMachineUserGroupMutation = { __typename?: 'Mutation', removeMachinesFromMachineUserGroup?: { __typename?: 'MachineUserGroupDtoOut', nodeId?: string | null, machinesCount?: number | null, machines?: Array<{ __typename?: 'MachineDtoOut', nodeId?: string | null, name?: string | null } | null> | null } | null };

export type UpdateMachineGroupMutationVariables = Exact<{
  nodeId: Scalars['String'];
  input?: InputMaybe<MachineGroupDtoIn>;
}>;


export type UpdateMachineGroupMutation = { __typename?: 'Mutation', updateMachineGroup?: { __typename?: 'MachineGroupDtoOut', nodeId?: string | null, name?: string | null, nodeStatus?: NodeStatus | null, nodeChangeDate?: Date | string | null, machines?: Array<{ __typename?: 'MachineDtoOut', name?: string | null, uuid?: string | null, nodeId?: string | null } | null> | null } | null };

export type UpdateMachineUserGroupMutationVariables = Exact<{
  input: MachineUserGroupUpdateDtoIn;
  nodeId: Scalars['String'];
}>;


export type UpdateMachineUserGroupMutation = { __typename?: 'Mutation', updateMachineUserGroup?: { __typename?: 'MachineUserGroupDtoOut', nodeId?: string | null, name?: string | null, machinesCount?: number | null, machineUsersCount?: number | null, machines?: Array<{ __typename?: 'MachineDtoOut', nodeId?: string | null, name?: string | null, uuid?: string | null } | null> | null, machineUsers?: Array<{ __typename?: 'MachineUserDtoOut', nodeId?: string | null, name?: string | null } | null> | null } | null };

export type UpdateSoftwarePackageMutationVariables = Exact<{
  nodeId: Scalars['String'];
  softwarePackage: SoftwarePackageDtoIn;
}>;


export type UpdateSoftwarePackageMutation = { __typename?: 'Mutation', updateSoftwarePackage?: { __typename?: 'SoftwarePackageDtoOut', common?: boolean | null, createdBy?: string | null, createdDate?: Date | string | null, description?: string | null, fileName?: string | null, id?: string | null, label?: string | null, name?: string | null, nodeId?: string | null, originUri?: string | null, parts?: Array<string | null> | null, productName?: string | null, releaseInfo?: string | null, revision?: string | null, version?: string | null } | null };

export type UpdateTemplateMutationVariables = Exact<{
  nodeId: Scalars['String'];
  template: TemplateDtoIn;
}>;


export type UpdateTemplateMutation = { __typename?: 'Mutation', updateTemplate?: { __typename?: 'TemplateDtoOut', createdBy?: string | null, description?: string | null, fileName: string, name: string, nodeId: string, parts?: Array<string | null> | null, version?: string | null } | null };

export type UpsertSmartLocationGroupMutationVariables = Exact<{
  smartGroup?: InputMaybe<SmartLocationGroupDtoIn>;
}>;


export type UpsertSmartLocationGroupMutation = { __typename?: 'Mutation', upsertSmartLocationGroup?: { __typename?: 'SmartLocationGroupDtoOut', nodeId?: string | null, name?: string | null, countries?: Array<string | null> | null, cities?: Array<string | null> | null, authorizedUsers?: Array<string | null> | null, locations?: Array<{ __typename?: 'LocationDtoOut', nodeId?: string | null, name?: string | null, machineNodeIds?: Array<string | null> | null } | null> | null } | null };

export type CreateRulesMutationVariables = Exact<{
  input: RulesDto;
}>;


export type CreateRulesMutation = { __typename?: 'Mutation', createRules?: string | null };

export type DeleteRulesMutationVariables = Exact<{
  nodeId: Scalars['String'];
}>;


export type DeleteRulesMutation = { __typename?: 'Mutation', deleteRules?: boolean | null };

export type FindAlertsByCriteriaQueryVariables = Exact<{
  input: AlertHistoryDtoIn;
}>;


export type FindAlertsByCriteriaQuery = { __typename?: 'Query', findAlertsByCriteria?: { __typename?: 'AlertHistoryDto', fullSize?: number | null, columns?: Array<{ __typename?: 'AlertHistoryReportPairDtoOut', key?: AlertHistoryOrderColumn | null, values?: Array<string | null> | null } | null> | null, rows?: Array<{ __typename?: 'Alert', alertLevel?: AlertLevel | null, alertText?: string | null, contact?: string | null, dateTime?: Date | string | null, filterType?: FilterType | null, locationName?: string | null, locationNodeId?: string | null, machineName?: string | null, machineNodeId?: string | null, nodeId?: string | null, triggerType?: TriggerType | null } | null> | null } | null };

export type UpdateRulesMutationVariables = Exact<{
  input: RulesDto;
}>;


export type UpdateRulesMutation = { __typename?: 'Mutation', updateRules?: string | null };

export type GetReportHeaderQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReportHeaderQuery = { __typename?: 'Query', getReportHeader?: { __typename?: 'ReportHeaderDtoOut', locations?: Array<{ __typename?: 'LocationDtoOut', nodeId?: string | null, name?: string | null, machineNodeIds?: Array<string | null> | null, longitude?: string | null, latitude?: string | null } | null> | null, machines?: Array<{ __typename?: 'MachineDtoOut', nodeId?: string | null, name?: string | null, uuid?: string | null } | null> | null, smartLocationGroups?: Array<{ __typename?: 'SmartLocationGroupDtoOut', nodeId?: string | null, name?: string | null, locations?: Array<{ __typename?: 'LocationDtoOut', nodeId?: string | null } | null> | null } | null> | null } | null };

export type CreateLocationMutationVariables = Exact<{
  input: LocationDtoIn;
}>;


export type CreateLocationMutation = { __typename?: 'Mutation', createLocation?: { __typename?: 'LocationDtoOut', nodeId?: string | null, name?: string | null, longitude?: string | null, latitude?: string | null, city?: string | null, country?: string | null, machineNodeIds?: Array<string | null> | null, nodeStatus?: NodeStatus | null, nodeChangeDate?: Date | string | null } | null };

export type DeleteLocationMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type DeleteLocationMutation = { __typename?: 'Mutation', deleteLocation?: { __typename?: 'LocationDtoOut', nodeId?: string | null } | null };

export type FindAllLocationsByNodeIdsQueryVariables = Exact<{
  nodeIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type FindAllLocationsByNodeIdsQuery = { __typename?: 'Query', findAllLocationsByNodeIds?: Array<{ __typename?: 'LocationDtoOut', nodeId?: string | null, name?: string | null, longitude?: string | null, latitude?: string | null, city?: string | null, country?: string | null, machineNodeIds?: Array<string | null> | null, nodeStatus?: NodeStatus | null, nodeChangeDate?: Date | string | null, customerReference?: string | null, description?: string | null } | null> | null };

export type FindAllLocationsFilteredQueryVariables = Exact<{
  locationFilters?: InputMaybe<LocationFiltersDto>;
  searchRequest: SearchRequestDto;
}>;


export type FindAllLocationsFilteredQuery = { __typename?: 'Query', findAllLocationsFiltered?: { __typename?: 'SearchResultDto', fullSize?: number | null, result?: Array<{ __typename?: 'LaneAllocationDto' } | { __typename?: 'LocationDtoOut', nodeId?: string | null, name?: string | null, longitude?: string | null, latitude?: string | null, city?: string | null, country?: string | null, machineNodeIds?: Array<string | null> | null, nodeStatus?: NodeStatus | null, nodeChangeDate?: Date | string | null, customerReference?: string | null, description?: string | null } | { __typename?: 'MachineDtoOut' } | { __typename?: 'MachineGroupDtoOut' } | { __typename?: 'MachineHistoryStatusDto' } | { __typename?: 'MachineOnlineStatusDto' } | { __typename?: 'MachineOnlineWithHistoryStatusDto' } | { __typename?: 'MachineUserDtoOut' } | { __typename?: 'MachineUserGroupDtoOut' } | { __typename?: 'MetadataDtoOut' } | { __typename?: 'OtaAuthorizationDto' } | { __typename?: 'OtaCodeDtoOut' } | { __typename?: 'ScheduledReportDtoOut' } | { __typename?: 'SingleExecutionDtoOut' } | { __typename?: 'SmartLocationGroupDtoOut' } | { __typename?: 'SoftwarePackageDtoOut' } | { __typename?: 'TemplateDtoOut' } | { __typename?: 'UserBalanceDtoOut' } | null> | null } | null };

export type UpdateLocationMutationVariables = Exact<{
  nodeId: Scalars['String'];
  input: LocationDtoIn;
}>;


export type UpdateLocationMutation = { __typename?: 'Mutation', updateLocation?: { __typename?: 'LocationDtoOut', nodeId?: string | null, name?: string | null, longitude?: string | null, latitude?: string | null, city?: string | null, country?: string | null, machineNodeIds?: Array<string | null> | null, nodeStatus?: NodeStatus | null, nodeChangeDate?: Date | string | null, customerReference?: string | null, description?: string | null } | null };

export type CreateMachineMutationVariables = Exact<{
  input: MachineDtoIn;
}>;


export type CreateMachineMutation = { __typename?: 'Mutation', createMachine?: { __typename?: 'MachineDtoOut', name?: string | null, nodeStatus?: NodeStatus | null, nodeChangeDate?: Date | string | null, nodeId?: string | null, uuid?: string | null, locationNodeId?: string | null, machineType?: { __typename?: 'MachineTypeDto', name: string, nodeId?: string | null } | null } | null };

export type CreateOtaKeyPairMutationVariables = Exact<{
  machineUuid: Scalars['String'];
  requestKey: Scalars['String'];
}>;


export type CreateOtaKeyPairMutation = { __typename?: 'Mutation', createOtaKeyPair?: string | null };

export type DeleteMachineMutationVariables = Exact<{
  nodeId: Scalars['String'];
}>;


export type DeleteMachineMutation = { __typename?: 'Mutation', deleteMachine?: { __typename?: 'MachineDtoOut', nodeId?: string | null } | null };

export type FindAllMachineTypePatternsQueryVariables = Exact<{ [key: string]: never; }>;


export type FindAllMachineTypePatternsQuery = { __typename?: 'Query', findAllMachineTypePatterns: Array<{ __typename?: 'MachineTypeDto', name: string, nodeId?: string | null, table: string, imageUrl?: string | null }> };

export type FindAllMachinesQueryVariables = Exact<{
  machineFilters?: InputMaybe<MachineFiltersDto>;
  searchRequest: SearchRequestDto;
}>;


export type FindAllMachinesQuery = { __typename?: 'Query', findAllMachines?: { __typename?: 'SearchResultDto', fullSize?: number | null, result?: Array<{ __typename?: 'LaneAllocationDto' } | { __typename?: 'LocationDtoOut' } | { __typename?: 'MachineDtoOut', name?: string | null, nodeId?: string | null, uuid?: string | null } | { __typename?: 'MachineGroupDtoOut' } | { __typename?: 'MachineHistoryStatusDto' } | { __typename?: 'MachineOnlineStatusDto' } | { __typename?: 'MachineOnlineWithHistoryStatusDto' } | { __typename?: 'MachineUserDtoOut' } | { __typename?: 'MachineUserGroupDtoOut' } | { __typename?: 'MetadataDtoOut' } | { __typename?: 'OtaAuthorizationDto' } | { __typename?: 'OtaCodeDtoOut' } | { __typename?: 'ScheduledReportDtoOut' } | { __typename?: 'SingleExecutionDtoOut' } | { __typename?: 'SmartLocationGroupDtoOut' } | { __typename?: 'SoftwarePackageDtoOut' } | { __typename?: 'TemplateDtoOut' } | { __typename?: 'UserBalanceDtoOut' } | null> | null } | null };

export type FindAllMachinesDetailsQueryVariables = Exact<{
  machineFilters?: InputMaybe<MachineFiltersDto>;
  searchRequest: SearchRequestDto;
}>;


export type FindAllMachinesDetailsQuery = { __typename?: 'Query', findAllMachines?: { __typename?: 'SearchResultDto', fullSize?: number | null, result?: Array<{ __typename?: 'LaneAllocationDto' } | { __typename?: 'LocationDtoOut' } | { __typename?: 'MachineDtoOut', name?: string | null, nodeId?: string | null, uuid?: string | null, locationNodeId?: string | null, machineType?: { __typename?: 'MachineTypeDto', name: string } | null, details?: { __typename?: 'MachineDetailsDto', version?: string | null } | null } | { __typename?: 'MachineGroupDtoOut' } | { __typename?: 'MachineHistoryStatusDto' } | { __typename?: 'MachineOnlineStatusDto' } | { __typename?: 'MachineOnlineWithHistoryStatusDto' } | { __typename?: 'MachineUserDtoOut' } | { __typename?: 'MachineUserGroupDtoOut' } | { __typename?: 'MetadataDtoOut' } | { __typename?: 'OtaAuthorizationDto' } | { __typename?: 'OtaCodeDtoOut' } | { __typename?: 'ScheduledReportDtoOut' } | { __typename?: 'SingleExecutionDtoOut' } | { __typename?: 'SmartLocationGroupDtoOut' } | { __typename?: 'SoftwarePackageDtoOut' } | { __typename?: 'TemplateDtoOut' } | { __typename?: 'UserBalanceDtoOut' } | null> | null } | null };

export type FindAllMachinesWithLocationsQueryVariables = Exact<{
  machineFilters?: InputMaybe<MachineFiltersDto>;
  searchRequest: SearchRequestDto;
}>;


export type FindAllMachinesWithLocationsQuery = { __typename?: 'Query', findAllMachines?: { __typename?: 'SearchResultDto', fullSize?: number | null, result?: Array<{ __typename?: 'LaneAllocationDto' } | { __typename?: 'LocationDtoOut' } | { __typename?: 'MachineDtoOut', name?: string | null, nodeId?: string | null, uuid?: string | null, locationNodeId?: string | null } | { __typename?: 'MachineGroupDtoOut' } | { __typename?: 'MachineHistoryStatusDto' } | { __typename?: 'MachineOnlineStatusDto' } | { __typename?: 'MachineOnlineWithHistoryStatusDto' } | { __typename?: 'MachineUserDtoOut' } | { __typename?: 'MachineUserGroupDtoOut' } | { __typename?: 'MetadataDtoOut' } | { __typename?: 'OtaAuthorizationDto' } | { __typename?: 'OtaCodeDtoOut' } | { __typename?: 'ScheduledReportDtoOut' } | { __typename?: 'SingleExecutionDtoOut' } | { __typename?: 'SmartLocationGroupDtoOut' } | { __typename?: 'SoftwarePackageDtoOut' } | { __typename?: 'TemplateDtoOut' } | { __typename?: 'UserBalanceDtoOut' } | null> | null } | null };

export type FindMachineByNodeIdQueryVariables = Exact<{
  nodeId: Scalars['String'];
}>;


export type FindMachineByNodeIdQuery = { __typename?: 'Query', findMachineByNodeId?: { __typename?: 'MachineDtoOut', nodeId?: string | null, uuid?: string | null, name?: string | null, nodeStatus?: NodeStatus | null, nodeChangeDate?: Date | string | null, machineId?: string | null, locationNodeId?: string | null, machineType?: { __typename?: 'MachineTypeDto', name: string, imageUrl?: string | null, nodeId?: string | null, table: string } | null, details?: { __typename?: 'MachineDetailsDto', capabilities?: Array<string | null> | null, dateTime?: string | null, version?: string | null, nodeId?: string | null, devices?: Array<{ __typename?: 'RmDeviceDto', id?: string | null, nodeId?: string | null, sensorInfo?: { __typename?: 'RmInfoDto', accType?: string | null, firmware?: string | null, hardware?: string | null, name?: string | null, nodeId?: string | null, protocol?: string | null, serialNumber?: string | null, version?: string | null } | null, deviceInfo?: { __typename?: 'RmInfoDto', accType?: string | null, firmware?: string | null, hardware?: string | null, name?: string | null, nodeId?: string | null, protocol?: string | null, serialNumber?: string | null, version?: string | null } | null } | null> | null } | null } | null };

export type GenerateCashOperationsReportQueryVariables = Exact<{
  cashOperationsReportCriteriaDto?: InputMaybe<CashOperationsReportCriteriaDto>;
}>;


export type GenerateCashOperationsReportQuery = { __typename?: 'Query', generateCashOperationsReport?: { __typename?: 'CashOperationsDtoOut', machineContentDtos?: Array<{ __typename?: 'MachineContentDto', currency?: string | null, refillStatus?: RefillStatus | null, dispenseAvailabilityRatio?: number | null, denominationDispensableMap?: Array<{ __typename?: 'ChartBarDto', color?: ChartBarColor | null, description?: Array<string | null> | null, name?: string | null, percent?: number | null, totalCount?: number | null, type?: string | null } | null> | null, denominationBankableMap?: Array<{ __typename?: 'ChartBarDto', color?: ChartBarColor | null, description?: Array<string | null> | null, name?: string | null, percent?: number | null, totalCount?: number | null, type?: string | null } | null> | null, containerDispensableMap?: Array<{ __typename?: 'ChartBarDto', color?: ChartBarColor | null, description?: Array<string | null> | null, name?: string | null, percent?: number | null, totalCount?: number | null, type?: string | null } | null> | null, containerBankableMap?: Array<{ __typename?: 'ChartBarDto', color?: ChartBarColor | null, description?: Array<string | null> | null, name?: string | null, percent?: number | null, totalCount?: number | null, type?: string | null } | null> | null, totals?: Array<{ __typename?: 'RmPairDto', key?: string | null, value?: string | null } | null> | null } | null> | null } | null };

export type ChartMapFragment = { __typename?: 'ChartBarDto', color?: ChartBarColor | null, description?: Array<string | null> | null, name?: string | null, percent?: number | null, totalCount?: number | null, type?: string | null };

export type GenerateMachineDetailsReportQueryVariables = Exact<{
  criteriaDto: MachineDetailsReportCriteriaDto;
}>;


export type GenerateMachineDetailsReportQuery = { __typename?: 'Query', generateMachineDetailsReport?: { __typename?: 'MachineDetailsReportDto', fullSize?: number | null, rows?: Array<{ __typename?: 'MachineDetailsReportRowDto', nodeId?: string | null, machineNodeId?: string | null, codVersion?: string | null, location?: string | null, machineAlias?: string | null, machineUuid?: string | null, machineType?: string | null } | null> | null } | null };

export type GenerateMachineViewTabQueryVariables = Exact<{
  input: MachineViewDtoIn;
}>;


export type GenerateMachineViewTabQuery = { __typename?: 'Query', generateMachineViewTab?: { __typename?: 'MachineViewDtoOut', fullSize?: number | null, rows?: Array<{ __typename?: 'MachineViewRowDtoOut', location?: { __typename?: 'LocationDtoOut', nodeId?: string | null, name?: string | null } | null, machine?: { __typename?: 'MachineThinDtoOut', nodeId?: string | null, uuid?: string | null, name?: string | null, nodeStatus?: NodeStatus | null, nodeChangeDate?: Date | string | null, machineType?: string | null, machineImageUrl?: string | null } | null, license?: { __typename?: 'CoDLicenseDtoOut', nodeId?: string | null, edition?: string | null, createdDate?: Date | string | null, licenseKey?: string | null, expirationDate?: Date | string | null, subscriptionActive?: boolean | null, licenseStartDate?: Date | string | null, lockedDueToFlipFlopping?: boolean | null } | null, ongoingDeployment?: { __typename?: 'ExtendedDeploymentDtoOut', nodeId?: string | null, state?: string | null, createdBy?: string | null, scheduleInfo?: string | null, template?: { __typename?: 'TemplateDtoOut', nodeId: string, name: string, version?: string | null, fileName: string } | null } | null, templateDeployment?: { __typename?: 'ExtendedDeploymentDtoOut', nodeId?: string | null, createdBy?: string | null, state?: string | null, template?: { __typename?: 'TemplateDtoOut', nodeId: string, name: string, version?: string | null, fileName: string } | null } | null, machineUserGroup?: Array<{ __typename?: 'MachineUserGroupViewDtoOut', nodeId: string, name: string } | null> | null, softwareInstalled?: { __typename?: 'ExtendedSoftwareInstallationDtoOut', createdBy?: string | null, nodeId?: string | null, state?: State | null, softwarePackage?: { __typename?: 'SoftwarePackageDtoOut', nodeId?: string | null, createdDate?: Date | string | null, version?: string | null, name?: string | null, productName?: string | null } | null } | null, ongoingSoftwareInstallation?: { __typename?: 'ExtendedSoftwareInstallationDtoOut', createdBy?: string | null, nodeId?: string | null, state?: State | null, scheduleInfo?: string | null, softwarePackage?: { __typename?: 'SoftwarePackageDtoOut', nodeId?: string | null, createdDate?: Date | string | null, version?: string | null, name?: string | null, productName?: string | null } | null } | null } | null> | null } | null };

export type GetMachinesOnlineStatusQueryVariables = Exact<{
  input: MachineOnlineStatusRequest;
}>;


export type GetMachinesOnlineStatusQuery = { __typename?: 'Query', getMachinesOnlineStatus?: { __typename?: 'MachinesOnlineStatusForDateTimeResponse', fullSize?: number | null, rows?: Array<{ __typename?: 'MachineOnlineStatusDto', eventDate?: string | null, licenseId?: string | null, locationId?: string | null, machineStatus?: MachineStatus | null, machineUuid?: string | null, machineName?: string | null, locationName?: string | null, nodeId?: string | null, onlineStatus?: OnlineStatus | null, receivedDate?: string | null, tenantId?: string | null, formattedEventDate?: string | null, formattedReceivedDate?: string | null } | null> | null } | null };

export type GetMachinesOnlineStatusHistoryQueryVariables = Exact<{
  input: MachineOnlineStatusHistoryRequest;
}>;


export type GetMachinesOnlineStatusHistoryQuery = { __typename?: 'Query', getMachinesOnlineStatusHistory?: { __typename?: 'MachinesOnlineStatusHistoryResponse', fullSize?: number | null, rows?: Array<{ __typename?: 'MachineOnlineWithHistoryStatusDto', eventDate?: string | null, licenseId?: string | null, locationId?: string | null, machineStatus?: MachineStatus | null, machineUuid?: string | null, machineName?: string | null, locationName?: string | null, nodeId?: string | null, onlineStatus?: OnlineStatus | null, receivedDate?: string | null, tenantId?: string | null, formattedEventDate?: string | null, formattedReceivedDate?: string | null, historyStatuses?: Array<{ __typename?: 'MachineHistoryStatusDto', eventDate?: string | null, licenseId?: string | null, machineStatus?: MachineStatus | null, machineUuid?: string | null, nodeId?: string | null, onlineStatus?: OnlineStatus | null, receivedDate?: string | null, formattedEventDate?: string | null, formattedReceivedDate?: string | null } | null> | null } | null> | null } | null };

export type GetPublicKeyQueryVariables = Exact<{
  machineUuid: Scalars['String'];
}>;


export type GetPublicKeyQuery = { __typename?: 'Query', getPublicKey?: string | null };

export type ActivateLicenseByNodeIdMutationVariables = Exact<{
  nodeId: Scalars['String'];
}>;


export type ActivateLicenseByNodeIdMutation = { __typename?: 'Mutation', activateLicenseByNodeId?: { __typename?: 'CoDLicenseDtoOut', nodeId?: string | null, subscriptionActive?: boolean | null, deactivatedDate?: Date | string | null, expirationDate?: Date | string | null, licenseStartDate?: Date | string | null } | null };

export type CreateMachineLicenseContentMutationVariables = Exact<{
  licenseContentDtoIn: LicenseContentDtoIn;
  tenantId: Scalars['String'];
}>;


export type CreateMachineLicenseContentMutation = { __typename?: 'Mutation', createMachineLicenseContent?: { __typename?: 'LicenseContentDtoOut', uuid?: string | null, nodeId?: string | null, lockedDueToFlipFlopping?: boolean | null, deactivatedDateTime?: Date | string | null, features?: Array<{ __typename?: 'LicenseFeatureDtoOut', nodeId?: string | null, key?: string | null, expiration?: { __typename?: 'LicenseExpirationDtoOut', nodeId?: string | null, date?: Date | string | null, disableFeatureWhenExpired?: boolean | null, warningBeforeExpirationDays?: number | null } | null } | null> | null } | null };

export type DeactivateLicenseByNodeIdMutationVariables = Exact<{
  nodeId: Scalars['String'];
}>;


export type DeactivateLicenseByNodeIdMutation = { __typename?: 'Mutation', deactivateLicenseByNodeId?: { __typename?: 'CoDLicenseDtoOut', nodeId?: string | null, subscriptionActive?: boolean | null, deactivatedDate?: Date | string | null, expirationDate?: Date | string | null, licenseStartDate?: Date | string | null } | null };

export type FindAllAvailableLicenseFeatureKeysQueryVariables = Exact<{ [key: string]: never; }>;


export type FindAllAvailableLicenseFeatureKeysQuery = { __typename?: 'Query', findAllAvailableLicenseFeatureKeys?: Array<string | null> | null };

export type FindAllMachineCoDLicensesQueryVariables = Exact<{
  machineUuid: Scalars['String'];
}>;


export type FindAllMachineCoDLicensesQuery = { __typename?: 'Query', findAllMachineCoDLicenses?: Array<{ __typename?: 'CoDLicenseDtoOut', comment?: string | null, nodeId?: string | null, paymentIntervalType?: PaymentIntervalType | null, serialNo?: string | null, subscriptionActive?: boolean | null, createdDate?: Date | string | null, deliveredDate?: Date | string | null, edition?: string | null, expirationDate?: Date | string | null, invoiceManager?: string | null, licenseId?: string | null, licenseKey?: string | null, deactivatedDate?: Date | string | null, licenseStartDate?: Date | string | null, lockedDueToFlipFlopping?: boolean | null } | null> | null };

export type FindLatestCoDLicenseByMachineUuidQueryVariables = Exact<{
  machineUuid: Scalars['String'];
}>;


export type FindLatestCoDLicenseByMachineUuidQuery = { __typename?: 'Query', findLatestCoDLicenseByMachineUuid?: { __typename?: 'CoDLicenseDtoOut', comment?: string | null, nodeId?: string | null, paymentIntervalType?: PaymentIntervalType | null, serialNo?: string | null, subscriptionActive?: boolean | null, createdDate?: Date | string | null, deliveredDate?: Date | string | null, edition?: string | null, expirationDate?: Date | string | null, invoiceManager?: string | null, licenseId?: string | null, licenseKey?: string | null, deactivatedDate?: Date | string | null, licenseStartDate?: Date | string | null, lockedDueToFlipFlopping?: boolean | null } | null };

export type GetMachineLicenseContentQueryVariables = Exact<{
  machineUuid: Scalars['String'];
}>;


export type GetMachineLicenseContentQuery = { __typename?: 'Query', getMachineLicenseContent?: { __typename?: 'LicenseContentDtoOut', uuid?: string | null, nodeId?: string | null, lockedDueToFlipFlopping?: boolean | null, deactivatedDateTime?: Date | string | null, features?: Array<{ __typename?: 'LicenseFeatureDtoOut', nodeId?: string | null, key?: string | null, expiration?: { __typename?: 'LicenseExpirationDtoOut', nodeId?: string | null, date?: Date | string | null, disableFeatureWhenExpired?: boolean | null, warningBeforeExpirationDays?: number | null } | null } | null> | null } | null };

export type UpgradeMachineLatestLicenseMutationVariables = Exact<{
  licenseSubscription: LicenseSubscriptionDtoIn;
}>;


export type UpgradeMachineLatestLicenseMutation = { __typename?: 'Mutation', upgradeMachineLatestLicense?: { __typename?: 'CoDLicenseDtoOut', nodeId?: string | null, comment?: string | null, paymentIntervalType?: PaymentIntervalType | null, serialNo?: string | null, subscriptionActive?: boolean | null, createdDate?: Date | string | null, deliveredDate?: Date | string | null, edition?: string | null, expirationDate?: Date | string | null, invoiceManager?: string | null, licenseId?: string | null, licenseKey?: string | null, deactivatedDate?: Date | string | null, licenseStartDate?: Date | string | null, lockedDueToFlipFlopping?: boolean | null } | null };

export type UpdateMachineMutationVariables = Exact<{
  nodeId: Scalars['String'];
  input: MachineDtoIn;
}>;


export type UpdateMachineMutation = { __typename?: 'Mutation', updateMachine?: { __typename?: 'MachineDtoOut', name?: string | null, nodeStatus?: NodeStatus | null, nodeChangeDate?: Date | string | null, nodeId?: string | null, uuid?: string | null, locationNodeId?: string | null, machineType?: { __typename?: 'MachineTypeDto', name: string, nodeId?: string | null } | null } | null };

export type CreateMachineUserMutationVariables = Exact<{
  input: MachineUserDtoIn;
}>;


export type CreateMachineUserMutation = { __typename?: 'Mutation', createMachineUser?: { __typename?: 'MachineUserDtoOut', nodeId?: string | null, name?: string | null, roleName?: string | null, userId?: string | null } | null };

export type DeleteMachineUserMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type DeleteMachineUserMutation = { __typename?: 'Mutation', deleteMachineUser?: { __typename?: 'MachineUserDtoOut', nodeId?: string | null } | null };

export type DeleteMachineUsersMutationVariables = Exact<{
  nodeIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type DeleteMachineUsersMutation = { __typename?: 'Mutation', deleteMachineUsers?: number | null };

export type FindAllDistinctRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type FindAllDistinctRolesQuery = { __typename?: 'Query', findAllDistinctRoles?: Array<string | null> | null };

export type FindAllMachineUsersFilteredQueryVariables = Exact<{
  machineUserFilters?: InputMaybe<MachineUserFiltersDto>;
  searchRequest: SearchRequestDto;
}>;


export type FindAllMachineUsersFilteredQuery = { __typename?: 'Query', findAllMachineUsersFiltered?: { __typename?: 'SearchResultDto', fullSize?: number | null, result?: Array<{ __typename?: 'LaneAllocationDto', nodeId?: string | null } | { __typename?: 'LocationDtoOut', nodeId?: string | null } | { __typename?: 'MachineDtoOut', nodeId?: string | null } | { __typename?: 'MachineGroupDtoOut', nodeId?: string | null } | { __typename?: 'MachineHistoryStatusDto', nodeId?: string | null } | { __typename?: 'MachineOnlineStatusDto', nodeId?: string | null } | { __typename?: 'MachineOnlineWithHistoryStatusDto', nodeId?: string | null } | { __typename?: 'MachineUserDtoOut', name?: string | null, userId?: string | null, roleName?: string | null, nodeId?: string | null, cardIdentifier?: string | null, deactivated?: boolean | null, validFrom?: string | null, validUntil?: string | null, nbrOfLogins?: number | null } | { __typename?: 'MachineUserGroupDtoOut', nodeId?: string | null } | { __typename?: 'MetadataDtoOut', nodeId?: string | null } | { __typename?: 'OtaAuthorizationDto', nodeId?: string | null } | { __typename?: 'OtaCodeDtoOut', nodeId?: string | null } | { __typename?: 'ScheduledReportDtoOut', nodeId?: string | null } | { __typename?: 'SingleExecutionDtoOut', nodeId?: string | null } | { __typename?: 'SmartLocationGroupDtoOut', nodeId?: string | null } | { __typename?: 'SoftwarePackageDtoOut', nodeId?: string | null } | { __typename?: 'TemplateDtoOut', nodeId: string } | { __typename?: 'UserBalanceDtoOut', nodeId?: string | null } | null> | null } | null };

export type FindMachineUserByUserIdQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type FindMachineUserByUserIdQuery = { __typename?: 'Query', findMachineUserByUserId?: { __typename?: 'MachineUserDtoOut', alias?: string | null, cardIdentifier?: string | null, changePinOnLogin?: boolean | null, deactivated?: boolean | null, doors?: Array<string | null> | null, fingerprints?: string | null, list?: boolean | null, machineUserGroupNodeIds?: Array<string | null> | null, name?: string | null, nbrOfBadPin?: number | null, nbrOfLogins?: number | null, nodeId?: string | null, noPin?: boolean | null, noPinBio?: boolean | null, noPinCard?: boolean | null, noPinDoor?: boolean | null, noPinLogin?: boolean | null, pin?: string | null, roleName?: string | null, userId?: string | null, validFrom?: string | null, validUntil?: string | null } | null };

export type FindMachineUserPersonalInfoQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type FindMachineUserPersonalInfoQuery = { __typename?: 'Query', findMachineUserByUserId?: { __typename?: 'MachineUserDtoOut', name?: string | null, nodeId?: string | null, userId?: string | null } | null };

export type ImportMachineUsersMutationVariables = Exact<{
  machineUserImport: MachineUserXmlImport;
}>;


export type ImportMachineUsersMutation = { __typename?: 'Mutation', importMachineUsers?: boolean | null };

export type UpdateMachineUserMutationVariables = Exact<{
  nodeId: Scalars['String'];
  input: MachineUserDtoIn;
}>;


export type UpdateMachineUserMutation = { __typename?: 'Mutation', updateMachineUser?: { __typename?: 'MachineUserDtoOut', alias?: string | null, cardIdentifier?: string | null, changePinOnLogin?: boolean | null, deactivated?: boolean | null, doors?: Array<string | null> | null, fingerprints?: string | null, list?: boolean | null, machineUserGroupNodeIds?: Array<string | null> | null, name?: string | null, nbrOfBadPin?: number | null, nbrOfLogins?: number | null, nodeId?: string | null, noPin?: boolean | null, noPinBio?: boolean | null, noPinCard?: boolean | null, noPinDoor?: boolean | null, noPinLogin?: boolean | null, pin?: string | null, roleName?: string | null, userId?: string | null, validFrom?: string | null, validUntil?: string | null } | null };

export type CreateOtaAuthorizationMutationVariables = Exact<{
  otaAuthorizationIn: OtaAuthorizationIn;
}>;


export type CreateOtaAuthorizationMutation = { __typename?: 'Mutation', createOtaAuthorization?: { __typename?: 'OtaAuthorizationDto', nodeId?: string | null } | null };

export type DeactivateOtaAuthorizationMutationVariables = Exact<{
  nodeId: Scalars['String'];
}>;


export type DeactivateOtaAuthorizationMutation = { __typename?: 'Mutation', deactivateOtaAuthorization?: boolean | null };

export type DeactivateOtaKeyPairMutationVariables = Exact<{
  machineUuid: Scalars['String'];
}>;


export type DeactivateOtaKeyPairMutation = { __typename?: 'Mutation', deactivateOtaKeyPair?: boolean | null };

export type FindAllOtaAuthorizationsQueryVariables = Exact<{
  searchRequest: SearchRequestDto;
  otaAuthorizationFiltersDto?: InputMaybe<OtaAuthorizationFiltersDto>;
}>;


export type FindAllOtaAuthorizationsQuery = { __typename?: 'Query', findAllOtaAuthorizations?: { __typename?: 'SearchResultDto', fullSize?: number | null, result?: Array<{ __typename?: 'LaneAllocationDto' } | { __typename?: 'LocationDtoOut' } | { __typename?: 'MachineDtoOut' } | { __typename?: 'MachineGroupDtoOut' } | { __typename?: 'MachineHistoryStatusDto' } | { __typename?: 'MachineOnlineStatusDto' } | { __typename?: 'MachineOnlineWithHistoryStatusDto' } | { __typename?: 'MachineUserDtoOut' } | { __typename?: 'MachineUserGroupDtoOut' } | { __typename?: 'MetadataDtoOut' } | { __typename?: 'OtaAuthorizationDto', nodeId?: string | null, nodeStatus?: NodeStatus | null, nodeChangeDate?: Date | string | null, userName?: string | null, connectUserName?: string | null, userRole?: string | null, userId?: string | null, expirationDateTime?: Date | string | null, machineUuid?: string | null, siteNodeId?: string | null, siteGroupNodeId?: string | null, deleteAfterFirstUse?: boolean | null, codeValidityIntervalMinutes?: number | null, customData?: Array<{ __typename?: 'MapDto', key?: string | null, value?: string | null }> | null } | { __typename?: 'OtaCodeDtoOut' } | { __typename?: 'ScheduledReportDtoOut' } | { __typename?: 'SingleExecutionDtoOut' } | { __typename?: 'SmartLocationGroupDtoOut' } | { __typename?: 'SoftwarePackageDtoOut' } | { __typename?: 'TemplateDtoOut' } | { __typename?: 'UserBalanceDtoOut' } | null> | null } | null };

export type GetOrCreateMutationVariables = Exact<{
  otaCodeDtoIn: OtaCodeInputDto;
}>;


export type GetOrCreateMutation = { __typename?: 'Mutation', getOrCreate?: { __typename?: 'OtaCodeDtoOut', nodeId?: string | null, code?: string | null } | null };

export type CreateScheduledReportMutationVariables = Exact<{
  input: ScheduledReportDtoIn;
}>;


export type CreateScheduledReportMutation = { __typename?: 'Mutation', createScheduledReport?: { __typename?: 'ScheduledReportDtoOut', fileType: FileType, instanceName: string, nextExecution?: Date | string | null, nodeId?: string | null, nodeStatus?: NodeStatus | null, locationNodeIds?: Array<string | null> | null, reportName?: ScheduledReportName | null, status?: ScheduledReportStatus | null, reportEmails: Array<{ __typename?: 'ScheduledReportEmailOut', email: string, subject?: string | null } | null> } | null };

export type FindBoxTotalsByCurrencyQueryVariables = Exact<{
  boxTotalsDtoIn?: InputMaybe<BoxTotalsDtoIn>;
}>;


export type FindBoxTotalsByCurrencyQuery = { __typename?: 'Query', findBoxTotalsByCurrency?: { __typename?: 'BoxTotalsDtoOut', boxTotals?: Array<{ __typename?: 'RmPairDto', key?: string | null, value?: string | null } | null> | null } | null };

export type FindDeviceMovementsForRmTransactionQueryVariables = Exact<{
  nodeId?: InputMaybe<Scalars['String']>;
}>;


export type FindDeviceMovementsForRmTransactionQuery = { __typename?: 'Query', findDeviceMovementsForRmTransaction?: Array<{ __typename?: 'RmDeviceMovementDto', nodeId?: string | null, deviceId?: string | null, boxMovements?: Array<{ __typename?: 'RmBoxMovementDto', boxId?: string | null, containerId?: string | null, nodeId?: string | null, movement?: Array<{ __typename?: 'RmValueBagDto', nodeId?: string | null, rejects?: number | null, totalAmount?: number | null, type?: string | null, values?: Array<{ __typename?: 'RmValueDto', denomination?: number | null, exchangeRate?: number | null, exchangeRateDecimals?: number | null, nodeId?: string | null, pieceValue?: number | null, reference?: string | null, total?: number | null, type?: string | null, c2Count?: number | null, c3Count?: number | null, c4bCount?: number | null, claimedValueType?: string | null, count?: number | null, creditCat2?: boolean | null, creditCat3?: boolean | null, currency?: string | null, customType?: string | null, decimals?: number | null } | null> | null } | null> | null, resultingContent?: Array<{ __typename?: 'RmValueBagDto', nodeId?: string | null, rejects?: number | null, totalAmount?: number | null, type?: string | null, values?: Array<{ __typename?: 'RmValueDto', denomination?: number | null, exchangeRate?: number | null, exchangeRateDecimals?: number | null, nodeId?: string | null, pieceValue?: number | null, reference?: string | null, total?: number | null, type?: string | null, c2Count?: number | null, c3Count?: number | null, c4bCount?: number | null, claimedValueType?: string | null, count?: number | null, creditCat2?: boolean | null, creditCat3?: boolean | null, currency?: string | null, customType?: string | null, decimals?: number | null } | null> | null } | null> | null } | null> | null } | null> | null };

export type FindRmDevicesForMachineDetailsQueryVariables = Exact<{
  machineDetailsNodeId?: InputMaybe<Scalars['String']>;
}>;


export type FindRmDevicesForMachineDetailsQuery = { __typename?: 'Query', findRmDevicesForMachineDetails?: Array<{ __typename?: 'RmDeviceDto', id?: string | null, nodeId?: string | null, deviceInfo?: { __typename?: 'RmInfoDto', accType?: string | null, firmware?: string | null, hardware?: string | null, name?: string | null, nodeId?: string | null, protocol?: string | null, serialNumber?: string | null, version?: string | null } | null, sensorInfo?: { __typename?: 'RmInfoDto', accType?: string | null, firmware?: string | null, hardware?: string | null, name?: string | null, nodeId?: string | null, protocol?: string | null, serialNumber?: string | null, version?: string | null } | null } | null> | null };

export type FindRmValuesForRmBoxQueryVariables = Exact<{
  nodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type FindRmValuesForRmBoxQuery = { __typename?: 'Query', findRmValuesForRmBox?: Array<{ __typename?: 'RmBoxDto', nodeId?: string | null, boxId?: string | null, total?: number | null, name?: string | null, type?: string | null, defaultLevel?: number | null, maximumLevel?: number | null, minimumLevel?: number | null, highLimitLevel?: number | null, lowLimitLevel?: number | null, fillStatus?: string | null, capabilities?: Array<string | null> | null, errorStatus?: Array<string | null> | null, values?: Array<{ __typename?: 'RmValueDto', nodeId?: string | null, total?: number | null, count?: number | null, decimals?: number | null, currency?: string | null, denomination?: number | null, pieceValue?: number | null, exchangeRate?: number | null, exchangeRateDecimals?: number | null, reference?: string | null, type?: string | null, claimedValueType?: string | null, customType?: string | null, c2Count?: number | null, c3Count?: number | null, c4bCount?: number | null, creditCat2?: boolean | null, creditCat3?: boolean | null } | null> | null } | null> | null };

export type FindValueBagsForRmTransactionQueryVariables = Exact<{
  nodeId?: InputMaybe<Scalars['String']>;
}>;


export type FindValueBagsForRmTransactionQuery = { __typename?: 'Query', findValueBagsForRmTransaction?: Array<{ __typename?: 'RmValueBagDto', nodeId?: string | null, totalAmount?: number | null, type?: string | null, rejects?: number | null, values?: Array<{ __typename?: 'RmValueDto', nodeId?: string | null, total?: number | null, count?: number | null, decimals?: number | null, currency?: string | null, denomination?: number | null, pieceValue?: number | null, exchangeRate?: number | null, exchangeRateDecimals?: number | null, reference?: string | null, type?: string | null, claimedValueType?: string | null, customType?: string | null, c2Count?: number | null, c3Count?: number | null, c4bCount?: number | null, creditCat2?: boolean | null, creditCat3?: boolean | null } | null> | null } | null> | null };

export type GenerateCashInventoryReportQueryVariables = Exact<{
  input: CashInventoryReportCriteriaDtoIn;
}>;


export type GenerateCashInventoryReportQuery = { __typename?: 'Query', generateCashInventoryReport?: { __typename?: 'CashInventoryReportDto', fullSize?: number | null, columns?: Array<{ __typename?: 'ReportPairDtoOut', key?: string | null, values?: Array<string | null> | null } | null> | null, rows?: Array<{ __typename?: 'CashInventoryReportRowDto', boxNodeIds?: Array<string | null> | null, machineNodeId?: string | null, machineTypeName?: string | null, machineName?: string | null, locationName?: string | null, totalAmounts?: Array<{ __typename?: 'AmountDto', amount?: string | null, count?: number | null, currency?: string | null } | null> | null } | null> | null } | null };

export type GenerateCashSummaryReportQueryVariables = Exact<{
  input: CashSummaryReportCriteriaDto;
}>;


export type GenerateCashSummaryReportQuery = { __typename?: 'Query', generateCashSummaryReport?: { __typename?: 'CashSummaryReportDto', totalAmounts?: Array<{ __typename?: 'SummaryGrandTotalDto', currency?: string | null, grandTotal?: string | null, machineTotal?: string | null, openShiftTotal?: string | null, claimedValueTotal?: string | null } | null> | null, rows?: Array<{ __typename?: 'MachineCurrencyContentDto', bankableAmount?: string | null, bankableCount?: number | null, currency?: string | null, dispensableAmount?: string | null, dispensableCount?: number | null, locationName?: string | null, machineName?: string | null, total?: string | null, subRows?: Array<{ __typename?: 'DenominationRowDto', type?: string | null, total?: string | null, denomination?: string | null, bankableAmount?: string | null, bankableCount?: number | null, currency?: string | null, dispensableAmount?: string | null, dispensableCount?: number | null } | null> | null } | null> | null } | null };

export type GenerateClaimedValuesReportQueryVariables = Exact<{
  input: ClaimedValuesReportCriteriaDtoIn;
}>;


export type GenerateClaimedValuesReportQuery = { __typename?: 'Query', generateClaimedValuesReport?: { __typename?: 'ClaimedValuesReportDtoOut', totalAmounts?: Array<{ __typename?: 'RmPairDto', key?: string | null, value?: string | null } | null> | null, rows?: Array<{ __typename?: 'ClaimedValuesReportRowDto', container?: string | null, count?: number | null, currency?: string | null, denomination?: string | null, machine?: string | null, site?: string | null, total?: string | null, type?: string | null, subRows?: Array<{ __typename?: 'ClaimedValuesReportRowDto', container?: string | null, count?: number | null, currency?: string | null, denomination?: string | null, machine?: string | null, site?: string | null, total?: string | null, type?: string | null } | null> | null } | null> | null } | null };

export type GenerateMachineErrorsReportQueryVariables = Exact<{
  input?: InputMaybe<ErrorsReportCriteriaDtoIn>;
}>;


export type GenerateMachineErrorsReportQuery = { __typename?: 'Query', generateMachineErrorsReport?: { __typename?: 'ReportDtoOut', fullSize?: number | null, columns?: Array<{ __typename?: 'ReportPairDtoOut', key?: string | null, values?: Array<string | null> | null } | null> | null, rows?: Array<{ __typename?: 'CorrectionTransactionReportRowDto', nodeId?: string | null, uuid?: string | null, dateTime?: string | null } | { __typename?: 'ErrorsReportRowDto', deviceId?: string | null, severity?: string | null, kind?: string | null, information?: string | null, extendedInfo?: string | null, errorCode?: string | null, cleared?: boolean | null, machineNodeId?: string | null, machineName?: string | null, locationNodeId?: string | null, timeZoneUtcOffset?: string | null, nodeId?: string | null, uuid?: string | null, dateTime?: string | null } | { __typename?: 'RmBoxContentDto', nodeId?: string | null, uuid?: string | null, dateTime?: string | null } | { __typename?: 'RmBoxExchangeDto', nodeId?: string | null, uuid?: string | null, dateTime?: string | null } | { __typename?: 'RmErrorDto', nodeId?: string | null, uuid?: string | null, dateTime?: string | null } | { __typename?: 'RmIdentifyDto', nodeId?: string | null, uuid?: string | null, dateTime?: string | null } | { __typename?: 'RmSystemStatusDto', nodeId?: string | null, uuid?: string | null, dateTime?: string | null } | { __typename?: 'RmTransactionDto', nodeId?: string | null, uuid?: string | null, dateTime?: string | null } | { __typename?: 'RmZReportDto', nodeId?: string | null, uuid?: string | null, dateTime?: string | null } | { __typename?: 'TransactionsReportRowDto', nodeId?: string | null, uuid?: string | null, dateTime?: string | null } | null> | null } | null };

export type GenerateMachineUserTransactionsReportQueryVariables = Exact<{
  criteriaDto: MachineUserTransactionsReportCriteriaDto;
}>;


export type GenerateMachineUserTransactionsReportQuery = { __typename?: 'Query', generateMachineUserTransactionsReport?: { __typename?: 'MachineUserTransactionsReportDto', columns?: Array<{ __typename?: 'ReportPairDtoOut', key?: string | null, values?: Array<string | null> | null } | null> | null, totalIn?: Array<{ __typename?: 'RmPairDto', key?: string | null, value?: string | null } | null> | null, totalOut?: Array<{ __typename?: 'RmPairDto', key?: string | null, value?: string | null } | null> | null, totalDiff?: Array<{ __typename?: 'RmPairDto', key?: string | null, value?: string | null } | null> | null, rows?: Array<{ __typename?: 'MachineUserTransactionsReportRowDto', userId?: string | null, userName?: string | null, totalIn?: Array<{ __typename?: 'RmPairDto', key?: string | null, value?: string | null } | null> | null, totalOut?: Array<{ __typename?: 'RmPairDto', key?: string | null, value?: string | null } | null> | null, totalDiff?: Array<{ __typename?: 'RmPairDto', key?: string | null, value?: string | null } | null> | null, transactionRows?: Array<{ __typename?: 'TransactionsReportRowDto', account?: string | null, roleName?: string | null, machineName?: string | null, locationName?: string | null, formattedDateTime?: string | null, accountingDate?: string | null, subType?: string | null, type?: string | null, workUnitName?: string | null, totalAmounts?: Array<{ __typename?: 'RmPairDto', key?: string | null, value?: string | null } | null> | null } | null> | null } | null> | null } | null };

export type GenerateManualDepositsReportQueryVariables = Exact<{
  input?: InputMaybe<ManualDepositsReportCriteriaDto>;
}>;


export type GenerateManualDepositsReportQuery = { __typename?: 'Query', generateManualDepositsReport?: { __typename?: 'ManualDepositsReportDto', totalAmounts?: Array<{ __typename?: 'RmPairDto', key?: string | null, value?: string | null } | null> | null, rows?: Array<{ __typename?: 'ManualDepositsGroupDto', groupValue?: string | null, subRows?: Array<{ __typename?: 'TransactionsReportRowDto', machineUserId?: string | null, machineUserName?: string | null, roleName?: string | null, workUnitName?: string | null, machineName?: string | null, locationName?: string | null, claimedValueTypes?: Array<string | null> | null, type?: string | null, devices?: Array<string | null> | null, bagIds?: Array<string | null> | null, dateTime?: string | null, timeZoneUtcOffset?: string | null, totalAmounts?: Array<{ __typename?: 'RmPairDto', key?: string | null, value?: string | null } | null> | null } | null> | null, totalAmounts?: Array<{ __typename?: 'RmPairDto', key?: string | null, value?: string | null } | null> | null } | null> | null } | null };

export type GenerateNetCashReportQueryVariables = Exact<{
  input: NetCashReportCriteriaDto;
}>;


export type GenerateNetCashReportQuery = { __typename?: 'Query', generateNetCashReport?: { __typename?: 'NetCashReportDtoOut', netCashReportRowDtos?: Array<{ __typename?: 'NetCashReportRowDto', machineName?: string | null, locationName?: string | null, openingTotalAmounts?: Array<{ __typename?: 'TotalAmountsDto', boxContentNodeIds?: Array<string | null> | null, totalAmounts?: Array<{ __typename?: 'AmountDto', amount?: string | null, count?: number | null, currency?: string | null } | null> | null } | null> | null, closingTotalAmounts?: Array<{ __typename?: 'TotalAmountsDto', boxContentNodeIds?: Array<string | null> | null, totalAmounts?: Array<{ __typename?: 'AmountDto', amount?: string | null, count?: number | null, currency?: string | null } | null> | null } | null> | null, transactionsInTotalAmounts?: Array<{ __typename?: 'AmountDto', amount?: string | null, count?: number | null, currency?: string | null } | null> | null, transactionsOutTotalAmounts?: Array<{ __typename?: 'AmountDto', amount?: string | null, count?: number | null, currency?: string | null } | null> | null } | null> | null } | null };

export type GenerateOpenShiftsReportQueryVariables = Exact<{
  input: OpenShiftsReportCriteriaDto;
}>;


export type GenerateOpenShiftsReportQuery = { __typename?: 'Query', generateOpenShiftsReport?: { __typename?: 'OpenShiftReportDto', columns?: Array<{ __typename?: 'ReportPairDtoOut', key?: string | null, values?: Array<string | null> | null } | null> | null, totalAmounts?: Array<{ __typename?: 'RmPairDto', key?: string | null, value?: string | null } | null> | null, rows?: Array<{ __typename?: 'OpenShiftDto', role?: string | null, userId?: string | null, userName?: string | null, totalAmounts?: Array<{ __typename?: 'RmPairDto', key?: string | null, value?: string | null } | null> | null, subRows?: Array<{ __typename?: 'TransactionsReportRowDto', nodeId?: string | null, type?: string | null, dateTime?: string | null, accountingDate?: string | null, machineNodeId?: string | null, locationNodeId?: string | null, totalAmounts?: Array<{ __typename?: 'RmPairDto', key?: string | null, value?: string | null } | null> | null } | null> | null } | null> | null } | null };

export type GenerateTransactionsReportQueryVariables = Exact<{
  input: TransactionsReportCriteriaDtoIn;
}>;


export type GenerateTransactionsReportQuery = { __typename?: 'Query', generateTransactionsReport?: { __typename?: 'ReportDtoOut', fullSize?: number | null, columns?: Array<{ __typename?: 'ReportPairDtoOut', key?: string | null, values?: Array<string | null> | null } | null> | null, rows?: Array<{ __typename?: 'CorrectionTransactionReportRowDto', nodeId?: string | null, machineNodeId?: string | null, machineName?: string | null, machineType?: string | null, locationNodeId?: string | null, comment?: string | null, createdBy?: string | null, machineUserName?: string | null, machineUserId?: string | null, sequence?: number | null, receivedDateTime?: string | null, accountingDate?: string | null, formattedAccountingDate?: string | null, formattedDateTime?: string | null, formattedReceivedDate?: string | null, transactionSeq?: number | null, type?: string | null, dateTime?: string | null, timeZoneUtcOffset?: string | null, correctionReason?: string | null, totalAmounts?: Array<{ __typename?: 'RmPairDto', key?: string | null, value?: string | null } | null> | null } | { __typename?: 'ErrorsReportRowDto' } | { __typename?: 'RmBoxContentDto' } | { __typename?: 'RmBoxExchangeDto' } | { __typename?: 'RmErrorDto' } | { __typename?: 'RmIdentifyDto' } | { __typename?: 'RmSystemStatusDto' } | { __typename?: 'RmTransactionDto' } | { __typename?: 'RmZReportDto' } | { __typename?: 'TransactionsReportRowDto', uuid?: string | null, machineName?: string | null, nodeId?: string | null, type?: string | null, dateTime?: string | null, timeZoneUtcOffset?: string | null, accountingDate?: string | null, machineNodeId?: string | null, locationNodeId?: string | null, locationName?: string | null, machineUserName?: string | null, machineUserId?: string | null, account?: string | null, subType?: string | null, sequence?: number | null, reference?: string | null, roleName?: string | null, machineType?: string | null, originUser?: string | null, originUserAccount?: string | null, transactionSeq?: number | null, workUnitName?: string | null, cardIdentifier?: string | null, mixEdited?: boolean | null, bagIds?: Array<string | null> | null, formattedAccountingDate?: string | null, formattedDateTime?: string | null, formattedReceivedDate?: string | null, receivedDateTime?: string | null, valuesByDenomination?: Array<{ __typename?: 'DenominationValueDto', denomination?: string | null, currency?: string | null, count?: number | null, type?: string | null } | null> | null, customData?: Array<{ __typename?: 'RmPairDto', key?: string | null, value?: string | null } | null> | null, totalAmounts?: Array<{ __typename?: 'RmPairDto', key?: string | null, value?: string | null } | null> | null } | null> | null } | null };

export type UpdateScheduledReportMutationVariables = Exact<{
  input: ScheduledReportDtoIn;
}>;


export type UpdateScheduledReportMutation = { __typename?: 'Mutation', updateScheduledReport?: { __typename?: 'ScheduledReportDtoOut', fileType: FileType, instanceName: string, nextExecution?: Date | string | null, nodeId?: string | null, nodeStatus?: NodeStatus | null, locationNodeIds?: Array<string | null> | null, reportName?: ScheduledReportName | null, status?: ScheduledReportStatus | null, reportEmails: Array<{ __typename?: 'ScheduledReportEmailOut', email: string, subject?: string | null } | null> } | null };

export type DeleteReportRequestMutationVariables = Exact<{
  nodeId: Scalars['String'];
}>;


export type DeleteReportRequestMutation = { __typename?: 'Mutation', deleteReportRequest?: boolean | null };

export type GetUpcomingExecutionDatesQueryVariables = Exact<{
  metadataDtoIn: MetadataDtoIn;
}>;


export type GetUpcomingExecutionDatesQuery = { __typename?: 'Query', getUpcomingExecutionDates?: Array<{ __typename?: 'PredictedExecutionDtoOut', execution?: string | null, startDate?: string | null, endDate?: string | null } | null> | null };

export type GetAllScheduledReportsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllScheduledReportsQuery = { __typename?: 'Query', getAllScheduledReports?: Array<{ __typename?: 'ScheduledReportDtoOut', nodeId?: string | null, nodeStatus?: NodeStatus | null, instanceName: string, fileType: FileType, reportName?: ScheduledReportName | null, nextExecution?: Date | string | null, status?: ScheduledReportStatus | null, inputPayload?: string | null, locationNodeIds?: Array<string | null> | null, metadata?: { __typename?: 'MetadataDtoOut', executionTime: string, zoneName: string, repeat: Repeat, repeatOnDay?: number | null, executeFrom?: Date | string | null, executeUntil?: Date | string | null, nodeId?: string | null } | null, reportEmails: Array<{ __typename?: 'ScheduledReportEmailOut', email: string, subject?: string | null } | null> } | null> | null };

export type ActivateTenantMutationVariables = Exact<{
  tenantId?: InputMaybe<Scalars['String']>;
}>;


export type ActivateTenantMutation = { __typename?: 'Mutation', activateTenant?: { __typename?: 'TenantDtoOut', nodeId?: string | null, tenantId?: string | null, nodeStatus?: NodeStatus | null } | null };

export type ConfigureTenantMutationVariables = Exact<{
  input: TenantDtoIn;
}>;


export type ConfigureTenantMutation = { __typename?: 'Mutation', configureTenant?: { __typename?: 'TenantDtoOut', billingId?: string | null, contractNumber?: string | null, createdDate?: string | null, endOfDay?: string | null, name?: string | null, nodeId?: string | null, tenantId?: string | null, nodeStatus?: NodeStatus | null, updatedDate?: string | null, nodeChangeDate?: Date | string | null, licenseAutoRenewalEnabled?: boolean | null, licenseValidityIntervalDays?: number | null, allowedLicenseFeatureKeys?: Array<string | null> | null, machineTypes?: Array<{ __typename?: 'MachineTypeDto', name: string, nodeId?: string | null, table: string, imageUrl?: string | null, licenseLabel?: string | null, licenseLevel?: string | null } | null> | null } | null };

export type CreateTenantWithExistingUserMutationVariables = Exact<{
  tenant: TenantWithExistingUserDtoIn;
}>;


export type CreateTenantWithExistingUserMutation = { __typename?: 'Mutation', createTenantWithExistingUser?: { __typename?: 'TenantDtoOut', billingId?: string | null, contractNumber?: string | null, createdDate?: string | null, endOfDay?: string | null, name?: string | null, nodeId?: string | null, tenantId?: string | null, nodeStatus?: NodeStatus | null, updatedDate?: string | null, nodeChangeDate?: Date | string | null, machineTypes?: Array<{ __typename?: 'MachineTypeDto', name: string, nodeId?: string | null, table: string, imageUrl?: string | null, licenseLabel?: string | null, licenseLevel?: string | null } | null> | null } | null };

export type CreateTenantWithNewUserMutationVariables = Exact<{
  tenant?: InputMaybe<TenantWithNewUserDtoIn>;
}>;


export type CreateTenantWithNewUserMutation = { __typename?: 'Mutation', createTenantWithNewUser?: { __typename?: 'TenantDtoOut', billingId?: string | null, contractNumber?: string | null, createdDate?: string | null, endOfDay?: string | null, name?: string | null, nodeId?: string | null, tenantId?: string | null, nodeStatus?: NodeStatus | null, updatedDate?: string | null, nodeChangeDate?: Date | string | null, machineTypes?: Array<{ __typename?: 'MachineTypeDto', name: string, nodeId?: string | null, table: string, imageUrl?: string | null, licenseLabel?: string | null, licenseLevel?: string | null } | null> | null } | null };

export type DeactivateTenantMutationVariables = Exact<{
  tenantId: Scalars['String'];
}>;


export type DeactivateTenantMutation = { __typename?: 'Mutation', deactivateTenant?: { __typename?: 'TenantDtoOut', nodeId?: string | null, tenantId?: string | null, nodeStatus?: NodeStatus | null } | null };

export type FindAllTenantsQueryVariables = Exact<{ [key: string]: never; }>;


export type FindAllTenantsQuery = { __typename?: 'Query', findAllTenants?: Array<{ __typename?: 'TenantDtoOut', billingId?: string | null, contractNumber?: string | null, createdDate?: string | null, endOfDay?: string | null, name?: string | null, nodeId?: string | null, tenantId?: string | null, nodeStatus?: NodeStatus | null, updatedDate?: string | null, nodeChangeDate?: Date | string | null, allowedLicenseFeatureKeys?: Array<string | null> | null, licenseAutoRenewalEnabled?: boolean | null, licenseValidityIntervalDays?: number | null, machineTypes?: Array<{ __typename?: 'MachineTypeDto', name: string, nodeId?: string | null, table: string, imageUrl?: string | null, licenseLabel?: string | null, licenseLevel?: string | null } | null> | null } | null> | null };

export type FindMyTenantsMetadataQueryVariables = Exact<{ [key: string]: never; }>;


export type FindMyTenantsMetadataQuery = { __typename?: 'Query', findMyTenantsMetadata?: Array<{ __typename?: 'TenantMetadataDtoOut', domainName?: string | null, nodeStatus?: NodeStatus | null, tenantId?: string | null, tenantName?: string | null } | null> | null };

export type FindTenantByTenantIdQueryVariables = Exact<{
  tenantId: Scalars['String'];
}>;


export type FindTenantByTenantIdQuery = { __typename?: 'Query', findTenantByTenantId?: { __typename?: 'TenantDtoOut', billingId?: string | null, contractNumber?: string | null, createdDate?: string | null, endOfDay?: string | null, name?: string | null, nodeId?: string | null, tenantId?: string | null, nodeStatus?: NodeStatus | null, updatedDate?: string | null, nodeChangeDate?: Date | string | null, licenseAutoRenewalEnabled?: boolean | null, licenseValidityIntervalDays?: number | null, allowedLicenseFeatureKeys?: Array<string | null> | null, machineTypes?: Array<{ __typename?: 'MachineTypeDto', name: string, nodeId?: string | null, table: string, imageUrl?: string | null, licenseLabel?: string | null, licenseLevel?: string | null } | null> | null } | null };

export type FindTenantFeaturesQueryVariables = Exact<{
  tenantId: Scalars['String'];
}>;


export type FindTenantFeaturesQuery = { __typename?: 'Query', findTenantFeatures?: { __typename?: 'TenantFeaturesDto', userBalanceEnabled?: boolean | null, commonSoftwarePackageUploadEnabled?: boolean | null, mumEnabled?: boolean | null, mumXmlImportEnabled?: boolean | null } | null };

export type SetTenantFeaturesMutationVariables = Exact<{
  features: TenantFeaturesDtoIn;
  tenantId: Scalars['String'];
}>;


export type SetTenantFeaturesMutation = { __typename?: 'Mutation', setTenantFeatures?: { __typename?: 'TenantFeaturesDto', userBalanceEnabled?: boolean | null, commonSoftwarePackageUploadEnabled?: boolean | null, mumEnabled?: boolean | null, mumXmlImportEnabled?: boolean | null } | null };

export type UpdateTenantMutationVariables = Exact<{
  tenant: TenantUpdateDtoIn;
}>;


export type UpdateTenantMutation = { __typename?: 'Mutation', updateTenant?: { __typename?: 'TenantDtoOut', billingId?: string | null, contractNumber?: string | null, createdDate?: string | null, endOfDay?: string | null, name?: string | null, nodeId?: string | null, tenantId?: string | null, nodeStatus?: NodeStatus | null, updatedDate?: string | null, nodeChangeDate?: Date | string | null, machineTypes?: Array<{ __typename?: 'MachineTypeDto', name: string, nodeId?: string | null, table: string, imageUrl?: string | null, licenseLabel?: string | null, licenseLevel?: string | null } | null> | null } | null };

export type CreateCorrectionReasonMutationVariables = Exact<{
  correctionReason: CorrectionReasonDtoIn;
}>;


export type CreateCorrectionReasonMutation = { __typename?: 'Mutation', createCorrectionReason?: { __typename?: 'CorrectionReasonDtoOut', nodeId?: string | null, name?: string | null, active?: boolean | null, lastEditedDate?: Date | string | null, lastEditedBy?: string | null } | null };

export type CreateCorrectionTransactionMutationVariables = Exact<{
  input: CorrectionTransactionDtoIn;
}>;


export type CreateCorrectionTransactionMutation = { __typename?: 'Mutation', createCorrectionTransaction?: { __typename?: 'CorrectionTransactionDtoOut', nodeId?: string | null } | null };

export type DeleteCorrectionReasonMutationVariables = Exact<{
  nodeId: Scalars['String'];
}>;


export type DeleteCorrectionReasonMutation = { __typename?: 'Mutation', deleteCorrectionReason?: boolean | null };

export type FindAllCorrectionReasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type FindAllCorrectionReasonsQuery = { __typename?: 'Query', findAllCorrectionReasons?: Array<{ __typename?: 'CorrectionReasonDtoOut', nodeId?: string | null, name?: string | null, active?: boolean | null, lastEditedBy?: string | null, lastEditedDate?: Date | string | null } | null> | null };

export type FindUserBalancesFilteredQueryVariables = Exact<{
  searchRequest: SearchRequestDto;
  userBalanceFiltersDto?: InputMaybe<UserBalanceFiltersDto>;
}>;


export type FindUserBalancesFilteredQuery = { __typename?: 'Query', findUserBalancesFiltered?: { __typename?: 'SearchResultDto', fullSize?: number | null, result?: Array<{ __typename?: 'LaneAllocationDto', nodeId?: string | null } | { __typename?: 'LocationDtoOut', nodeId?: string | null } | { __typename?: 'MachineDtoOut', nodeId?: string | null } | { __typename?: 'MachineGroupDtoOut', nodeId?: string | null } | { __typename?: 'MachineHistoryStatusDto', nodeId?: string | null } | { __typename?: 'MachineOnlineStatusDto', nodeId?: string | null } | { __typename?: 'MachineOnlineWithHistoryStatusDto', nodeId?: string | null } | { __typename?: 'MachineUserDtoOut', nodeId?: string | null } | { __typename?: 'MachineUserGroupDtoOut', nodeId?: string | null } | { __typename?: 'MetadataDtoOut', nodeId?: string | null } | { __typename?: 'OtaAuthorizationDto', nodeId?: string | null } | { __typename?: 'OtaCodeDtoOut', nodeId?: string | null } | { __typename?: 'ScheduledReportDtoOut', nodeId?: string | null } | { __typename?: 'SingleExecutionDtoOut', nodeId?: string | null } | { __typename?: 'SmartLocationGroupDtoOut', nodeId?: string | null } | { __typename?: 'SoftwarePackageDtoOut', nodeId?: string | null } | { __typename?: 'TemplateDtoOut', nodeId: string } | { __typename?: 'UserBalanceDtoOut', date?: Date | string | null, currencyCode?: string | null, balance?: string | null, nodeId?: string | null, machineUser?: { __typename?: 'MachineUserDtoOut', nodeId?: string | null, name?: string | null } | null } | null> | null } | null };

export type GetSumValueOfTransactionsQueryVariables = Exact<{
  dateTime: Scalars['DateTime'];
  currency: Scalars['String'];
  locationId?: InputMaybe<Scalars['String']>;
  machineNodeId?: InputMaybe<Scalars['String']>;
  transactionType?: InputMaybe<TransactionType>;
  transactionDateTime: TransactionDateTime;
  zoneId?: InputMaybe<Scalars['ZoneId']>;
}>;


export type GetSumValueOfTransactionsQuery = { __typename?: 'Query', dispense?: number | null, deposit?: number | null, emptyOut?: number | null, endOfShift?: number | null, manualRefill?: number | null, exchange?: number | null, purge?: number | null, possibleTampering?: number | null, unfinishedTransaction?: number | null, refill?: number | null };

export type UpdateCorrectionReasonMutationVariables = Exact<{
  nodeId: Scalars['String'];
  correctionReason: CorrectionReasonDtoIn;
}>;


export type UpdateCorrectionReasonMutation = { __typename?: 'Mutation', updateCorrectionReason?: { __typename?: 'CorrectionReasonDtoOut', nodeId?: string | null, name?: string | null, active?: boolean | null, lastEditedDate?: Date | string | null, lastEditedBy?: string | null } | null };

export type ActiveDeactivateUserMutationVariables = Exact<{
  domainName?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
  activeOrDeactivate?: InputMaybe<Scalars['Boolean']>;
}>;


export type ActiveDeactivateUserMutation = { __typename?: 'Mutation', activeDeactivateUser?: boolean | null };

export type CreateUserMutationVariables = Exact<{
  isUserDtoInDto?: InputMaybe<IsUserDtoInDto>;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser?: boolean | null };

export type DeleteUserMutationVariables = Exact<{
  domainName?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser?: boolean | null };

export type FindAllDomainNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type FindAllDomainNamesQuery = { __typename?: 'Query', findAllDomainNames?: Array<string | null> | null };

export type FindListOfUsersQueryVariables = Exact<{
  domainName: Scalars['String'];
  isUserFilterDtoIn?: InputMaybe<IsUserFilterDtoIn>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type FindListOfUsersQuery = { __typename?: 'Query', findListOfUsers?: { __typename?: 'IdentifyUserListDtoOut', totalResults?: number | null, isUserDtoOut?: Array<{ __typename?: 'IdentifyUserDtoOut', accountLocked?: boolean | null, userName?: string | null, domainName?: string | null, createdDate?: string | null, lastModifiedDate?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, tenantPermissions?: Array<{ __typename?: 'UserIdentifyRolOrGroupDtoOut', name?: string | null } | null> | null, locationGroupPermissions?: Array<{ __typename?: 'UserIdentifyRolOrGroupDtoOut', name?: string | null } | null> | null, locationPermissions?: Array<{ __typename?: 'UserIdentifyRolOrGroupDtoOut', name?: string | null } | null> | null, machinePermissions?: Array<{ __typename?: 'UserIdentifyRolOrGroupDtoOut', name?: string | null } | null> | null, userRoles?: Array<{ __typename?: 'UserIdentifyRolOrGroupDtoOut', name?: string | null } | null> | null } | null> | null } | null };

export type FindListOfUsersByTenantQueryVariables = Exact<{
  filterByUserName?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type FindListOfUsersByTenantQuery = { __typename?: 'Query', findListOfUsersByTenant?: { __typename?: 'IdentifyUserListDtoOut', totalResults?: number | null, isUserDtoOut?: Array<{ __typename?: 'IdentifyUserDtoOut', accountLocked?: boolean | null, userName?: string | null, domainName?: string | null, createdDate?: string | null, lastModifiedDate?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, locationGroupPermissions?: Array<{ __typename?: 'UserIdentifyRolOrGroupDtoOut', name?: string | null } | null> | null, locationPermissions?: Array<{ __typename?: 'UserIdentifyRolOrGroupDtoOut', name?: string | null } | null> | null, machinePermissions?: Array<{ __typename?: 'UserIdentifyRolOrGroupDtoOut', name?: string | null } | null> | null, tenantPermissions?: Array<{ __typename?: 'UserIdentifyRolOrGroupDtoOut', name?: string | null } | null> | null, userRoles?: Array<{ __typename?: 'UserIdentifyRolOrGroupDtoOut', name?: string | null } | null> | null } | null> | null } | null };

export type FindUserPermissionListQueryVariables = Exact<{ [key: string]: never; }>;


export type FindUserPermissionListQuery = { __typename?: 'Query', findUserPermissionList?: { __typename?: 'IdentifyRolesDtoOut', totalResults?: number | null, userRoles?: Array<{ __typename?: 'UserIdentifyRolOrGroupDtoOut', name?: string | null } | null> | null } | null };

export type FindUserRolesListQueryVariables = Exact<{
  domainName: Scalars['String'];
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type FindUserRolesListQuery = { __typename?: 'Query', findUserRolesList?: { __typename?: 'IdentifyRolesDtoOut', totalResults?: number | null, userRoles?: Array<{ __typename?: 'UserIdentifyRolOrGroupDtoOut', name?: string | null } | null> | null } | null };

export type UpdateUserPasswordMutationVariables = Exact<{
  domainName?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
}>;


export type UpdateUserPasswordMutation = { __typename?: 'Mutation', updateUserPassword?: boolean | null };

export type UpdateUserPermissionOrRoleMutationVariables = Exact<{
  isUserUpdateDtoIn?: InputMaybe<IsUserUpdateDtoIn>;
}>;


export type UpdateUserPermissionOrRoleMutation = { __typename?: 'Mutation', updateUserPermissionOrRole?: boolean | null };

export type CancelDeploymentMutationVariables = Exact<{
  nodeId: Scalars['String'];
}>;


export type CancelDeploymentMutation = { __typename?: 'Mutation', cancelDeployment?: boolean | null };

export type DeleteLogMutationVariables = Exact<{
  nodeId: Scalars['String'];
}>;


export type DeleteLogMutation = { __typename?: 'Mutation', deleteLog?: boolean | null };

export type DeleteRmCommandMutationVariables = Exact<{
  commandNodeId: Scalars['String'];
}>;


export type DeleteRmCommandMutation = { __typename?: 'Mutation', deleteRmCommand?: boolean | null };

export type DeleteSoftwareInstallationMutationVariables = Exact<{
  nodeId: Scalars['String'];
}>;


export type DeleteSoftwareInstallationMutation = { __typename?: 'Mutation', deleteSoftwareInstallation?: boolean | null };

export type FindSoftwareInstallationsQueryVariables = Exact<{
  installationNodeId?: InputMaybe<Scalars['String']>;
  machineNodeId?: InputMaybe<Scalars['String']>;
  ongoing?: InputMaybe<Scalars['Boolean']>;
  current?: InputMaybe<Scalars['Boolean']>;
}>;


export type FindSoftwareInstallationsQuery = { __typename?: 'Query', findSoftwareInstallations?: Array<{ __typename?: 'SoftwareInstallationDtoOut', nodeId?: string | null, createdBy?: string | null, createdDate?: Date | string | null, scheduleInfo?: string | null, stateChangedDate?: Date | string | null } | null> | null };

export type GetAllCommandsQueryVariables = Exact<{
  machineNodeId: Scalars['String'];
  cpPageRequest: CpPageRequest;
}>;


export type GetAllCommandsQuery = { __typename?: 'Query', getAllCommands?: Array<{ __typename?: 'RmCommandDto', ended?: string | null, executedBy?: string | null, machineNodeId?: string | null, name?: string | null, nodeId?: string | null, started?: string | null, status?: string | null, parameters?: { __typename?: 'RmCommandParametersDto', deviceId?: string | null, from?: Date | string | null, link?: string | null, systemDump?: boolean | null, timeout?: number | null, types?: Array<string | null> | null, until?: Date | string | null } | null } | null> | null };

export type GetAllLogsQueryVariables = Exact<{
  machineNodeId: Scalars['String'];
  cpPageRequest: CpPageRequest;
}>;


export type GetAllLogsQuery = { __typename?: 'Query', getAllLogs?: Array<{ __typename?: 'LogInfoDto', fromDate?: Date | string | null, nodeId?: string | null, numberOfLogfiles?: number | null, originUri?: string | null, retrievalDate?: Date | string | null, retrievedBy?: string | null, size?: number | null, toDate?: Date | string | null, zipFileName?: string | null } | null> | null };

export type GetDeploymentsForMachineNodeIdQueryVariables = Exact<{
  machineUuid: Scalars['String'];
}>;


export type GetDeploymentsForMachineNodeIdQuery = { __typename?: 'Query', getDeploymentsForMachineNodeId?: Array<{ __typename?: 'DeploymentDtoOut', createdBy?: string | null, current?: boolean | null, machineNodeId?: string | null, nodeId?: string | null, scheduleInfo?: string | null, state?: string | null, statusChangedDate?: Date | string | null, template?: { __typename?: 'TemplateDtoOut', createdBy?: string | null, description?: string | null, fileName: string, name: string, nodeId: string, parts?: Array<string | null> | null, version?: string | null } | null } | null> | null };

export type GetLogLinksQueryVariables = Exact<{
  key: Scalars['String'];
}>;


export type GetLogLinksQuery = { __typename?: 'Query', getLogLinks?: { __typename?: 'S3PreSignedData', urlForDelete?: string | null, urlForGet?: string | null, urlForPut?: string | null } | null };

export type PostRebootCommandMutationVariables = Exact<{
  machineNodeId: Scalars['String'];
}>;


export type PostRebootCommandMutation = { __typename?: 'Mutation', postRebootCommand?: { __typename?: 'RmCommandDto', machineNodeId?: string | null, name?: string | null, nodeId?: string | null } | null };

export type PostRestartCommandMutationVariables = Exact<{
  machineNodeId: Scalars['String'];
}>;


export type PostRestartCommandMutation = { __typename?: 'Mutation', postRestartCommand?: { __typename?: 'RmCommandDto', machineNodeId?: string | null, nodeId?: string | null, name?: string | null } | null };

export type PostRetrieveLogsMutationVariables = Exact<{
  logSearch?: InputMaybe<LogSearchDtoIn>;
}>;


export type PostRetrieveLogsMutation = { __typename?: 'Mutation', postRetrieveLogs?: { __typename?: 'RmCommandDto', ended?: string | null, executedBy?: string | null, machineNodeId?: string | null, name?: string | null, nodeId?: string | null, started?: string | null, status?: string | null, parameters?: { __typename?: 'RmCommandParametersDto', deviceId?: string | null, from?: Date | string | null, link?: string | null, systemDump?: boolean | null, timeout?: number | null, types?: Array<string | null> | null, until?: Date | string | null } | null } | null };

export const MachineUserGroupFragmentFragmentDoc = gql`
    fragment MachineUserGroupFragment on MachineUserGroupDtoOut {
  nodeId
  name
  machines {
    nodeId
    name
    uuid
  }
  machineUsers {
    nodeId
    name
  }
  machinesCount
  machineUsersCount
}
    `;
export const ChartMapFragmentDoc = gql`
    fragment ChartMap on ChartBarDto {
  color
  description
  name
  percent
  totalCount
  type
}
    `;
export const AddMachineUsersToMachineUserGroupDocument = gql`
    mutation addMachineUsersToMachineUserGroup($machineUserNodeIds: [String]!, $nodeId: String!) {
  addMachineUsersToMachineUserGroup(
    machineUserNodeIds: $machineUserNodeIds
    nodeId: $nodeId
  ) {
    nodeId
    machineUsersCount
    machineUsers {
      nodeId
      name
      machineUserGroupNodeIds
    }
  }
}
    `;
export type AddMachineUsersToMachineUserGroupMutationFn = Apollo.MutationFunction<AddMachineUsersToMachineUserGroupMutation, AddMachineUsersToMachineUserGroupMutationVariables>;

/**
 * __useAddMachineUsersToMachineUserGroupMutation__
 *
 * To run a mutation, you first call `useAddMachineUsersToMachineUserGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMachineUsersToMachineUserGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMachineUsersToMachineUserGroupMutation, { data, loading, error }] = useAddMachineUsersToMachineUserGroupMutation({
 *   variables: {
 *      machineUserNodeIds: // value for 'machineUserNodeIds'
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useAddMachineUsersToMachineUserGroupMutation(baseOptions?: Apollo.MutationHookOptions<AddMachineUsersToMachineUserGroupMutation, AddMachineUsersToMachineUserGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMachineUsersToMachineUserGroupMutation, AddMachineUsersToMachineUserGroupMutationVariables>(AddMachineUsersToMachineUserGroupDocument, options);
      }
export type AddMachineUsersToMachineUserGroupMutationHookResult = ReturnType<typeof useAddMachineUsersToMachineUserGroupMutation>;
export type AddMachineUsersToMachineUserGroupMutationResult = Apollo.MutationResult<AddMachineUsersToMachineUserGroupMutation>;
export type AddMachineUsersToMachineUserGroupMutationOptions = Apollo.BaseMutationOptions<AddMachineUsersToMachineUserGroupMutation, AddMachineUsersToMachineUserGroupMutationVariables>;
export const AddMachinesToMachineUserGroupDocument = gql`
    mutation addMachinesToMachineUserGroup($machineNodeIds: [String]!, $nodeId: String!) {
  addMachinesToMachineUserGroup(machineNodeIds: $machineNodeIds, nodeId: $nodeId) {
    nodeId
    machinesCount
    machines {
      nodeId
      name
    }
  }
}
    `;
export type AddMachinesToMachineUserGroupMutationFn = Apollo.MutationFunction<AddMachinesToMachineUserGroupMutation, AddMachinesToMachineUserGroupMutationVariables>;

/**
 * __useAddMachinesToMachineUserGroupMutation__
 *
 * To run a mutation, you first call `useAddMachinesToMachineUserGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMachinesToMachineUserGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMachinesToMachineUserGroupMutation, { data, loading, error }] = useAddMachinesToMachineUserGroupMutation({
 *   variables: {
 *      machineNodeIds: // value for 'machineNodeIds'
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useAddMachinesToMachineUserGroupMutation(baseOptions?: Apollo.MutationHookOptions<AddMachinesToMachineUserGroupMutation, AddMachinesToMachineUserGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMachinesToMachineUserGroupMutation, AddMachinesToMachineUserGroupMutationVariables>(AddMachinesToMachineUserGroupDocument, options);
      }
export type AddMachinesToMachineUserGroupMutationHookResult = ReturnType<typeof useAddMachinesToMachineUserGroupMutation>;
export type AddMachinesToMachineUserGroupMutationResult = Apollo.MutationResult<AddMachinesToMachineUserGroupMutation>;
export type AddMachinesToMachineUserGroupMutationOptions = Apollo.BaseMutationOptions<AddMachinesToMachineUserGroupMutation, AddMachinesToMachineUserGroupMutationVariables>;
export const CreateDeploymentsDocument = gql`
    mutation createDeployments($deployment: DeploymentDtoIn!) {
  createDeployments(deployment: $deployment) {
    createdBy
    current
    machineNodeId
    nodeId
    scheduleInfo
    state
    statusChangedDate
    template {
      nodeId
    }
  }
}
    `;
export type CreateDeploymentsMutationFn = Apollo.MutationFunction<CreateDeploymentsMutation, CreateDeploymentsMutationVariables>;

/**
 * __useCreateDeploymentsMutation__
 *
 * To run a mutation, you first call `useCreateDeploymentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeploymentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDeploymentsMutation, { data, loading, error }] = useCreateDeploymentsMutation({
 *   variables: {
 *      deployment: // value for 'deployment'
 *   },
 * });
 */
export function useCreateDeploymentsMutation(baseOptions?: Apollo.MutationHookOptions<CreateDeploymentsMutation, CreateDeploymentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDeploymentsMutation, CreateDeploymentsMutationVariables>(CreateDeploymentsDocument, options);
      }
export type CreateDeploymentsMutationHookResult = ReturnType<typeof useCreateDeploymentsMutation>;
export type CreateDeploymentsMutationResult = Apollo.MutationResult<CreateDeploymentsMutation>;
export type CreateDeploymentsMutationOptions = Apollo.BaseMutationOptions<CreateDeploymentsMutation, CreateDeploymentsMutationVariables>;
export const CreateMachineGroupDocument = gql`
    mutation createMachineGroup($input: MachineGroupDtoIn) {
  createMachineGroup(machineGroup: $input) {
    nodeId
    name
    machines {
      name
      uuid
      nodeId
    }
    nodeStatus
    nodeChangeDate
  }
}
    `;
export type CreateMachineGroupMutationFn = Apollo.MutationFunction<CreateMachineGroupMutation, CreateMachineGroupMutationVariables>;

/**
 * __useCreateMachineGroupMutation__
 *
 * To run a mutation, you first call `useCreateMachineGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMachineGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMachineGroupMutation, { data, loading, error }] = useCreateMachineGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMachineGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateMachineGroupMutation, CreateMachineGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMachineGroupMutation, CreateMachineGroupMutationVariables>(CreateMachineGroupDocument, options);
      }
export type CreateMachineGroupMutationHookResult = ReturnType<typeof useCreateMachineGroupMutation>;
export type CreateMachineGroupMutationResult = Apollo.MutationResult<CreateMachineGroupMutation>;
export type CreateMachineGroupMutationOptions = Apollo.BaseMutationOptions<CreateMachineGroupMutation, CreateMachineGroupMutationVariables>;
export const CreateMachineUserGroupDocument = gql`
    mutation createMachineUserGroup($input: MachineUserGroupDtoIn!) {
  createMachineUserGroup(machineUserGroup: $input) {
    ...MachineUserGroupFragment
  }
}
    ${MachineUserGroupFragmentFragmentDoc}`;
export type CreateMachineUserGroupMutationFn = Apollo.MutationFunction<CreateMachineUserGroupMutation, CreateMachineUserGroupMutationVariables>;

/**
 * __useCreateMachineUserGroupMutation__
 *
 * To run a mutation, you first call `useCreateMachineUserGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMachineUserGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMachineUserGroupMutation, { data, loading, error }] = useCreateMachineUserGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMachineUserGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateMachineUserGroupMutation, CreateMachineUserGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMachineUserGroupMutation, CreateMachineUserGroupMutationVariables>(CreateMachineUserGroupDocument, options);
      }
export type CreateMachineUserGroupMutationHookResult = ReturnType<typeof useCreateMachineUserGroupMutation>;
export type CreateMachineUserGroupMutationResult = Apollo.MutationResult<CreateMachineUserGroupMutation>;
export type CreateMachineUserGroupMutationOptions = Apollo.BaseMutationOptions<CreateMachineUserGroupMutation, CreateMachineUserGroupMutationVariables>;
export const CreateSoftwareInstallationsDocument = gql`
    mutation createSoftwareInstallations($softwareInstallation: SoftwareInstallationDtoIn!) {
  createSoftwareInstallations(softwareInstallation: $softwareInstallation) {
    createdBy
    createdDate
    machineNodeId
    nodeId
    stateChangedDate
    scheduleInfo
    softwarePackage {
      nodeId
    }
  }
}
    `;
export type CreateSoftwareInstallationsMutationFn = Apollo.MutationFunction<CreateSoftwareInstallationsMutation, CreateSoftwareInstallationsMutationVariables>;

/**
 * __useCreateSoftwareInstallationsMutation__
 *
 * To run a mutation, you first call `useCreateSoftwareInstallationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSoftwareInstallationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSoftwareInstallationsMutation, { data, loading, error }] = useCreateSoftwareInstallationsMutation({
 *   variables: {
 *      softwareInstallation: // value for 'softwareInstallation'
 *   },
 * });
 */
export function useCreateSoftwareInstallationsMutation(baseOptions?: Apollo.MutationHookOptions<CreateSoftwareInstallationsMutation, CreateSoftwareInstallationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSoftwareInstallationsMutation, CreateSoftwareInstallationsMutationVariables>(CreateSoftwareInstallationsDocument, options);
      }
export type CreateSoftwareInstallationsMutationHookResult = ReturnType<typeof useCreateSoftwareInstallationsMutation>;
export type CreateSoftwareInstallationsMutationResult = Apollo.MutationResult<CreateSoftwareInstallationsMutation>;
export type CreateSoftwareInstallationsMutationOptions = Apollo.BaseMutationOptions<CreateSoftwareInstallationsMutation, CreateSoftwareInstallationsMutationVariables>;
export const CreateSoftwarePackageDocument = gql`
    mutation createSoftwarePackage($input: SoftwarePackageDtoIn!) {
  createSoftwarePackage(softwarePackage: $input) {
    nodeId
    common
    productName
    releaseInfo
    revision
    version
    createdBy
    createdDate
    description
    fileName
    id
    label
    name
    originUri
  }
}
    `;
export type CreateSoftwarePackageMutationFn = Apollo.MutationFunction<CreateSoftwarePackageMutation, CreateSoftwarePackageMutationVariables>;

/**
 * __useCreateSoftwarePackageMutation__
 *
 * To run a mutation, you first call `useCreateSoftwarePackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSoftwarePackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSoftwarePackageMutation, { data, loading, error }] = useCreateSoftwarePackageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSoftwarePackageMutation(baseOptions?: Apollo.MutationHookOptions<CreateSoftwarePackageMutation, CreateSoftwarePackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSoftwarePackageMutation, CreateSoftwarePackageMutationVariables>(CreateSoftwarePackageDocument, options);
      }
export type CreateSoftwarePackageMutationHookResult = ReturnType<typeof useCreateSoftwarePackageMutation>;
export type CreateSoftwarePackageMutationResult = Apollo.MutationResult<CreateSoftwarePackageMutation>;
export type CreateSoftwarePackageMutationOptions = Apollo.BaseMutationOptions<CreateSoftwarePackageMutation, CreateSoftwarePackageMutationVariables>;
export const CreateTemplateDocument = gql`
    mutation createTemplate($template: TemplateDtoIn!) {
  createTemplate(template: $template) {
    nodeId
    name
    description
    version
    fileName
    parts
  }
}
    `;
export type CreateTemplateMutationFn = Apollo.MutationFunction<CreateTemplateMutation, CreateTemplateMutationVariables>;

/**
 * __useCreateTemplateMutation__
 *
 * To run a mutation, you first call `useCreateTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTemplateMutation, { data, loading, error }] = useCreateTemplateMutation({
 *   variables: {
 *      template: // value for 'template'
 *   },
 * });
 */
export function useCreateTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateTemplateMutation, CreateTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTemplateMutation, CreateTemplateMutationVariables>(CreateTemplateDocument, options);
      }
export type CreateTemplateMutationHookResult = ReturnType<typeof useCreateTemplateMutation>;
export type CreateTemplateMutationResult = Apollo.MutationResult<CreateTemplateMutation>;
export type CreateTemplateMutationOptions = Apollo.BaseMutationOptions<CreateTemplateMutation, CreateTemplateMutationVariables>;
export const DeactivateLaneAllocationDocument = gql`
    mutation deactivateLaneAllocation($allocationNodeId: String!) {
  deactivateLaneAllocation(allocationNodeId: $allocationNodeId)
}
    `;
export type DeactivateLaneAllocationMutationFn = Apollo.MutationFunction<DeactivateLaneAllocationMutation, DeactivateLaneAllocationMutationVariables>;

/**
 * __useDeactivateLaneAllocationMutation__
 *
 * To run a mutation, you first call `useDeactivateLaneAllocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateLaneAllocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateLaneAllocationMutation, { data, loading, error }] = useDeactivateLaneAllocationMutation({
 *   variables: {
 *      allocationNodeId: // value for 'allocationNodeId'
 *   },
 * });
 */
export function useDeactivateLaneAllocationMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateLaneAllocationMutation, DeactivateLaneAllocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateLaneAllocationMutation, DeactivateLaneAllocationMutationVariables>(DeactivateLaneAllocationDocument, options);
      }
export type DeactivateLaneAllocationMutationHookResult = ReturnType<typeof useDeactivateLaneAllocationMutation>;
export type DeactivateLaneAllocationMutationResult = Apollo.MutationResult<DeactivateLaneAllocationMutation>;
export type DeactivateLaneAllocationMutationOptions = Apollo.BaseMutationOptions<DeactivateLaneAllocationMutation, DeactivateLaneAllocationMutationVariables>;
export const DeleteMachineGroupDocument = gql`
    mutation deleteMachineGroup($nodeId: String!) {
  deleteMachineGroup(nodeId: $nodeId) {
    nodeId
    machines {
      uuid
      nodeId
    }
    nodeStatus
    nodeChangeDate
  }
}
    `;
export type DeleteMachineGroupMutationFn = Apollo.MutationFunction<DeleteMachineGroupMutation, DeleteMachineGroupMutationVariables>;

/**
 * __useDeleteMachineGroupMutation__
 *
 * To run a mutation, you first call `useDeleteMachineGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMachineGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMachineGroupMutation, { data, loading, error }] = useDeleteMachineGroupMutation({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useDeleteMachineGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMachineGroupMutation, DeleteMachineGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMachineGroupMutation, DeleteMachineGroupMutationVariables>(DeleteMachineGroupDocument, options);
      }
export type DeleteMachineGroupMutationHookResult = ReturnType<typeof useDeleteMachineGroupMutation>;
export type DeleteMachineGroupMutationResult = Apollo.MutationResult<DeleteMachineGroupMutation>;
export type DeleteMachineGroupMutationOptions = Apollo.BaseMutationOptions<DeleteMachineGroupMutation, DeleteMachineGroupMutationVariables>;
export const DeleteMachineUserGroupByNodeIdDocument = gql`
    mutation deleteMachineUserGroupByNodeId($nodeId: String!) {
  deleteMachineUserGroupByNodeId(nodeId: $nodeId) {
    nodeId
    name
  }
}
    `;
export type DeleteMachineUserGroupByNodeIdMutationFn = Apollo.MutationFunction<DeleteMachineUserGroupByNodeIdMutation, DeleteMachineUserGroupByNodeIdMutationVariables>;

/**
 * __useDeleteMachineUserGroupByNodeIdMutation__
 *
 * To run a mutation, you first call `useDeleteMachineUserGroupByNodeIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMachineUserGroupByNodeIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMachineUserGroupByNodeIdMutation, { data, loading, error }] = useDeleteMachineUserGroupByNodeIdMutation({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useDeleteMachineUserGroupByNodeIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMachineUserGroupByNodeIdMutation, DeleteMachineUserGroupByNodeIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMachineUserGroupByNodeIdMutation, DeleteMachineUserGroupByNodeIdMutationVariables>(DeleteMachineUserGroupByNodeIdDocument, options);
      }
export type DeleteMachineUserGroupByNodeIdMutationHookResult = ReturnType<typeof useDeleteMachineUserGroupByNodeIdMutation>;
export type DeleteMachineUserGroupByNodeIdMutationResult = Apollo.MutationResult<DeleteMachineUserGroupByNodeIdMutation>;
export type DeleteMachineUserGroupByNodeIdMutationOptions = Apollo.BaseMutationOptions<DeleteMachineUserGroupByNodeIdMutation, DeleteMachineUserGroupByNodeIdMutationVariables>;
export const DeleteSmartLocationGroupDocument = gql`
    mutation deleteSmartLocationGroup($nodeId: String) {
  deleteSmartLocationGroup(nodeId: $nodeId)
}
    `;
export type DeleteSmartLocationGroupMutationFn = Apollo.MutationFunction<DeleteSmartLocationGroupMutation, DeleteSmartLocationGroupMutationVariables>;

/**
 * __useDeleteSmartLocationGroupMutation__
 *
 * To run a mutation, you first call `useDeleteSmartLocationGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSmartLocationGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSmartLocationGroupMutation, { data, loading, error }] = useDeleteSmartLocationGroupMutation({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useDeleteSmartLocationGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSmartLocationGroupMutation, DeleteSmartLocationGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSmartLocationGroupMutation, DeleteSmartLocationGroupMutationVariables>(DeleteSmartLocationGroupDocument, options);
      }
export type DeleteSmartLocationGroupMutationHookResult = ReturnType<typeof useDeleteSmartLocationGroupMutation>;
export type DeleteSmartLocationGroupMutationResult = Apollo.MutationResult<DeleteSmartLocationGroupMutation>;
export type DeleteSmartLocationGroupMutationOptions = Apollo.BaseMutationOptions<DeleteSmartLocationGroupMutation, DeleteSmartLocationGroupMutationVariables>;
export const DeleteSoftwarePackageDocument = gql`
    mutation deleteSoftwarePackage($nodeId: String!) {
  deleteSoftwarePackage(nodeId: $nodeId)
}
    `;
export type DeleteSoftwarePackageMutationFn = Apollo.MutationFunction<DeleteSoftwarePackageMutation, DeleteSoftwarePackageMutationVariables>;

/**
 * __useDeleteSoftwarePackageMutation__
 *
 * To run a mutation, you first call `useDeleteSoftwarePackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSoftwarePackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSoftwarePackageMutation, { data, loading, error }] = useDeleteSoftwarePackageMutation({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useDeleteSoftwarePackageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSoftwarePackageMutation, DeleteSoftwarePackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSoftwarePackageMutation, DeleteSoftwarePackageMutationVariables>(DeleteSoftwarePackageDocument, options);
      }
export type DeleteSoftwarePackageMutationHookResult = ReturnType<typeof useDeleteSoftwarePackageMutation>;
export type DeleteSoftwarePackageMutationResult = Apollo.MutationResult<DeleteSoftwarePackageMutation>;
export type DeleteSoftwarePackageMutationOptions = Apollo.BaseMutationOptions<DeleteSoftwarePackageMutation, DeleteSoftwarePackageMutationVariables>;
export const DeleteTemplateDocument = gql`
    mutation deleteTemplate($nodeId: String!) {
  deleteTemplate(nodeId: $nodeId)
}
    `;
export type DeleteTemplateMutationFn = Apollo.MutationFunction<DeleteTemplateMutation, DeleteTemplateMutationVariables>;

/**
 * __useDeleteTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTemplateMutation, { data, loading, error }] = useDeleteTemplateMutation({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useDeleteTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTemplateMutation, DeleteTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTemplateMutation, DeleteTemplateMutationVariables>(DeleteTemplateDocument, options);
      }
export type DeleteTemplateMutationHookResult = ReturnType<typeof useDeleteTemplateMutation>;
export type DeleteTemplateMutationResult = Apollo.MutationResult<DeleteTemplateMutation>;
export type DeleteTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteTemplateMutation, DeleteTemplateMutationVariables>;
export const FindAllCitiesDocument = gql`
    query findAllCities {
  findAllCities
}
    `;

/**
 * __useFindAllCitiesQuery__
 *
 * To run a query within a React component, call `useFindAllCitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllCitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllCitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindAllCitiesQuery(baseOptions?: Apollo.QueryHookOptions<FindAllCitiesQuery, FindAllCitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllCitiesQuery, FindAllCitiesQueryVariables>(FindAllCitiesDocument, options);
      }
export function useFindAllCitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllCitiesQuery, FindAllCitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllCitiesQuery, FindAllCitiesQueryVariables>(FindAllCitiesDocument, options);
        }
export type FindAllCitiesQueryHookResult = ReturnType<typeof useFindAllCitiesQuery>;
export type FindAllCitiesLazyQueryHookResult = ReturnType<typeof useFindAllCitiesLazyQuery>;
export type FindAllCitiesQueryResult = Apollo.QueryResult<FindAllCitiesQuery, FindAllCitiesQueryVariables>;
export function refetchFindAllCitiesQuery(variables?: FindAllCitiesQueryVariables) {
      return { query: FindAllCitiesDocument, variables: variables }
    }
export const FindAllCountriesDocument = gql`
    query findAllCountries {
  findAllCountries
}
    `;

/**
 * __useFindAllCountriesQuery__
 *
 * To run a query within a React component, call `useFindAllCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindAllCountriesQuery(baseOptions?: Apollo.QueryHookOptions<FindAllCountriesQuery, FindAllCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllCountriesQuery, FindAllCountriesQueryVariables>(FindAllCountriesDocument, options);
      }
export function useFindAllCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllCountriesQuery, FindAllCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllCountriesQuery, FindAllCountriesQueryVariables>(FindAllCountriesDocument, options);
        }
export type FindAllCountriesQueryHookResult = ReturnType<typeof useFindAllCountriesQuery>;
export type FindAllCountriesLazyQueryHookResult = ReturnType<typeof useFindAllCountriesLazyQuery>;
export type FindAllCountriesQueryResult = Apollo.QueryResult<FindAllCountriesQuery, FindAllCountriesQueryVariables>;
export function refetchFindAllCountriesQuery(variables?: FindAllCountriesQueryVariables) {
      return { query: FindAllCountriesDocument, variables: variables }
    }
export const FindAllLaneAllocationsDocument = gql`
    query findAllLaneAllocations($searchRequest: SearchRequestDto!, $laneAllocationFilters: LaneAllocationFiltersDto) {
  findAllLaneAllocations(
    searchRequest: $searchRequest
    laneAllocationFilters: $laneAllocationFilters
  ) {
    fullSize
    result {
      ... on LaneAllocationDto {
        nodeId
        allocationId
        locationName
        workUnitName
        allocationDateTime
        expirationDateTime
        userName
        machineName
        active
      }
    }
  }
}
    `;

/**
 * __useFindAllLaneAllocationsQuery__
 *
 * To run a query within a React component, call `useFindAllLaneAllocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllLaneAllocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllLaneAllocationsQuery({
 *   variables: {
 *      searchRequest: // value for 'searchRequest'
 *      laneAllocationFilters: // value for 'laneAllocationFilters'
 *   },
 * });
 */
export function useFindAllLaneAllocationsQuery(baseOptions: Apollo.QueryHookOptions<FindAllLaneAllocationsQuery, FindAllLaneAllocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllLaneAllocationsQuery, FindAllLaneAllocationsQueryVariables>(FindAllLaneAllocationsDocument, options);
      }
export function useFindAllLaneAllocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllLaneAllocationsQuery, FindAllLaneAllocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllLaneAllocationsQuery, FindAllLaneAllocationsQueryVariables>(FindAllLaneAllocationsDocument, options);
        }
export type FindAllLaneAllocationsQueryHookResult = ReturnType<typeof useFindAllLaneAllocationsQuery>;
export type FindAllLaneAllocationsLazyQueryHookResult = ReturnType<typeof useFindAllLaneAllocationsLazyQuery>;
export type FindAllLaneAllocationsQueryResult = Apollo.QueryResult<FindAllLaneAllocationsQuery, FindAllLaneAllocationsQueryVariables>;
export function refetchFindAllLaneAllocationsQuery(variables: FindAllLaneAllocationsQueryVariables) {
      return { query: FindAllLaneAllocationsDocument, variables: variables }
    }
export const FindAllLocationGroupsFilteredDocument = gql`
    query findAllLocationGroupsFiltered($locationGroupFilters: LocationGroupFiltersDto, $searchRequest: SearchRequestDto!) {
  findAllLocationGroupsFiltered(
    locationGroupFilters: $locationGroupFilters
    searchRequest: $searchRequest
  ) {
    fullSize
    result {
      ... on SmartLocationGroupDtoOut {
        nodeId
        name
        countries
        cities
        authorizedUsers
        locations {
          nodeId
          name
          nodeStatus
        }
      }
    }
  }
}
    `;

/**
 * __useFindAllLocationGroupsFilteredQuery__
 *
 * To run a query within a React component, call `useFindAllLocationGroupsFilteredQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllLocationGroupsFilteredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllLocationGroupsFilteredQuery({
 *   variables: {
 *      locationGroupFilters: // value for 'locationGroupFilters'
 *      searchRequest: // value for 'searchRequest'
 *   },
 * });
 */
export function useFindAllLocationGroupsFilteredQuery(baseOptions: Apollo.QueryHookOptions<FindAllLocationGroupsFilteredQuery, FindAllLocationGroupsFilteredQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllLocationGroupsFilteredQuery, FindAllLocationGroupsFilteredQueryVariables>(FindAllLocationGroupsFilteredDocument, options);
      }
export function useFindAllLocationGroupsFilteredLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllLocationGroupsFilteredQuery, FindAllLocationGroupsFilteredQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllLocationGroupsFilteredQuery, FindAllLocationGroupsFilteredQueryVariables>(FindAllLocationGroupsFilteredDocument, options);
        }
export type FindAllLocationGroupsFilteredQueryHookResult = ReturnType<typeof useFindAllLocationGroupsFilteredQuery>;
export type FindAllLocationGroupsFilteredLazyQueryHookResult = ReturnType<typeof useFindAllLocationGroupsFilteredLazyQuery>;
export type FindAllLocationGroupsFilteredQueryResult = Apollo.QueryResult<FindAllLocationGroupsFilteredQuery, FindAllLocationGroupsFilteredQueryVariables>;
export function refetchFindAllLocationGroupsFilteredQuery(variables: FindAllLocationGroupsFilteredQueryVariables) {
      return { query: FindAllLocationGroupsFilteredDocument, variables: variables }
    }
export const FindAllLocationGroupsFilteredCountsDocument = gql`
    query findAllLocationGroupsFilteredCounts($locationGroupFilters: LocationGroupFiltersDto, $searchRequest: SearchRequestDto!) {
  findAllLocationGroupsFiltered(
    locationGroupFilters: $locationGroupFilters
    searchRequest: $searchRequest
  ) {
    fullSize
    result {
      ... on SmartLocationGroupDtoOut {
        nodeId
        name
        authorizedUsers
        countriesCount
        citiesCount
        locationsCount
      }
    }
  }
}
    `;

/**
 * __useFindAllLocationGroupsFilteredCountsQuery__
 *
 * To run a query within a React component, call `useFindAllLocationGroupsFilteredCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllLocationGroupsFilteredCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllLocationGroupsFilteredCountsQuery({
 *   variables: {
 *      locationGroupFilters: // value for 'locationGroupFilters'
 *      searchRequest: // value for 'searchRequest'
 *   },
 * });
 */
export function useFindAllLocationGroupsFilteredCountsQuery(baseOptions: Apollo.QueryHookOptions<FindAllLocationGroupsFilteredCountsQuery, FindAllLocationGroupsFilteredCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllLocationGroupsFilteredCountsQuery, FindAllLocationGroupsFilteredCountsQueryVariables>(FindAllLocationGroupsFilteredCountsDocument, options);
      }
export function useFindAllLocationGroupsFilteredCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllLocationGroupsFilteredCountsQuery, FindAllLocationGroupsFilteredCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllLocationGroupsFilteredCountsQuery, FindAllLocationGroupsFilteredCountsQueryVariables>(FindAllLocationGroupsFilteredCountsDocument, options);
        }
export type FindAllLocationGroupsFilteredCountsQueryHookResult = ReturnType<typeof useFindAllLocationGroupsFilteredCountsQuery>;
export type FindAllLocationGroupsFilteredCountsLazyQueryHookResult = ReturnType<typeof useFindAllLocationGroupsFilteredCountsLazyQuery>;
export type FindAllLocationGroupsFilteredCountsQueryResult = Apollo.QueryResult<FindAllLocationGroupsFilteredCountsQuery, FindAllLocationGroupsFilteredCountsQueryVariables>;
export function refetchFindAllLocationGroupsFilteredCountsQuery(variables: FindAllLocationGroupsFilteredCountsQueryVariables) {
      return { query: FindAllLocationGroupsFilteredCountsDocument, variables: variables }
    }
export const FindAllMachineGroupsFilteredDocument = gql`
    query findAllMachineGroupsFiltered($machineGroupFilters: MachineGroupFiltersDto, $searchRequest: SearchRequestDto!) {
  findAllMachineGroupsFiltered(
    machineGroupFilters: $machineGroupFilters
    searchRequest: $searchRequest
  ) {
    fullSize
    result {
      ... on MachineGroupDtoOut {
        nodeId
        name
        nodeStatus
        nodeChangeDate
        machines {
          name
          uuid
          nodeId
        }
      }
    }
  }
}
    `;

/**
 * __useFindAllMachineGroupsFilteredQuery__
 *
 * To run a query within a React component, call `useFindAllMachineGroupsFilteredQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllMachineGroupsFilteredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllMachineGroupsFilteredQuery({
 *   variables: {
 *      machineGroupFilters: // value for 'machineGroupFilters'
 *      searchRequest: // value for 'searchRequest'
 *   },
 * });
 */
export function useFindAllMachineGroupsFilteredQuery(baseOptions: Apollo.QueryHookOptions<FindAllMachineGroupsFilteredQuery, FindAllMachineGroupsFilteredQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllMachineGroupsFilteredQuery, FindAllMachineGroupsFilteredQueryVariables>(FindAllMachineGroupsFilteredDocument, options);
      }
export function useFindAllMachineGroupsFilteredLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllMachineGroupsFilteredQuery, FindAllMachineGroupsFilteredQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllMachineGroupsFilteredQuery, FindAllMachineGroupsFilteredQueryVariables>(FindAllMachineGroupsFilteredDocument, options);
        }
export type FindAllMachineGroupsFilteredQueryHookResult = ReturnType<typeof useFindAllMachineGroupsFilteredQuery>;
export type FindAllMachineGroupsFilteredLazyQueryHookResult = ReturnType<typeof useFindAllMachineGroupsFilteredLazyQuery>;
export type FindAllMachineGroupsFilteredQueryResult = Apollo.QueryResult<FindAllMachineGroupsFilteredQuery, FindAllMachineGroupsFilteredQueryVariables>;
export function refetchFindAllMachineGroupsFilteredQuery(variables: FindAllMachineGroupsFilteredQueryVariables) {
      return { query: FindAllMachineGroupsFilteredDocument, variables: variables }
    }
export const FindAllMachineUserGroupsFilteredDocument = gql`
    query findAllMachineUserGroupsFiltered($filters: MachineUserGroupFiltersDto, $searchRequest: SearchRequestDto!) {
  findAllMachineUserGroupsFiltered(
    machineUserGroupFilters: $filters
    searchRequest: $searchRequest
  ) {
    fullSize
    result {
      nodeId
      ... on MachineUserGroupDtoOut {
        name
      }
    }
  }
}
    `;

/**
 * __useFindAllMachineUserGroupsFilteredQuery__
 *
 * To run a query within a React component, call `useFindAllMachineUserGroupsFilteredQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllMachineUserGroupsFilteredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllMachineUserGroupsFilteredQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      searchRequest: // value for 'searchRequest'
 *   },
 * });
 */
export function useFindAllMachineUserGroupsFilteredQuery(baseOptions: Apollo.QueryHookOptions<FindAllMachineUserGroupsFilteredQuery, FindAllMachineUserGroupsFilteredQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllMachineUserGroupsFilteredQuery, FindAllMachineUserGroupsFilteredQueryVariables>(FindAllMachineUserGroupsFilteredDocument, options);
      }
export function useFindAllMachineUserGroupsFilteredLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllMachineUserGroupsFilteredQuery, FindAllMachineUserGroupsFilteredQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllMachineUserGroupsFilteredQuery, FindAllMachineUserGroupsFilteredQueryVariables>(FindAllMachineUserGroupsFilteredDocument, options);
        }
export type FindAllMachineUserGroupsFilteredQueryHookResult = ReturnType<typeof useFindAllMachineUserGroupsFilteredQuery>;
export type FindAllMachineUserGroupsFilteredLazyQueryHookResult = ReturnType<typeof useFindAllMachineUserGroupsFilteredLazyQuery>;
export type FindAllMachineUserGroupsFilteredQueryResult = Apollo.QueryResult<FindAllMachineUserGroupsFilteredQuery, FindAllMachineUserGroupsFilteredQueryVariables>;
export function refetchFindAllMachineUserGroupsFilteredQuery(variables: FindAllMachineUserGroupsFilteredQueryVariables) {
      return { query: FindAllMachineUserGroupsFilteredDocument, variables: variables }
    }
export const FindAllMachineUserGroupsFilteredCountsDocument = gql`
    query findAllMachineUserGroupsFilteredCounts($filters: MachineUserGroupFiltersDto, $searchRequest: SearchRequestDto!) {
  findAllMachineUserGroupsFiltered(
    machineUserGroupFilters: $filters
    searchRequest: $searchRequest
  ) {
    fullSize
    result {
      nodeId
      ... on MachineUserGroupDtoOut {
        name
        machinesCount
        machineUsersCount
      }
    }
  }
}
    `;

/**
 * __useFindAllMachineUserGroupsFilteredCountsQuery__
 *
 * To run a query within a React component, call `useFindAllMachineUserGroupsFilteredCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllMachineUserGroupsFilteredCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllMachineUserGroupsFilteredCountsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      searchRequest: // value for 'searchRequest'
 *   },
 * });
 */
export function useFindAllMachineUserGroupsFilteredCountsQuery(baseOptions: Apollo.QueryHookOptions<FindAllMachineUserGroupsFilteredCountsQuery, FindAllMachineUserGroupsFilteredCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllMachineUserGroupsFilteredCountsQuery, FindAllMachineUserGroupsFilteredCountsQueryVariables>(FindAllMachineUserGroupsFilteredCountsDocument, options);
      }
export function useFindAllMachineUserGroupsFilteredCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllMachineUserGroupsFilteredCountsQuery, FindAllMachineUserGroupsFilteredCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllMachineUserGroupsFilteredCountsQuery, FindAllMachineUserGroupsFilteredCountsQueryVariables>(FindAllMachineUserGroupsFilteredCountsDocument, options);
        }
export type FindAllMachineUserGroupsFilteredCountsQueryHookResult = ReturnType<typeof useFindAllMachineUserGroupsFilteredCountsQuery>;
export type FindAllMachineUserGroupsFilteredCountsLazyQueryHookResult = ReturnType<typeof useFindAllMachineUserGroupsFilteredCountsLazyQuery>;
export type FindAllMachineUserGroupsFilteredCountsQueryResult = Apollo.QueryResult<FindAllMachineUserGroupsFilteredCountsQuery, FindAllMachineUserGroupsFilteredCountsQueryVariables>;
export function refetchFindAllMachineUserGroupsFilteredCountsQuery(variables: FindAllMachineUserGroupsFilteredCountsQueryVariables) {
      return { query: FindAllMachineUserGroupsFilteredCountsDocument, variables: variables }
    }
export const FindAllSoftwarePackagesFilteredDocument = gql`
    query findAllSoftwarePackagesFiltered($searchRequest: SearchRequestDto!, $softwarePackageFilters: SoftwarePackageFiltersDto) {
  findAllSoftwarePackagesFiltered(
    searchRequest: $searchRequest
    softwarePackageFilters: $softwarePackageFilters
  ) {
    fullSize
    result {
      nodeId
      ... on SoftwarePackageDtoOut {
        id
        name
        productName
        version
        parts
        fileName
        revision
        label
        description
        originUri
        common
        releaseInfo
        createdBy
        createdDate
      }
    }
  }
}
    `;

/**
 * __useFindAllSoftwarePackagesFilteredQuery__
 *
 * To run a query within a React component, call `useFindAllSoftwarePackagesFilteredQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllSoftwarePackagesFilteredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllSoftwarePackagesFilteredQuery({
 *   variables: {
 *      searchRequest: // value for 'searchRequest'
 *      softwarePackageFilters: // value for 'softwarePackageFilters'
 *   },
 * });
 */
export function useFindAllSoftwarePackagesFilteredQuery(baseOptions: Apollo.QueryHookOptions<FindAllSoftwarePackagesFilteredQuery, FindAllSoftwarePackagesFilteredQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllSoftwarePackagesFilteredQuery, FindAllSoftwarePackagesFilteredQueryVariables>(FindAllSoftwarePackagesFilteredDocument, options);
      }
export function useFindAllSoftwarePackagesFilteredLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllSoftwarePackagesFilteredQuery, FindAllSoftwarePackagesFilteredQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllSoftwarePackagesFilteredQuery, FindAllSoftwarePackagesFilteredQueryVariables>(FindAllSoftwarePackagesFilteredDocument, options);
        }
export type FindAllSoftwarePackagesFilteredQueryHookResult = ReturnType<typeof useFindAllSoftwarePackagesFilteredQuery>;
export type FindAllSoftwarePackagesFilteredLazyQueryHookResult = ReturnType<typeof useFindAllSoftwarePackagesFilteredLazyQuery>;
export type FindAllSoftwarePackagesFilteredQueryResult = Apollo.QueryResult<FindAllSoftwarePackagesFilteredQuery, FindAllSoftwarePackagesFilteredQueryVariables>;
export function refetchFindAllSoftwarePackagesFilteredQuery(variables: FindAllSoftwarePackagesFilteredQueryVariables) {
      return { query: FindAllSoftwarePackagesFilteredDocument, variables: variables }
    }
export const FindCountriesToCitiesDocument = gql`
    query findCountriesToCities {
  findCountriesToCities {
    key
    value
  }
}
    `;

/**
 * __useFindCountriesToCitiesQuery__
 *
 * To run a query within a React component, call `useFindCountriesToCitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindCountriesToCitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindCountriesToCitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindCountriesToCitiesQuery(baseOptions?: Apollo.QueryHookOptions<FindCountriesToCitiesQuery, FindCountriesToCitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindCountriesToCitiesQuery, FindCountriesToCitiesQueryVariables>(FindCountriesToCitiesDocument, options);
      }
export function useFindCountriesToCitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindCountriesToCitiesQuery, FindCountriesToCitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindCountriesToCitiesQuery, FindCountriesToCitiesQueryVariables>(FindCountriesToCitiesDocument, options);
        }
export type FindCountriesToCitiesQueryHookResult = ReturnType<typeof useFindCountriesToCitiesQuery>;
export type FindCountriesToCitiesLazyQueryHookResult = ReturnType<typeof useFindCountriesToCitiesLazyQuery>;
export type FindCountriesToCitiesQueryResult = Apollo.QueryResult<FindCountriesToCitiesQuery, FindCountriesToCitiesQueryVariables>;
export function refetchFindCountriesToCitiesQuery(variables?: FindCountriesToCitiesQueryVariables) {
      return { query: FindCountriesToCitiesDocument, variables: variables }
    }
export const FindMachineGroupByNodeIdDocument = gql`
    query findMachineGroupByNodeId($nodeId: String!) {
  findMachineGroupByNodeId(nodeId: $nodeId) {
    nodeId
    name
    machines {
      name
      uuid
      nodeId
    }
    nodeStatus
    nodeChangeDate
  }
}
    `;

/**
 * __useFindMachineGroupByNodeIdQuery__
 *
 * To run a query within a React component, call `useFindMachineGroupByNodeIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindMachineGroupByNodeIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindMachineGroupByNodeIdQuery({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useFindMachineGroupByNodeIdQuery(baseOptions: Apollo.QueryHookOptions<FindMachineGroupByNodeIdQuery, FindMachineGroupByNodeIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindMachineGroupByNodeIdQuery, FindMachineGroupByNodeIdQueryVariables>(FindMachineGroupByNodeIdDocument, options);
      }
export function useFindMachineGroupByNodeIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindMachineGroupByNodeIdQuery, FindMachineGroupByNodeIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindMachineGroupByNodeIdQuery, FindMachineGroupByNodeIdQueryVariables>(FindMachineGroupByNodeIdDocument, options);
        }
export type FindMachineGroupByNodeIdQueryHookResult = ReturnType<typeof useFindMachineGroupByNodeIdQuery>;
export type FindMachineGroupByNodeIdLazyQueryHookResult = ReturnType<typeof useFindMachineGroupByNodeIdLazyQuery>;
export type FindMachineGroupByNodeIdQueryResult = Apollo.QueryResult<FindMachineGroupByNodeIdQuery, FindMachineGroupByNodeIdQueryVariables>;
export function refetchFindMachineGroupByNodeIdQuery(variables: FindMachineGroupByNodeIdQueryVariables) {
      return { query: FindMachineGroupByNodeIdDocument, variables: variables }
    }
export const FindMachineUserGroupByNodeIdDocument = gql`
    query findMachineUserGroupByNodeId($nodeId: String!) {
  findMachineUserGroupByNodeId(nodeId: $nodeId) {
    ...MachineUserGroupFragment
  }
}
    ${MachineUserGroupFragmentFragmentDoc}`;

/**
 * __useFindMachineUserGroupByNodeIdQuery__
 *
 * To run a query within a React component, call `useFindMachineUserGroupByNodeIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindMachineUserGroupByNodeIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindMachineUserGroupByNodeIdQuery({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useFindMachineUserGroupByNodeIdQuery(baseOptions: Apollo.QueryHookOptions<FindMachineUserGroupByNodeIdQuery, FindMachineUserGroupByNodeIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindMachineUserGroupByNodeIdQuery, FindMachineUserGroupByNodeIdQueryVariables>(FindMachineUserGroupByNodeIdDocument, options);
      }
export function useFindMachineUserGroupByNodeIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindMachineUserGroupByNodeIdQuery, FindMachineUserGroupByNodeIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindMachineUserGroupByNodeIdQuery, FindMachineUserGroupByNodeIdQueryVariables>(FindMachineUserGroupByNodeIdDocument, options);
        }
export type FindMachineUserGroupByNodeIdQueryHookResult = ReturnType<typeof useFindMachineUserGroupByNodeIdQuery>;
export type FindMachineUserGroupByNodeIdLazyQueryHookResult = ReturnType<typeof useFindMachineUserGroupByNodeIdLazyQuery>;
export type FindMachineUserGroupByNodeIdQueryResult = Apollo.QueryResult<FindMachineUserGroupByNodeIdQuery, FindMachineUserGroupByNodeIdQueryVariables>;
export function refetchFindMachineUserGroupByNodeIdQuery(variables: FindMachineUserGroupByNodeIdQueryVariables) {
      return { query: FindMachineUserGroupByNodeIdDocument, variables: variables }
    }
export const FindMachineUserGroupWithMachinesByNodeIdDocument = gql`
    query findMachineUserGroupWithMachinesByNodeId($nodeId: String!) {
  findMachineUserGroupByNodeId(nodeId: $nodeId) {
    nodeId
    machines {
      nodeId
      uuid
      name
    }
  }
}
    `;

/**
 * __useFindMachineUserGroupWithMachinesByNodeIdQuery__
 *
 * To run a query within a React component, call `useFindMachineUserGroupWithMachinesByNodeIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindMachineUserGroupWithMachinesByNodeIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindMachineUserGroupWithMachinesByNodeIdQuery({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useFindMachineUserGroupWithMachinesByNodeIdQuery(baseOptions: Apollo.QueryHookOptions<FindMachineUserGroupWithMachinesByNodeIdQuery, FindMachineUserGroupWithMachinesByNodeIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindMachineUserGroupWithMachinesByNodeIdQuery, FindMachineUserGroupWithMachinesByNodeIdQueryVariables>(FindMachineUserGroupWithMachinesByNodeIdDocument, options);
      }
export function useFindMachineUserGroupWithMachinesByNodeIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindMachineUserGroupWithMachinesByNodeIdQuery, FindMachineUserGroupWithMachinesByNodeIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindMachineUserGroupWithMachinesByNodeIdQuery, FindMachineUserGroupWithMachinesByNodeIdQueryVariables>(FindMachineUserGroupWithMachinesByNodeIdDocument, options);
        }
export type FindMachineUserGroupWithMachinesByNodeIdQueryHookResult = ReturnType<typeof useFindMachineUserGroupWithMachinesByNodeIdQuery>;
export type FindMachineUserGroupWithMachinesByNodeIdLazyQueryHookResult = ReturnType<typeof useFindMachineUserGroupWithMachinesByNodeIdLazyQuery>;
export type FindMachineUserGroupWithMachinesByNodeIdQueryResult = Apollo.QueryResult<FindMachineUserGroupWithMachinesByNodeIdQuery, FindMachineUserGroupWithMachinesByNodeIdQueryVariables>;
export function refetchFindMachineUserGroupWithMachinesByNodeIdQuery(variables: FindMachineUserGroupWithMachinesByNodeIdQueryVariables) {
      return { query: FindMachineUserGroupWithMachinesByNodeIdDocument, variables: variables }
    }
export const FindMachineUserGroupWithMachineUsersByNodeIdDocument = gql`
    query findMachineUserGroupWithMachineUsersByNodeId($nodeId: String!) {
  findMachineUserGroupByNodeId(nodeId: $nodeId) {
    nodeId
    machineUsers {
      nodeId
      name
    }
  }
}
    `;

/**
 * __useFindMachineUserGroupWithMachineUsersByNodeIdQuery__
 *
 * To run a query within a React component, call `useFindMachineUserGroupWithMachineUsersByNodeIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindMachineUserGroupWithMachineUsersByNodeIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindMachineUserGroupWithMachineUsersByNodeIdQuery({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useFindMachineUserGroupWithMachineUsersByNodeIdQuery(baseOptions: Apollo.QueryHookOptions<FindMachineUserGroupWithMachineUsersByNodeIdQuery, FindMachineUserGroupWithMachineUsersByNodeIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindMachineUserGroupWithMachineUsersByNodeIdQuery, FindMachineUserGroupWithMachineUsersByNodeIdQueryVariables>(FindMachineUserGroupWithMachineUsersByNodeIdDocument, options);
      }
export function useFindMachineUserGroupWithMachineUsersByNodeIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindMachineUserGroupWithMachineUsersByNodeIdQuery, FindMachineUserGroupWithMachineUsersByNodeIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindMachineUserGroupWithMachineUsersByNodeIdQuery, FindMachineUserGroupWithMachineUsersByNodeIdQueryVariables>(FindMachineUserGroupWithMachineUsersByNodeIdDocument, options);
        }
export type FindMachineUserGroupWithMachineUsersByNodeIdQueryHookResult = ReturnType<typeof useFindMachineUserGroupWithMachineUsersByNodeIdQuery>;
export type FindMachineUserGroupWithMachineUsersByNodeIdLazyQueryHookResult = ReturnType<typeof useFindMachineUserGroupWithMachineUsersByNodeIdLazyQuery>;
export type FindMachineUserGroupWithMachineUsersByNodeIdQueryResult = Apollo.QueryResult<FindMachineUserGroupWithMachineUsersByNodeIdQuery, FindMachineUserGroupWithMachineUsersByNodeIdQueryVariables>;
export function refetchFindMachineUserGroupWithMachineUsersByNodeIdQuery(variables: FindMachineUserGroupWithMachineUsersByNodeIdQueryVariables) {
      return { query: FindMachineUserGroupWithMachineUsersByNodeIdDocument, variables: variables }
    }
export const FindMachinesEligibleToAttachToMgDocument = gql`
    query findMachinesEligibleToAttachToMG {
  findMachinesEligibleToAttachToMG {
    nodeId
    name
    nodeStatus
    nodeChangeDate
  }
}
    `;

/**
 * __useFindMachinesEligibleToAttachToMgQuery__
 *
 * To run a query within a React component, call `useFindMachinesEligibleToAttachToMgQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindMachinesEligibleToAttachToMgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindMachinesEligibleToAttachToMgQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindMachinesEligibleToAttachToMgQuery(baseOptions?: Apollo.QueryHookOptions<FindMachinesEligibleToAttachToMgQuery, FindMachinesEligibleToAttachToMgQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindMachinesEligibleToAttachToMgQuery, FindMachinesEligibleToAttachToMgQueryVariables>(FindMachinesEligibleToAttachToMgDocument, options);
      }
export function useFindMachinesEligibleToAttachToMgLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindMachinesEligibleToAttachToMgQuery, FindMachinesEligibleToAttachToMgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindMachinesEligibleToAttachToMgQuery, FindMachinesEligibleToAttachToMgQueryVariables>(FindMachinesEligibleToAttachToMgDocument, options);
        }
export type FindMachinesEligibleToAttachToMgQueryHookResult = ReturnType<typeof useFindMachinesEligibleToAttachToMgQuery>;
export type FindMachinesEligibleToAttachToMgLazyQueryHookResult = ReturnType<typeof useFindMachinesEligibleToAttachToMgLazyQuery>;
export type FindMachinesEligibleToAttachToMgQueryResult = Apollo.QueryResult<FindMachinesEligibleToAttachToMgQuery, FindMachinesEligibleToAttachToMgQueryVariables>;
export function refetchFindMachinesEligibleToAttachToMgQuery(variables?: FindMachinesEligibleToAttachToMgQueryVariables) {
      return { query: FindMachinesEligibleToAttachToMgDocument, variables: variables }
    }
export const GetAllTemplatesFilteredDocument = gql`
    query getAllTemplatesFiltered($searchRequest: SearchRequestDto!, $templateFilters: TemplateFiltersDto) {
  getAllTemplatesFiltered(
    searchRequest: $searchRequest
    templateFilters: $templateFilters
  ) {
    fullSize
    result {
      nodeId
      ... on TemplateDtoOut {
        name
        description
        version
        fileName
        parts
      }
    }
  }
}
    `;

/**
 * __useGetAllTemplatesFilteredQuery__
 *
 * To run a query within a React component, call `useGetAllTemplatesFilteredQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTemplatesFilteredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllTemplatesFilteredQuery({
 *   variables: {
 *      searchRequest: // value for 'searchRequest'
 *      templateFilters: // value for 'templateFilters'
 *   },
 * });
 */
export function useGetAllTemplatesFilteredQuery(baseOptions: Apollo.QueryHookOptions<GetAllTemplatesFilteredQuery, GetAllTemplatesFilteredQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllTemplatesFilteredQuery, GetAllTemplatesFilteredQueryVariables>(GetAllTemplatesFilteredDocument, options);
      }
export function useGetAllTemplatesFilteredLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllTemplatesFilteredQuery, GetAllTemplatesFilteredQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllTemplatesFilteredQuery, GetAllTemplatesFilteredQueryVariables>(GetAllTemplatesFilteredDocument, options);
        }
export type GetAllTemplatesFilteredQueryHookResult = ReturnType<typeof useGetAllTemplatesFilteredQuery>;
export type GetAllTemplatesFilteredLazyQueryHookResult = ReturnType<typeof useGetAllTemplatesFilteredLazyQuery>;
export type GetAllTemplatesFilteredQueryResult = Apollo.QueryResult<GetAllTemplatesFilteredQuery, GetAllTemplatesFilteredQueryVariables>;
export function refetchGetAllTemplatesFilteredQuery(variables: GetAllTemplatesFilteredQueryVariables) {
      return { query: GetAllTemplatesFilteredDocument, variables: variables }
    }
export const GetPreSignedDataForConfigurationDocument = gql`
    query getPreSignedDataForConfiguration($fileName: String!) {
  getPreSignedDataForConfiguration(fileName: $fileName) {
    urlForGet
    urlForPut
    urlForDelete
  }
}
    `;

/**
 * __useGetPreSignedDataForConfigurationQuery__
 *
 * To run a query within a React component, call `useGetPreSignedDataForConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreSignedDataForConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreSignedDataForConfigurationQuery({
 *   variables: {
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useGetPreSignedDataForConfigurationQuery(baseOptions: Apollo.QueryHookOptions<GetPreSignedDataForConfigurationQuery, GetPreSignedDataForConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPreSignedDataForConfigurationQuery, GetPreSignedDataForConfigurationQueryVariables>(GetPreSignedDataForConfigurationDocument, options);
      }
export function useGetPreSignedDataForConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPreSignedDataForConfigurationQuery, GetPreSignedDataForConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPreSignedDataForConfigurationQuery, GetPreSignedDataForConfigurationQueryVariables>(GetPreSignedDataForConfigurationDocument, options);
        }
export type GetPreSignedDataForConfigurationQueryHookResult = ReturnType<typeof useGetPreSignedDataForConfigurationQuery>;
export type GetPreSignedDataForConfigurationLazyQueryHookResult = ReturnType<typeof useGetPreSignedDataForConfigurationLazyQuery>;
export type GetPreSignedDataForConfigurationQueryResult = Apollo.QueryResult<GetPreSignedDataForConfigurationQuery, GetPreSignedDataForConfigurationQueryVariables>;
export function refetchGetPreSignedDataForConfigurationQuery(variables: GetPreSignedDataForConfigurationQueryVariables) {
      return { query: GetPreSignedDataForConfigurationDocument, variables: variables }
    }
export const GetPreSignedDataForSoftwarePackageDocument = gql`
    query getPreSignedDataForSoftwarePackage($fileName: String!) {
  getPreSignedDataForSoftwarePackage(fileName: $fileName) {
    urlForGet
    urlForPut
    urlForDelete
  }
}
    `;

/**
 * __useGetPreSignedDataForSoftwarePackageQuery__
 *
 * To run a query within a React component, call `useGetPreSignedDataForSoftwarePackageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreSignedDataForSoftwarePackageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreSignedDataForSoftwarePackageQuery({
 *   variables: {
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useGetPreSignedDataForSoftwarePackageQuery(baseOptions: Apollo.QueryHookOptions<GetPreSignedDataForSoftwarePackageQuery, GetPreSignedDataForSoftwarePackageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPreSignedDataForSoftwarePackageQuery, GetPreSignedDataForSoftwarePackageQueryVariables>(GetPreSignedDataForSoftwarePackageDocument, options);
      }
export function useGetPreSignedDataForSoftwarePackageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPreSignedDataForSoftwarePackageQuery, GetPreSignedDataForSoftwarePackageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPreSignedDataForSoftwarePackageQuery, GetPreSignedDataForSoftwarePackageQueryVariables>(GetPreSignedDataForSoftwarePackageDocument, options);
        }
export type GetPreSignedDataForSoftwarePackageQueryHookResult = ReturnType<typeof useGetPreSignedDataForSoftwarePackageQuery>;
export type GetPreSignedDataForSoftwarePackageLazyQueryHookResult = ReturnType<typeof useGetPreSignedDataForSoftwarePackageLazyQuery>;
export type GetPreSignedDataForSoftwarePackageQueryResult = Apollo.QueryResult<GetPreSignedDataForSoftwarePackageQuery, GetPreSignedDataForSoftwarePackageQueryVariables>;
export function refetchGetPreSignedDataForSoftwarePackageQuery(variables: GetPreSignedDataForSoftwarePackageQueryVariables) {
      return { query: GetPreSignedDataForSoftwarePackageDocument, variables: variables }
    }
export const RemoveMachineUsersFromMachineUserGroupDocument = gql`
    mutation removeMachineUsersFromMachineUserGroup($machineUserNodeIds: [String]!, $nodeId: String!) {
  removeMachineUsersFromMachineUserGroup(
    machineUserNodeIds: $machineUserNodeIds
    nodeId: $nodeId
  ) {
    nodeId
    machineUsersCount
    machineUsers {
      nodeId
      name
      machineUserGroupNodeIds
    }
  }
}
    `;
export type RemoveMachineUsersFromMachineUserGroupMutationFn = Apollo.MutationFunction<RemoveMachineUsersFromMachineUserGroupMutation, RemoveMachineUsersFromMachineUserGroupMutationVariables>;

/**
 * __useRemoveMachineUsersFromMachineUserGroupMutation__
 *
 * To run a mutation, you first call `useRemoveMachineUsersFromMachineUserGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMachineUsersFromMachineUserGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMachineUsersFromMachineUserGroupMutation, { data, loading, error }] = useRemoveMachineUsersFromMachineUserGroupMutation({
 *   variables: {
 *      machineUserNodeIds: // value for 'machineUserNodeIds'
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useRemoveMachineUsersFromMachineUserGroupMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMachineUsersFromMachineUserGroupMutation, RemoveMachineUsersFromMachineUserGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMachineUsersFromMachineUserGroupMutation, RemoveMachineUsersFromMachineUserGroupMutationVariables>(RemoveMachineUsersFromMachineUserGroupDocument, options);
      }
export type RemoveMachineUsersFromMachineUserGroupMutationHookResult = ReturnType<typeof useRemoveMachineUsersFromMachineUserGroupMutation>;
export type RemoveMachineUsersFromMachineUserGroupMutationResult = Apollo.MutationResult<RemoveMachineUsersFromMachineUserGroupMutation>;
export type RemoveMachineUsersFromMachineUserGroupMutationOptions = Apollo.BaseMutationOptions<RemoveMachineUsersFromMachineUserGroupMutation, RemoveMachineUsersFromMachineUserGroupMutationVariables>;
export const RemoveMachinesFromMachineUserGroupDocument = gql`
    mutation removeMachinesFromMachineUserGroup($machineNodeIds: [String]!, $nodeId: String!) {
  removeMachinesFromMachineUserGroup(
    machineNodeIds: $machineNodeIds
    nodeId: $nodeId
  ) {
    nodeId
    machinesCount
    machines {
      nodeId
      name
    }
  }
}
    `;
export type RemoveMachinesFromMachineUserGroupMutationFn = Apollo.MutationFunction<RemoveMachinesFromMachineUserGroupMutation, RemoveMachinesFromMachineUserGroupMutationVariables>;

/**
 * __useRemoveMachinesFromMachineUserGroupMutation__
 *
 * To run a mutation, you first call `useRemoveMachinesFromMachineUserGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMachinesFromMachineUserGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMachinesFromMachineUserGroupMutation, { data, loading, error }] = useRemoveMachinesFromMachineUserGroupMutation({
 *   variables: {
 *      machineNodeIds: // value for 'machineNodeIds'
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useRemoveMachinesFromMachineUserGroupMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMachinesFromMachineUserGroupMutation, RemoveMachinesFromMachineUserGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMachinesFromMachineUserGroupMutation, RemoveMachinesFromMachineUserGroupMutationVariables>(RemoveMachinesFromMachineUserGroupDocument, options);
      }
export type RemoveMachinesFromMachineUserGroupMutationHookResult = ReturnType<typeof useRemoveMachinesFromMachineUserGroupMutation>;
export type RemoveMachinesFromMachineUserGroupMutationResult = Apollo.MutationResult<RemoveMachinesFromMachineUserGroupMutation>;
export type RemoveMachinesFromMachineUserGroupMutationOptions = Apollo.BaseMutationOptions<RemoveMachinesFromMachineUserGroupMutation, RemoveMachinesFromMachineUserGroupMutationVariables>;
export const UpdateMachineGroupDocument = gql`
    mutation updateMachineGroup($nodeId: String!, $input: MachineGroupDtoIn) {
  updateMachineGroup(nodeId: $nodeId, machineGroup: $input) {
    nodeId
    name
    machines {
      name
      uuid
      nodeId
    }
    nodeStatus
    nodeChangeDate
  }
}
    `;
export type UpdateMachineGroupMutationFn = Apollo.MutationFunction<UpdateMachineGroupMutation, UpdateMachineGroupMutationVariables>;

/**
 * __useUpdateMachineGroupMutation__
 *
 * To run a mutation, you first call `useUpdateMachineGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMachineGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMachineGroupMutation, { data, loading, error }] = useUpdateMachineGroupMutation({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMachineGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMachineGroupMutation, UpdateMachineGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMachineGroupMutation, UpdateMachineGroupMutationVariables>(UpdateMachineGroupDocument, options);
      }
export type UpdateMachineGroupMutationHookResult = ReturnType<typeof useUpdateMachineGroupMutation>;
export type UpdateMachineGroupMutationResult = Apollo.MutationResult<UpdateMachineGroupMutation>;
export type UpdateMachineGroupMutationOptions = Apollo.BaseMutationOptions<UpdateMachineGroupMutation, UpdateMachineGroupMutationVariables>;
export const UpdateMachineUserGroupDocument = gql`
    mutation updateMachineUserGroup($input: MachineUserGroupUpdateDtoIn!, $nodeId: String!) {
  updateMachineUserGroup(machineUserGroup: $input, nodeId: $nodeId) {
    ...MachineUserGroupFragment
  }
}
    ${MachineUserGroupFragmentFragmentDoc}`;
export type UpdateMachineUserGroupMutationFn = Apollo.MutationFunction<UpdateMachineUserGroupMutation, UpdateMachineUserGroupMutationVariables>;

/**
 * __useUpdateMachineUserGroupMutation__
 *
 * To run a mutation, you first call `useUpdateMachineUserGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMachineUserGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMachineUserGroupMutation, { data, loading, error }] = useUpdateMachineUserGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useUpdateMachineUserGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMachineUserGroupMutation, UpdateMachineUserGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMachineUserGroupMutation, UpdateMachineUserGroupMutationVariables>(UpdateMachineUserGroupDocument, options);
      }
export type UpdateMachineUserGroupMutationHookResult = ReturnType<typeof useUpdateMachineUserGroupMutation>;
export type UpdateMachineUserGroupMutationResult = Apollo.MutationResult<UpdateMachineUserGroupMutation>;
export type UpdateMachineUserGroupMutationOptions = Apollo.BaseMutationOptions<UpdateMachineUserGroupMutation, UpdateMachineUserGroupMutationVariables>;
export const UpdateSoftwarePackageDocument = gql`
    mutation updateSoftwarePackage($nodeId: String!, $softwarePackage: SoftwarePackageDtoIn!) {
  updateSoftwarePackage(nodeId: $nodeId, softwarePackage: $softwarePackage) {
    common
    createdBy
    createdDate
    description
    fileName
    id
    label
    name
    nodeId
    originUri
    parts
    productName
    releaseInfo
    revision
    version
  }
}
    `;
export type UpdateSoftwarePackageMutationFn = Apollo.MutationFunction<UpdateSoftwarePackageMutation, UpdateSoftwarePackageMutationVariables>;

/**
 * __useUpdateSoftwarePackageMutation__
 *
 * To run a mutation, you first call `useUpdateSoftwarePackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSoftwarePackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSoftwarePackageMutation, { data, loading, error }] = useUpdateSoftwarePackageMutation({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *      softwarePackage: // value for 'softwarePackage'
 *   },
 * });
 */
export function useUpdateSoftwarePackageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSoftwarePackageMutation, UpdateSoftwarePackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSoftwarePackageMutation, UpdateSoftwarePackageMutationVariables>(UpdateSoftwarePackageDocument, options);
      }
export type UpdateSoftwarePackageMutationHookResult = ReturnType<typeof useUpdateSoftwarePackageMutation>;
export type UpdateSoftwarePackageMutationResult = Apollo.MutationResult<UpdateSoftwarePackageMutation>;
export type UpdateSoftwarePackageMutationOptions = Apollo.BaseMutationOptions<UpdateSoftwarePackageMutation, UpdateSoftwarePackageMutationVariables>;
export const UpdateTemplateDocument = gql`
    mutation updateTemplate($nodeId: String!, $template: TemplateDtoIn!) {
  updateTemplate(nodeId: $nodeId, template: $template) {
    createdBy
    description
    fileName
    name
    nodeId
    parts
    version
  }
}
    `;
export type UpdateTemplateMutationFn = Apollo.MutationFunction<UpdateTemplateMutation, UpdateTemplateMutationVariables>;

/**
 * __useUpdateTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTemplateMutation, { data, loading, error }] = useUpdateTemplateMutation({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *      template: // value for 'template'
 *   },
 * });
 */
export function useUpdateTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTemplateMutation, UpdateTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTemplateMutation, UpdateTemplateMutationVariables>(UpdateTemplateDocument, options);
      }
export type UpdateTemplateMutationHookResult = ReturnType<typeof useUpdateTemplateMutation>;
export type UpdateTemplateMutationResult = Apollo.MutationResult<UpdateTemplateMutation>;
export type UpdateTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateTemplateMutation, UpdateTemplateMutationVariables>;
export const UpsertSmartLocationGroupDocument = gql`
    mutation upsertSmartLocationGroup($smartGroup: SmartLocationGroupDtoIn) {
  upsertSmartLocationGroup(smartGroup: $smartGroup) {
    nodeId
    name
    countries
    cities
    authorizedUsers
    locations {
      nodeId
      name
      machineNodeIds
    }
  }
}
    `;
export type UpsertSmartLocationGroupMutationFn = Apollo.MutationFunction<UpsertSmartLocationGroupMutation, UpsertSmartLocationGroupMutationVariables>;

/**
 * __useUpsertSmartLocationGroupMutation__
 *
 * To run a mutation, you first call `useUpsertSmartLocationGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertSmartLocationGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertSmartLocationGroupMutation, { data, loading, error }] = useUpsertSmartLocationGroupMutation({
 *   variables: {
 *      smartGroup: // value for 'smartGroup'
 *   },
 * });
 */
export function useUpsertSmartLocationGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpsertSmartLocationGroupMutation, UpsertSmartLocationGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertSmartLocationGroupMutation, UpsertSmartLocationGroupMutationVariables>(UpsertSmartLocationGroupDocument, options);
      }
export type UpsertSmartLocationGroupMutationHookResult = ReturnType<typeof useUpsertSmartLocationGroupMutation>;
export type UpsertSmartLocationGroupMutationResult = Apollo.MutationResult<UpsertSmartLocationGroupMutation>;
export type UpsertSmartLocationGroupMutationOptions = Apollo.BaseMutationOptions<UpsertSmartLocationGroupMutation, UpsertSmartLocationGroupMutationVariables>;
export const CreateRulesDocument = gql`
    mutation createRules($input: RulesDto!) {
  createRules(input: $input)
}
    `;
export type CreateRulesMutationFn = Apollo.MutationFunction<CreateRulesMutation, CreateRulesMutationVariables>;

/**
 * __useCreateRulesMutation__
 *
 * To run a mutation, you first call `useCreateRulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRulesMutation, { data, loading, error }] = useCreateRulesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRulesMutation(baseOptions?: Apollo.MutationHookOptions<CreateRulesMutation, CreateRulesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRulesMutation, CreateRulesMutationVariables>(CreateRulesDocument, options);
      }
export type CreateRulesMutationHookResult = ReturnType<typeof useCreateRulesMutation>;
export type CreateRulesMutationResult = Apollo.MutationResult<CreateRulesMutation>;
export type CreateRulesMutationOptions = Apollo.BaseMutationOptions<CreateRulesMutation, CreateRulesMutationVariables>;
export const DeleteRulesDocument = gql`
    mutation deleteRules($nodeId: String!) {
  deleteRules(input: $nodeId)
}
    `;
export type DeleteRulesMutationFn = Apollo.MutationFunction<DeleteRulesMutation, DeleteRulesMutationVariables>;

/**
 * __useDeleteRulesMutation__
 *
 * To run a mutation, you first call `useDeleteRulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRulesMutation, { data, loading, error }] = useDeleteRulesMutation({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useDeleteRulesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRulesMutation, DeleteRulesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRulesMutation, DeleteRulesMutationVariables>(DeleteRulesDocument, options);
      }
export type DeleteRulesMutationHookResult = ReturnType<typeof useDeleteRulesMutation>;
export type DeleteRulesMutationResult = Apollo.MutationResult<DeleteRulesMutation>;
export type DeleteRulesMutationOptions = Apollo.BaseMutationOptions<DeleteRulesMutation, DeleteRulesMutationVariables>;
export const FindAlertsByCriteriaDocument = gql`
    query findAlertsByCriteria($input: AlertHistoryDtoIn!) {
  findAlertsByCriteria(input: $input) {
    fullSize
    columns {
      key
      values
    }
    rows {
      alertLevel
      alertText
      contact
      dateTime
      filterType
      locationName
      locationNodeId
      machineName
      machineNodeId
      nodeId
      triggerType
    }
  }
}
    `;

/**
 * __useFindAlertsByCriteriaQuery__
 *
 * To run a query within a React component, call `useFindAlertsByCriteriaQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAlertsByCriteriaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAlertsByCriteriaQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindAlertsByCriteriaQuery(baseOptions: Apollo.QueryHookOptions<FindAlertsByCriteriaQuery, FindAlertsByCriteriaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAlertsByCriteriaQuery, FindAlertsByCriteriaQueryVariables>(FindAlertsByCriteriaDocument, options);
      }
export function useFindAlertsByCriteriaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAlertsByCriteriaQuery, FindAlertsByCriteriaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAlertsByCriteriaQuery, FindAlertsByCriteriaQueryVariables>(FindAlertsByCriteriaDocument, options);
        }
export type FindAlertsByCriteriaQueryHookResult = ReturnType<typeof useFindAlertsByCriteriaQuery>;
export type FindAlertsByCriteriaLazyQueryHookResult = ReturnType<typeof useFindAlertsByCriteriaLazyQuery>;
export type FindAlertsByCriteriaQueryResult = Apollo.QueryResult<FindAlertsByCriteriaQuery, FindAlertsByCriteriaQueryVariables>;
export function refetchFindAlertsByCriteriaQuery(variables: FindAlertsByCriteriaQueryVariables) {
      return { query: FindAlertsByCriteriaDocument, variables: variables }
    }
export const UpdateRulesDocument = gql`
    mutation updateRules($input: RulesDto!) {
  updateRules(input: $input)
}
    `;
export type UpdateRulesMutationFn = Apollo.MutationFunction<UpdateRulesMutation, UpdateRulesMutationVariables>;

/**
 * __useUpdateRulesMutation__
 *
 * To run a mutation, you first call `useUpdateRulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRulesMutation, { data, loading, error }] = useUpdateRulesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRulesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRulesMutation, UpdateRulesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRulesMutation, UpdateRulesMutationVariables>(UpdateRulesDocument, options);
      }
export type UpdateRulesMutationHookResult = ReturnType<typeof useUpdateRulesMutation>;
export type UpdateRulesMutationResult = Apollo.MutationResult<UpdateRulesMutation>;
export type UpdateRulesMutationOptions = Apollo.BaseMutationOptions<UpdateRulesMutation, UpdateRulesMutationVariables>;
export const GetReportHeaderDocument = gql`
    query getReportHeader {
  getReportHeader {
    locations {
      nodeId
      name
      machineNodeIds
      longitude
      latitude
    }
    machines {
      nodeId
      name
      uuid
    }
    smartLocationGroups {
      nodeId
      name
      locations {
        nodeId
      }
    }
  }
}
    `;

/**
 * __useGetReportHeaderQuery__
 *
 * To run a query within a React component, call `useGetReportHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportHeaderQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReportHeaderQuery(baseOptions?: Apollo.QueryHookOptions<GetReportHeaderQuery, GetReportHeaderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportHeaderQuery, GetReportHeaderQueryVariables>(GetReportHeaderDocument, options);
      }
export function useGetReportHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportHeaderQuery, GetReportHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportHeaderQuery, GetReportHeaderQueryVariables>(GetReportHeaderDocument, options);
        }
export type GetReportHeaderQueryHookResult = ReturnType<typeof useGetReportHeaderQuery>;
export type GetReportHeaderLazyQueryHookResult = ReturnType<typeof useGetReportHeaderLazyQuery>;
export type GetReportHeaderQueryResult = Apollo.QueryResult<GetReportHeaderQuery, GetReportHeaderQueryVariables>;
export function refetchGetReportHeaderQuery(variables?: GetReportHeaderQueryVariables) {
      return { query: GetReportHeaderDocument, variables: variables }
    }
export const CreateLocationDocument = gql`
    mutation createLocation($input: LocationDtoIn!) {
  createLocation(location: $input) {
    nodeId
    name
    longitude
    latitude
    city
    country
    machineNodeIds
    nodeStatus
    nodeChangeDate
  }
}
    `;
export type CreateLocationMutationFn = Apollo.MutationFunction<CreateLocationMutation, CreateLocationMutationVariables>;

/**
 * __useCreateLocationMutation__
 *
 * To run a mutation, you first call `useCreateLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocationMutation, { data, loading, error }] = useCreateLocationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLocationMutation(baseOptions?: Apollo.MutationHookOptions<CreateLocationMutation, CreateLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLocationMutation, CreateLocationMutationVariables>(CreateLocationDocument, options);
      }
export type CreateLocationMutationHookResult = ReturnType<typeof useCreateLocationMutation>;
export type CreateLocationMutationResult = Apollo.MutationResult<CreateLocationMutation>;
export type CreateLocationMutationOptions = Apollo.BaseMutationOptions<CreateLocationMutation, CreateLocationMutationVariables>;
export const DeleteLocationDocument = gql`
    mutation deleteLocation($input: String!) {
  deleteLocation(nodeId: $input) {
    nodeId
  }
}
    `;
export type DeleteLocationMutationFn = Apollo.MutationFunction<DeleteLocationMutation, DeleteLocationMutationVariables>;

/**
 * __useDeleteLocationMutation__
 *
 * To run a mutation, you first call `useDeleteLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationMutation, { data, loading, error }] = useDeleteLocationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteLocationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLocationMutation, DeleteLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLocationMutation, DeleteLocationMutationVariables>(DeleteLocationDocument, options);
      }
export type DeleteLocationMutationHookResult = ReturnType<typeof useDeleteLocationMutation>;
export type DeleteLocationMutationResult = Apollo.MutationResult<DeleteLocationMutation>;
export type DeleteLocationMutationOptions = Apollo.BaseMutationOptions<DeleteLocationMutation, DeleteLocationMutationVariables>;
export const FindAllLocationsByNodeIdsDocument = gql`
    query findAllLocationsByNodeIds($nodeIds: [String!]!) {
  findAllLocationsByNodeIds(nodeIds: $nodeIds) {
    nodeId
    name
    longitude
    latitude
    city
    country
    machineNodeIds
    nodeStatus
    nodeChangeDate
    customerReference
    description
  }
}
    `;

/**
 * __useFindAllLocationsByNodeIdsQuery__
 *
 * To run a query within a React component, call `useFindAllLocationsByNodeIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllLocationsByNodeIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllLocationsByNodeIdsQuery({
 *   variables: {
 *      nodeIds: // value for 'nodeIds'
 *   },
 * });
 */
export function useFindAllLocationsByNodeIdsQuery(baseOptions: Apollo.QueryHookOptions<FindAllLocationsByNodeIdsQuery, FindAllLocationsByNodeIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllLocationsByNodeIdsQuery, FindAllLocationsByNodeIdsQueryVariables>(FindAllLocationsByNodeIdsDocument, options);
      }
export function useFindAllLocationsByNodeIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllLocationsByNodeIdsQuery, FindAllLocationsByNodeIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllLocationsByNodeIdsQuery, FindAllLocationsByNodeIdsQueryVariables>(FindAllLocationsByNodeIdsDocument, options);
        }
export type FindAllLocationsByNodeIdsQueryHookResult = ReturnType<typeof useFindAllLocationsByNodeIdsQuery>;
export type FindAllLocationsByNodeIdsLazyQueryHookResult = ReturnType<typeof useFindAllLocationsByNodeIdsLazyQuery>;
export type FindAllLocationsByNodeIdsQueryResult = Apollo.QueryResult<FindAllLocationsByNodeIdsQuery, FindAllLocationsByNodeIdsQueryVariables>;
export function refetchFindAllLocationsByNodeIdsQuery(variables: FindAllLocationsByNodeIdsQueryVariables) {
      return { query: FindAllLocationsByNodeIdsDocument, variables: variables }
    }
export const FindAllLocationsFilteredDocument = gql`
    query findAllLocationsFiltered($locationFilters: LocationFiltersDto, $searchRequest: SearchRequestDto!) {
  findAllLocationsFiltered(
    locationFilters: $locationFilters
    searchRequest: $searchRequest
  ) {
    fullSize
    result {
      ... on LocationDtoOut {
        nodeId
        name
        longitude
        latitude
        city
        country
        machineNodeIds
        nodeStatus
        nodeChangeDate
        customerReference
        description
      }
    }
  }
}
    `;

/**
 * __useFindAllLocationsFilteredQuery__
 *
 * To run a query within a React component, call `useFindAllLocationsFilteredQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllLocationsFilteredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllLocationsFilteredQuery({
 *   variables: {
 *      locationFilters: // value for 'locationFilters'
 *      searchRequest: // value for 'searchRequest'
 *   },
 * });
 */
export function useFindAllLocationsFilteredQuery(baseOptions: Apollo.QueryHookOptions<FindAllLocationsFilteredQuery, FindAllLocationsFilteredQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllLocationsFilteredQuery, FindAllLocationsFilteredQueryVariables>(FindAllLocationsFilteredDocument, options);
      }
export function useFindAllLocationsFilteredLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllLocationsFilteredQuery, FindAllLocationsFilteredQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllLocationsFilteredQuery, FindAllLocationsFilteredQueryVariables>(FindAllLocationsFilteredDocument, options);
        }
export type FindAllLocationsFilteredQueryHookResult = ReturnType<typeof useFindAllLocationsFilteredQuery>;
export type FindAllLocationsFilteredLazyQueryHookResult = ReturnType<typeof useFindAllLocationsFilteredLazyQuery>;
export type FindAllLocationsFilteredQueryResult = Apollo.QueryResult<FindAllLocationsFilteredQuery, FindAllLocationsFilteredQueryVariables>;
export function refetchFindAllLocationsFilteredQuery(variables: FindAllLocationsFilteredQueryVariables) {
      return { query: FindAllLocationsFilteredDocument, variables: variables }
    }
export const UpdateLocationDocument = gql`
    mutation updateLocation($nodeId: String!, $input: LocationDtoIn!) {
  updateLocation(nodeId: $nodeId, location: $input) {
    nodeId
    name
    longitude
    latitude
    city
    country
    machineNodeIds
    nodeStatus
    nodeChangeDate
    customerReference
    description
  }
}
    `;
export type UpdateLocationMutationFn = Apollo.MutationFunction<UpdateLocationMutation, UpdateLocationMutationVariables>;

/**
 * __useUpdateLocationMutation__
 *
 * To run a mutation, you first call `useUpdateLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationMutation, { data, loading, error }] = useUpdateLocationMutation({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLocationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLocationMutation, UpdateLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLocationMutation, UpdateLocationMutationVariables>(UpdateLocationDocument, options);
      }
export type UpdateLocationMutationHookResult = ReturnType<typeof useUpdateLocationMutation>;
export type UpdateLocationMutationResult = Apollo.MutationResult<UpdateLocationMutation>;
export type UpdateLocationMutationOptions = Apollo.BaseMutationOptions<UpdateLocationMutation, UpdateLocationMutationVariables>;
export const CreateMachineDocument = gql`
    mutation createMachine($input: MachineDtoIn!) {
  createMachine(machine: $input) {
    name
    nodeStatus
    nodeChangeDate
    nodeId
    uuid
    locationNodeId
    machineType {
      name
      nodeId
    }
  }
}
    `;
export type CreateMachineMutationFn = Apollo.MutationFunction<CreateMachineMutation, CreateMachineMutationVariables>;

/**
 * __useCreateMachineMutation__
 *
 * To run a mutation, you first call `useCreateMachineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMachineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMachineMutation, { data, loading, error }] = useCreateMachineMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMachineMutation(baseOptions?: Apollo.MutationHookOptions<CreateMachineMutation, CreateMachineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMachineMutation, CreateMachineMutationVariables>(CreateMachineDocument, options);
      }
export type CreateMachineMutationHookResult = ReturnType<typeof useCreateMachineMutation>;
export type CreateMachineMutationResult = Apollo.MutationResult<CreateMachineMutation>;
export type CreateMachineMutationOptions = Apollo.BaseMutationOptions<CreateMachineMutation, CreateMachineMutationVariables>;
export const CreateOtaKeyPairDocument = gql`
    mutation createOtaKeyPair($machineUuid: String!, $requestKey: String!) {
  createOtaKeyPair(machineUuid: $machineUuid, requestKey: $requestKey)
}
    `;
export type CreateOtaKeyPairMutationFn = Apollo.MutationFunction<CreateOtaKeyPairMutation, CreateOtaKeyPairMutationVariables>;

/**
 * __useCreateOtaKeyPairMutation__
 *
 * To run a mutation, you first call `useCreateOtaKeyPairMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOtaKeyPairMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOtaKeyPairMutation, { data, loading, error }] = useCreateOtaKeyPairMutation({
 *   variables: {
 *      machineUuid: // value for 'machineUuid'
 *      requestKey: // value for 'requestKey'
 *   },
 * });
 */
export function useCreateOtaKeyPairMutation(baseOptions?: Apollo.MutationHookOptions<CreateOtaKeyPairMutation, CreateOtaKeyPairMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOtaKeyPairMutation, CreateOtaKeyPairMutationVariables>(CreateOtaKeyPairDocument, options);
      }
export type CreateOtaKeyPairMutationHookResult = ReturnType<typeof useCreateOtaKeyPairMutation>;
export type CreateOtaKeyPairMutationResult = Apollo.MutationResult<CreateOtaKeyPairMutation>;
export type CreateOtaKeyPairMutationOptions = Apollo.BaseMutationOptions<CreateOtaKeyPairMutation, CreateOtaKeyPairMutationVariables>;
export const DeleteMachineDocument = gql`
    mutation deleteMachine($nodeId: String!) {
  deleteMachine(nodeId: $nodeId) {
    nodeId
  }
}
    `;
export type DeleteMachineMutationFn = Apollo.MutationFunction<DeleteMachineMutation, DeleteMachineMutationVariables>;

/**
 * __useDeleteMachineMutation__
 *
 * To run a mutation, you first call `useDeleteMachineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMachineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMachineMutation, { data, loading, error }] = useDeleteMachineMutation({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useDeleteMachineMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMachineMutation, DeleteMachineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMachineMutation, DeleteMachineMutationVariables>(DeleteMachineDocument, options);
      }
export type DeleteMachineMutationHookResult = ReturnType<typeof useDeleteMachineMutation>;
export type DeleteMachineMutationResult = Apollo.MutationResult<DeleteMachineMutation>;
export type DeleteMachineMutationOptions = Apollo.BaseMutationOptions<DeleteMachineMutation, DeleteMachineMutationVariables>;
export const FindAllMachineTypePatternsDocument = gql`
    query findAllMachineTypePatterns {
  findAllMachineTypePatterns {
    name
    nodeId
    table
    imageUrl
  }
}
    `;

/**
 * __useFindAllMachineTypePatternsQuery__
 *
 * To run a query within a React component, call `useFindAllMachineTypePatternsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllMachineTypePatternsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllMachineTypePatternsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindAllMachineTypePatternsQuery(baseOptions?: Apollo.QueryHookOptions<FindAllMachineTypePatternsQuery, FindAllMachineTypePatternsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllMachineTypePatternsQuery, FindAllMachineTypePatternsQueryVariables>(FindAllMachineTypePatternsDocument, options);
      }
export function useFindAllMachineTypePatternsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllMachineTypePatternsQuery, FindAllMachineTypePatternsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllMachineTypePatternsQuery, FindAllMachineTypePatternsQueryVariables>(FindAllMachineTypePatternsDocument, options);
        }
export type FindAllMachineTypePatternsQueryHookResult = ReturnType<typeof useFindAllMachineTypePatternsQuery>;
export type FindAllMachineTypePatternsLazyQueryHookResult = ReturnType<typeof useFindAllMachineTypePatternsLazyQuery>;
export type FindAllMachineTypePatternsQueryResult = Apollo.QueryResult<FindAllMachineTypePatternsQuery, FindAllMachineTypePatternsQueryVariables>;
export function refetchFindAllMachineTypePatternsQuery(variables?: FindAllMachineTypePatternsQueryVariables) {
      return { query: FindAllMachineTypePatternsDocument, variables: variables }
    }
export const FindAllMachinesDocument = gql`
    query findAllMachines($machineFilters: MachineFiltersDto, $searchRequest: SearchRequestDto!) {
  findAllMachines(machineFilters: $machineFilters, searchRequest: $searchRequest) {
    fullSize
    result {
      ... on MachineDtoOut {
        name
        nodeId
        uuid
      }
    }
  }
}
    `;

/**
 * __useFindAllMachinesQuery__
 *
 * To run a query within a React component, call `useFindAllMachinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllMachinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllMachinesQuery({
 *   variables: {
 *      machineFilters: // value for 'machineFilters'
 *      searchRequest: // value for 'searchRequest'
 *   },
 * });
 */
export function useFindAllMachinesQuery(baseOptions: Apollo.QueryHookOptions<FindAllMachinesQuery, FindAllMachinesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllMachinesQuery, FindAllMachinesQueryVariables>(FindAllMachinesDocument, options);
      }
export function useFindAllMachinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllMachinesQuery, FindAllMachinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllMachinesQuery, FindAllMachinesQueryVariables>(FindAllMachinesDocument, options);
        }
export type FindAllMachinesQueryHookResult = ReturnType<typeof useFindAllMachinesQuery>;
export type FindAllMachinesLazyQueryHookResult = ReturnType<typeof useFindAllMachinesLazyQuery>;
export type FindAllMachinesQueryResult = Apollo.QueryResult<FindAllMachinesQuery, FindAllMachinesQueryVariables>;
export function refetchFindAllMachinesQuery(variables: FindAllMachinesQueryVariables) {
      return { query: FindAllMachinesDocument, variables: variables }
    }
export const FindAllMachinesDetailsDocument = gql`
    query findAllMachinesDetails($machineFilters: MachineFiltersDto, $searchRequest: SearchRequestDto!) {
  findAllMachines(machineFilters: $machineFilters, searchRequest: $searchRequest) {
    fullSize
    result {
      ... on MachineDtoOut {
        name
        nodeId
        uuid
        locationNodeId
        machineType {
          name
        }
        details {
          version
        }
      }
    }
  }
}
    `;

/**
 * __useFindAllMachinesDetailsQuery__
 *
 * To run a query within a React component, call `useFindAllMachinesDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllMachinesDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllMachinesDetailsQuery({
 *   variables: {
 *      machineFilters: // value for 'machineFilters'
 *      searchRequest: // value for 'searchRequest'
 *   },
 * });
 */
export function useFindAllMachinesDetailsQuery(baseOptions: Apollo.QueryHookOptions<FindAllMachinesDetailsQuery, FindAllMachinesDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllMachinesDetailsQuery, FindAllMachinesDetailsQueryVariables>(FindAllMachinesDetailsDocument, options);
      }
export function useFindAllMachinesDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllMachinesDetailsQuery, FindAllMachinesDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllMachinesDetailsQuery, FindAllMachinesDetailsQueryVariables>(FindAllMachinesDetailsDocument, options);
        }
export type FindAllMachinesDetailsQueryHookResult = ReturnType<typeof useFindAllMachinesDetailsQuery>;
export type FindAllMachinesDetailsLazyQueryHookResult = ReturnType<typeof useFindAllMachinesDetailsLazyQuery>;
export type FindAllMachinesDetailsQueryResult = Apollo.QueryResult<FindAllMachinesDetailsQuery, FindAllMachinesDetailsQueryVariables>;
export function refetchFindAllMachinesDetailsQuery(variables: FindAllMachinesDetailsQueryVariables) {
      return { query: FindAllMachinesDetailsDocument, variables: variables }
    }
export const FindAllMachinesWithLocationsDocument = gql`
    query findAllMachinesWithLocations($machineFilters: MachineFiltersDto, $searchRequest: SearchRequestDto!) {
  findAllMachines(machineFilters: $machineFilters, searchRequest: $searchRequest) {
    fullSize
    result {
      ... on MachineDtoOut {
        name
        nodeId
        uuid
        locationNodeId
      }
    }
  }
}
    `;

/**
 * __useFindAllMachinesWithLocationsQuery__
 *
 * To run a query within a React component, call `useFindAllMachinesWithLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllMachinesWithLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllMachinesWithLocationsQuery({
 *   variables: {
 *      machineFilters: // value for 'machineFilters'
 *      searchRequest: // value for 'searchRequest'
 *   },
 * });
 */
export function useFindAllMachinesWithLocationsQuery(baseOptions: Apollo.QueryHookOptions<FindAllMachinesWithLocationsQuery, FindAllMachinesWithLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllMachinesWithLocationsQuery, FindAllMachinesWithLocationsQueryVariables>(FindAllMachinesWithLocationsDocument, options);
      }
export function useFindAllMachinesWithLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllMachinesWithLocationsQuery, FindAllMachinesWithLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllMachinesWithLocationsQuery, FindAllMachinesWithLocationsQueryVariables>(FindAllMachinesWithLocationsDocument, options);
        }
export type FindAllMachinesWithLocationsQueryHookResult = ReturnType<typeof useFindAllMachinesWithLocationsQuery>;
export type FindAllMachinesWithLocationsLazyQueryHookResult = ReturnType<typeof useFindAllMachinesWithLocationsLazyQuery>;
export type FindAllMachinesWithLocationsQueryResult = Apollo.QueryResult<FindAllMachinesWithLocationsQuery, FindAllMachinesWithLocationsQueryVariables>;
export function refetchFindAllMachinesWithLocationsQuery(variables: FindAllMachinesWithLocationsQueryVariables) {
      return { query: FindAllMachinesWithLocationsDocument, variables: variables }
    }
export const FindMachineByNodeIdDocument = gql`
    query findMachineByNodeId($nodeId: String!) {
  findMachineByNodeId(nodeId: $nodeId) {
    nodeId
    uuid
    name
    nodeStatus
    nodeChangeDate
    machineId
    locationNodeId
    machineType {
      name
      imageUrl
      nodeId
      table
    }
    details {
      capabilities
      dateTime
      version
      nodeId
      devices {
        id
        nodeId
        sensorInfo {
          accType
          firmware
          hardware
          name
          nodeId
          protocol
          serialNumber
          version
        }
        deviceInfo {
          accType
          firmware
          hardware
          name
          nodeId
          protocol
          serialNumber
          version
        }
      }
    }
  }
}
    `;

/**
 * __useFindMachineByNodeIdQuery__
 *
 * To run a query within a React component, call `useFindMachineByNodeIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindMachineByNodeIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindMachineByNodeIdQuery({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useFindMachineByNodeIdQuery(baseOptions: Apollo.QueryHookOptions<FindMachineByNodeIdQuery, FindMachineByNodeIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindMachineByNodeIdQuery, FindMachineByNodeIdQueryVariables>(FindMachineByNodeIdDocument, options);
      }
export function useFindMachineByNodeIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindMachineByNodeIdQuery, FindMachineByNodeIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindMachineByNodeIdQuery, FindMachineByNodeIdQueryVariables>(FindMachineByNodeIdDocument, options);
        }
export type FindMachineByNodeIdQueryHookResult = ReturnType<typeof useFindMachineByNodeIdQuery>;
export type FindMachineByNodeIdLazyQueryHookResult = ReturnType<typeof useFindMachineByNodeIdLazyQuery>;
export type FindMachineByNodeIdQueryResult = Apollo.QueryResult<FindMachineByNodeIdQuery, FindMachineByNodeIdQueryVariables>;
export function refetchFindMachineByNodeIdQuery(variables: FindMachineByNodeIdQueryVariables) {
      return { query: FindMachineByNodeIdDocument, variables: variables }
    }
export const GenerateCashOperationsReportDocument = gql`
    query generateCashOperationsReport($cashOperationsReportCriteriaDto: CashOperationsReportCriteriaDto) {
  generateCashOperationsReport(
    cashOperationsReportCriteriaDto: $cashOperationsReportCriteriaDto
  ) {
    machineContentDtos {
      currency
      refillStatus
      dispenseAvailabilityRatio
      denominationDispensableMap {
        ...ChartMap
      }
      denominationBankableMap {
        ...ChartMap
      }
      containerDispensableMap {
        ...ChartMap
      }
      containerBankableMap {
        ...ChartMap
      }
      totals {
        key
        value
      }
    }
  }
}
    ${ChartMapFragmentDoc}`;

/**
 * __useGenerateCashOperationsReportQuery__
 *
 * To run a query within a React component, call `useGenerateCashOperationsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateCashOperationsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateCashOperationsReportQuery({
 *   variables: {
 *      cashOperationsReportCriteriaDto: // value for 'cashOperationsReportCriteriaDto'
 *   },
 * });
 */
export function useGenerateCashOperationsReportQuery(baseOptions?: Apollo.QueryHookOptions<GenerateCashOperationsReportQuery, GenerateCashOperationsReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateCashOperationsReportQuery, GenerateCashOperationsReportQueryVariables>(GenerateCashOperationsReportDocument, options);
      }
export function useGenerateCashOperationsReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateCashOperationsReportQuery, GenerateCashOperationsReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateCashOperationsReportQuery, GenerateCashOperationsReportQueryVariables>(GenerateCashOperationsReportDocument, options);
        }
export type GenerateCashOperationsReportQueryHookResult = ReturnType<typeof useGenerateCashOperationsReportQuery>;
export type GenerateCashOperationsReportLazyQueryHookResult = ReturnType<typeof useGenerateCashOperationsReportLazyQuery>;
export type GenerateCashOperationsReportQueryResult = Apollo.QueryResult<GenerateCashOperationsReportQuery, GenerateCashOperationsReportQueryVariables>;
export function refetchGenerateCashOperationsReportQuery(variables?: GenerateCashOperationsReportQueryVariables) {
      return { query: GenerateCashOperationsReportDocument, variables: variables }
    }
export const GenerateMachineDetailsReportDocument = gql`
    query generateMachineDetailsReport($criteriaDto: MachineDetailsReportCriteriaDto!) {
  generateMachineDetailsReport(criteriaDto: $criteriaDto) {
    fullSize
    rows {
      nodeId
      machineNodeId
      codVersion
      location
      machineAlias
      machineUuid
      machineType
    }
  }
}
    `;

/**
 * __useGenerateMachineDetailsReportQuery__
 *
 * To run a query within a React component, call `useGenerateMachineDetailsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateMachineDetailsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateMachineDetailsReportQuery({
 *   variables: {
 *      criteriaDto: // value for 'criteriaDto'
 *   },
 * });
 */
export function useGenerateMachineDetailsReportQuery(baseOptions: Apollo.QueryHookOptions<GenerateMachineDetailsReportQuery, GenerateMachineDetailsReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateMachineDetailsReportQuery, GenerateMachineDetailsReportQueryVariables>(GenerateMachineDetailsReportDocument, options);
      }
export function useGenerateMachineDetailsReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateMachineDetailsReportQuery, GenerateMachineDetailsReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateMachineDetailsReportQuery, GenerateMachineDetailsReportQueryVariables>(GenerateMachineDetailsReportDocument, options);
        }
export type GenerateMachineDetailsReportQueryHookResult = ReturnType<typeof useGenerateMachineDetailsReportQuery>;
export type GenerateMachineDetailsReportLazyQueryHookResult = ReturnType<typeof useGenerateMachineDetailsReportLazyQuery>;
export type GenerateMachineDetailsReportQueryResult = Apollo.QueryResult<GenerateMachineDetailsReportQuery, GenerateMachineDetailsReportQueryVariables>;
export function refetchGenerateMachineDetailsReportQuery(variables: GenerateMachineDetailsReportQueryVariables) {
      return { query: GenerateMachineDetailsReportDocument, variables: variables }
    }
export const GenerateMachineViewTabDocument = gql`
    query generateMachineViewTab($input: MachineViewDtoIn!) {
  generateMachineViewTab(input: $input) {
    fullSize
    rows {
      location {
        nodeId
        name
      }
      machine {
        nodeId
        uuid
        name
        nodeStatus
        nodeChangeDate
        machineType
        machineImageUrl
      }
      license {
        nodeId
        edition
        createdDate
        licenseKey
        expirationDate
        subscriptionActive
        licenseStartDate
        lockedDueToFlipFlopping
      }
      ongoingDeployment {
        nodeId
        state
        createdBy
        scheduleInfo
        state
        template {
          nodeId
          name
          version
          fileName
        }
      }
      templateDeployment {
        nodeId
        createdBy
        state
        template {
          nodeId
          name
          version
          fileName
        }
      }
      machineUserGroup {
        nodeId
        name
      }
      softwareInstalled {
        createdBy
        nodeId
        state
        softwarePackage {
          nodeId
          createdDate
          version
          name
          productName
        }
      }
      ongoingSoftwareInstallation {
        createdBy
        nodeId
        state
        scheduleInfo
        softwarePackage {
          nodeId
          createdDate
          version
          name
          productName
        }
      }
    }
  }
}
    `;

/**
 * __useGenerateMachineViewTabQuery__
 *
 * To run a query within a React component, call `useGenerateMachineViewTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateMachineViewTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateMachineViewTabQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateMachineViewTabQuery(baseOptions: Apollo.QueryHookOptions<GenerateMachineViewTabQuery, GenerateMachineViewTabQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateMachineViewTabQuery, GenerateMachineViewTabQueryVariables>(GenerateMachineViewTabDocument, options);
      }
export function useGenerateMachineViewTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateMachineViewTabQuery, GenerateMachineViewTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateMachineViewTabQuery, GenerateMachineViewTabQueryVariables>(GenerateMachineViewTabDocument, options);
        }
export type GenerateMachineViewTabQueryHookResult = ReturnType<typeof useGenerateMachineViewTabQuery>;
export type GenerateMachineViewTabLazyQueryHookResult = ReturnType<typeof useGenerateMachineViewTabLazyQuery>;
export type GenerateMachineViewTabQueryResult = Apollo.QueryResult<GenerateMachineViewTabQuery, GenerateMachineViewTabQueryVariables>;
export function refetchGenerateMachineViewTabQuery(variables: GenerateMachineViewTabQueryVariables) {
      return { query: GenerateMachineViewTabDocument, variables: variables }
    }
export const GetMachinesOnlineStatusDocument = gql`
    query getMachinesOnlineStatus($input: MachineOnlineStatusRequest!) {
  getMachinesOnlineStatus(input: $input) {
    fullSize
    rows {
      eventDate
      licenseId
      locationId
      machineStatus
      machineUuid
      machineName
      locationName
      nodeId
      onlineStatus
      receivedDate
      tenantId
      formattedEventDate
      formattedReceivedDate
    }
  }
}
    `;

/**
 * __useGetMachinesOnlineStatusQuery__
 *
 * To run a query within a React component, call `useGetMachinesOnlineStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMachinesOnlineStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMachinesOnlineStatusQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetMachinesOnlineStatusQuery(baseOptions: Apollo.QueryHookOptions<GetMachinesOnlineStatusQuery, GetMachinesOnlineStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMachinesOnlineStatusQuery, GetMachinesOnlineStatusQueryVariables>(GetMachinesOnlineStatusDocument, options);
      }
export function useGetMachinesOnlineStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMachinesOnlineStatusQuery, GetMachinesOnlineStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMachinesOnlineStatusQuery, GetMachinesOnlineStatusQueryVariables>(GetMachinesOnlineStatusDocument, options);
        }
export type GetMachinesOnlineStatusQueryHookResult = ReturnType<typeof useGetMachinesOnlineStatusQuery>;
export type GetMachinesOnlineStatusLazyQueryHookResult = ReturnType<typeof useGetMachinesOnlineStatusLazyQuery>;
export type GetMachinesOnlineStatusQueryResult = Apollo.QueryResult<GetMachinesOnlineStatusQuery, GetMachinesOnlineStatusQueryVariables>;
export function refetchGetMachinesOnlineStatusQuery(variables: GetMachinesOnlineStatusQueryVariables) {
      return { query: GetMachinesOnlineStatusDocument, variables: variables }
    }
export const GetMachinesOnlineStatusHistoryDocument = gql`
    query getMachinesOnlineStatusHistory($input: MachineOnlineStatusHistoryRequest!) {
  getMachinesOnlineStatusHistory(input: $input) {
    fullSize
    rows {
      eventDate
      licenseId
      locationId
      machineStatus
      machineUuid
      machineName
      locationName
      nodeId
      onlineStatus
      receivedDate
      tenantId
      formattedEventDate
      formattedReceivedDate
      historyStatuses {
        eventDate
        licenseId
        machineStatus
        machineUuid
        nodeId
        onlineStatus
        receivedDate
        formattedEventDate
        formattedReceivedDate
      }
    }
  }
}
    `;

/**
 * __useGetMachinesOnlineStatusHistoryQuery__
 *
 * To run a query within a React component, call `useGetMachinesOnlineStatusHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMachinesOnlineStatusHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMachinesOnlineStatusHistoryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetMachinesOnlineStatusHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetMachinesOnlineStatusHistoryQuery, GetMachinesOnlineStatusHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMachinesOnlineStatusHistoryQuery, GetMachinesOnlineStatusHistoryQueryVariables>(GetMachinesOnlineStatusHistoryDocument, options);
      }
export function useGetMachinesOnlineStatusHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMachinesOnlineStatusHistoryQuery, GetMachinesOnlineStatusHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMachinesOnlineStatusHistoryQuery, GetMachinesOnlineStatusHistoryQueryVariables>(GetMachinesOnlineStatusHistoryDocument, options);
        }
export type GetMachinesOnlineStatusHistoryQueryHookResult = ReturnType<typeof useGetMachinesOnlineStatusHistoryQuery>;
export type GetMachinesOnlineStatusHistoryLazyQueryHookResult = ReturnType<typeof useGetMachinesOnlineStatusHistoryLazyQuery>;
export type GetMachinesOnlineStatusHistoryQueryResult = Apollo.QueryResult<GetMachinesOnlineStatusHistoryQuery, GetMachinesOnlineStatusHistoryQueryVariables>;
export function refetchGetMachinesOnlineStatusHistoryQuery(variables: GetMachinesOnlineStatusHistoryQueryVariables) {
      return { query: GetMachinesOnlineStatusHistoryDocument, variables: variables }
    }
export const GetPublicKeyDocument = gql`
    query getPublicKey($machineUuid: String!) {
  getPublicKey(machineUuid: $machineUuid)
}
    `;

/**
 * __useGetPublicKeyQuery__
 *
 * To run a query within a React component, call `useGetPublicKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicKeyQuery({
 *   variables: {
 *      machineUuid: // value for 'machineUuid'
 *   },
 * });
 */
export function useGetPublicKeyQuery(baseOptions: Apollo.QueryHookOptions<GetPublicKeyQuery, GetPublicKeyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicKeyQuery, GetPublicKeyQueryVariables>(GetPublicKeyDocument, options);
      }
export function useGetPublicKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicKeyQuery, GetPublicKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicKeyQuery, GetPublicKeyQueryVariables>(GetPublicKeyDocument, options);
        }
export type GetPublicKeyQueryHookResult = ReturnType<typeof useGetPublicKeyQuery>;
export type GetPublicKeyLazyQueryHookResult = ReturnType<typeof useGetPublicKeyLazyQuery>;
export type GetPublicKeyQueryResult = Apollo.QueryResult<GetPublicKeyQuery, GetPublicKeyQueryVariables>;
export function refetchGetPublicKeyQuery(variables: GetPublicKeyQueryVariables) {
      return { query: GetPublicKeyDocument, variables: variables }
    }
export const ActivateLicenseByNodeIdDocument = gql`
    mutation activateLicenseByNodeId($nodeId: String!) {
  activateLicenseByNodeId(nodeId: $nodeId) {
    nodeId
    subscriptionActive
    deactivatedDate
    expirationDate
    licenseStartDate
  }
}
    `;
export type ActivateLicenseByNodeIdMutationFn = Apollo.MutationFunction<ActivateLicenseByNodeIdMutation, ActivateLicenseByNodeIdMutationVariables>;

/**
 * __useActivateLicenseByNodeIdMutation__
 *
 * To run a mutation, you first call `useActivateLicenseByNodeIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateLicenseByNodeIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateLicenseByNodeIdMutation, { data, loading, error }] = useActivateLicenseByNodeIdMutation({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useActivateLicenseByNodeIdMutation(baseOptions?: Apollo.MutationHookOptions<ActivateLicenseByNodeIdMutation, ActivateLicenseByNodeIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateLicenseByNodeIdMutation, ActivateLicenseByNodeIdMutationVariables>(ActivateLicenseByNodeIdDocument, options);
      }
export type ActivateLicenseByNodeIdMutationHookResult = ReturnType<typeof useActivateLicenseByNodeIdMutation>;
export type ActivateLicenseByNodeIdMutationResult = Apollo.MutationResult<ActivateLicenseByNodeIdMutation>;
export type ActivateLicenseByNodeIdMutationOptions = Apollo.BaseMutationOptions<ActivateLicenseByNodeIdMutation, ActivateLicenseByNodeIdMutationVariables>;
export const CreateMachineLicenseContentDocument = gql`
    mutation createMachineLicenseContent($licenseContentDtoIn: LicenseContentDtoIn!, $tenantId: String!) {
  createMachineLicenseContent(
    licenseContentDtoIn: $licenseContentDtoIn
    tenantId: $tenantId
  ) {
    uuid
    nodeId
    lockedDueToFlipFlopping
    deactivatedDateTime
    features {
      nodeId
      key
      expiration {
        nodeId
        date
        disableFeatureWhenExpired
        warningBeforeExpirationDays
      }
    }
  }
}
    `;
export type CreateMachineLicenseContentMutationFn = Apollo.MutationFunction<CreateMachineLicenseContentMutation, CreateMachineLicenseContentMutationVariables>;

/**
 * __useCreateMachineLicenseContentMutation__
 *
 * To run a mutation, you first call `useCreateMachineLicenseContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMachineLicenseContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMachineLicenseContentMutation, { data, loading, error }] = useCreateMachineLicenseContentMutation({
 *   variables: {
 *      licenseContentDtoIn: // value for 'licenseContentDtoIn'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useCreateMachineLicenseContentMutation(baseOptions?: Apollo.MutationHookOptions<CreateMachineLicenseContentMutation, CreateMachineLicenseContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMachineLicenseContentMutation, CreateMachineLicenseContentMutationVariables>(CreateMachineLicenseContentDocument, options);
      }
export type CreateMachineLicenseContentMutationHookResult = ReturnType<typeof useCreateMachineLicenseContentMutation>;
export type CreateMachineLicenseContentMutationResult = Apollo.MutationResult<CreateMachineLicenseContentMutation>;
export type CreateMachineLicenseContentMutationOptions = Apollo.BaseMutationOptions<CreateMachineLicenseContentMutation, CreateMachineLicenseContentMutationVariables>;
export const DeactivateLicenseByNodeIdDocument = gql`
    mutation deactivateLicenseByNodeId($nodeId: String!) {
  deactivateLicenseByNodeId(nodeId: $nodeId) {
    nodeId
    subscriptionActive
    deactivatedDate
    expirationDate
    licenseStartDate
  }
}
    `;
export type DeactivateLicenseByNodeIdMutationFn = Apollo.MutationFunction<DeactivateLicenseByNodeIdMutation, DeactivateLicenseByNodeIdMutationVariables>;

/**
 * __useDeactivateLicenseByNodeIdMutation__
 *
 * To run a mutation, you first call `useDeactivateLicenseByNodeIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateLicenseByNodeIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateLicenseByNodeIdMutation, { data, loading, error }] = useDeactivateLicenseByNodeIdMutation({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useDeactivateLicenseByNodeIdMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateLicenseByNodeIdMutation, DeactivateLicenseByNodeIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateLicenseByNodeIdMutation, DeactivateLicenseByNodeIdMutationVariables>(DeactivateLicenseByNodeIdDocument, options);
      }
export type DeactivateLicenseByNodeIdMutationHookResult = ReturnType<typeof useDeactivateLicenseByNodeIdMutation>;
export type DeactivateLicenseByNodeIdMutationResult = Apollo.MutationResult<DeactivateLicenseByNodeIdMutation>;
export type DeactivateLicenseByNodeIdMutationOptions = Apollo.BaseMutationOptions<DeactivateLicenseByNodeIdMutation, DeactivateLicenseByNodeIdMutationVariables>;
export const FindAllAvailableLicenseFeatureKeysDocument = gql`
    query findAllAvailableLicenseFeatureKeys {
  findAllAvailableLicenseFeatureKeys
}
    `;

/**
 * __useFindAllAvailableLicenseFeatureKeysQuery__
 *
 * To run a query within a React component, call `useFindAllAvailableLicenseFeatureKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllAvailableLicenseFeatureKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllAvailableLicenseFeatureKeysQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindAllAvailableLicenseFeatureKeysQuery(baseOptions?: Apollo.QueryHookOptions<FindAllAvailableLicenseFeatureKeysQuery, FindAllAvailableLicenseFeatureKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllAvailableLicenseFeatureKeysQuery, FindAllAvailableLicenseFeatureKeysQueryVariables>(FindAllAvailableLicenseFeatureKeysDocument, options);
      }
export function useFindAllAvailableLicenseFeatureKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllAvailableLicenseFeatureKeysQuery, FindAllAvailableLicenseFeatureKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllAvailableLicenseFeatureKeysQuery, FindAllAvailableLicenseFeatureKeysQueryVariables>(FindAllAvailableLicenseFeatureKeysDocument, options);
        }
export type FindAllAvailableLicenseFeatureKeysQueryHookResult = ReturnType<typeof useFindAllAvailableLicenseFeatureKeysQuery>;
export type FindAllAvailableLicenseFeatureKeysLazyQueryHookResult = ReturnType<typeof useFindAllAvailableLicenseFeatureKeysLazyQuery>;
export type FindAllAvailableLicenseFeatureKeysQueryResult = Apollo.QueryResult<FindAllAvailableLicenseFeatureKeysQuery, FindAllAvailableLicenseFeatureKeysQueryVariables>;
export function refetchFindAllAvailableLicenseFeatureKeysQuery(variables?: FindAllAvailableLicenseFeatureKeysQueryVariables) {
      return { query: FindAllAvailableLicenseFeatureKeysDocument, variables: variables }
    }
export const FindAllMachineCoDLicensesDocument = gql`
    query findAllMachineCoDLicenses($machineUuid: String!) {
  findAllMachineCoDLicenses(machineUuid: $machineUuid) {
    comment
    nodeId
    paymentIntervalType
    serialNo
    subscriptionActive
    createdDate
    deliveredDate
    edition
    expirationDate
    invoiceManager
    licenseId
    licenseKey
    deactivatedDate
    licenseStartDate
    lockedDueToFlipFlopping
  }
}
    `;

/**
 * __useFindAllMachineCoDLicensesQuery__
 *
 * To run a query within a React component, call `useFindAllMachineCoDLicensesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllMachineCoDLicensesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllMachineCoDLicensesQuery({
 *   variables: {
 *      machineUuid: // value for 'machineUuid'
 *   },
 * });
 */
export function useFindAllMachineCoDLicensesQuery(baseOptions: Apollo.QueryHookOptions<FindAllMachineCoDLicensesQuery, FindAllMachineCoDLicensesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllMachineCoDLicensesQuery, FindAllMachineCoDLicensesQueryVariables>(FindAllMachineCoDLicensesDocument, options);
      }
export function useFindAllMachineCoDLicensesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllMachineCoDLicensesQuery, FindAllMachineCoDLicensesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllMachineCoDLicensesQuery, FindAllMachineCoDLicensesQueryVariables>(FindAllMachineCoDLicensesDocument, options);
        }
export type FindAllMachineCoDLicensesQueryHookResult = ReturnType<typeof useFindAllMachineCoDLicensesQuery>;
export type FindAllMachineCoDLicensesLazyQueryHookResult = ReturnType<typeof useFindAllMachineCoDLicensesLazyQuery>;
export type FindAllMachineCoDLicensesQueryResult = Apollo.QueryResult<FindAllMachineCoDLicensesQuery, FindAllMachineCoDLicensesQueryVariables>;
export function refetchFindAllMachineCoDLicensesQuery(variables: FindAllMachineCoDLicensesQueryVariables) {
      return { query: FindAllMachineCoDLicensesDocument, variables: variables }
    }
export const FindLatestCoDLicenseByMachineUuidDocument = gql`
    query findLatestCoDLicenseByMachineUuid($machineUuid: String!) {
  findLatestCoDLicenseByMachineUuid(machineUuid: $machineUuid) {
    comment
    nodeId
    paymentIntervalType
    serialNo
    subscriptionActive
    createdDate
    deliveredDate
    edition
    expirationDate
    invoiceManager
    licenseId
    licenseKey
    deactivatedDate
    licenseStartDate
    lockedDueToFlipFlopping
  }
}
    `;

/**
 * __useFindLatestCoDLicenseByMachineUuidQuery__
 *
 * To run a query within a React component, call `useFindLatestCoDLicenseByMachineUuidQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindLatestCoDLicenseByMachineUuidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindLatestCoDLicenseByMachineUuidQuery({
 *   variables: {
 *      machineUuid: // value for 'machineUuid'
 *   },
 * });
 */
export function useFindLatestCoDLicenseByMachineUuidQuery(baseOptions: Apollo.QueryHookOptions<FindLatestCoDLicenseByMachineUuidQuery, FindLatestCoDLicenseByMachineUuidQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindLatestCoDLicenseByMachineUuidQuery, FindLatestCoDLicenseByMachineUuidQueryVariables>(FindLatestCoDLicenseByMachineUuidDocument, options);
      }
export function useFindLatestCoDLicenseByMachineUuidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindLatestCoDLicenseByMachineUuidQuery, FindLatestCoDLicenseByMachineUuidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindLatestCoDLicenseByMachineUuidQuery, FindLatestCoDLicenseByMachineUuidQueryVariables>(FindLatestCoDLicenseByMachineUuidDocument, options);
        }
export type FindLatestCoDLicenseByMachineUuidQueryHookResult = ReturnType<typeof useFindLatestCoDLicenseByMachineUuidQuery>;
export type FindLatestCoDLicenseByMachineUuidLazyQueryHookResult = ReturnType<typeof useFindLatestCoDLicenseByMachineUuidLazyQuery>;
export type FindLatestCoDLicenseByMachineUuidQueryResult = Apollo.QueryResult<FindLatestCoDLicenseByMachineUuidQuery, FindLatestCoDLicenseByMachineUuidQueryVariables>;
export function refetchFindLatestCoDLicenseByMachineUuidQuery(variables: FindLatestCoDLicenseByMachineUuidQueryVariables) {
      return { query: FindLatestCoDLicenseByMachineUuidDocument, variables: variables }
    }
export const GetMachineLicenseContentDocument = gql`
    query getMachineLicenseContent($machineUuid: String!) {
  getMachineLicenseContent(machineUuid: $machineUuid) {
    uuid
    nodeId
    lockedDueToFlipFlopping
    deactivatedDateTime
    features {
      nodeId
      key
      expiration {
        nodeId
        date
        disableFeatureWhenExpired
        warningBeforeExpirationDays
      }
    }
  }
}
    `;

/**
 * __useGetMachineLicenseContentQuery__
 *
 * To run a query within a React component, call `useGetMachineLicenseContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMachineLicenseContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMachineLicenseContentQuery({
 *   variables: {
 *      machineUuid: // value for 'machineUuid'
 *   },
 * });
 */
export function useGetMachineLicenseContentQuery(baseOptions: Apollo.QueryHookOptions<GetMachineLicenseContentQuery, GetMachineLicenseContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMachineLicenseContentQuery, GetMachineLicenseContentQueryVariables>(GetMachineLicenseContentDocument, options);
      }
export function useGetMachineLicenseContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMachineLicenseContentQuery, GetMachineLicenseContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMachineLicenseContentQuery, GetMachineLicenseContentQueryVariables>(GetMachineLicenseContentDocument, options);
        }
export type GetMachineLicenseContentQueryHookResult = ReturnType<typeof useGetMachineLicenseContentQuery>;
export type GetMachineLicenseContentLazyQueryHookResult = ReturnType<typeof useGetMachineLicenseContentLazyQuery>;
export type GetMachineLicenseContentQueryResult = Apollo.QueryResult<GetMachineLicenseContentQuery, GetMachineLicenseContentQueryVariables>;
export function refetchGetMachineLicenseContentQuery(variables: GetMachineLicenseContentQueryVariables) {
      return { query: GetMachineLicenseContentDocument, variables: variables }
    }
export const UpgradeMachineLatestLicenseDocument = gql`
    mutation upgradeMachineLatestLicense($licenseSubscription: LicenseSubscriptionDtoIn!) {
  upgradeMachineLatestLicense(licenseSubscription: $licenseSubscription) {
    nodeId
    comment
    nodeId
    paymentIntervalType
    serialNo
    subscriptionActive
    createdDate
    deliveredDate
    edition
    expirationDate
    invoiceManager
    licenseId
    licenseKey
    deactivatedDate
    licenseStartDate
    lockedDueToFlipFlopping
  }
}
    `;
export type UpgradeMachineLatestLicenseMutationFn = Apollo.MutationFunction<UpgradeMachineLatestLicenseMutation, UpgradeMachineLatestLicenseMutationVariables>;

/**
 * __useUpgradeMachineLatestLicenseMutation__
 *
 * To run a mutation, you first call `useUpgradeMachineLatestLicenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpgradeMachineLatestLicenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upgradeMachineLatestLicenseMutation, { data, loading, error }] = useUpgradeMachineLatestLicenseMutation({
 *   variables: {
 *      licenseSubscription: // value for 'licenseSubscription'
 *   },
 * });
 */
export function useUpgradeMachineLatestLicenseMutation(baseOptions?: Apollo.MutationHookOptions<UpgradeMachineLatestLicenseMutation, UpgradeMachineLatestLicenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpgradeMachineLatestLicenseMutation, UpgradeMachineLatestLicenseMutationVariables>(UpgradeMachineLatestLicenseDocument, options);
      }
export type UpgradeMachineLatestLicenseMutationHookResult = ReturnType<typeof useUpgradeMachineLatestLicenseMutation>;
export type UpgradeMachineLatestLicenseMutationResult = Apollo.MutationResult<UpgradeMachineLatestLicenseMutation>;
export type UpgradeMachineLatestLicenseMutationOptions = Apollo.BaseMutationOptions<UpgradeMachineLatestLicenseMutation, UpgradeMachineLatestLicenseMutationVariables>;
export const UpdateMachineDocument = gql`
    mutation updateMachine($nodeId: String!, $input: MachineDtoIn!) {
  updateMachine(nodeId: $nodeId, machine: $input) {
    name
    nodeStatus
    nodeChangeDate
    nodeId
    uuid
    locationNodeId
    machineType {
      name
      nodeId
    }
  }
}
    `;
export type UpdateMachineMutationFn = Apollo.MutationFunction<UpdateMachineMutation, UpdateMachineMutationVariables>;

/**
 * __useUpdateMachineMutation__
 *
 * To run a mutation, you first call `useUpdateMachineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMachineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMachineMutation, { data, loading, error }] = useUpdateMachineMutation({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMachineMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMachineMutation, UpdateMachineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMachineMutation, UpdateMachineMutationVariables>(UpdateMachineDocument, options);
      }
export type UpdateMachineMutationHookResult = ReturnType<typeof useUpdateMachineMutation>;
export type UpdateMachineMutationResult = Apollo.MutationResult<UpdateMachineMutation>;
export type UpdateMachineMutationOptions = Apollo.BaseMutationOptions<UpdateMachineMutation, UpdateMachineMutationVariables>;
export const CreateMachineUserDocument = gql`
    mutation createMachineUser($input: MachineUserDtoIn!) {
  createMachineUser(machineUser: $input) {
    nodeId
    name
    roleName
    userId
  }
}
    `;
export type CreateMachineUserMutationFn = Apollo.MutationFunction<CreateMachineUserMutation, CreateMachineUserMutationVariables>;

/**
 * __useCreateMachineUserMutation__
 *
 * To run a mutation, you first call `useCreateMachineUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMachineUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMachineUserMutation, { data, loading, error }] = useCreateMachineUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMachineUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateMachineUserMutation, CreateMachineUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMachineUserMutation, CreateMachineUserMutationVariables>(CreateMachineUserDocument, options);
      }
export type CreateMachineUserMutationHookResult = ReturnType<typeof useCreateMachineUserMutation>;
export type CreateMachineUserMutationResult = Apollo.MutationResult<CreateMachineUserMutation>;
export type CreateMachineUserMutationOptions = Apollo.BaseMutationOptions<CreateMachineUserMutation, CreateMachineUserMutationVariables>;
export const DeleteMachineUserDocument = gql`
    mutation deleteMachineUser($input: String!) {
  deleteMachineUser(nodeId: $input) {
    nodeId
  }
}
    `;
export type DeleteMachineUserMutationFn = Apollo.MutationFunction<DeleteMachineUserMutation, DeleteMachineUserMutationVariables>;

/**
 * __useDeleteMachineUserMutation__
 *
 * To run a mutation, you first call `useDeleteMachineUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMachineUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMachineUserMutation, { data, loading, error }] = useDeleteMachineUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteMachineUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMachineUserMutation, DeleteMachineUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMachineUserMutation, DeleteMachineUserMutationVariables>(DeleteMachineUserDocument, options);
      }
export type DeleteMachineUserMutationHookResult = ReturnType<typeof useDeleteMachineUserMutation>;
export type DeleteMachineUserMutationResult = Apollo.MutationResult<DeleteMachineUserMutation>;
export type DeleteMachineUserMutationOptions = Apollo.BaseMutationOptions<DeleteMachineUserMutation, DeleteMachineUserMutationVariables>;
export const DeleteMachineUsersDocument = gql`
    mutation deleteMachineUsers($nodeIds: [String!]!) {
  deleteMachineUsers(nodeId: $nodeIds)
}
    `;
export type DeleteMachineUsersMutationFn = Apollo.MutationFunction<DeleteMachineUsersMutation, DeleteMachineUsersMutationVariables>;

/**
 * __useDeleteMachineUsersMutation__
 *
 * To run a mutation, you first call `useDeleteMachineUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMachineUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMachineUsersMutation, { data, loading, error }] = useDeleteMachineUsersMutation({
 *   variables: {
 *      nodeIds: // value for 'nodeIds'
 *   },
 * });
 */
export function useDeleteMachineUsersMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMachineUsersMutation, DeleteMachineUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMachineUsersMutation, DeleteMachineUsersMutationVariables>(DeleteMachineUsersDocument, options);
      }
export type DeleteMachineUsersMutationHookResult = ReturnType<typeof useDeleteMachineUsersMutation>;
export type DeleteMachineUsersMutationResult = Apollo.MutationResult<DeleteMachineUsersMutation>;
export type DeleteMachineUsersMutationOptions = Apollo.BaseMutationOptions<DeleteMachineUsersMutation, DeleteMachineUsersMutationVariables>;
export const FindAllDistinctRolesDocument = gql`
    query findAllDistinctRoles {
  findAllDistinctRoles
}
    `;

/**
 * __useFindAllDistinctRolesQuery__
 *
 * To run a query within a React component, call `useFindAllDistinctRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllDistinctRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllDistinctRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindAllDistinctRolesQuery(baseOptions?: Apollo.QueryHookOptions<FindAllDistinctRolesQuery, FindAllDistinctRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllDistinctRolesQuery, FindAllDistinctRolesQueryVariables>(FindAllDistinctRolesDocument, options);
      }
export function useFindAllDistinctRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllDistinctRolesQuery, FindAllDistinctRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllDistinctRolesQuery, FindAllDistinctRolesQueryVariables>(FindAllDistinctRolesDocument, options);
        }
export type FindAllDistinctRolesQueryHookResult = ReturnType<typeof useFindAllDistinctRolesQuery>;
export type FindAllDistinctRolesLazyQueryHookResult = ReturnType<typeof useFindAllDistinctRolesLazyQuery>;
export type FindAllDistinctRolesQueryResult = Apollo.QueryResult<FindAllDistinctRolesQuery, FindAllDistinctRolesQueryVariables>;
export function refetchFindAllDistinctRolesQuery(variables?: FindAllDistinctRolesQueryVariables) {
      return { query: FindAllDistinctRolesDocument, variables: variables }
    }
export const FindAllMachineUsersFilteredDocument = gql`
    query findAllMachineUsersFiltered($machineUserFilters: MachineUserFiltersDto, $searchRequest: SearchRequestDto!) {
  findAllMachineUsersFiltered(
    machineUserFilters: $machineUserFilters
    searchRequest: $searchRequest
  ) {
    fullSize
    result {
      nodeId
      ... on MachineUserDtoOut {
        name
        userId
        roleName
        nodeId
        cardIdentifier
        deactivated
        roleName
        validFrom
        validUntil
        nbrOfLogins
      }
    }
  }
}
    `;

/**
 * __useFindAllMachineUsersFilteredQuery__
 *
 * To run a query within a React component, call `useFindAllMachineUsersFilteredQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllMachineUsersFilteredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllMachineUsersFilteredQuery({
 *   variables: {
 *      machineUserFilters: // value for 'machineUserFilters'
 *      searchRequest: // value for 'searchRequest'
 *   },
 * });
 */
export function useFindAllMachineUsersFilteredQuery(baseOptions: Apollo.QueryHookOptions<FindAllMachineUsersFilteredQuery, FindAllMachineUsersFilteredQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllMachineUsersFilteredQuery, FindAllMachineUsersFilteredQueryVariables>(FindAllMachineUsersFilteredDocument, options);
      }
export function useFindAllMachineUsersFilteredLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllMachineUsersFilteredQuery, FindAllMachineUsersFilteredQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllMachineUsersFilteredQuery, FindAllMachineUsersFilteredQueryVariables>(FindAllMachineUsersFilteredDocument, options);
        }
export type FindAllMachineUsersFilteredQueryHookResult = ReturnType<typeof useFindAllMachineUsersFilteredQuery>;
export type FindAllMachineUsersFilteredLazyQueryHookResult = ReturnType<typeof useFindAllMachineUsersFilteredLazyQuery>;
export type FindAllMachineUsersFilteredQueryResult = Apollo.QueryResult<FindAllMachineUsersFilteredQuery, FindAllMachineUsersFilteredQueryVariables>;
export function refetchFindAllMachineUsersFilteredQuery(variables: FindAllMachineUsersFilteredQueryVariables) {
      return { query: FindAllMachineUsersFilteredDocument, variables: variables }
    }
export const FindMachineUserByUserIdDocument = gql`
    query findMachineUserByUserId($userId: String!) {
  findMachineUserByUserId(userId: $userId) {
    alias
    cardIdentifier
    changePinOnLogin
    deactivated
    doors
    fingerprints
    list
    machineUserGroupNodeIds
    name
    nbrOfBadPin
    nbrOfLogins
    nodeId
    noPin
    noPinBio
    noPinCard
    noPinDoor
    noPinLogin
    pin
    roleName
    userId
    validFrom
    validUntil
  }
}
    `;

/**
 * __useFindMachineUserByUserIdQuery__
 *
 * To run a query within a React component, call `useFindMachineUserByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindMachineUserByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindMachineUserByUserIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useFindMachineUserByUserIdQuery(baseOptions: Apollo.QueryHookOptions<FindMachineUserByUserIdQuery, FindMachineUserByUserIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindMachineUserByUserIdQuery, FindMachineUserByUserIdQueryVariables>(FindMachineUserByUserIdDocument, options);
      }
export function useFindMachineUserByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindMachineUserByUserIdQuery, FindMachineUserByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindMachineUserByUserIdQuery, FindMachineUserByUserIdQueryVariables>(FindMachineUserByUserIdDocument, options);
        }
export type FindMachineUserByUserIdQueryHookResult = ReturnType<typeof useFindMachineUserByUserIdQuery>;
export type FindMachineUserByUserIdLazyQueryHookResult = ReturnType<typeof useFindMachineUserByUserIdLazyQuery>;
export type FindMachineUserByUserIdQueryResult = Apollo.QueryResult<FindMachineUserByUserIdQuery, FindMachineUserByUserIdQueryVariables>;
export function refetchFindMachineUserByUserIdQuery(variables: FindMachineUserByUserIdQueryVariables) {
      return { query: FindMachineUserByUserIdDocument, variables: variables }
    }
export const FindMachineUserPersonalInfoDocument = gql`
    query findMachineUserPersonalInfo($userId: String!) {
  findMachineUserByUserId(userId: $userId) {
    name
    nodeId
    userId
  }
}
    `;

/**
 * __useFindMachineUserPersonalInfoQuery__
 *
 * To run a query within a React component, call `useFindMachineUserPersonalInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindMachineUserPersonalInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindMachineUserPersonalInfoQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useFindMachineUserPersonalInfoQuery(baseOptions: Apollo.QueryHookOptions<FindMachineUserPersonalInfoQuery, FindMachineUserPersonalInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindMachineUserPersonalInfoQuery, FindMachineUserPersonalInfoQueryVariables>(FindMachineUserPersonalInfoDocument, options);
      }
export function useFindMachineUserPersonalInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindMachineUserPersonalInfoQuery, FindMachineUserPersonalInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindMachineUserPersonalInfoQuery, FindMachineUserPersonalInfoQueryVariables>(FindMachineUserPersonalInfoDocument, options);
        }
export type FindMachineUserPersonalInfoQueryHookResult = ReturnType<typeof useFindMachineUserPersonalInfoQuery>;
export type FindMachineUserPersonalInfoLazyQueryHookResult = ReturnType<typeof useFindMachineUserPersonalInfoLazyQuery>;
export type FindMachineUserPersonalInfoQueryResult = Apollo.QueryResult<FindMachineUserPersonalInfoQuery, FindMachineUserPersonalInfoQueryVariables>;
export function refetchFindMachineUserPersonalInfoQuery(variables: FindMachineUserPersonalInfoQueryVariables) {
      return { query: FindMachineUserPersonalInfoDocument, variables: variables }
    }
export const ImportMachineUsersDocument = gql`
    mutation importMachineUsers($machineUserImport: MachineUserXmlImport!) {
  importMachineUsers(machineUserImport: $machineUserImport)
}
    `;
export type ImportMachineUsersMutationFn = Apollo.MutationFunction<ImportMachineUsersMutation, ImportMachineUsersMutationVariables>;

/**
 * __useImportMachineUsersMutation__
 *
 * To run a mutation, you first call `useImportMachineUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportMachineUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importMachineUsersMutation, { data, loading, error }] = useImportMachineUsersMutation({
 *   variables: {
 *      machineUserImport: // value for 'machineUserImport'
 *   },
 * });
 */
export function useImportMachineUsersMutation(baseOptions?: Apollo.MutationHookOptions<ImportMachineUsersMutation, ImportMachineUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportMachineUsersMutation, ImportMachineUsersMutationVariables>(ImportMachineUsersDocument, options);
      }
export type ImportMachineUsersMutationHookResult = ReturnType<typeof useImportMachineUsersMutation>;
export type ImportMachineUsersMutationResult = Apollo.MutationResult<ImportMachineUsersMutation>;
export type ImportMachineUsersMutationOptions = Apollo.BaseMutationOptions<ImportMachineUsersMutation, ImportMachineUsersMutationVariables>;
export const UpdateMachineUserDocument = gql`
    mutation updateMachineUser($nodeId: String!, $input: MachineUserDtoIn!) {
  updateMachineUser(nodeId: $nodeId, machineUser: $input) {
    alias
    cardIdentifier
    changePinOnLogin
    deactivated
    doors
    fingerprints
    list
    machineUserGroupNodeIds
    name
    nbrOfBadPin
    nbrOfLogins
    nodeId
    noPin
    noPinBio
    noPinCard
    noPinDoor
    noPinLogin
    pin
    roleName
    userId
    validFrom
    validUntil
  }
}
    `;
export type UpdateMachineUserMutationFn = Apollo.MutationFunction<UpdateMachineUserMutation, UpdateMachineUserMutationVariables>;

/**
 * __useUpdateMachineUserMutation__
 *
 * To run a mutation, you first call `useUpdateMachineUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMachineUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMachineUserMutation, { data, loading, error }] = useUpdateMachineUserMutation({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMachineUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMachineUserMutation, UpdateMachineUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMachineUserMutation, UpdateMachineUserMutationVariables>(UpdateMachineUserDocument, options);
      }
export type UpdateMachineUserMutationHookResult = ReturnType<typeof useUpdateMachineUserMutation>;
export type UpdateMachineUserMutationResult = Apollo.MutationResult<UpdateMachineUserMutation>;
export type UpdateMachineUserMutationOptions = Apollo.BaseMutationOptions<UpdateMachineUserMutation, UpdateMachineUserMutationVariables>;
export const CreateOtaAuthorizationDocument = gql`
    mutation createOtaAuthorization($otaAuthorizationIn: OtaAuthorizationIn!) {
  createOtaAuthorization(otaAuthorizationIn: $otaAuthorizationIn) {
    nodeId
  }
}
    `;
export type CreateOtaAuthorizationMutationFn = Apollo.MutationFunction<CreateOtaAuthorizationMutation, CreateOtaAuthorizationMutationVariables>;

/**
 * __useCreateOtaAuthorizationMutation__
 *
 * To run a mutation, you first call `useCreateOtaAuthorizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOtaAuthorizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOtaAuthorizationMutation, { data, loading, error }] = useCreateOtaAuthorizationMutation({
 *   variables: {
 *      otaAuthorizationIn: // value for 'otaAuthorizationIn'
 *   },
 * });
 */
export function useCreateOtaAuthorizationMutation(baseOptions?: Apollo.MutationHookOptions<CreateOtaAuthorizationMutation, CreateOtaAuthorizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOtaAuthorizationMutation, CreateOtaAuthorizationMutationVariables>(CreateOtaAuthorizationDocument, options);
      }
export type CreateOtaAuthorizationMutationHookResult = ReturnType<typeof useCreateOtaAuthorizationMutation>;
export type CreateOtaAuthorizationMutationResult = Apollo.MutationResult<CreateOtaAuthorizationMutation>;
export type CreateOtaAuthorizationMutationOptions = Apollo.BaseMutationOptions<CreateOtaAuthorizationMutation, CreateOtaAuthorizationMutationVariables>;
export const DeactivateOtaAuthorizationDocument = gql`
    mutation deactivateOtaAuthorization($nodeId: String!) {
  deactivateOtaAuthorization(nodeId: $nodeId)
}
    `;
export type DeactivateOtaAuthorizationMutationFn = Apollo.MutationFunction<DeactivateOtaAuthorizationMutation, DeactivateOtaAuthorizationMutationVariables>;

/**
 * __useDeactivateOtaAuthorizationMutation__
 *
 * To run a mutation, you first call `useDeactivateOtaAuthorizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateOtaAuthorizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateOtaAuthorizationMutation, { data, loading, error }] = useDeactivateOtaAuthorizationMutation({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useDeactivateOtaAuthorizationMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateOtaAuthorizationMutation, DeactivateOtaAuthorizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateOtaAuthorizationMutation, DeactivateOtaAuthorizationMutationVariables>(DeactivateOtaAuthorizationDocument, options);
      }
export type DeactivateOtaAuthorizationMutationHookResult = ReturnType<typeof useDeactivateOtaAuthorizationMutation>;
export type DeactivateOtaAuthorizationMutationResult = Apollo.MutationResult<DeactivateOtaAuthorizationMutation>;
export type DeactivateOtaAuthorizationMutationOptions = Apollo.BaseMutationOptions<DeactivateOtaAuthorizationMutation, DeactivateOtaAuthorizationMutationVariables>;
export const DeactivateOtaKeyPairDocument = gql`
    mutation deactivateOtaKeyPair($machineUuid: String!) {
  deactivateOtaKeyPair(machineUuid: $machineUuid)
}
    `;
export type DeactivateOtaKeyPairMutationFn = Apollo.MutationFunction<DeactivateOtaKeyPairMutation, DeactivateOtaKeyPairMutationVariables>;

/**
 * __useDeactivateOtaKeyPairMutation__
 *
 * To run a mutation, you first call `useDeactivateOtaKeyPairMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateOtaKeyPairMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateOtaKeyPairMutation, { data, loading, error }] = useDeactivateOtaKeyPairMutation({
 *   variables: {
 *      machineUuid: // value for 'machineUuid'
 *   },
 * });
 */
export function useDeactivateOtaKeyPairMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateOtaKeyPairMutation, DeactivateOtaKeyPairMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateOtaKeyPairMutation, DeactivateOtaKeyPairMutationVariables>(DeactivateOtaKeyPairDocument, options);
      }
export type DeactivateOtaKeyPairMutationHookResult = ReturnType<typeof useDeactivateOtaKeyPairMutation>;
export type DeactivateOtaKeyPairMutationResult = Apollo.MutationResult<DeactivateOtaKeyPairMutation>;
export type DeactivateOtaKeyPairMutationOptions = Apollo.BaseMutationOptions<DeactivateOtaKeyPairMutation, DeactivateOtaKeyPairMutationVariables>;
export const FindAllOtaAuthorizationsDocument = gql`
    query findAllOtaAuthorizations($searchRequest: SearchRequestDto!, $otaAuthorizationFiltersDto: OtaAuthorizationFiltersDto) {
  findAllOtaAuthorizations(
    searchRequest: $searchRequest
    otaAuthorizationFiltersDto: $otaAuthorizationFiltersDto
  ) {
    fullSize
    result {
      ... on OtaAuthorizationDto {
        nodeId
        nodeStatus
        nodeChangeDate
        userName
        connectUserName
        userRole
        userId
        expirationDateTime
        machineUuid
        siteNodeId
        siteGroupNodeId
        deleteAfterFirstUse
        codeValidityIntervalMinutes
        customData {
          key
          value
        }
      }
    }
  }
}
    `;

/**
 * __useFindAllOtaAuthorizationsQuery__
 *
 * To run a query within a React component, call `useFindAllOtaAuthorizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllOtaAuthorizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllOtaAuthorizationsQuery({
 *   variables: {
 *      searchRequest: // value for 'searchRequest'
 *      otaAuthorizationFiltersDto: // value for 'otaAuthorizationFiltersDto'
 *   },
 * });
 */
export function useFindAllOtaAuthorizationsQuery(baseOptions: Apollo.QueryHookOptions<FindAllOtaAuthorizationsQuery, FindAllOtaAuthorizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllOtaAuthorizationsQuery, FindAllOtaAuthorizationsQueryVariables>(FindAllOtaAuthorizationsDocument, options);
      }
export function useFindAllOtaAuthorizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllOtaAuthorizationsQuery, FindAllOtaAuthorizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllOtaAuthorizationsQuery, FindAllOtaAuthorizationsQueryVariables>(FindAllOtaAuthorizationsDocument, options);
        }
export type FindAllOtaAuthorizationsQueryHookResult = ReturnType<typeof useFindAllOtaAuthorizationsQuery>;
export type FindAllOtaAuthorizationsLazyQueryHookResult = ReturnType<typeof useFindAllOtaAuthorizationsLazyQuery>;
export type FindAllOtaAuthorizationsQueryResult = Apollo.QueryResult<FindAllOtaAuthorizationsQuery, FindAllOtaAuthorizationsQueryVariables>;
export function refetchFindAllOtaAuthorizationsQuery(variables: FindAllOtaAuthorizationsQueryVariables) {
      return { query: FindAllOtaAuthorizationsDocument, variables: variables }
    }
export const GetOrCreateDocument = gql`
    mutation getOrCreate($otaCodeDtoIn: OtaCodeInputDto!) {
  getOrCreate(otaCodeDtoIn: $otaCodeDtoIn) {
    nodeId
    code
  }
}
    `;
export type GetOrCreateMutationFn = Apollo.MutationFunction<GetOrCreateMutation, GetOrCreateMutationVariables>;

/**
 * __useGetOrCreateMutation__
 *
 * To run a mutation, you first call `useGetOrCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetOrCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getOrCreateMutation, { data, loading, error }] = useGetOrCreateMutation({
 *   variables: {
 *      otaCodeDtoIn: // value for 'otaCodeDtoIn'
 *   },
 * });
 */
export function useGetOrCreateMutation(baseOptions?: Apollo.MutationHookOptions<GetOrCreateMutation, GetOrCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetOrCreateMutation, GetOrCreateMutationVariables>(GetOrCreateDocument, options);
      }
export type GetOrCreateMutationHookResult = ReturnType<typeof useGetOrCreateMutation>;
export type GetOrCreateMutationResult = Apollo.MutationResult<GetOrCreateMutation>;
export type GetOrCreateMutationOptions = Apollo.BaseMutationOptions<GetOrCreateMutation, GetOrCreateMutationVariables>;
export const CreateScheduledReportDocument = gql`
    mutation createScheduledReport($input: ScheduledReportDtoIn!) {
  createScheduledReport(params: $input) {
    fileType
    instanceName
    nextExecution
    nodeId
    nodeStatus
    locationNodeIds
    reportEmails {
      email
      subject
    }
    reportName
    status
  }
}
    `;
export type CreateScheduledReportMutationFn = Apollo.MutationFunction<CreateScheduledReportMutation, CreateScheduledReportMutationVariables>;

/**
 * __useCreateScheduledReportMutation__
 *
 * To run a mutation, you first call `useCreateScheduledReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScheduledReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScheduledReportMutation, { data, loading, error }] = useCreateScheduledReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateScheduledReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateScheduledReportMutation, CreateScheduledReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateScheduledReportMutation, CreateScheduledReportMutationVariables>(CreateScheduledReportDocument, options);
      }
export type CreateScheduledReportMutationHookResult = ReturnType<typeof useCreateScheduledReportMutation>;
export type CreateScheduledReportMutationResult = Apollo.MutationResult<CreateScheduledReportMutation>;
export type CreateScheduledReportMutationOptions = Apollo.BaseMutationOptions<CreateScheduledReportMutation, CreateScheduledReportMutationVariables>;
export const FindBoxTotalsByCurrencyDocument = gql`
    query findBoxTotalsByCurrency($boxTotalsDtoIn: BoxTotalsDtoIn) {
  findBoxTotalsByCurrency(boxTotalsDtoIn: $boxTotalsDtoIn) {
    boxTotals {
      key
      value
    }
  }
}
    `;

/**
 * __useFindBoxTotalsByCurrencyQuery__
 *
 * To run a query within a React component, call `useFindBoxTotalsByCurrencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindBoxTotalsByCurrencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindBoxTotalsByCurrencyQuery({
 *   variables: {
 *      boxTotalsDtoIn: // value for 'boxTotalsDtoIn'
 *   },
 * });
 */
export function useFindBoxTotalsByCurrencyQuery(baseOptions?: Apollo.QueryHookOptions<FindBoxTotalsByCurrencyQuery, FindBoxTotalsByCurrencyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindBoxTotalsByCurrencyQuery, FindBoxTotalsByCurrencyQueryVariables>(FindBoxTotalsByCurrencyDocument, options);
      }
export function useFindBoxTotalsByCurrencyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindBoxTotalsByCurrencyQuery, FindBoxTotalsByCurrencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindBoxTotalsByCurrencyQuery, FindBoxTotalsByCurrencyQueryVariables>(FindBoxTotalsByCurrencyDocument, options);
        }
export type FindBoxTotalsByCurrencyQueryHookResult = ReturnType<typeof useFindBoxTotalsByCurrencyQuery>;
export type FindBoxTotalsByCurrencyLazyQueryHookResult = ReturnType<typeof useFindBoxTotalsByCurrencyLazyQuery>;
export type FindBoxTotalsByCurrencyQueryResult = Apollo.QueryResult<FindBoxTotalsByCurrencyQuery, FindBoxTotalsByCurrencyQueryVariables>;
export function refetchFindBoxTotalsByCurrencyQuery(variables?: FindBoxTotalsByCurrencyQueryVariables) {
      return { query: FindBoxTotalsByCurrencyDocument, variables: variables }
    }
export const FindDeviceMovementsForRmTransactionDocument = gql`
    query findDeviceMovementsForRmTransaction($nodeId: String) {
  findDeviceMovementsForRmTransaction(transactionNodeId: $nodeId) {
    nodeId
    deviceId
    boxMovements {
      boxId
      containerId
      nodeId
      movement {
        nodeId
        rejects
        totalAmount
        type
        values {
          denomination
          exchangeRate
          exchangeRateDecimals
          nodeId
          pieceValue
          reference
          total
          type
          c2Count
          c3Count
          c4bCount
          claimedValueType
          count
          creditCat2
          creditCat3
          currency
          customType
          decimals
        }
      }
      resultingContent {
        nodeId
        rejects
        totalAmount
        type
        values {
          denomination
          exchangeRate
          exchangeRateDecimals
          nodeId
          pieceValue
          reference
          total
          type
          c2Count
          c3Count
          c4bCount
          claimedValueType
          count
          creditCat2
          creditCat3
          currency
          customType
          decimals
        }
      }
    }
  }
}
    `;

/**
 * __useFindDeviceMovementsForRmTransactionQuery__
 *
 * To run a query within a React component, call `useFindDeviceMovementsForRmTransactionQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindDeviceMovementsForRmTransactionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindDeviceMovementsForRmTransactionQuery({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useFindDeviceMovementsForRmTransactionQuery(baseOptions?: Apollo.QueryHookOptions<FindDeviceMovementsForRmTransactionQuery, FindDeviceMovementsForRmTransactionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindDeviceMovementsForRmTransactionQuery, FindDeviceMovementsForRmTransactionQueryVariables>(FindDeviceMovementsForRmTransactionDocument, options);
      }
export function useFindDeviceMovementsForRmTransactionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindDeviceMovementsForRmTransactionQuery, FindDeviceMovementsForRmTransactionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindDeviceMovementsForRmTransactionQuery, FindDeviceMovementsForRmTransactionQueryVariables>(FindDeviceMovementsForRmTransactionDocument, options);
        }
export type FindDeviceMovementsForRmTransactionQueryHookResult = ReturnType<typeof useFindDeviceMovementsForRmTransactionQuery>;
export type FindDeviceMovementsForRmTransactionLazyQueryHookResult = ReturnType<typeof useFindDeviceMovementsForRmTransactionLazyQuery>;
export type FindDeviceMovementsForRmTransactionQueryResult = Apollo.QueryResult<FindDeviceMovementsForRmTransactionQuery, FindDeviceMovementsForRmTransactionQueryVariables>;
export function refetchFindDeviceMovementsForRmTransactionQuery(variables?: FindDeviceMovementsForRmTransactionQueryVariables) {
      return { query: FindDeviceMovementsForRmTransactionDocument, variables: variables }
    }
export const FindRmDevicesForMachineDetailsDocument = gql`
    query findRmDevicesForMachineDetails($machineDetailsNodeId: String) {
  findRmDevicesForMachineDetails(machineDetailsNodeId: $machineDetailsNodeId) {
    id
    nodeId
    deviceInfo {
      accType
      firmware
      hardware
      name
      nodeId
      protocol
      serialNumber
      version
    }
    sensorInfo {
      accType
      firmware
      hardware
      name
      nodeId
      protocol
      serialNumber
      version
    }
  }
}
    `;

/**
 * __useFindRmDevicesForMachineDetailsQuery__
 *
 * To run a query within a React component, call `useFindRmDevicesForMachineDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindRmDevicesForMachineDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindRmDevicesForMachineDetailsQuery({
 *   variables: {
 *      machineDetailsNodeId: // value for 'machineDetailsNodeId'
 *   },
 * });
 */
export function useFindRmDevicesForMachineDetailsQuery(baseOptions?: Apollo.QueryHookOptions<FindRmDevicesForMachineDetailsQuery, FindRmDevicesForMachineDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindRmDevicesForMachineDetailsQuery, FindRmDevicesForMachineDetailsQueryVariables>(FindRmDevicesForMachineDetailsDocument, options);
      }
export function useFindRmDevicesForMachineDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindRmDevicesForMachineDetailsQuery, FindRmDevicesForMachineDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindRmDevicesForMachineDetailsQuery, FindRmDevicesForMachineDetailsQueryVariables>(FindRmDevicesForMachineDetailsDocument, options);
        }
export type FindRmDevicesForMachineDetailsQueryHookResult = ReturnType<typeof useFindRmDevicesForMachineDetailsQuery>;
export type FindRmDevicesForMachineDetailsLazyQueryHookResult = ReturnType<typeof useFindRmDevicesForMachineDetailsLazyQuery>;
export type FindRmDevicesForMachineDetailsQueryResult = Apollo.QueryResult<FindRmDevicesForMachineDetailsQuery, FindRmDevicesForMachineDetailsQueryVariables>;
export function refetchFindRmDevicesForMachineDetailsQuery(variables?: FindRmDevicesForMachineDetailsQueryVariables) {
      return { query: FindRmDevicesForMachineDetailsDocument, variables: variables }
    }
export const FindRmValuesForRmBoxDocument = gql`
    query findRmValuesForRmBox($nodeIds: [String]) {
  findRmValuesForRmBox(rmBoxNodeIds: $nodeIds) {
    nodeId
    boxId
    total
    name
    values {
      nodeId
      total
      count
      decimals
      currency
      denomination
      pieceValue
      exchangeRate
      exchangeRateDecimals
      reference
      type
      claimedValueType
      customType
      c2Count
      c3Count
      c4bCount
      creditCat2
      creditCat3
    }
    type
    defaultLevel
    maximumLevel
    minimumLevel
    highLimitLevel
    lowLimitLevel
    fillStatus
    capabilities
    errorStatus
  }
}
    `;

/**
 * __useFindRmValuesForRmBoxQuery__
 *
 * To run a query within a React component, call `useFindRmValuesForRmBoxQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindRmValuesForRmBoxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindRmValuesForRmBoxQuery({
 *   variables: {
 *      nodeIds: // value for 'nodeIds'
 *   },
 * });
 */
export function useFindRmValuesForRmBoxQuery(baseOptions?: Apollo.QueryHookOptions<FindRmValuesForRmBoxQuery, FindRmValuesForRmBoxQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindRmValuesForRmBoxQuery, FindRmValuesForRmBoxQueryVariables>(FindRmValuesForRmBoxDocument, options);
      }
export function useFindRmValuesForRmBoxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindRmValuesForRmBoxQuery, FindRmValuesForRmBoxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindRmValuesForRmBoxQuery, FindRmValuesForRmBoxQueryVariables>(FindRmValuesForRmBoxDocument, options);
        }
export type FindRmValuesForRmBoxQueryHookResult = ReturnType<typeof useFindRmValuesForRmBoxQuery>;
export type FindRmValuesForRmBoxLazyQueryHookResult = ReturnType<typeof useFindRmValuesForRmBoxLazyQuery>;
export type FindRmValuesForRmBoxQueryResult = Apollo.QueryResult<FindRmValuesForRmBoxQuery, FindRmValuesForRmBoxQueryVariables>;
export function refetchFindRmValuesForRmBoxQuery(variables?: FindRmValuesForRmBoxQueryVariables) {
      return { query: FindRmValuesForRmBoxDocument, variables: variables }
    }
export const FindValueBagsForRmTransactionDocument = gql`
    query findValueBagsForRmTransaction($nodeId: String) {
  findValueBagsForRmTransaction(transactionNodeId: $nodeId) {
    nodeId
    totalAmount
    type
    rejects
    values {
      nodeId
      total
      count
      decimals
      currency
      denomination
      pieceValue
      exchangeRate
      exchangeRateDecimals
      reference
      type
      claimedValueType
      customType
      c2Count
      c3Count
      c4bCount
      creditCat2
      creditCat3
    }
  }
}
    `;

/**
 * __useFindValueBagsForRmTransactionQuery__
 *
 * To run a query within a React component, call `useFindValueBagsForRmTransactionQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindValueBagsForRmTransactionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindValueBagsForRmTransactionQuery({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useFindValueBagsForRmTransactionQuery(baseOptions?: Apollo.QueryHookOptions<FindValueBagsForRmTransactionQuery, FindValueBagsForRmTransactionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindValueBagsForRmTransactionQuery, FindValueBagsForRmTransactionQueryVariables>(FindValueBagsForRmTransactionDocument, options);
      }
export function useFindValueBagsForRmTransactionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindValueBagsForRmTransactionQuery, FindValueBagsForRmTransactionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindValueBagsForRmTransactionQuery, FindValueBagsForRmTransactionQueryVariables>(FindValueBagsForRmTransactionDocument, options);
        }
export type FindValueBagsForRmTransactionQueryHookResult = ReturnType<typeof useFindValueBagsForRmTransactionQuery>;
export type FindValueBagsForRmTransactionLazyQueryHookResult = ReturnType<typeof useFindValueBagsForRmTransactionLazyQuery>;
export type FindValueBagsForRmTransactionQueryResult = Apollo.QueryResult<FindValueBagsForRmTransactionQuery, FindValueBagsForRmTransactionQueryVariables>;
export function refetchFindValueBagsForRmTransactionQuery(variables?: FindValueBagsForRmTransactionQueryVariables) {
      return { query: FindValueBagsForRmTransactionDocument, variables: variables }
    }
export const GenerateCashInventoryReportDocument = gql`
    query generateCashInventoryReport($input: CashInventoryReportCriteriaDtoIn!) {
  generateCashInventoryReport(cashInventoryReportCriteria: $input) {
    fullSize
    columns {
      key
      values
    }
    rows {
      boxNodeIds
      machineNodeId
      machineTypeName
      machineName
      locationName
      totalAmounts {
        amount
        count
        currency
      }
    }
  }
}
    `;

/**
 * __useGenerateCashInventoryReportQuery__
 *
 * To run a query within a React component, call `useGenerateCashInventoryReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateCashInventoryReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateCashInventoryReportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateCashInventoryReportQuery(baseOptions: Apollo.QueryHookOptions<GenerateCashInventoryReportQuery, GenerateCashInventoryReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateCashInventoryReportQuery, GenerateCashInventoryReportQueryVariables>(GenerateCashInventoryReportDocument, options);
      }
export function useGenerateCashInventoryReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateCashInventoryReportQuery, GenerateCashInventoryReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateCashInventoryReportQuery, GenerateCashInventoryReportQueryVariables>(GenerateCashInventoryReportDocument, options);
        }
export type GenerateCashInventoryReportQueryHookResult = ReturnType<typeof useGenerateCashInventoryReportQuery>;
export type GenerateCashInventoryReportLazyQueryHookResult = ReturnType<typeof useGenerateCashInventoryReportLazyQuery>;
export type GenerateCashInventoryReportQueryResult = Apollo.QueryResult<GenerateCashInventoryReportQuery, GenerateCashInventoryReportQueryVariables>;
export function refetchGenerateCashInventoryReportQuery(variables: GenerateCashInventoryReportQueryVariables) {
      return { query: GenerateCashInventoryReportDocument, variables: variables }
    }
export const GenerateCashSummaryReportDocument = gql`
    query generateCashSummaryReport($input: CashSummaryReportCriteriaDto!) {
  generateCashSummaryReport(criteriaDto: $input) {
    totalAmounts: grandTotals {
      currency
      grandTotal
      machineTotal
      openShiftTotal
      claimedValueTotal
    }
    rows: machineContents {
      bankableAmount
      bankableCount
      currency
      dispensableAmount
      dispensableCount
      locationName
      machineName
      total
      subRows: denominationRows {
        type
        total
        denomination
        bankableAmount
        bankableCount
        currency
        dispensableAmount
        dispensableCount
      }
    }
  }
}
    `;

/**
 * __useGenerateCashSummaryReportQuery__
 *
 * To run a query within a React component, call `useGenerateCashSummaryReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateCashSummaryReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateCashSummaryReportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateCashSummaryReportQuery(baseOptions: Apollo.QueryHookOptions<GenerateCashSummaryReportQuery, GenerateCashSummaryReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateCashSummaryReportQuery, GenerateCashSummaryReportQueryVariables>(GenerateCashSummaryReportDocument, options);
      }
export function useGenerateCashSummaryReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateCashSummaryReportQuery, GenerateCashSummaryReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateCashSummaryReportQuery, GenerateCashSummaryReportQueryVariables>(GenerateCashSummaryReportDocument, options);
        }
export type GenerateCashSummaryReportQueryHookResult = ReturnType<typeof useGenerateCashSummaryReportQuery>;
export type GenerateCashSummaryReportLazyQueryHookResult = ReturnType<typeof useGenerateCashSummaryReportLazyQuery>;
export type GenerateCashSummaryReportQueryResult = Apollo.QueryResult<GenerateCashSummaryReportQuery, GenerateCashSummaryReportQueryVariables>;
export function refetchGenerateCashSummaryReportQuery(variables: GenerateCashSummaryReportQueryVariables) {
      return { query: GenerateCashSummaryReportDocument, variables: variables }
    }
export const GenerateClaimedValuesReportDocument = gql`
    query generateClaimedValuesReport($input: ClaimedValuesReportCriteriaDtoIn!) {
  generateClaimedValuesReport(claimedValuesReportCriteria: $input) {
    totalAmounts: grandTotals {
      key
      value
    }
    rows {
      container
      count
      currency
      denomination
      machine
      site
      total
      type
      subRows {
        container
        count
        currency
        denomination
        machine
        site
        total
        type
      }
    }
  }
}
    `;

/**
 * __useGenerateClaimedValuesReportQuery__
 *
 * To run a query within a React component, call `useGenerateClaimedValuesReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateClaimedValuesReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateClaimedValuesReportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateClaimedValuesReportQuery(baseOptions: Apollo.QueryHookOptions<GenerateClaimedValuesReportQuery, GenerateClaimedValuesReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateClaimedValuesReportQuery, GenerateClaimedValuesReportQueryVariables>(GenerateClaimedValuesReportDocument, options);
      }
export function useGenerateClaimedValuesReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateClaimedValuesReportQuery, GenerateClaimedValuesReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateClaimedValuesReportQuery, GenerateClaimedValuesReportQueryVariables>(GenerateClaimedValuesReportDocument, options);
        }
export type GenerateClaimedValuesReportQueryHookResult = ReturnType<typeof useGenerateClaimedValuesReportQuery>;
export type GenerateClaimedValuesReportLazyQueryHookResult = ReturnType<typeof useGenerateClaimedValuesReportLazyQuery>;
export type GenerateClaimedValuesReportQueryResult = Apollo.QueryResult<GenerateClaimedValuesReportQuery, GenerateClaimedValuesReportQueryVariables>;
export function refetchGenerateClaimedValuesReportQuery(variables: GenerateClaimedValuesReportQueryVariables) {
      return { query: GenerateClaimedValuesReportDocument, variables: variables }
    }
export const GenerateMachineErrorsReportDocument = gql`
    query generateMachineErrorsReport($input: ErrorsReportCriteriaDtoIn) {
  generateMachineErrorsReport(reportHeaderCriteria: $input) {
    fullSize
    columns {
      key
      values
    }
    rows {
      nodeId
      uuid
      dateTime
      ... on ErrorsReportRowDto {
        deviceId
        severity
        kind
        information
        extendedInfo
        errorCode
        cleared
        machineNodeId
        machineName
        locationNodeId
        timeZoneUtcOffset
      }
    }
  }
}
    `;

/**
 * __useGenerateMachineErrorsReportQuery__
 *
 * To run a query within a React component, call `useGenerateMachineErrorsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateMachineErrorsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateMachineErrorsReportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateMachineErrorsReportQuery(baseOptions?: Apollo.QueryHookOptions<GenerateMachineErrorsReportQuery, GenerateMachineErrorsReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateMachineErrorsReportQuery, GenerateMachineErrorsReportQueryVariables>(GenerateMachineErrorsReportDocument, options);
      }
export function useGenerateMachineErrorsReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateMachineErrorsReportQuery, GenerateMachineErrorsReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateMachineErrorsReportQuery, GenerateMachineErrorsReportQueryVariables>(GenerateMachineErrorsReportDocument, options);
        }
export type GenerateMachineErrorsReportQueryHookResult = ReturnType<typeof useGenerateMachineErrorsReportQuery>;
export type GenerateMachineErrorsReportLazyQueryHookResult = ReturnType<typeof useGenerateMachineErrorsReportLazyQuery>;
export type GenerateMachineErrorsReportQueryResult = Apollo.QueryResult<GenerateMachineErrorsReportQuery, GenerateMachineErrorsReportQueryVariables>;
export function refetchGenerateMachineErrorsReportQuery(variables?: GenerateMachineErrorsReportQueryVariables) {
      return { query: GenerateMachineErrorsReportDocument, variables: variables }
    }
export const GenerateMachineUserTransactionsReportDocument = gql`
    query generateMachineUserTransactionsReport($criteriaDto: MachineUserTransactionsReportCriteriaDto!) {
  generateMachineUserTransactionsReport(criteriaDto: $criteriaDto) {
    columns {
      key
      values
    }
    totalIn {
      key
      value
    }
    totalOut {
      key
      value
    }
    totalDiff {
      key
      value
    }
    rows {
      userId
      userName
      totalIn {
        key
        value
      }
      totalOut {
        key
        value
      }
      totalDiff {
        key
        value
      }
      transactionRows: rows {
        account
        roleName
        machineName
        locationName
        formattedDateTime
        accountingDate
        subType
        type
        workUnitName
        totalAmounts {
          key
          value
        }
      }
    }
  }
}
    `;

/**
 * __useGenerateMachineUserTransactionsReportQuery__
 *
 * To run a query within a React component, call `useGenerateMachineUserTransactionsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateMachineUserTransactionsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateMachineUserTransactionsReportQuery({
 *   variables: {
 *      criteriaDto: // value for 'criteriaDto'
 *   },
 * });
 */
export function useGenerateMachineUserTransactionsReportQuery(baseOptions: Apollo.QueryHookOptions<GenerateMachineUserTransactionsReportQuery, GenerateMachineUserTransactionsReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateMachineUserTransactionsReportQuery, GenerateMachineUserTransactionsReportQueryVariables>(GenerateMachineUserTransactionsReportDocument, options);
      }
export function useGenerateMachineUserTransactionsReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateMachineUserTransactionsReportQuery, GenerateMachineUserTransactionsReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateMachineUserTransactionsReportQuery, GenerateMachineUserTransactionsReportQueryVariables>(GenerateMachineUserTransactionsReportDocument, options);
        }
export type GenerateMachineUserTransactionsReportQueryHookResult = ReturnType<typeof useGenerateMachineUserTransactionsReportQuery>;
export type GenerateMachineUserTransactionsReportLazyQueryHookResult = ReturnType<typeof useGenerateMachineUserTransactionsReportLazyQuery>;
export type GenerateMachineUserTransactionsReportQueryResult = Apollo.QueryResult<GenerateMachineUserTransactionsReportQuery, GenerateMachineUserTransactionsReportQueryVariables>;
export function refetchGenerateMachineUserTransactionsReportQuery(variables: GenerateMachineUserTransactionsReportQueryVariables) {
      return { query: GenerateMachineUserTransactionsReportDocument, variables: variables }
    }
export const GenerateManualDepositsReportDocument = gql`
    query generateManualDepositsReport($input: ManualDepositsReportCriteriaDto) {
  generateManualDepositsReport(criteriaDto: $input) {
    totalAmounts: grandTotals {
      key
      value
    }
    rows {
      subRows {
        machineUserId
        machineUserName
        roleName
        workUnitName
        machineName
        locationName
        claimedValueTypes
        type
        devices
        bagIds
        dateTime
        timeZoneUtcOffset
        totalAmounts {
          key
          value
        }
      }
      groupValue
      totalAmounts: grandTotals {
        key
        value
      }
    }
  }
}
    `;

/**
 * __useGenerateManualDepositsReportQuery__
 *
 * To run a query within a React component, call `useGenerateManualDepositsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateManualDepositsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateManualDepositsReportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateManualDepositsReportQuery(baseOptions?: Apollo.QueryHookOptions<GenerateManualDepositsReportQuery, GenerateManualDepositsReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateManualDepositsReportQuery, GenerateManualDepositsReportQueryVariables>(GenerateManualDepositsReportDocument, options);
      }
export function useGenerateManualDepositsReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateManualDepositsReportQuery, GenerateManualDepositsReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateManualDepositsReportQuery, GenerateManualDepositsReportQueryVariables>(GenerateManualDepositsReportDocument, options);
        }
export type GenerateManualDepositsReportQueryHookResult = ReturnType<typeof useGenerateManualDepositsReportQuery>;
export type GenerateManualDepositsReportLazyQueryHookResult = ReturnType<typeof useGenerateManualDepositsReportLazyQuery>;
export type GenerateManualDepositsReportQueryResult = Apollo.QueryResult<GenerateManualDepositsReportQuery, GenerateManualDepositsReportQueryVariables>;
export function refetchGenerateManualDepositsReportQuery(variables?: GenerateManualDepositsReportQueryVariables) {
      return { query: GenerateManualDepositsReportDocument, variables: variables }
    }
export const GenerateNetCashReportDocument = gql`
    query generateNetCashReport($input: NetCashReportCriteriaDto!) {
  generateNetCashReport(criteriaDto: $input) {
    netCashReportRowDtos {
      machineName
      locationName
      openingTotalAmounts {
        boxContentNodeIds
        totalAmounts {
          amount
          count
          currency
        }
      }
      closingTotalAmounts {
        boxContentNodeIds
        totalAmounts {
          amount
          count
          currency
        }
      }
      transactionsInTotalAmounts {
        amount
        count
        currency
      }
      transactionsOutTotalAmounts {
        amount
        count
        currency
      }
    }
  }
}
    `;

/**
 * __useGenerateNetCashReportQuery__
 *
 * To run a query within a React component, call `useGenerateNetCashReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateNetCashReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateNetCashReportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateNetCashReportQuery(baseOptions: Apollo.QueryHookOptions<GenerateNetCashReportQuery, GenerateNetCashReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateNetCashReportQuery, GenerateNetCashReportQueryVariables>(GenerateNetCashReportDocument, options);
      }
export function useGenerateNetCashReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateNetCashReportQuery, GenerateNetCashReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateNetCashReportQuery, GenerateNetCashReportQueryVariables>(GenerateNetCashReportDocument, options);
        }
export type GenerateNetCashReportQueryHookResult = ReturnType<typeof useGenerateNetCashReportQuery>;
export type GenerateNetCashReportLazyQueryHookResult = ReturnType<typeof useGenerateNetCashReportLazyQuery>;
export type GenerateNetCashReportQueryResult = Apollo.QueryResult<GenerateNetCashReportQuery, GenerateNetCashReportQueryVariables>;
export function refetchGenerateNetCashReportQuery(variables: GenerateNetCashReportQueryVariables) {
      return { query: GenerateNetCashReportDocument, variables: variables }
    }
export const GenerateOpenShiftsReportDocument = gql`
    query generateOpenShiftsReport($input: OpenShiftsReportCriteriaDto!) {
  generateOpenShiftsReport(criteriaDto: $input) {
    columns {
      key
      values
    }
    totalAmounts: grandTotals {
      key
      value
    }
    rows: openShifts {
      role
      userId
      userName
      totalAmounts: totals {
        key
        value
      }
      subRows: transactions {
        nodeId
        type
        dateTime
        accountingDate
        machineNodeId
        locationNodeId
        totalAmounts {
          key
          value
        }
      }
    }
  }
}
    `;

/**
 * __useGenerateOpenShiftsReportQuery__
 *
 * To run a query within a React component, call `useGenerateOpenShiftsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateOpenShiftsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateOpenShiftsReportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateOpenShiftsReportQuery(baseOptions: Apollo.QueryHookOptions<GenerateOpenShiftsReportQuery, GenerateOpenShiftsReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateOpenShiftsReportQuery, GenerateOpenShiftsReportQueryVariables>(GenerateOpenShiftsReportDocument, options);
      }
export function useGenerateOpenShiftsReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateOpenShiftsReportQuery, GenerateOpenShiftsReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateOpenShiftsReportQuery, GenerateOpenShiftsReportQueryVariables>(GenerateOpenShiftsReportDocument, options);
        }
export type GenerateOpenShiftsReportQueryHookResult = ReturnType<typeof useGenerateOpenShiftsReportQuery>;
export type GenerateOpenShiftsReportLazyQueryHookResult = ReturnType<typeof useGenerateOpenShiftsReportLazyQuery>;
export type GenerateOpenShiftsReportQueryResult = Apollo.QueryResult<GenerateOpenShiftsReportQuery, GenerateOpenShiftsReportQueryVariables>;
export function refetchGenerateOpenShiftsReportQuery(variables: GenerateOpenShiftsReportQueryVariables) {
      return { query: GenerateOpenShiftsReportDocument, variables: variables }
    }
export const GenerateTransactionsReportDocument = gql`
    query generateTransactionsReport($input: TransactionsReportCriteriaDtoIn!) {
  generateTransactionsReport(transactionsReportCriteria: $input) {
    fullSize
    columns {
      key
      values
    }
    rows {
      ... on TransactionsReportRowDto {
        uuid
        machineName
        nodeId
        type
        dateTime
        timeZoneUtcOffset
        accountingDate
        machineNodeId
        locationNodeId
        locationName
        machineUserName
        machineUserId
        account
        subType
        sequence
        reference
        account
        roleName
        machineType
        valuesByDenomination {
          denomination
          currency
          count
          type
        }
        originUser
        originUserAccount
        transactionSeq
        workUnitName
        cardIdentifier
        mixEdited
        bagIds
        formattedAccountingDate
        formattedDateTime
        formattedReceivedDate
        receivedDateTime
        customData {
          key
          value
        }
        totalAmounts {
          key
          value
        }
      }
      ... on CorrectionTransactionReportRowDto {
        nodeId
        machineNodeId
        machineName
        machineType
        locationNodeId
        comment
        createdBy
        machineUserName
        machineUserId
        sequence
        receivedDateTime
        accountingDate
        formattedAccountingDate
        formattedDateTime
        formattedReceivedDate
        transactionSeq
        type
        dateTime
        timeZoneUtcOffset
        correctionReason
        totalAmounts {
          key
          value
        }
      }
    }
  }
}
    `;

/**
 * __useGenerateTransactionsReportQuery__
 *
 * To run a query within a React component, call `useGenerateTransactionsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateTransactionsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateTransactionsReportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateTransactionsReportQuery(baseOptions: Apollo.QueryHookOptions<GenerateTransactionsReportQuery, GenerateTransactionsReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateTransactionsReportQuery, GenerateTransactionsReportQueryVariables>(GenerateTransactionsReportDocument, options);
      }
export function useGenerateTransactionsReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateTransactionsReportQuery, GenerateTransactionsReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateTransactionsReportQuery, GenerateTransactionsReportQueryVariables>(GenerateTransactionsReportDocument, options);
        }
export type GenerateTransactionsReportQueryHookResult = ReturnType<typeof useGenerateTransactionsReportQuery>;
export type GenerateTransactionsReportLazyQueryHookResult = ReturnType<typeof useGenerateTransactionsReportLazyQuery>;
export type GenerateTransactionsReportQueryResult = Apollo.QueryResult<GenerateTransactionsReportQuery, GenerateTransactionsReportQueryVariables>;
export function refetchGenerateTransactionsReportQuery(variables: GenerateTransactionsReportQueryVariables) {
      return { query: GenerateTransactionsReportDocument, variables: variables }
    }
export const UpdateScheduledReportDocument = gql`
    mutation updateScheduledReport($input: ScheduledReportDtoIn!) {
  updateScheduledReport(params: $input) {
    fileType
    instanceName
    nextExecution
    nodeId
    nodeStatus
    locationNodeIds
    reportEmails {
      email
      subject
    }
    reportName
    status
  }
}
    `;
export type UpdateScheduledReportMutationFn = Apollo.MutationFunction<UpdateScheduledReportMutation, UpdateScheduledReportMutationVariables>;

/**
 * __useUpdateScheduledReportMutation__
 *
 * To run a mutation, you first call `useUpdateScheduledReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduledReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduledReportMutation, { data, loading, error }] = useUpdateScheduledReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateScheduledReportMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScheduledReportMutation, UpdateScheduledReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScheduledReportMutation, UpdateScheduledReportMutationVariables>(UpdateScheduledReportDocument, options);
      }
export type UpdateScheduledReportMutationHookResult = ReturnType<typeof useUpdateScheduledReportMutation>;
export type UpdateScheduledReportMutationResult = Apollo.MutationResult<UpdateScheduledReportMutation>;
export type UpdateScheduledReportMutationOptions = Apollo.BaseMutationOptions<UpdateScheduledReportMutation, UpdateScheduledReportMutationVariables>;
export const DeleteReportRequestDocument = gql`
    mutation deleteReportRequest($nodeId: String!) {
  deleteReportRequest(nodeId: $nodeId)
}
    `;
export type DeleteReportRequestMutationFn = Apollo.MutationFunction<DeleteReportRequestMutation, DeleteReportRequestMutationVariables>;

/**
 * __useDeleteReportRequestMutation__
 *
 * To run a mutation, you first call `useDeleteReportRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReportRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReportRequestMutation, { data, loading, error }] = useDeleteReportRequestMutation({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useDeleteReportRequestMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReportRequestMutation, DeleteReportRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReportRequestMutation, DeleteReportRequestMutationVariables>(DeleteReportRequestDocument, options);
      }
export type DeleteReportRequestMutationHookResult = ReturnType<typeof useDeleteReportRequestMutation>;
export type DeleteReportRequestMutationResult = Apollo.MutationResult<DeleteReportRequestMutation>;
export type DeleteReportRequestMutationOptions = Apollo.BaseMutationOptions<DeleteReportRequestMutation, DeleteReportRequestMutationVariables>;
export const GetUpcomingExecutionDatesDocument = gql`
    query getUpcomingExecutionDates($metadataDtoIn: MetadataDtoIn!) {
  getUpcomingExecutionDates(metadataDtoIn: $metadataDtoIn) {
    execution
    startDate
    endDate
  }
}
    `;

/**
 * __useGetUpcomingExecutionDatesQuery__
 *
 * To run a query within a React component, call `useGetUpcomingExecutionDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUpcomingExecutionDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUpcomingExecutionDatesQuery({
 *   variables: {
 *      metadataDtoIn: // value for 'metadataDtoIn'
 *   },
 * });
 */
export function useGetUpcomingExecutionDatesQuery(baseOptions: Apollo.QueryHookOptions<GetUpcomingExecutionDatesQuery, GetUpcomingExecutionDatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUpcomingExecutionDatesQuery, GetUpcomingExecutionDatesQueryVariables>(GetUpcomingExecutionDatesDocument, options);
      }
export function useGetUpcomingExecutionDatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUpcomingExecutionDatesQuery, GetUpcomingExecutionDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUpcomingExecutionDatesQuery, GetUpcomingExecutionDatesQueryVariables>(GetUpcomingExecutionDatesDocument, options);
        }
export type GetUpcomingExecutionDatesQueryHookResult = ReturnType<typeof useGetUpcomingExecutionDatesQuery>;
export type GetUpcomingExecutionDatesLazyQueryHookResult = ReturnType<typeof useGetUpcomingExecutionDatesLazyQuery>;
export type GetUpcomingExecutionDatesQueryResult = Apollo.QueryResult<GetUpcomingExecutionDatesQuery, GetUpcomingExecutionDatesQueryVariables>;
export function refetchGetUpcomingExecutionDatesQuery(variables: GetUpcomingExecutionDatesQueryVariables) {
      return { query: GetUpcomingExecutionDatesDocument, variables: variables }
    }
export const GetAllScheduledReportsDocument = gql`
    query getAllScheduledReports {
  getAllScheduledReports {
    nodeId
    nodeStatus
    instanceName
    fileType
    reportName
    nextExecution
    status
    inputPayload
    locationNodeIds
    metadata {
      executionTime
      zoneName
      repeat
      repeatOnDay
      executeFrom
      executeUntil
      nodeId
    }
    reportEmails {
      email
      subject
    }
  }
}
    `;

/**
 * __useGetAllScheduledReportsQuery__
 *
 * To run a query within a React component, call `useGetAllScheduledReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllScheduledReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllScheduledReportsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllScheduledReportsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllScheduledReportsQuery, GetAllScheduledReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllScheduledReportsQuery, GetAllScheduledReportsQueryVariables>(GetAllScheduledReportsDocument, options);
      }
export function useGetAllScheduledReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllScheduledReportsQuery, GetAllScheduledReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllScheduledReportsQuery, GetAllScheduledReportsQueryVariables>(GetAllScheduledReportsDocument, options);
        }
export type GetAllScheduledReportsQueryHookResult = ReturnType<typeof useGetAllScheduledReportsQuery>;
export type GetAllScheduledReportsLazyQueryHookResult = ReturnType<typeof useGetAllScheduledReportsLazyQuery>;
export type GetAllScheduledReportsQueryResult = Apollo.QueryResult<GetAllScheduledReportsQuery, GetAllScheduledReportsQueryVariables>;
export function refetchGetAllScheduledReportsQuery(variables?: GetAllScheduledReportsQueryVariables) {
      return { query: GetAllScheduledReportsDocument, variables: variables }
    }
export const ActivateTenantDocument = gql`
    mutation activateTenant($tenantId: String) {
  activateTenant(tenantId: $tenantId) {
    nodeId
    tenantId
    nodeStatus
  }
}
    `;
export type ActivateTenantMutationFn = Apollo.MutationFunction<ActivateTenantMutation, ActivateTenantMutationVariables>;

/**
 * __useActivateTenantMutation__
 *
 * To run a mutation, you first call `useActivateTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateTenantMutation, { data, loading, error }] = useActivateTenantMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useActivateTenantMutation(baseOptions?: Apollo.MutationHookOptions<ActivateTenantMutation, ActivateTenantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateTenantMutation, ActivateTenantMutationVariables>(ActivateTenantDocument, options);
      }
export type ActivateTenantMutationHookResult = ReturnType<typeof useActivateTenantMutation>;
export type ActivateTenantMutationResult = Apollo.MutationResult<ActivateTenantMutation>;
export type ActivateTenantMutationOptions = Apollo.BaseMutationOptions<ActivateTenantMutation, ActivateTenantMutationVariables>;
export const ConfigureTenantDocument = gql`
    mutation configureTenant($input: TenantDtoIn!) {
  configureTenant(tenant: $input) {
    billingId
    contractNumber
    createdDate
    endOfDay
    name
    nodeId
    tenantId
    nodeStatus
    updatedDate
    nodeChangeDate
    licenseAutoRenewalEnabled
    licenseValidityIntervalDays
    allowedLicenseFeatureKeys
    machineTypes {
      name
      nodeId
      table
      imageUrl
      licenseLabel
      licenseLevel
    }
  }
}
    `;
export type ConfigureTenantMutationFn = Apollo.MutationFunction<ConfigureTenantMutation, ConfigureTenantMutationVariables>;

/**
 * __useConfigureTenantMutation__
 *
 * To run a mutation, you first call `useConfigureTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigureTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configureTenantMutation, { data, loading, error }] = useConfigureTenantMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfigureTenantMutation(baseOptions?: Apollo.MutationHookOptions<ConfigureTenantMutation, ConfigureTenantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfigureTenantMutation, ConfigureTenantMutationVariables>(ConfigureTenantDocument, options);
      }
export type ConfigureTenantMutationHookResult = ReturnType<typeof useConfigureTenantMutation>;
export type ConfigureTenantMutationResult = Apollo.MutationResult<ConfigureTenantMutation>;
export type ConfigureTenantMutationOptions = Apollo.BaseMutationOptions<ConfigureTenantMutation, ConfigureTenantMutationVariables>;
export const CreateTenantWithExistingUserDocument = gql`
    mutation createTenantWithExistingUser($tenant: TenantWithExistingUserDtoIn!) {
  createTenantWithExistingUser(tenant: $tenant) {
    billingId
    contractNumber
    createdDate
    endOfDay
    name
    nodeId
    tenantId
    nodeStatus
    updatedDate
    nodeChangeDate
    machineTypes {
      name
      nodeId
      table
      imageUrl
      licenseLabel
      licenseLevel
    }
  }
}
    `;
export type CreateTenantWithExistingUserMutationFn = Apollo.MutationFunction<CreateTenantWithExistingUserMutation, CreateTenantWithExistingUserMutationVariables>;

/**
 * __useCreateTenantWithExistingUserMutation__
 *
 * To run a mutation, you first call `useCreateTenantWithExistingUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTenantWithExistingUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTenantWithExistingUserMutation, { data, loading, error }] = useCreateTenantWithExistingUserMutation({
 *   variables: {
 *      tenant: // value for 'tenant'
 *   },
 * });
 */
export function useCreateTenantWithExistingUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateTenantWithExistingUserMutation, CreateTenantWithExistingUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTenantWithExistingUserMutation, CreateTenantWithExistingUserMutationVariables>(CreateTenantWithExistingUserDocument, options);
      }
export type CreateTenantWithExistingUserMutationHookResult = ReturnType<typeof useCreateTenantWithExistingUserMutation>;
export type CreateTenantWithExistingUserMutationResult = Apollo.MutationResult<CreateTenantWithExistingUserMutation>;
export type CreateTenantWithExistingUserMutationOptions = Apollo.BaseMutationOptions<CreateTenantWithExistingUserMutation, CreateTenantWithExistingUserMutationVariables>;
export const CreateTenantWithNewUserDocument = gql`
    mutation createTenantWithNewUser($tenant: TenantWithNewUserDtoIn) {
  createTenantWithNewUser(tenant: $tenant) {
    billingId
    contractNumber
    createdDate
    endOfDay
    name
    nodeId
    tenantId
    nodeStatus
    updatedDate
    nodeChangeDate
    machineTypes {
      name
      nodeId
      table
      imageUrl
      licenseLabel
      licenseLevel
    }
  }
}
    `;
export type CreateTenantWithNewUserMutationFn = Apollo.MutationFunction<CreateTenantWithNewUserMutation, CreateTenantWithNewUserMutationVariables>;

/**
 * __useCreateTenantWithNewUserMutation__
 *
 * To run a mutation, you first call `useCreateTenantWithNewUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTenantWithNewUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTenantWithNewUserMutation, { data, loading, error }] = useCreateTenantWithNewUserMutation({
 *   variables: {
 *      tenant: // value for 'tenant'
 *   },
 * });
 */
export function useCreateTenantWithNewUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateTenantWithNewUserMutation, CreateTenantWithNewUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTenantWithNewUserMutation, CreateTenantWithNewUserMutationVariables>(CreateTenantWithNewUserDocument, options);
      }
export type CreateTenantWithNewUserMutationHookResult = ReturnType<typeof useCreateTenantWithNewUserMutation>;
export type CreateTenantWithNewUserMutationResult = Apollo.MutationResult<CreateTenantWithNewUserMutation>;
export type CreateTenantWithNewUserMutationOptions = Apollo.BaseMutationOptions<CreateTenantWithNewUserMutation, CreateTenantWithNewUserMutationVariables>;
export const DeactivateTenantDocument = gql`
    mutation deactivateTenant($tenantId: String!) {
  deactivateTenant(tenantId: $tenantId) {
    nodeId
    tenantId
    nodeStatus
  }
}
    `;
export type DeactivateTenantMutationFn = Apollo.MutationFunction<DeactivateTenantMutation, DeactivateTenantMutationVariables>;

/**
 * __useDeactivateTenantMutation__
 *
 * To run a mutation, you first call `useDeactivateTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateTenantMutation, { data, loading, error }] = useDeactivateTenantMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useDeactivateTenantMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateTenantMutation, DeactivateTenantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateTenantMutation, DeactivateTenantMutationVariables>(DeactivateTenantDocument, options);
      }
export type DeactivateTenantMutationHookResult = ReturnType<typeof useDeactivateTenantMutation>;
export type DeactivateTenantMutationResult = Apollo.MutationResult<DeactivateTenantMutation>;
export type DeactivateTenantMutationOptions = Apollo.BaseMutationOptions<DeactivateTenantMutation, DeactivateTenantMutationVariables>;
export const FindAllTenantsDocument = gql`
    query findAllTenants {
  findAllTenants {
    billingId
    contractNumber
    createdDate
    endOfDay
    name
    nodeId
    tenantId
    nodeStatus
    updatedDate
    nodeChangeDate
    allowedLicenseFeatureKeys
    licenseAutoRenewalEnabled
    licenseValidityIntervalDays
    machineTypes {
      name
      nodeId
      table
      imageUrl
      licenseLabel
      licenseLevel
    }
  }
}
    `;

/**
 * __useFindAllTenantsQuery__
 *
 * To run a query within a React component, call `useFindAllTenantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllTenantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllTenantsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindAllTenantsQuery(baseOptions?: Apollo.QueryHookOptions<FindAllTenantsQuery, FindAllTenantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllTenantsQuery, FindAllTenantsQueryVariables>(FindAllTenantsDocument, options);
      }
export function useFindAllTenantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllTenantsQuery, FindAllTenantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllTenantsQuery, FindAllTenantsQueryVariables>(FindAllTenantsDocument, options);
        }
export type FindAllTenantsQueryHookResult = ReturnType<typeof useFindAllTenantsQuery>;
export type FindAllTenantsLazyQueryHookResult = ReturnType<typeof useFindAllTenantsLazyQuery>;
export type FindAllTenantsQueryResult = Apollo.QueryResult<FindAllTenantsQuery, FindAllTenantsQueryVariables>;
export function refetchFindAllTenantsQuery(variables?: FindAllTenantsQueryVariables) {
      return { query: FindAllTenantsDocument, variables: variables }
    }
export const FindMyTenantsMetadataDocument = gql`
    query findMyTenantsMetadata {
  findMyTenantsMetadata {
    domainName
    nodeStatus
    tenantId
    tenantName
  }
}
    `;

/**
 * __useFindMyTenantsMetadataQuery__
 *
 * To run a query within a React component, call `useFindMyTenantsMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindMyTenantsMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindMyTenantsMetadataQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindMyTenantsMetadataQuery(baseOptions?: Apollo.QueryHookOptions<FindMyTenantsMetadataQuery, FindMyTenantsMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindMyTenantsMetadataQuery, FindMyTenantsMetadataQueryVariables>(FindMyTenantsMetadataDocument, options);
      }
export function useFindMyTenantsMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindMyTenantsMetadataQuery, FindMyTenantsMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindMyTenantsMetadataQuery, FindMyTenantsMetadataQueryVariables>(FindMyTenantsMetadataDocument, options);
        }
export type FindMyTenantsMetadataQueryHookResult = ReturnType<typeof useFindMyTenantsMetadataQuery>;
export type FindMyTenantsMetadataLazyQueryHookResult = ReturnType<typeof useFindMyTenantsMetadataLazyQuery>;
export type FindMyTenantsMetadataQueryResult = Apollo.QueryResult<FindMyTenantsMetadataQuery, FindMyTenantsMetadataQueryVariables>;
export function refetchFindMyTenantsMetadataQuery(variables?: FindMyTenantsMetadataQueryVariables) {
      return { query: FindMyTenantsMetadataDocument, variables: variables }
    }
export const FindTenantByTenantIdDocument = gql`
    query findTenantByTenantId($tenantId: String!) {
  findTenantByTenantId(tenantId: $tenantId) {
    billingId
    contractNumber
    createdDate
    endOfDay
    name
    nodeId
    tenantId
    nodeStatus
    updatedDate
    nodeChangeDate
    licenseAutoRenewalEnabled
    licenseValidityIntervalDays
    allowedLicenseFeatureKeys
    machineTypes {
      name
      nodeId
      table
      imageUrl
      licenseLabel
      licenseLevel
    }
  }
}
    `;

/**
 * __useFindTenantByTenantIdQuery__
 *
 * To run a query within a React component, call `useFindTenantByTenantIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindTenantByTenantIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindTenantByTenantIdQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useFindTenantByTenantIdQuery(baseOptions: Apollo.QueryHookOptions<FindTenantByTenantIdQuery, FindTenantByTenantIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindTenantByTenantIdQuery, FindTenantByTenantIdQueryVariables>(FindTenantByTenantIdDocument, options);
      }
export function useFindTenantByTenantIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindTenantByTenantIdQuery, FindTenantByTenantIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindTenantByTenantIdQuery, FindTenantByTenantIdQueryVariables>(FindTenantByTenantIdDocument, options);
        }
export type FindTenantByTenantIdQueryHookResult = ReturnType<typeof useFindTenantByTenantIdQuery>;
export type FindTenantByTenantIdLazyQueryHookResult = ReturnType<typeof useFindTenantByTenantIdLazyQuery>;
export type FindTenantByTenantIdQueryResult = Apollo.QueryResult<FindTenantByTenantIdQuery, FindTenantByTenantIdQueryVariables>;
export function refetchFindTenantByTenantIdQuery(variables: FindTenantByTenantIdQueryVariables) {
      return { query: FindTenantByTenantIdDocument, variables: variables }
    }
export const FindTenantFeaturesDocument = gql`
    query findTenantFeatures($tenantId: String!) {
  findTenantFeatures(tenantId: $tenantId) {
    userBalanceEnabled
    commonSoftwarePackageUploadEnabled
    mumEnabled
    mumXmlImportEnabled
  }
}
    `;

/**
 * __useFindTenantFeaturesQuery__
 *
 * To run a query within a React component, call `useFindTenantFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindTenantFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindTenantFeaturesQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useFindTenantFeaturesQuery(baseOptions: Apollo.QueryHookOptions<FindTenantFeaturesQuery, FindTenantFeaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindTenantFeaturesQuery, FindTenantFeaturesQueryVariables>(FindTenantFeaturesDocument, options);
      }
export function useFindTenantFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindTenantFeaturesQuery, FindTenantFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindTenantFeaturesQuery, FindTenantFeaturesQueryVariables>(FindTenantFeaturesDocument, options);
        }
export type FindTenantFeaturesQueryHookResult = ReturnType<typeof useFindTenantFeaturesQuery>;
export type FindTenantFeaturesLazyQueryHookResult = ReturnType<typeof useFindTenantFeaturesLazyQuery>;
export type FindTenantFeaturesQueryResult = Apollo.QueryResult<FindTenantFeaturesQuery, FindTenantFeaturesQueryVariables>;
export function refetchFindTenantFeaturesQuery(variables: FindTenantFeaturesQueryVariables) {
      return { query: FindTenantFeaturesDocument, variables: variables }
    }
export const SetTenantFeaturesDocument = gql`
    mutation setTenantFeatures($features: TenantFeaturesDtoIn!, $tenantId: String!) {
  setTenantFeatures(features: $features, tenantId: $tenantId) {
    userBalanceEnabled
    commonSoftwarePackageUploadEnabled
    mumEnabled
    mumXmlImportEnabled
  }
}
    `;
export type SetTenantFeaturesMutationFn = Apollo.MutationFunction<SetTenantFeaturesMutation, SetTenantFeaturesMutationVariables>;

/**
 * __useSetTenantFeaturesMutation__
 *
 * To run a mutation, you first call `useSetTenantFeaturesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTenantFeaturesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTenantFeaturesMutation, { data, loading, error }] = useSetTenantFeaturesMutation({
 *   variables: {
 *      features: // value for 'features'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useSetTenantFeaturesMutation(baseOptions?: Apollo.MutationHookOptions<SetTenantFeaturesMutation, SetTenantFeaturesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetTenantFeaturesMutation, SetTenantFeaturesMutationVariables>(SetTenantFeaturesDocument, options);
      }
export type SetTenantFeaturesMutationHookResult = ReturnType<typeof useSetTenantFeaturesMutation>;
export type SetTenantFeaturesMutationResult = Apollo.MutationResult<SetTenantFeaturesMutation>;
export type SetTenantFeaturesMutationOptions = Apollo.BaseMutationOptions<SetTenantFeaturesMutation, SetTenantFeaturesMutationVariables>;
export const UpdateTenantDocument = gql`
    mutation updateTenant($tenant: TenantUpdateDtoIn!) {
  updateTenant(tenant: $tenant) {
    billingId
    contractNumber
    createdDate
    endOfDay
    name
    nodeId
    tenantId
    nodeStatus
    updatedDate
    nodeChangeDate
    machineTypes {
      name
      nodeId
      table
      imageUrl
      licenseLabel
      licenseLevel
    }
  }
}
    `;
export type UpdateTenantMutationFn = Apollo.MutationFunction<UpdateTenantMutation, UpdateTenantMutationVariables>;

/**
 * __useUpdateTenantMutation__
 *
 * To run a mutation, you first call `useUpdateTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTenantMutation, { data, loading, error }] = useUpdateTenantMutation({
 *   variables: {
 *      tenant: // value for 'tenant'
 *   },
 * });
 */
export function useUpdateTenantMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTenantMutation, UpdateTenantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTenantMutation, UpdateTenantMutationVariables>(UpdateTenantDocument, options);
      }
export type UpdateTenantMutationHookResult = ReturnType<typeof useUpdateTenantMutation>;
export type UpdateTenantMutationResult = Apollo.MutationResult<UpdateTenantMutation>;
export type UpdateTenantMutationOptions = Apollo.BaseMutationOptions<UpdateTenantMutation, UpdateTenantMutationVariables>;
export const CreateCorrectionReasonDocument = gql`
    mutation createCorrectionReason($correctionReason: CorrectionReasonDtoIn!) {
  createCorrectionReason(correctionReason: $correctionReason) {
    nodeId
    name
    active
    lastEditedDate
    lastEditedBy
  }
}
    `;
export type CreateCorrectionReasonMutationFn = Apollo.MutationFunction<CreateCorrectionReasonMutation, CreateCorrectionReasonMutationVariables>;

/**
 * __useCreateCorrectionReasonMutation__
 *
 * To run a mutation, you first call `useCreateCorrectionReasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCorrectionReasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCorrectionReasonMutation, { data, loading, error }] = useCreateCorrectionReasonMutation({
 *   variables: {
 *      correctionReason: // value for 'correctionReason'
 *   },
 * });
 */
export function useCreateCorrectionReasonMutation(baseOptions?: Apollo.MutationHookOptions<CreateCorrectionReasonMutation, CreateCorrectionReasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCorrectionReasonMutation, CreateCorrectionReasonMutationVariables>(CreateCorrectionReasonDocument, options);
      }
export type CreateCorrectionReasonMutationHookResult = ReturnType<typeof useCreateCorrectionReasonMutation>;
export type CreateCorrectionReasonMutationResult = Apollo.MutationResult<CreateCorrectionReasonMutation>;
export type CreateCorrectionReasonMutationOptions = Apollo.BaseMutationOptions<CreateCorrectionReasonMutation, CreateCorrectionReasonMutationVariables>;
export const CreateCorrectionTransactionDocument = gql`
    mutation createCorrectionTransaction($input: CorrectionTransactionDtoIn!) {
  createCorrectionTransaction(correctionTransaction: $input) {
    nodeId
  }
}
    `;
export type CreateCorrectionTransactionMutationFn = Apollo.MutationFunction<CreateCorrectionTransactionMutation, CreateCorrectionTransactionMutationVariables>;

/**
 * __useCreateCorrectionTransactionMutation__
 *
 * To run a mutation, you first call `useCreateCorrectionTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCorrectionTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCorrectionTransactionMutation, { data, loading, error }] = useCreateCorrectionTransactionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCorrectionTransactionMutation(baseOptions?: Apollo.MutationHookOptions<CreateCorrectionTransactionMutation, CreateCorrectionTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCorrectionTransactionMutation, CreateCorrectionTransactionMutationVariables>(CreateCorrectionTransactionDocument, options);
      }
export type CreateCorrectionTransactionMutationHookResult = ReturnType<typeof useCreateCorrectionTransactionMutation>;
export type CreateCorrectionTransactionMutationResult = Apollo.MutationResult<CreateCorrectionTransactionMutation>;
export type CreateCorrectionTransactionMutationOptions = Apollo.BaseMutationOptions<CreateCorrectionTransactionMutation, CreateCorrectionTransactionMutationVariables>;
export const DeleteCorrectionReasonDocument = gql`
    mutation deleteCorrectionReason($nodeId: String!) {
  deleteCorrectionReason(nodeId: $nodeId)
}
    `;
export type DeleteCorrectionReasonMutationFn = Apollo.MutationFunction<DeleteCorrectionReasonMutation, DeleteCorrectionReasonMutationVariables>;

/**
 * __useDeleteCorrectionReasonMutation__
 *
 * To run a mutation, you first call `useDeleteCorrectionReasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCorrectionReasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCorrectionReasonMutation, { data, loading, error }] = useDeleteCorrectionReasonMutation({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useDeleteCorrectionReasonMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCorrectionReasonMutation, DeleteCorrectionReasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCorrectionReasonMutation, DeleteCorrectionReasonMutationVariables>(DeleteCorrectionReasonDocument, options);
      }
export type DeleteCorrectionReasonMutationHookResult = ReturnType<typeof useDeleteCorrectionReasonMutation>;
export type DeleteCorrectionReasonMutationResult = Apollo.MutationResult<DeleteCorrectionReasonMutation>;
export type DeleteCorrectionReasonMutationOptions = Apollo.BaseMutationOptions<DeleteCorrectionReasonMutation, DeleteCorrectionReasonMutationVariables>;
export const FindAllCorrectionReasonsDocument = gql`
    query findAllCorrectionReasons {
  findAllCorrectionReasons {
    nodeId
    name
    active
    lastEditedBy
    lastEditedDate
  }
}
    `;

/**
 * __useFindAllCorrectionReasonsQuery__
 *
 * To run a query within a React component, call `useFindAllCorrectionReasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllCorrectionReasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllCorrectionReasonsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindAllCorrectionReasonsQuery(baseOptions?: Apollo.QueryHookOptions<FindAllCorrectionReasonsQuery, FindAllCorrectionReasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllCorrectionReasonsQuery, FindAllCorrectionReasonsQueryVariables>(FindAllCorrectionReasonsDocument, options);
      }
export function useFindAllCorrectionReasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllCorrectionReasonsQuery, FindAllCorrectionReasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllCorrectionReasonsQuery, FindAllCorrectionReasonsQueryVariables>(FindAllCorrectionReasonsDocument, options);
        }
export type FindAllCorrectionReasonsQueryHookResult = ReturnType<typeof useFindAllCorrectionReasonsQuery>;
export type FindAllCorrectionReasonsLazyQueryHookResult = ReturnType<typeof useFindAllCorrectionReasonsLazyQuery>;
export type FindAllCorrectionReasonsQueryResult = Apollo.QueryResult<FindAllCorrectionReasonsQuery, FindAllCorrectionReasonsQueryVariables>;
export function refetchFindAllCorrectionReasonsQuery(variables?: FindAllCorrectionReasonsQueryVariables) {
      return { query: FindAllCorrectionReasonsDocument, variables: variables }
    }
export const FindUserBalancesFilteredDocument = gql`
    query findUserBalancesFiltered($searchRequest: SearchRequestDto!, $userBalanceFiltersDto: UserBalanceFiltersDto) {
  findUserBalancesFiltered(
    searchRequest: $searchRequest
    userBalanceFiltersDto: $userBalanceFiltersDto
  ) {
    fullSize
    result {
      nodeId
      ... on UserBalanceDtoOut {
        date
        currencyCode
        balance
        machineUser {
          nodeId
          name
        }
      }
    }
  }
}
    `;

/**
 * __useFindUserBalancesFilteredQuery__
 *
 * To run a query within a React component, call `useFindUserBalancesFilteredQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUserBalancesFilteredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUserBalancesFilteredQuery({
 *   variables: {
 *      searchRequest: // value for 'searchRequest'
 *      userBalanceFiltersDto: // value for 'userBalanceFiltersDto'
 *   },
 * });
 */
export function useFindUserBalancesFilteredQuery(baseOptions: Apollo.QueryHookOptions<FindUserBalancesFilteredQuery, FindUserBalancesFilteredQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindUserBalancesFilteredQuery, FindUserBalancesFilteredQueryVariables>(FindUserBalancesFilteredDocument, options);
      }
export function useFindUserBalancesFilteredLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUserBalancesFilteredQuery, FindUserBalancesFilteredQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindUserBalancesFilteredQuery, FindUserBalancesFilteredQueryVariables>(FindUserBalancesFilteredDocument, options);
        }
export type FindUserBalancesFilteredQueryHookResult = ReturnType<typeof useFindUserBalancesFilteredQuery>;
export type FindUserBalancesFilteredLazyQueryHookResult = ReturnType<typeof useFindUserBalancesFilteredLazyQuery>;
export type FindUserBalancesFilteredQueryResult = Apollo.QueryResult<FindUserBalancesFilteredQuery, FindUserBalancesFilteredQueryVariables>;
export function refetchFindUserBalancesFilteredQuery(variables: FindUserBalancesFilteredQueryVariables) {
      return { query: FindUserBalancesFilteredDocument, variables: variables }
    }
export const GetSumValueOfTransactionsDocument = gql`
    query getSumValueOfTransactions($dateTime: DateTime!, $currency: String!, $locationId: String, $machineNodeId: String, $transactionType: TransactionType = ALL, $transactionDateTime: TransactionDateTime!, $zoneId: ZoneId) {
  dispense: getSumValueOfTransactions(
    transportationOperationCriteriaDto: {date: $dateTime, currency: $currency, locationNodeId: $locationId, machineNodeId: $machineNodeId, transactionType: $transactionType, queryTransactionBy: $transactionDateTime, zoneId: $zoneId, rmTransactionType: DISPENSE}
  )
  deposit: getSumValueOfTransactions(
    transportationOperationCriteriaDto: {date: $dateTime, currency: $currency, locationNodeId: $locationId, machineNodeId: $machineNodeId, transactionType: $transactionType, queryTransactionBy: $transactionDateTime, zoneId: $zoneId, rmTransactionType: DEPOSIT}
  )
  emptyOut: getSumValueOfTransactions(
    transportationOperationCriteriaDto: {date: $dateTime, currency: $currency, locationNodeId: $locationId, machineNodeId: $machineNodeId, transactionType: $transactionType, queryTransactionBy: $transactionDateTime, zoneId: $zoneId, rmTransactionType: EMPTY_OUT}
  )
  endOfShift: getSumValueOfTransactions(
    transportationOperationCriteriaDto: {date: $dateTime, currency: $currency, locationNodeId: $locationId, machineNodeId: $machineNodeId, transactionType: $transactionType, queryTransactionBy: $transactionDateTime, zoneId: $zoneId, rmTransactionType: END_OF_SHIFT}
  )
  manualRefill: getSumValueOfTransactions(
    transportationOperationCriteriaDto: {date: $dateTime, currency: $currency, locationNodeId: $locationId, machineNodeId: $machineNodeId, transactionType: $transactionType, queryTransactionBy: $transactionDateTime, zoneId: $zoneId, rmTransactionType: MANUAL_REFILL}
  )
  exchange: getSumValueOfTransactions(
    transportationOperationCriteriaDto: {date: $dateTime, currency: $currency, locationNodeId: $locationId, machineNodeId: $machineNodeId, transactionType: $transactionType, queryTransactionBy: $transactionDateTime, zoneId: $zoneId, rmTransactionType: EXCHANGE}
  )
  purge: getSumValueOfTransactions(
    transportationOperationCriteriaDto: {date: $dateTime, currency: $currency, locationNodeId: $locationId, machineNodeId: $machineNodeId, transactionType: $transactionType, queryTransactionBy: $transactionDateTime, zoneId: $zoneId, rmTransactionType: PURGE}
  )
  possibleTampering: getSumValueOfTransactions(
    transportationOperationCriteriaDto: {date: $dateTime, currency: $currency, locationNodeId: $locationId, machineNodeId: $machineNodeId, transactionType: $transactionType, queryTransactionBy: $transactionDateTime, zoneId: $zoneId, rmTransactionType: POSSIBLE_TAMPERING}
  )
  unfinishedTransaction: getSumValueOfTransactions(
    transportationOperationCriteriaDto: {date: $dateTime, currency: $currency, locationNodeId: $locationId, machineNodeId: $machineNodeId, transactionType: $transactionType, queryTransactionBy: $transactionDateTime, zoneId: $zoneId, rmTransactionType: UNFINISHED_TRANSACTION}
  )
  refill: getSumValueOfTransactions(
    transportationOperationCriteriaDto: {date: $dateTime, currency: $currency, locationNodeId: $locationId, machineNodeId: $machineNodeId, transactionType: $transactionType, queryTransactionBy: $transactionDateTime, zoneId: $zoneId, rmTransactionType: REFILL}
  )
}
    `;

/**
 * __useGetSumValueOfTransactionsQuery__
 *
 * To run a query within a React component, call `useGetSumValueOfTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSumValueOfTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSumValueOfTransactionsQuery({
 *   variables: {
 *      dateTime: // value for 'dateTime'
 *      currency: // value for 'currency'
 *      locationId: // value for 'locationId'
 *      machineNodeId: // value for 'machineNodeId'
 *      transactionType: // value for 'transactionType'
 *      transactionDateTime: // value for 'transactionDateTime'
 *      zoneId: // value for 'zoneId'
 *   },
 * });
 */
export function useGetSumValueOfTransactionsQuery(baseOptions: Apollo.QueryHookOptions<GetSumValueOfTransactionsQuery, GetSumValueOfTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSumValueOfTransactionsQuery, GetSumValueOfTransactionsQueryVariables>(GetSumValueOfTransactionsDocument, options);
      }
export function useGetSumValueOfTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSumValueOfTransactionsQuery, GetSumValueOfTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSumValueOfTransactionsQuery, GetSumValueOfTransactionsQueryVariables>(GetSumValueOfTransactionsDocument, options);
        }
export type GetSumValueOfTransactionsQueryHookResult = ReturnType<typeof useGetSumValueOfTransactionsQuery>;
export type GetSumValueOfTransactionsLazyQueryHookResult = ReturnType<typeof useGetSumValueOfTransactionsLazyQuery>;
export type GetSumValueOfTransactionsQueryResult = Apollo.QueryResult<GetSumValueOfTransactionsQuery, GetSumValueOfTransactionsQueryVariables>;
export function refetchGetSumValueOfTransactionsQuery(variables: GetSumValueOfTransactionsQueryVariables) {
      return { query: GetSumValueOfTransactionsDocument, variables: variables }
    }
export const UpdateCorrectionReasonDocument = gql`
    mutation updateCorrectionReason($nodeId: String!, $correctionReason: CorrectionReasonDtoIn!) {
  updateCorrectionReason(nodeId: $nodeId, correctionReason: $correctionReason) {
    nodeId
    name
    active
    lastEditedDate
    lastEditedBy
  }
}
    `;
export type UpdateCorrectionReasonMutationFn = Apollo.MutationFunction<UpdateCorrectionReasonMutation, UpdateCorrectionReasonMutationVariables>;

/**
 * __useUpdateCorrectionReasonMutation__
 *
 * To run a mutation, you first call `useUpdateCorrectionReasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCorrectionReasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCorrectionReasonMutation, { data, loading, error }] = useUpdateCorrectionReasonMutation({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *      correctionReason: // value for 'correctionReason'
 *   },
 * });
 */
export function useUpdateCorrectionReasonMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCorrectionReasonMutation, UpdateCorrectionReasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCorrectionReasonMutation, UpdateCorrectionReasonMutationVariables>(UpdateCorrectionReasonDocument, options);
      }
export type UpdateCorrectionReasonMutationHookResult = ReturnType<typeof useUpdateCorrectionReasonMutation>;
export type UpdateCorrectionReasonMutationResult = Apollo.MutationResult<UpdateCorrectionReasonMutation>;
export type UpdateCorrectionReasonMutationOptions = Apollo.BaseMutationOptions<UpdateCorrectionReasonMutation, UpdateCorrectionReasonMutationVariables>;
export const ActiveDeactivateUserDocument = gql`
    mutation activeDeactivateUser($domainName: String, $userName: String, $activeOrDeactivate: Boolean) {
  activeDeactivateUser(
    domainName: $domainName
    userName: $userName
    activeOrDeactivate: $activeOrDeactivate
  )
}
    `;
export type ActiveDeactivateUserMutationFn = Apollo.MutationFunction<ActiveDeactivateUserMutation, ActiveDeactivateUserMutationVariables>;

/**
 * __useActiveDeactivateUserMutation__
 *
 * To run a mutation, you first call `useActiveDeactivateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActiveDeactivateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activeDeactivateUserMutation, { data, loading, error }] = useActiveDeactivateUserMutation({
 *   variables: {
 *      domainName: // value for 'domainName'
 *      userName: // value for 'userName'
 *      activeOrDeactivate: // value for 'activeOrDeactivate'
 *   },
 * });
 */
export function useActiveDeactivateUserMutation(baseOptions?: Apollo.MutationHookOptions<ActiveDeactivateUserMutation, ActiveDeactivateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActiveDeactivateUserMutation, ActiveDeactivateUserMutationVariables>(ActiveDeactivateUserDocument, options);
      }
export type ActiveDeactivateUserMutationHookResult = ReturnType<typeof useActiveDeactivateUserMutation>;
export type ActiveDeactivateUserMutationResult = Apollo.MutationResult<ActiveDeactivateUserMutation>;
export type ActiveDeactivateUserMutationOptions = Apollo.BaseMutationOptions<ActiveDeactivateUserMutation, ActiveDeactivateUserMutationVariables>;
export const CreateUserDocument = gql`
    mutation createUser($isUserDtoInDto: IsUserDtoInDto) {
  createUser(isUserDtoInDto: $isUserDtoInDto)
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      isUserDtoInDto: // value for 'isUserDtoInDto'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const DeleteUserDocument = gql`
    mutation deleteUser($domainName: String, $userName: String) {
  deleteUser(domainName: $domainName, userName: $userName)
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      domainName: // value for 'domainName'
 *      userName: // value for 'userName'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const FindAllDomainNamesDocument = gql`
    query findAllDomainNames {
  findAllDomainNames
}
    `;

/**
 * __useFindAllDomainNamesQuery__
 *
 * To run a query within a React component, call `useFindAllDomainNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllDomainNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllDomainNamesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindAllDomainNamesQuery(baseOptions?: Apollo.QueryHookOptions<FindAllDomainNamesQuery, FindAllDomainNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllDomainNamesQuery, FindAllDomainNamesQueryVariables>(FindAllDomainNamesDocument, options);
      }
export function useFindAllDomainNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllDomainNamesQuery, FindAllDomainNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllDomainNamesQuery, FindAllDomainNamesQueryVariables>(FindAllDomainNamesDocument, options);
        }
export type FindAllDomainNamesQueryHookResult = ReturnType<typeof useFindAllDomainNamesQuery>;
export type FindAllDomainNamesLazyQueryHookResult = ReturnType<typeof useFindAllDomainNamesLazyQuery>;
export type FindAllDomainNamesQueryResult = Apollo.QueryResult<FindAllDomainNamesQuery, FindAllDomainNamesQueryVariables>;
export function refetchFindAllDomainNamesQuery(variables?: FindAllDomainNamesQueryVariables) {
      return { query: FindAllDomainNamesDocument, variables: variables }
    }
export const FindListOfUsersDocument = gql`
    query findListOfUsers($domainName: String!, $isUserFilterDtoIn: IsUserFilterDtoIn, $offset: Int, $limit: Int) {
  findListOfUsers(
    domainName: $domainName
    isUserFilterDtoIn: $isUserFilterDtoIn
    offset: $offset
    limit: $limit
  ) {
    totalResults
    isUserDtoOut {
      accountLocked
      userName
      domainName
      createdDate
      lastModifiedDate
      firstName
      lastName
      email
      tenantPermissions {
        name
      }
      locationGroupPermissions {
        name
      }
      locationPermissions {
        name
      }
      machinePermissions {
        name
      }
      userRoles {
        name
      }
    }
  }
}
    `;

/**
 * __useFindListOfUsersQuery__
 *
 * To run a query within a React component, call `useFindListOfUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindListOfUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindListOfUsersQuery({
 *   variables: {
 *      domainName: // value for 'domainName'
 *      isUserFilterDtoIn: // value for 'isUserFilterDtoIn'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFindListOfUsersQuery(baseOptions: Apollo.QueryHookOptions<FindListOfUsersQuery, FindListOfUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindListOfUsersQuery, FindListOfUsersQueryVariables>(FindListOfUsersDocument, options);
      }
export function useFindListOfUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindListOfUsersQuery, FindListOfUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindListOfUsersQuery, FindListOfUsersQueryVariables>(FindListOfUsersDocument, options);
        }
export type FindListOfUsersQueryHookResult = ReturnType<typeof useFindListOfUsersQuery>;
export type FindListOfUsersLazyQueryHookResult = ReturnType<typeof useFindListOfUsersLazyQuery>;
export type FindListOfUsersQueryResult = Apollo.QueryResult<FindListOfUsersQuery, FindListOfUsersQueryVariables>;
export function refetchFindListOfUsersQuery(variables: FindListOfUsersQueryVariables) {
      return { query: FindListOfUsersDocument, variables: variables }
    }
export const FindListOfUsersByTenantDocument = gql`
    query findListOfUsersByTenant($filterByUserName: String, $offset: Int, $limit: Int) {
  findListOfUsersByTenant(
    filterByUserName: $filterByUserName
    offset: $offset
    limit: $limit
  ) {
    totalResults
    isUserDtoOut {
      accountLocked
      userName
      domainName
      createdDate
      lastModifiedDate
      firstName
      lastName
      email
      locationGroupPermissions {
        name
      }
      locationPermissions {
        name
      }
      machinePermissions {
        name
      }
      tenantPermissions {
        name
      }
      userRoles {
        name
      }
    }
  }
}
    `;

/**
 * __useFindListOfUsersByTenantQuery__
 *
 * To run a query within a React component, call `useFindListOfUsersByTenantQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindListOfUsersByTenantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindListOfUsersByTenantQuery({
 *   variables: {
 *      filterByUserName: // value for 'filterByUserName'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFindListOfUsersByTenantQuery(baseOptions?: Apollo.QueryHookOptions<FindListOfUsersByTenantQuery, FindListOfUsersByTenantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindListOfUsersByTenantQuery, FindListOfUsersByTenantQueryVariables>(FindListOfUsersByTenantDocument, options);
      }
export function useFindListOfUsersByTenantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindListOfUsersByTenantQuery, FindListOfUsersByTenantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindListOfUsersByTenantQuery, FindListOfUsersByTenantQueryVariables>(FindListOfUsersByTenantDocument, options);
        }
export type FindListOfUsersByTenantQueryHookResult = ReturnType<typeof useFindListOfUsersByTenantQuery>;
export type FindListOfUsersByTenantLazyQueryHookResult = ReturnType<typeof useFindListOfUsersByTenantLazyQuery>;
export type FindListOfUsersByTenantQueryResult = Apollo.QueryResult<FindListOfUsersByTenantQuery, FindListOfUsersByTenantQueryVariables>;
export function refetchFindListOfUsersByTenantQuery(variables?: FindListOfUsersByTenantQueryVariables) {
      return { query: FindListOfUsersByTenantDocument, variables: variables }
    }
export const FindUserPermissionListDocument = gql`
    query findUserPermissionList {
  findUserPermissionList {
    userRoles {
      name
    }
    totalResults
  }
}
    `;

/**
 * __useFindUserPermissionListQuery__
 *
 * To run a query within a React component, call `useFindUserPermissionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUserPermissionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUserPermissionListQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindUserPermissionListQuery(baseOptions?: Apollo.QueryHookOptions<FindUserPermissionListQuery, FindUserPermissionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindUserPermissionListQuery, FindUserPermissionListQueryVariables>(FindUserPermissionListDocument, options);
      }
export function useFindUserPermissionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUserPermissionListQuery, FindUserPermissionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindUserPermissionListQuery, FindUserPermissionListQueryVariables>(FindUserPermissionListDocument, options);
        }
export type FindUserPermissionListQueryHookResult = ReturnType<typeof useFindUserPermissionListQuery>;
export type FindUserPermissionListLazyQueryHookResult = ReturnType<typeof useFindUserPermissionListLazyQuery>;
export type FindUserPermissionListQueryResult = Apollo.QueryResult<FindUserPermissionListQuery, FindUserPermissionListQueryVariables>;
export function refetchFindUserPermissionListQuery(variables?: FindUserPermissionListQueryVariables) {
      return { query: FindUserPermissionListDocument, variables: variables }
    }
export const FindUserRolesListDocument = gql`
    query findUserRolesList($domainName: String!, $offset: Int, $limit: Int) {
  findUserRolesList(domainName: $domainName, offset: $offset, limit: $limit) {
    userRoles {
      name
    }
    totalResults
  }
}
    `;

/**
 * __useFindUserRolesListQuery__
 *
 * To run a query within a React component, call `useFindUserRolesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUserRolesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUserRolesListQuery({
 *   variables: {
 *      domainName: // value for 'domainName'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFindUserRolesListQuery(baseOptions: Apollo.QueryHookOptions<FindUserRolesListQuery, FindUserRolesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindUserRolesListQuery, FindUserRolesListQueryVariables>(FindUserRolesListDocument, options);
      }
export function useFindUserRolesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUserRolesListQuery, FindUserRolesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindUserRolesListQuery, FindUserRolesListQueryVariables>(FindUserRolesListDocument, options);
        }
export type FindUserRolesListQueryHookResult = ReturnType<typeof useFindUserRolesListQuery>;
export type FindUserRolesListLazyQueryHookResult = ReturnType<typeof useFindUserRolesListLazyQuery>;
export type FindUserRolesListQueryResult = Apollo.QueryResult<FindUserRolesListQuery, FindUserRolesListQueryVariables>;
export function refetchFindUserRolesListQuery(variables: FindUserRolesListQueryVariables) {
      return { query: FindUserRolesListDocument, variables: variables }
    }
export const UpdateUserPasswordDocument = gql`
    mutation updateUserPassword($domainName: String, $userName: String, $password: String) {
  updateUserPassword(
    domainName: $domainName
    userName: $userName
    password: $password
  )
}
    `;
export type UpdateUserPasswordMutationFn = Apollo.MutationFunction<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>;

/**
 * __useUpdateUserPasswordMutation__
 *
 * To run a mutation, you first call `useUpdateUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPasswordMutation, { data, loading, error }] = useUpdateUserPasswordMutation({
 *   variables: {
 *      domainName: // value for 'domainName'
 *      userName: // value for 'userName'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useUpdateUserPasswordMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>(UpdateUserPasswordDocument, options);
      }
export type UpdateUserPasswordMutationHookResult = ReturnType<typeof useUpdateUserPasswordMutation>;
export type UpdateUserPasswordMutationResult = Apollo.MutationResult<UpdateUserPasswordMutation>;
export type UpdateUserPasswordMutationOptions = Apollo.BaseMutationOptions<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>;
export const UpdateUserPermissionOrRoleDocument = gql`
    mutation updateUserPermissionOrRole($isUserUpdateDtoIn: IsUserUpdateDtoIn) {
  updateUserPermissionOrRole(isUserUpdateDtoIn: $isUserUpdateDtoIn)
}
    `;
export type UpdateUserPermissionOrRoleMutationFn = Apollo.MutationFunction<UpdateUserPermissionOrRoleMutation, UpdateUserPermissionOrRoleMutationVariables>;

/**
 * __useUpdateUserPermissionOrRoleMutation__
 *
 * To run a mutation, you first call `useUpdateUserPermissionOrRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPermissionOrRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPermissionOrRoleMutation, { data, loading, error }] = useUpdateUserPermissionOrRoleMutation({
 *   variables: {
 *      isUserUpdateDtoIn: // value for 'isUserUpdateDtoIn'
 *   },
 * });
 */
export function useUpdateUserPermissionOrRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserPermissionOrRoleMutation, UpdateUserPermissionOrRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserPermissionOrRoleMutation, UpdateUserPermissionOrRoleMutationVariables>(UpdateUserPermissionOrRoleDocument, options);
      }
export type UpdateUserPermissionOrRoleMutationHookResult = ReturnType<typeof useUpdateUserPermissionOrRoleMutation>;
export type UpdateUserPermissionOrRoleMutationResult = Apollo.MutationResult<UpdateUserPermissionOrRoleMutation>;
export type UpdateUserPermissionOrRoleMutationOptions = Apollo.BaseMutationOptions<UpdateUserPermissionOrRoleMutation, UpdateUserPermissionOrRoleMutationVariables>;
export const CancelDeploymentDocument = gql`
    mutation cancelDeployment($nodeId: String!) {
  cancelDeployment(nodeId: $nodeId)
}
    `;
export type CancelDeploymentMutationFn = Apollo.MutationFunction<CancelDeploymentMutation, CancelDeploymentMutationVariables>;

/**
 * __useCancelDeploymentMutation__
 *
 * To run a mutation, you first call `useCancelDeploymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelDeploymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelDeploymentMutation, { data, loading, error }] = useCancelDeploymentMutation({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useCancelDeploymentMutation(baseOptions?: Apollo.MutationHookOptions<CancelDeploymentMutation, CancelDeploymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelDeploymentMutation, CancelDeploymentMutationVariables>(CancelDeploymentDocument, options);
      }
export type CancelDeploymentMutationHookResult = ReturnType<typeof useCancelDeploymentMutation>;
export type CancelDeploymentMutationResult = Apollo.MutationResult<CancelDeploymentMutation>;
export type CancelDeploymentMutationOptions = Apollo.BaseMutationOptions<CancelDeploymentMutation, CancelDeploymentMutationVariables>;
export const DeleteLogDocument = gql`
    mutation deleteLog($nodeId: String!) {
  deleteLog(nodeId: $nodeId)
}
    `;
export type DeleteLogMutationFn = Apollo.MutationFunction<DeleteLogMutation, DeleteLogMutationVariables>;

/**
 * __useDeleteLogMutation__
 *
 * To run a mutation, you first call `useDeleteLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLogMutation, { data, loading, error }] = useDeleteLogMutation({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useDeleteLogMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLogMutation, DeleteLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLogMutation, DeleteLogMutationVariables>(DeleteLogDocument, options);
      }
export type DeleteLogMutationHookResult = ReturnType<typeof useDeleteLogMutation>;
export type DeleteLogMutationResult = Apollo.MutationResult<DeleteLogMutation>;
export type DeleteLogMutationOptions = Apollo.BaseMutationOptions<DeleteLogMutation, DeleteLogMutationVariables>;
export const DeleteRmCommandDocument = gql`
    mutation deleteRmCommand($commandNodeId: String!) {
  deleteRmCommand(commandNodeId: $commandNodeId)
}
    `;
export type DeleteRmCommandMutationFn = Apollo.MutationFunction<DeleteRmCommandMutation, DeleteRmCommandMutationVariables>;

/**
 * __useDeleteRmCommandMutation__
 *
 * To run a mutation, you first call `useDeleteRmCommandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRmCommandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRmCommandMutation, { data, loading, error }] = useDeleteRmCommandMutation({
 *   variables: {
 *      commandNodeId: // value for 'commandNodeId'
 *   },
 * });
 */
export function useDeleteRmCommandMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRmCommandMutation, DeleteRmCommandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRmCommandMutation, DeleteRmCommandMutationVariables>(DeleteRmCommandDocument, options);
      }
export type DeleteRmCommandMutationHookResult = ReturnType<typeof useDeleteRmCommandMutation>;
export type DeleteRmCommandMutationResult = Apollo.MutationResult<DeleteRmCommandMutation>;
export type DeleteRmCommandMutationOptions = Apollo.BaseMutationOptions<DeleteRmCommandMutation, DeleteRmCommandMutationVariables>;
export const DeleteSoftwareInstallationDocument = gql`
    mutation deleteSoftwareInstallation($nodeId: String!) {
  deleteSoftwareInstallation(nodeId: $nodeId)
}
    `;
export type DeleteSoftwareInstallationMutationFn = Apollo.MutationFunction<DeleteSoftwareInstallationMutation, DeleteSoftwareInstallationMutationVariables>;

/**
 * __useDeleteSoftwareInstallationMutation__
 *
 * To run a mutation, you first call `useDeleteSoftwareInstallationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSoftwareInstallationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSoftwareInstallationMutation, { data, loading, error }] = useDeleteSoftwareInstallationMutation({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useDeleteSoftwareInstallationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSoftwareInstallationMutation, DeleteSoftwareInstallationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSoftwareInstallationMutation, DeleteSoftwareInstallationMutationVariables>(DeleteSoftwareInstallationDocument, options);
      }
export type DeleteSoftwareInstallationMutationHookResult = ReturnType<typeof useDeleteSoftwareInstallationMutation>;
export type DeleteSoftwareInstallationMutationResult = Apollo.MutationResult<DeleteSoftwareInstallationMutation>;
export type DeleteSoftwareInstallationMutationOptions = Apollo.BaseMutationOptions<DeleteSoftwareInstallationMutation, DeleteSoftwareInstallationMutationVariables>;
export const FindSoftwareInstallationsDocument = gql`
    query findSoftwareInstallations($installationNodeId: String, $machineNodeId: String, $ongoing: Boolean, $current: Boolean) {
  findSoftwareInstallations(
    installationNodeId: $installationNodeId
    machineNodeId: $machineNodeId
    ongoing: $ongoing
    current: $current
  ) {
    nodeId
    createdBy
    createdDate
    scheduleInfo
    stateChangedDate
  }
}
    `;

/**
 * __useFindSoftwareInstallationsQuery__
 *
 * To run a query within a React component, call `useFindSoftwareInstallationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindSoftwareInstallationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindSoftwareInstallationsQuery({
 *   variables: {
 *      installationNodeId: // value for 'installationNodeId'
 *      machineNodeId: // value for 'machineNodeId'
 *      ongoing: // value for 'ongoing'
 *      current: // value for 'current'
 *   },
 * });
 */
export function useFindSoftwareInstallationsQuery(baseOptions?: Apollo.QueryHookOptions<FindSoftwareInstallationsQuery, FindSoftwareInstallationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindSoftwareInstallationsQuery, FindSoftwareInstallationsQueryVariables>(FindSoftwareInstallationsDocument, options);
      }
export function useFindSoftwareInstallationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindSoftwareInstallationsQuery, FindSoftwareInstallationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindSoftwareInstallationsQuery, FindSoftwareInstallationsQueryVariables>(FindSoftwareInstallationsDocument, options);
        }
export type FindSoftwareInstallationsQueryHookResult = ReturnType<typeof useFindSoftwareInstallationsQuery>;
export type FindSoftwareInstallationsLazyQueryHookResult = ReturnType<typeof useFindSoftwareInstallationsLazyQuery>;
export type FindSoftwareInstallationsQueryResult = Apollo.QueryResult<FindSoftwareInstallationsQuery, FindSoftwareInstallationsQueryVariables>;
export function refetchFindSoftwareInstallationsQuery(variables?: FindSoftwareInstallationsQueryVariables) {
      return { query: FindSoftwareInstallationsDocument, variables: variables }
    }
export const GetAllCommandsDocument = gql`
    query getAllCommands($machineNodeId: String!, $cpPageRequest: CpPageRequest!) {
  getAllCommands(machineNodeId: $machineNodeId, cpPageRequest: $cpPageRequest) {
    ended
    executedBy
    machineNodeId
    name
    nodeId
    started
    status
    parameters {
      deviceId
      from
      link
      systemDump
      timeout
      types
      until
    }
  }
}
    `;

/**
 * __useGetAllCommandsQuery__
 *
 * To run a query within a React component, call `useGetAllCommandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCommandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCommandsQuery({
 *   variables: {
 *      machineNodeId: // value for 'machineNodeId'
 *      cpPageRequest: // value for 'cpPageRequest'
 *   },
 * });
 */
export function useGetAllCommandsQuery(baseOptions: Apollo.QueryHookOptions<GetAllCommandsQuery, GetAllCommandsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCommandsQuery, GetAllCommandsQueryVariables>(GetAllCommandsDocument, options);
      }
export function useGetAllCommandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCommandsQuery, GetAllCommandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCommandsQuery, GetAllCommandsQueryVariables>(GetAllCommandsDocument, options);
        }
export type GetAllCommandsQueryHookResult = ReturnType<typeof useGetAllCommandsQuery>;
export type GetAllCommandsLazyQueryHookResult = ReturnType<typeof useGetAllCommandsLazyQuery>;
export type GetAllCommandsQueryResult = Apollo.QueryResult<GetAllCommandsQuery, GetAllCommandsQueryVariables>;
export function refetchGetAllCommandsQuery(variables: GetAllCommandsQueryVariables) {
      return { query: GetAllCommandsDocument, variables: variables }
    }
export const GetAllLogsDocument = gql`
    query getAllLogs($machineNodeId: String!, $cpPageRequest: CpPageRequest!) {
  getAllLogs(machineNodeId: $machineNodeId, cpPageRequest: $cpPageRequest) {
    fromDate
    nodeId
    numberOfLogfiles
    originUri
    retrievalDate
    retrievedBy
    size
    toDate
    zipFileName
  }
}
    `;

/**
 * __useGetAllLogsQuery__
 *
 * To run a query within a React component, call `useGetAllLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllLogsQuery({
 *   variables: {
 *      machineNodeId: // value for 'machineNodeId'
 *      cpPageRequest: // value for 'cpPageRequest'
 *   },
 * });
 */
export function useGetAllLogsQuery(baseOptions: Apollo.QueryHookOptions<GetAllLogsQuery, GetAllLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllLogsQuery, GetAllLogsQueryVariables>(GetAllLogsDocument, options);
      }
export function useGetAllLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllLogsQuery, GetAllLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllLogsQuery, GetAllLogsQueryVariables>(GetAllLogsDocument, options);
        }
export type GetAllLogsQueryHookResult = ReturnType<typeof useGetAllLogsQuery>;
export type GetAllLogsLazyQueryHookResult = ReturnType<typeof useGetAllLogsLazyQuery>;
export type GetAllLogsQueryResult = Apollo.QueryResult<GetAllLogsQuery, GetAllLogsQueryVariables>;
export function refetchGetAllLogsQuery(variables: GetAllLogsQueryVariables) {
      return { query: GetAllLogsDocument, variables: variables }
    }
export const GetDeploymentsForMachineNodeIdDocument = gql`
    query getDeploymentsForMachineNodeId($machineUuid: String!) {
  getDeploymentsForMachineNodeId(machineUuid: $machineUuid) {
    createdBy
    current
    machineNodeId
    nodeId
    scheduleInfo
    state
    statusChangedDate
    template {
      createdBy
      description
      fileName
      name
      nodeId
      parts
      version
    }
  }
}
    `;

/**
 * __useGetDeploymentsForMachineNodeIdQuery__
 *
 * To run a query within a React component, call `useGetDeploymentsForMachineNodeIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeploymentsForMachineNodeIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeploymentsForMachineNodeIdQuery({
 *   variables: {
 *      machineUuid: // value for 'machineUuid'
 *   },
 * });
 */
export function useGetDeploymentsForMachineNodeIdQuery(baseOptions: Apollo.QueryHookOptions<GetDeploymentsForMachineNodeIdQuery, GetDeploymentsForMachineNodeIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeploymentsForMachineNodeIdQuery, GetDeploymentsForMachineNodeIdQueryVariables>(GetDeploymentsForMachineNodeIdDocument, options);
      }
export function useGetDeploymentsForMachineNodeIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeploymentsForMachineNodeIdQuery, GetDeploymentsForMachineNodeIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeploymentsForMachineNodeIdQuery, GetDeploymentsForMachineNodeIdQueryVariables>(GetDeploymentsForMachineNodeIdDocument, options);
        }
export type GetDeploymentsForMachineNodeIdQueryHookResult = ReturnType<typeof useGetDeploymentsForMachineNodeIdQuery>;
export type GetDeploymentsForMachineNodeIdLazyQueryHookResult = ReturnType<typeof useGetDeploymentsForMachineNodeIdLazyQuery>;
export type GetDeploymentsForMachineNodeIdQueryResult = Apollo.QueryResult<GetDeploymentsForMachineNodeIdQuery, GetDeploymentsForMachineNodeIdQueryVariables>;
export function refetchGetDeploymentsForMachineNodeIdQuery(variables: GetDeploymentsForMachineNodeIdQueryVariables) {
      return { query: GetDeploymentsForMachineNodeIdDocument, variables: variables }
    }
export const GetLogLinksDocument = gql`
    query getLogLinks($key: String!) {
  getLogLinks(key: $key) {
    urlForDelete
    urlForGet
    urlForPut
  }
}
    `;

/**
 * __useGetLogLinksQuery__
 *
 * To run a query within a React component, call `useGetLogLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLogLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLogLinksQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useGetLogLinksQuery(baseOptions: Apollo.QueryHookOptions<GetLogLinksQuery, GetLogLinksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLogLinksQuery, GetLogLinksQueryVariables>(GetLogLinksDocument, options);
      }
export function useGetLogLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLogLinksQuery, GetLogLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLogLinksQuery, GetLogLinksQueryVariables>(GetLogLinksDocument, options);
        }
export type GetLogLinksQueryHookResult = ReturnType<typeof useGetLogLinksQuery>;
export type GetLogLinksLazyQueryHookResult = ReturnType<typeof useGetLogLinksLazyQuery>;
export type GetLogLinksQueryResult = Apollo.QueryResult<GetLogLinksQuery, GetLogLinksQueryVariables>;
export function refetchGetLogLinksQuery(variables: GetLogLinksQueryVariables) {
      return { query: GetLogLinksDocument, variables: variables }
    }
export const PostRebootCommandDocument = gql`
    mutation postRebootCommand($machineNodeId: String!) {
  postRebootCommand(machineNodeId: $machineNodeId) {
    machineNodeId
    name
    nodeId
  }
}
    `;
export type PostRebootCommandMutationFn = Apollo.MutationFunction<PostRebootCommandMutation, PostRebootCommandMutationVariables>;

/**
 * __usePostRebootCommandMutation__
 *
 * To run a mutation, you first call `usePostRebootCommandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostRebootCommandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postRebootCommandMutation, { data, loading, error }] = usePostRebootCommandMutation({
 *   variables: {
 *      machineNodeId: // value for 'machineNodeId'
 *   },
 * });
 */
export function usePostRebootCommandMutation(baseOptions?: Apollo.MutationHookOptions<PostRebootCommandMutation, PostRebootCommandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostRebootCommandMutation, PostRebootCommandMutationVariables>(PostRebootCommandDocument, options);
      }
export type PostRebootCommandMutationHookResult = ReturnType<typeof usePostRebootCommandMutation>;
export type PostRebootCommandMutationResult = Apollo.MutationResult<PostRebootCommandMutation>;
export type PostRebootCommandMutationOptions = Apollo.BaseMutationOptions<PostRebootCommandMutation, PostRebootCommandMutationVariables>;
export const PostRestartCommandDocument = gql`
    mutation postRestartCommand($machineNodeId: String!) {
  postRestartCommand(machineNodeId: $machineNodeId) {
    machineNodeId
    nodeId
    name
  }
}
    `;
export type PostRestartCommandMutationFn = Apollo.MutationFunction<PostRestartCommandMutation, PostRestartCommandMutationVariables>;

/**
 * __usePostRestartCommandMutation__
 *
 * To run a mutation, you first call `usePostRestartCommandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostRestartCommandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postRestartCommandMutation, { data, loading, error }] = usePostRestartCommandMutation({
 *   variables: {
 *      machineNodeId: // value for 'machineNodeId'
 *   },
 * });
 */
export function usePostRestartCommandMutation(baseOptions?: Apollo.MutationHookOptions<PostRestartCommandMutation, PostRestartCommandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostRestartCommandMutation, PostRestartCommandMutationVariables>(PostRestartCommandDocument, options);
      }
export type PostRestartCommandMutationHookResult = ReturnType<typeof usePostRestartCommandMutation>;
export type PostRestartCommandMutationResult = Apollo.MutationResult<PostRestartCommandMutation>;
export type PostRestartCommandMutationOptions = Apollo.BaseMutationOptions<PostRestartCommandMutation, PostRestartCommandMutationVariables>;
export const PostRetrieveLogsDocument = gql`
    mutation postRetrieveLogs($logSearch: LogSearchDtoIn) {
  postRetrieveLogs(logSearch: $logSearch) {
    ended
    executedBy
    machineNodeId
    name
    nodeId
    started
    status
    parameters {
      deviceId
      from
      link
      systemDump
      timeout
      types
      until
    }
  }
}
    `;
export type PostRetrieveLogsMutationFn = Apollo.MutationFunction<PostRetrieveLogsMutation, PostRetrieveLogsMutationVariables>;

/**
 * __usePostRetrieveLogsMutation__
 *
 * To run a mutation, you first call `usePostRetrieveLogsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostRetrieveLogsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postRetrieveLogsMutation, { data, loading, error }] = usePostRetrieveLogsMutation({
 *   variables: {
 *      logSearch: // value for 'logSearch'
 *   },
 * });
 */
export function usePostRetrieveLogsMutation(baseOptions?: Apollo.MutationHookOptions<PostRetrieveLogsMutation, PostRetrieveLogsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostRetrieveLogsMutation, PostRetrieveLogsMutationVariables>(PostRetrieveLogsDocument, options);
      }
export type PostRetrieveLogsMutationHookResult = ReturnType<typeof usePostRetrieveLogsMutation>;
export type PostRetrieveLogsMutationResult = Apollo.MutationResult<PostRetrieveLogsMutation>;
export type PostRetrieveLogsMutationOptions = Apollo.BaseMutationOptions<PostRetrieveLogsMutation, PostRetrieveLogsMutationVariables>;